// Extracted from bob .babylon file
// 1 mesh(es), 1 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { BobMesh, BobMaterials } from "./types.js";

export const BOB_MATERIALS: BobMaterials = [
  {
    name: "texture",
    albedoColor: [0.80000000, 0.80000000, 0.80000000],
    albedoTexture: "/3d/textures/bob/bob-texture.png",
    metallic: 0.00000000,
    roughness: 0.77500000,
  },
];

const BOB_MESH_0: BobMesh = {
  name: "character_Cube.004_texture",
  positions: new Float32Array([
    -0.06673200, 1.74224400, 0.09034200,
    -0.03931300, 1.72033400, 0.07901500,
    -0.03902000, 1.72058700, 0.11273700,
    -0.06658700, 1.74240700, 0.12530800,
    -0.03931300, 1.72033400, 0.07901500,
    -0.00648800, 1.69684800, 0.06363900,
    -0.00648800, 1.69743800, 0.09534400,
    -0.03902000, 1.72058700, 0.11273700,
    -0.03902000, 1.72058700, 0.11273700,
    -0.00648800, 1.69743800, 0.09534400,
    -0.00648800, 1.71206600, 0.12945100,
    -0.03806000, 1.73381200, 0.14396700,
    -0.06658700, 1.74240700, 0.12530800,
    -0.03902000, 1.72058700, 0.11273700,
    -0.03806000, 1.73381200, 0.14396700,
    -0.06609300, 1.75424600, 0.15415800,
    -0.00648800, 1.71206600, 0.12945100,
    -0.00648800, 1.74831600, 0.15363600,
    -0.03743200, 1.76701700, 0.16103800,
    -0.03806000, 1.73381200, 0.14396700,
    -0.00648800, 1.74831600, 0.15363600,
    -0.00648800, 1.79564900, 0.16567200,
    -0.03800800, 1.81035700, 0.16684400,
    -0.03743200, 1.76701700, 0.16103800,
    -0.03743200, 1.76701700, 0.16103800,
    -0.03800800, 1.81035700, 0.16684400,
    -0.05271200, 1.81615100, 0.16708600,
    -0.05684400, 1.80576500, 0.16559500,
    -0.06207900, 1.79022200, 0.16550300,
    -0.06430000, 1.78311600, 0.16563800,
    -0.03806000, 1.73381200, 0.14396700,
    -0.03743200, 1.76701700, 0.16103800,
    -0.06430000, 1.78311600, 0.16563800,
    -0.06613800, 1.77627000, 0.16312200,
    -0.06609300, 1.75424600, 0.15415800,
    -0.00648800, 1.79564900, 0.16567200,
    -0.00649200, 1.84353000, 0.16891300,
    -0.02666100, 1.85050700, 0.16869900,
    -0.03296000, 1.84510400, 0.16812100,
    -0.03838500, 1.83814200, 0.16793100,
    -0.03800800, 1.81035700, 0.16684400,
    -0.00649200, 1.84353000, 0.16891300,
    -0.00649700, 1.85633300, 0.16940400,
    -0.01344300, 1.85544200, 0.16920500,
    -0.01945200, 1.85334600, 0.16898100,
    -0.02666100, 1.85050700, 0.16869900,
    -0.03800800, 1.81035700, 0.16684400,
    -0.03838500, 1.83814200, 0.16793100,
    -0.04678300, 1.82708300, 0.16721900,
    -0.05171800, 1.81893100, 0.16711700,
    -0.05271200, 1.81615100, 0.16708600,
    -0.06609300, 1.75424600, 0.15415800,
    -0.06613800, 1.77627000, 0.16312200,
    -0.07201800, 1.75921600, 0.15490800,
    0.05362400, 1.74213500, 0.09034800,
    0.05342900, 1.74234700, 0.12558800,
    0.02604400, 1.72058700, 0.11273700,
    0.02633700, 1.72033400, 0.07901500,
    0.02633700, 1.72033400, 0.07901500,
    0.02604400, 1.72058700, 0.11273700,
    -0.00648800, 1.69743800, 0.09534400,
    -0.00648800, 1.69684800, 0.06363900,
    0.02604400, 1.72058700, 0.11273700,
    0.02508300, 1.73380900, 0.14396400,
    -0.00648800, 1.71206600, 0.12945100,
    -0.00648800, 1.69743800, 0.09534400,
    0.05342900, 1.74234700, 0.12558800,
    0.05312300, 1.75424100, 0.15415100,
    0.02508300, 1.73380900, 0.14396400,
    0.02604400, 1.72058700, 0.11273700,
    -0.00648800, 1.71206600, 0.12945100,
    0.02508300, 1.73380900, 0.14396400,
    0.02444800, 1.76700500, 0.16103400,
    -0.00648800, 1.74831600, 0.15363600,
    -0.00648800, 1.74831600, 0.15363600,
    0.02444800, 1.76700500, 0.16103400,
    0.02500400, 1.81033600, 0.16684200,
    -0.00648800, 1.79564900, 0.16567200,
    0.02444800, 1.76700500, 0.16103400,
    0.04906700, 1.78153300, 0.16538200,
    0.04498400, 1.79151700, 0.16510300,
    0.03674900, 1.81131400, 0.16653200,
    0.03522000, 1.81454800, 0.16701700,
    0.02500400, 1.81033600, 0.16684200,
    0.02508300, 1.73380900, 0.14396400,
    0.05312300, 1.75424100, 0.15415100,
    0.05276100, 1.77279400, 0.16186800,
    0.04906700, 1.78153300, 0.16538200,
    0.02444800, 1.76700500, 0.16103400,
    -0.00648800, 1.79564900, 0.16567200,
    0.02500400, 1.81033600, 0.16684200,
    0.02535200, 1.83372400, 0.16775900,
    0.01831300, 1.84487000, 0.16816200,
    0.01225100, 1.84999200, 0.16871400,
    -0.00649200, 1.84353000, 0.16891300,
    -0.00649200, 1.84353000, 0.16891300,
    0.01225100, 1.84999200, 0.16871400,
    0.00923800, 1.85256700, 0.16896000,
    0.00100300, 1.85536200, 0.16938100,
    -0.00649700, 1.85633300, 0.16940400,
    0.02500400, 1.81033600, 0.16684200,
    0.03522000, 1.81454800, 0.16701700,
    0.02535200, 1.83372400, 0.16775900,
    0.05312300, 1.75424100, 0.15415100,
    0.05904700, 1.75919900, 0.15489200,
    0.05658500, 1.76580800, 0.15829600,
    0.05276100, 1.77279400, 0.16186800,
    -0.07477600, 1.75006400, 0.12699100,
    -0.07496400, 1.75003000, 0.09198000,
    -0.06673200, 1.74224400, 0.09034200,
    -0.06658700, 1.74240700, 0.12530800,
    -0.07201800, 1.75921600, 0.15490800,
    -0.07477600, 1.75006400, 0.12699100,
    -0.06658700, 1.74240700, 0.12530800,
    -0.06609300, 1.75424600, 0.15415800,
    0.06167700, 1.75012500, 0.12752600,
    0.05904700, 1.75919900, 0.15489200,
    0.05312300, 1.75424100, 0.15415100,
    0.05342900, 1.74234700, 0.12558800,
    -0.06393800, 1.74638300, 0.09032000,
    -0.06402300, 1.74664800, 0.12456000,
    -0.03676000, 1.72503000, 0.11193800,
    -0.03673100, 1.72464300, 0.07897400,
    -0.03673100, 1.72464300, 0.07897400,
    -0.03676000, 1.72503000, 0.11193800,
    -0.00648800, 1.70258800, 0.09473200,
    -0.00648800, 1.70204400, 0.06358000,
    -0.03676000, 1.72503000, 0.11193800,
    -0.03696700, 1.73763300, 0.14103200,
    -0.00648800, 1.71646600, 0.12699200,
    -0.00648800, 1.70258800, 0.09473200,
    -0.06402300, 1.74664800, 0.12456000,
    -0.06461800, 1.75775500, 0.15108500,
    -0.03696700, 1.73763300, 0.14103200,
    -0.03676000, 1.72503000, 0.11193800,
    -0.00648800, 1.75061700, 0.14949200,
    -0.03745700, 1.76874700, 0.15668000,
    -0.03806100, 1.81086000, 0.16224400,
    -0.00648800, 1.79646300, 0.16110800,
    -0.03745700, 1.76874700, 0.15668000,
    -0.06435200, 1.78446800, 0.16117600,
    -0.06225200, 1.79076000, 0.16091000,
    -0.05701700, 1.80630300, 0.16100200,
    -0.05277400, 1.81651900, 0.16247600,
    -0.03806100, 1.81086000, 0.16224400,
    -0.03696700, 1.73763300, 0.14103200,
    -0.06461800, 1.75775500, 0.15108500,
    -0.06595300, 1.77856400, 0.15897900,
    -0.06435200, 1.78446800, 0.16117600,
    -0.03745700, 1.76874700, 0.15668000,
    -0.00648800, 1.79646300, 0.16110800,
    -0.03806100, 1.81086000, 0.16224400,
    -0.03833900, 1.83842200, 0.16331700,
    -0.03291900, 1.84541800, 0.16350800,
    -0.02660500, 1.85080100, 0.16408600,
    -0.00648800, 1.84382400, 0.16429900,
    -0.00648800, 1.84382400, 0.16429900,
    -0.02660500, 1.85080100, 0.16408600,
    -0.01934200, 1.85356900, 0.16436500,
    -0.01333300, 1.85566500, 0.16458900,
    -0.00648800, 1.85659700, 0.16478800,
    -0.03806100, 1.81086000, 0.16224400,
    -0.05277400, 1.81651900, 0.16247600,
    -0.05165300, 1.81910000, 0.16249900,
    -0.04671800, 1.82725100, 0.16260000,
    -0.03833900, 1.83842200, 0.16331700,
    0.02375500, 1.72464300, 0.07897400,
    -0.00648800, 1.70204400, 0.06358000,
    -0.00648800, 1.70258800, 0.09473200,
    0.02378400, 1.72503000, 0.11193800,
    0.02378400, 1.72503000, 0.11193800,
    -0.00648800, 1.70258800, 0.09473200,
    -0.00648800, 1.71646600, 0.12699200,
    0.02399100, 1.73763300, 0.14103200,
    -0.00648800, 1.75061700, 0.14949200,
    -0.00648800, 1.79646300, 0.16110800,
    0.02508500, 1.81086000, 0.16224400,
    0.02448100, 1.76874700, 0.15668000,
    0.02448100, 1.76874700, 0.15668000,
    0.02508500, 1.81086000, 0.16224400,
    0.03534400, 1.81496600, 0.16241300,
    0.03696800, 1.81188000, 0.16194300,
    0.04520300, 1.79208300, 0.16051400,
    0.04913300, 1.78298400, 0.16094500,
    0.02399100, 1.73763300, 0.14103200,
    0.02448100, 1.76874700, 0.15668000,
    0.04913300, 1.78298400, 0.16094500,
    0.05253800, 1.77509800, 0.15773200,
    0.05164300, 1.75775500, 0.15108500,
    -0.00648800, 1.79646300, 0.16110800,
    -0.00648800, 1.84382400, 0.16429900,
    0.01219500, 1.85030300, 0.16410200,
    0.01827200, 1.84518500, 0.16354900,
    0.02531900, 1.83402300, 0.16314600,
    0.02508500, 1.81086000, 0.16224400,
    -0.00648800, 1.84382400, 0.16429900,
    -0.00648800, 1.85659700, 0.16478800,
    0.00091200, 1.85566500, 0.16476800,
    0.00914700, 1.85287000, 0.16435100,
    0.01219500, 1.85030300, 0.16410200,
    0.02508500, 1.81086000, 0.16224400,
    0.02531900, 1.83402300, 0.16314600,
    0.03534400, 1.81496600, 0.16241300,
    0.05164300, 1.75775500, 0.15108500,
    0.05253800, 1.77509800, 0.15773200,
    0.05566400, 1.76786100, 0.15415200,
    0.05725200, 1.76235900, 0.15169300,
    -0.07197400, 1.75411600, 0.12626800,
    -0.06402300, 1.74664800, 0.12456000,
    -0.06393800, 1.74638300, 0.09032000,
    -0.07199600, 1.75401200, 0.09196600,
    -0.07024900, 1.76237700, 0.15169500,
    -0.06461800, 1.75775500, 0.15108500,
    -0.06402300, 1.74664800, 0.12456000,
    -0.07197400, 1.75411600, 0.12626800,
    0.05904700, 1.75416200, 0.12627900,
    0.05104700, 1.74664800, 0.12456000,
    0.05164300, 1.75775500, 0.15108500,
    0.05725200, 1.76235900, 0.15169300,
    -0.00648800, 1.69684800, 0.06363900,
    -0.03931300, 1.72033400, 0.07901500,
    -0.03673100, 1.72464300, 0.07897400,
    -0.00648800, 1.70204400, 0.06358000,
    -0.03931300, 1.72033400, 0.07901500,
    -0.06673200, 1.74224400, 0.09034200,
    -0.06393800, 1.74638300, 0.09032000,
    -0.03673100, 1.72464300, 0.07897400,
    0.05342900, 1.74234700, 0.12558800,
    0.05362400, 1.74213500, 0.09034800,
    0.05096200, 1.74638300, 0.09032000,
    0.05104700, 1.74664800, 0.12456000,
    0.02633700, 1.72033400, 0.07901500,
    -0.00648800, 1.69684800, 0.06363900,
    -0.00648800, 1.70204400, 0.06358000,
    0.02375500, 1.72464300, 0.07897400,
    0.05362400, 1.74213500, 0.09034800,
    0.02633700, 1.72033400, 0.07901500,
    0.02375500, 1.72464300, 0.07897400,
    0.05096200, 1.74638300, 0.09032000,
    0.01225100, 1.84999200, 0.16871400,
    0.01831300, 1.84487000, 0.16816200,
    0.01827200, 1.84518500, 0.16354900,
    0.01219500, 1.85030300, 0.16410200,
    0.01831300, 1.84487000, 0.16816200,
    0.02535200, 1.83372400, 0.16775900,
    0.02531900, 1.83402300, 0.16314600,
    0.01827200, 1.84518500, 0.16354900,
    0.05276100, 1.77279400, 0.16186800,
    0.05658500, 1.76580800, 0.15829600,
    0.05566400, 1.76786100, 0.15415200,
    0.05253800, 1.77509800, 0.15773200,
    0.05658500, 1.76580800, 0.15829600,
    0.05904700, 1.75919900, 0.15489200,
    0.05725200, 1.76235900, 0.15169300,
    0.05566400, 1.76786100, 0.15415200,
    -0.00649700, 1.85633300, 0.16940400,
    0.00100300, 1.85536200, 0.16938100,
    0.00091200, 1.85566500, 0.16476800,
    -0.00648800, 1.85659700, 0.16478800,
    0.00100300, 1.85536200, 0.16938100,
    0.00923800, 1.85256700, 0.16896000,
    0.00914700, 1.85287000, 0.16435100,
    0.00091200, 1.85566500, 0.16476800,
    0.00923800, 1.85256700, 0.16896000,
    0.01225100, 1.84999200, 0.16871400,
    0.01219500, 1.85030300, 0.16410200,
    0.00914700, 1.85287000, 0.16435100,
    0.03522000, 1.81454800, 0.16701700,
    0.03674900, 1.81131400, 0.16653200,
    0.03696800, 1.81188000, 0.16194300,
    0.03534400, 1.81496600, 0.16241300,
    0.03674900, 1.81131400, 0.16653200,
    0.04498400, 1.79151700, 0.16510300,
    0.04520300, 1.79208300, 0.16051400,
    0.03696800, 1.81188000, 0.16194300,
    0.04498400, 1.79151700, 0.16510300,
    0.04906700, 1.78153300, 0.16538200,
    0.04913300, 1.78298400, 0.16094500,
    0.04520300, 1.79208300, 0.16051400,
    0.04906700, 1.78153300, 0.16538200,
    0.05276100, 1.77279400, 0.16186800,
    0.05253800, 1.77509800, 0.15773200,
    0.04913300, 1.78298400, 0.16094500,
    0.02535200, 1.83372400, 0.16775900,
    0.03522000, 1.81454800, 0.16701700,
    0.03534400, 1.81496600, 0.16241300,
    0.02531900, 1.83402300, 0.16314600,
    -0.04678300, 1.82708300, 0.16721900,
    -0.03838500, 1.83814200, 0.16793100,
    -0.03833900, 1.83842200, 0.16331700,
    -0.04671800, 1.82725100, 0.16260000,
    -0.05171800, 1.81893100, 0.16711700,
    -0.04678300, 1.82708300, 0.16721900,
    -0.04671800, 1.82725100, 0.16260000,
    -0.05165300, 1.81910000, 0.16249900,
    -0.05271200, 1.81615100, 0.16708600,
    -0.05171800, 1.81893100, 0.16711700,
    -0.05165300, 1.81910000, 0.16249900,
    -0.05277400, 1.81651900, 0.16247600,
    -0.03296000, 1.84510400, 0.16812100,
    -0.02666100, 1.85050700, 0.16869900,
    -0.02660500, 1.85080100, 0.16408600,
    -0.03291900, 1.84541800, 0.16350800,
    -0.03838500, 1.83814200, 0.16793100,
    -0.03296000, 1.84510400, 0.16812100,
    -0.03291900, 1.84541800, 0.16350800,
    -0.03833900, 1.83842200, 0.16331700,
    -0.07201800, 1.75921600, 0.15490800,
    -0.06613800, 1.77627000, 0.16312200,
    -0.06595300, 1.77856400, 0.15897900,
    -0.07024900, 1.76237700, 0.15169500,
    -0.01344300, 1.85544200, 0.16920500,
    -0.00649700, 1.85633300, 0.16940400,
    -0.00648800, 1.85659700, 0.16478800,
    -0.01333300, 1.85566500, 0.16458900,
    -0.01945200, 1.85334600, 0.16898100,
    -0.01344300, 1.85544200, 0.16920500,
    -0.01333300, 1.85566500, 0.16458900,
    -0.01934200, 1.85356900, 0.16436500,
    -0.02666100, 1.85050700, 0.16869900,
    -0.01945200, 1.85334600, 0.16898100,
    -0.01934200, 1.85356900, 0.16436500,
    -0.02660500, 1.85080100, 0.16408600,
    -0.05684400, 1.80576500, 0.16559500,
    -0.05271200, 1.81615100, 0.16708600,
    -0.05277400, 1.81651900, 0.16247600,
    -0.05701700, 1.80630300, 0.16100200,
    -0.06207900, 1.79022200, 0.16550300,
    -0.05684400, 1.80576500, 0.16559500,
    -0.05701700, 1.80630300, 0.16100200,
    -0.06225200, 1.79076000, 0.16091000,
    -0.06430000, 1.78311600, 0.16563800,
    -0.06207900, 1.79022200, 0.16550300,
    -0.06225200, 1.79076000, 0.16091000,
    -0.06435200, 1.78446800, 0.16117600,
    -0.06613800, 1.77627000, 0.16312200,
    -0.06430000, 1.78311600, 0.16563800,
    -0.06435200, 1.78446800, 0.16117600,
    -0.06595300, 1.77856400, 0.15897900,
    -0.06673200, 1.74224400, 0.09034200,
    -0.07496400, 1.75003000, 0.09198000,
    -0.07199600, 1.75401200, 0.09196600,
    -0.06393800, 1.74638300, 0.09032000,
    -0.07496400, 1.75003000, 0.09198000,
    -0.07477600, 1.75006400, 0.12699100,
    -0.07197400, 1.75411600, 0.12626800,
    -0.07199600, 1.75401200, 0.09196600,
    -0.07477600, 1.75006400, 0.12699100,
    -0.07201800, 1.75921600, 0.15490800,
    -0.07024900, 1.76237700, 0.15169500,
    -0.07197400, 1.75411600, 0.12626800,
    0.06167700, 1.75012500, 0.12752600,
    0.05342900, 1.74234700, 0.12558800,
    0.05104700, 1.74664800, 0.12456000,
    0.05904700, 1.75416200, 0.12627900,
    0.05904700, 1.75919900, 0.15489200,
    0.06167700, 1.75012500, 0.12752600,
    0.05904700, 1.75416200, 0.12627900,
    0.05725200, 1.76235900, 0.15169300,
    -0.11249200, 1.97995400, -0.10453600,
    -0.10505200, 2.00071000, -0.10286000,
    -0.09861000, 1.99807000, -0.11876600,
    -0.10097600, 1.98385100, -0.12390400,
    -0.10147800, 1.78995600, 0.05758600,
    -0.11943900, 1.83718200, 0.04989200,
    -0.11935400, 1.83811200, -0.02448000,
    -0.10057300, 1.79281600, -0.00707100,
    -0.06857100, 1.98267100, 0.17835300,
    -0.06888200, 2.01121300, 0.17388900,
    -0.09861100, 1.99758800, 0.17206800,
    -0.09864900, 1.96916600, 0.17498900,
    -0.06888200, 2.01121300, 0.17388900,
    -0.06946000, 2.03556000, 0.15847800,
    -0.09817700, 2.01910100, 0.15877900,
    -0.09861100, 1.99758800, 0.17206800,
    -0.09861100, 1.99758800, 0.17206800,
    -0.09817700, 2.01910100, 0.15877900,
    -0.11862100, 2.00212400, 0.15739300,
    -0.12304500, 1.98119600, 0.16322600,
    -0.09864900, 1.96916600, 0.17498900,
    -0.09861100, 1.99758800, 0.17206800,
    -0.12304500, 1.98119600, 0.16322600,
    -0.12248300, 1.95260100, 0.16074300,
    -0.11840000, 1.83559100, 0.12296900,
    -0.12827800, 1.88996300, 0.12149900,
    -0.12819600, 1.88862900, 0.04326300,
    -0.11943900, 1.83718200, 0.04989200,
    -0.07132300, 2.07447300, 0.04789700,
    -0.10333300, 2.04141300, 0.04800000,
    -0.10017900, 2.03029100, 0.13226900,
    -0.07034300, 2.05232500, 0.13073200,
    -0.10017900, 2.03029100, 0.13226900,
    -0.12429000, 2.00245800, 0.13455700,
    -0.11862100, 2.00212400, 0.15739300,
    -0.09817700, 2.01910100, 0.15877900,
    -0.07034300, 2.05232500, 0.13073200,
    -0.10017900, 2.03029100, 0.13226900,
    -0.09817700, 2.01910100, 0.15877900,
    -0.06946000, 2.03556000, 0.15847800,
    -0.03671200, 1.96191000, -0.16758100,
    -0.03673200, 2.01231600, -0.14864000,
    -0.00648500, 2.01689600, -0.15089100,
    -0.00649100, 1.96225800, -0.16898000,
    -0.06350000, 2.00299100, -0.14382300,
    -0.06460300, 2.02434700, -0.12759300,
    -0.03731100, 2.03732700, -0.12997700,
    -0.03673200, 2.01231600, -0.14864000,
    -0.03673200, 2.01231600, -0.14864000,
    -0.03731100, 2.03732700, -0.12997700,
    -0.00648900, 2.04436300, -0.13092000,
    -0.00648500, 2.01689600, -0.15089100,
    -0.13325800, 1.94431800, -0.02756000,
    -0.13331900, 1.97233400, -0.04459600,
    -0.11249200, 1.97995400, -0.10453600,
    -0.11813200, 1.94078700, -0.10993400,
    -0.13282200, 1.93079500, -0.04443200,
    -0.08611700, 1.95273800, -0.14955400,
    -0.08515400, 1.99238200, -0.13587800,
    -0.06350000, 2.00299100, -0.14382300,
    -0.06353300, 1.95827000, -0.16093200,
    -0.10097600, 1.98385100, -0.12390400,
    -0.09861000, 1.99807000, -0.11876600,
    -0.08590200, 2.00946300, -0.12354800,
    -0.08515400, 1.99238200, -0.13587800,
    -0.08515400, 1.99238200, -0.13587800,
    -0.08590200, 2.00946300, -0.12354800,
    -0.06460300, 2.02434700, -0.12759300,
    -0.06350000, 2.00299100, -0.14382300,
    -0.06353300, 1.95827000, -0.16093200,
    -0.06350000, 2.00299100, -0.14382300,
    -0.03673200, 2.01231600, -0.14864000,
    -0.03671200, 1.96191000, -0.16758100,
    -0.00648800, 1.70777600, 0.00744100,
    -0.00648800, 1.71015300, 0.02391900,
    -0.03654800, 1.73228700, 0.01709900,
    -0.03633000, 1.73110000, -0.01302000,
    -0.02660500, 1.85080100, 0.16408600,
    -0.01934200, 1.85356900, 0.16438300,
    -0.01333300, 1.85566500, 0.16466800,
    -0.00648800, 1.85659700, 0.16497900,
    -0.00648800, 1.89163000, 0.16746900,
    -0.03838700, 1.89957500, 0.16683300,
    -0.03833900, 1.83842200, 0.16331700,
    -0.03291900, 1.84541800, 0.16350800,
    -0.08568200, 1.76699000, 0.12921300,
    -0.07197400, 1.75411600, 0.12626800,
    -0.07024900, 1.76237700, 0.15169500,
    -0.08653400, 1.77574500, 0.15346000,
    -0.10107400, 1.78738000, 0.12805900,
    -0.08568200, 1.76699000, 0.12921300,
    -0.08653400, 1.77574500, 0.15346000,
    -0.09909100, 1.78903700, 0.14801900,
    -0.06278000, 1.75243900, -0.03155400,
    -0.06309000, 1.75307700, 0.00989500,
    -0.08454200, 1.77281300, 0.00181900,
    -0.08213000, 1.77357200, -0.04593800,
    -0.00648800, 2.10253200, 0.04804000,
    -0.03864100, 2.09304300, 0.04789900,
    -0.03858400, 2.06704400, 0.13031500,
    -0.00648800, 2.07312500, 0.13077200,
    -0.03858400, 2.06704400, 0.13031500,
    -0.07034300, 2.05232500, 0.13073200,
    -0.06946000, 2.03556000, 0.15847800,
    -0.03820000, 2.04719800, 0.15884000,
    -0.00648800, 2.07312500, 0.13077200,
    -0.03858400, 2.06704400, 0.13031500,
    -0.03820000, 2.04719800, 0.15884000,
    -0.00648800, 2.05140600, 0.15937500,
    -0.00649400, 1.98441700, 0.18061200,
    -0.00649200, 2.02184600, 0.17581800,
    -0.03773700, 2.01912400, 0.17468900,
    -0.03735900, 1.98440100, 0.17940100,
    -0.00649200, 2.02184600, 0.17581800,
    -0.00648800, 2.05140600, 0.15937500,
    -0.03820000, 2.04719800, 0.15884000,
    -0.03773700, 2.01912400, 0.17468900,
    -0.03773700, 2.01912400, 0.17468900,
    -0.03820000, 2.04719800, 0.15884000,
    -0.06946000, 2.03556000, 0.15847800,
    -0.06888200, 2.01121300, 0.17388900,
    -0.03735900, 1.98440100, 0.17940100,
    -0.03773700, 2.01912400, 0.17468900,
    -0.06888200, 2.01121300, 0.17388900,
    -0.06857100, 1.98267100, 0.17835300,
    -0.00648900, 2.04436300, -0.13092000,
    -0.03731100, 2.03732700, -0.12997700,
    -0.03823400, 2.05896800, -0.10414400,
    -0.00648600, 2.06562900, -0.10334400,
    -0.03731100, 2.03732700, -0.12997700,
    -0.06460300, 2.02434700, -0.12759300,
    -0.06697400, 2.04217400, -0.10417100,
    -0.03823400, 2.05896800, -0.10414400,
    -0.03823400, 2.05896800, -0.10414400,
    -0.03866200, 2.08844500, -0.03445800,
    -0.00648800, 2.09688100, -0.03254600,
    -0.00648600, 2.06562900, -0.10334400,
    -0.07131300, 2.07108800, -0.03696600,
    -0.07132300, 2.07447300, 0.04789700,
    -0.03864100, 2.09304300, 0.04789900,
    -0.03866200, 2.08844500, -0.03445800,
    -0.03866200, 2.08844500, -0.03445800,
    -0.03864100, 2.09304300, 0.04789900,
    -0.00648800, 2.10253200, 0.04804000,
    -0.00648800, 2.09688100, -0.03254600,
    -0.03864100, 2.09304300, 0.04789900,
    -0.07132300, 2.07447300, 0.04789700,
    -0.07034300, 2.05232500, 0.13073200,
    -0.03858400, 2.06704400, 0.13031500,
    -0.09080100, 1.79452100, -0.06928600,
    -0.07852500, 1.78372600, -0.06369000,
    -0.08213000, 1.77357200, -0.04593800,
    -0.09632100, 1.79187900, -0.05786400,
    -0.07852500, 1.78372600, -0.06369000,
    -0.05995800, 1.76625000, -0.05353900,
    -0.06278000, 1.75243900, -0.03155400,
    -0.08213000, 1.77357200, -0.04593800,
    -0.08213000, 1.77357200, -0.04593800,
    -0.08454200, 1.77281300, 0.00181900,
    -0.10057300, 1.79281600, -0.00707100,
    -0.09632100, 1.79187900, -0.05786400,
    -0.06309000, 1.75307700, 0.00989500,
    -0.06393800, 1.74946700, 0.05846100,
    -0.08562000, 1.76953300, 0.05974700,
    -0.08454200, 1.77281300, 0.00181900,
    -0.08454200, 1.77281300, 0.00181900,
    -0.08562000, 1.76953300, 0.05974700,
    -0.10147800, 1.78995600, 0.05758600,
    -0.10057300, 1.79281600, -0.00707100,
    -0.10147800, 1.78995600, 0.05758600,
    -0.08562000, 1.76953300, 0.05974700,
    -0.08568200, 1.76699000, 0.12921300,
    -0.10107400, 1.78738000, 0.12805900,
    -0.05995800, 1.76625000, -0.05353900,
    -0.03643600, 1.74227300, -0.03691300,
    -0.03633000, 1.73110000, -0.01302000,
    -0.06278000, 1.75243900, -0.03155400,
    -0.03643600, 1.74227300, -0.03691300,
    -0.00648800, 1.72060100, -0.01493100,
    -0.00648800, 1.70777600, 0.00744100,
    -0.03633000, 1.73110000, -0.01302000,
    -0.03633000, 1.73110000, -0.01302000,
    -0.03654800, 1.73228700, 0.01709900,
    -0.06309000, 1.75307700, 0.00989500,
    -0.06278000, 1.75243900, -0.03155400,
    -0.00648800, 1.71015300, 0.02391900,
    -0.00648800, 1.70540400, 0.04363400,
    -0.03673100, 1.72794200, 0.05243600,
    -0.03654800, 1.73228700, 0.01709900,
    -0.03654800, 1.73228700, 0.01709900,
    -0.03673100, 1.72794200, 0.05243600,
    -0.06393800, 1.74946700, 0.05846100,
    -0.06309000, 1.75307700, 0.00989500,
    -0.10505200, 2.00071000, -0.10286000,
    -0.12595100, 2.00353900, -0.04470700,
    -0.10333300, 2.03980100, -0.04016900,
    -0.09000400, 2.02154500, -0.10368200,
    -0.03673100, 1.72794200, 0.05243600,
    -0.00648800, 1.70540400, 0.04363400,
    -0.00648800, 1.70204400, 0.06358000,
    -0.03673100, 1.72464300, 0.07897400,
    -0.06393800, 1.74946700, 0.05846100,
    -0.03673100, 1.72794200, 0.05243600,
    -0.03673100, 1.72464300, 0.07897400,
    -0.06393800, 1.74638300, 0.09032000,
    -0.06460300, 2.02434700, -0.12759300,
    -0.08590200, 2.00946300, -0.12354800,
    -0.09000400, 2.02154500, -0.10368200,
    -0.06697400, 2.04217400, -0.10417100,
    -0.08590200, 2.00946300, -0.12354800,
    -0.09861000, 1.99807000, -0.11876600,
    -0.10505200, 2.00071000, -0.10286000,
    -0.09000400, 2.02154500, -0.10368200,
    -0.09000400, 2.02154500, -0.10368200,
    -0.10333300, 2.03980100, -0.04016900,
    -0.07131300, 2.07108800, -0.03696600,
    -0.06697400, 2.04217400, -0.10417100,
    -0.12655800, 2.00367500, 0.04766900,
    -0.10333300, 2.04141300, 0.04800000,
    -0.10333300, 2.03980100, -0.04016900,
    -0.12595100, 2.00353900, -0.04470700,
    -0.10333300, 2.03980100, -0.04016900,
    -0.10333300, 2.04141300, 0.04800000,
    -0.07132300, 2.07447300, 0.04789700,
    -0.07131300, 2.07108800, -0.03696600,
    -0.10333300, 2.04141300, 0.04800000,
    -0.12655800, 2.00367500, 0.04766900,
    -0.12429000, 2.00245800, 0.13455700,
    -0.10017900, 2.03029100, 0.13226900,
    -0.12248300, 1.95260100, 0.16074300,
    -0.12304500, 1.98119600, 0.16322600,
    -0.13306200, 1.97285300, 0.13394600,
    -0.13216900, 1.94538400, 0.13006600,
    -0.12304500, 1.98119600, 0.16322600,
    -0.11862100, 2.00212400, 0.15739300,
    -0.12429000, 2.00245800, 0.13455700,
    -0.13306200, 1.97285300, 0.13394600,
    -0.13306200, 1.97285300, 0.13394600,
    -0.13444000, 1.97191200, 0.04670700,
    -0.13325600, 1.94435300, 0.02904300,
    -0.13216900, 1.94538400, 0.13006600,
    -0.13282200, 1.93079500, -0.04443200,
    -0.12932300, 1.90290500, -0.03927000,
    -0.13402600, 1.90050700, -0.03925200,
    -0.13957200, 1.93011900, -0.04288800,
    -0.11943900, 1.83718200, 0.04989200,
    -0.12819600, 1.88862900, 0.04326300,
    -0.12746100, 1.88872800, -0.03686300,
    -0.11935400, 1.83811200, -0.02448000,
    -0.12429000, 2.00245800, 0.13455700,
    -0.12655800, 2.00367500, 0.04766900,
    -0.13444000, 1.97191200, 0.04670700,
    -0.13306200, 1.97285300, 0.13394600,
    -0.13331900, 1.97233400, -0.04459600,
    -0.12595100, 2.00353900, -0.04470700,
    -0.10505200, 2.00071000, -0.10286000,
    -0.11249200, 1.97995400, -0.10453600,
    -0.12105500, 1.88220600, -0.10930800,
    -0.11634600, 1.83495700, -0.09247000,
    -0.11935400, 1.83811200, -0.02448000,
    -0.12746100, 1.88872800, -0.03686300,
    -0.10427800, 1.94666800, -0.13290700,
    -0.10097600, 1.98385100, -0.12390400,
    -0.08515400, 1.99238200, -0.13587800,
    -0.08611700, 1.95273800, -0.14955400,
    -0.10107400, 1.78738000, 0.12805900,
    -0.11840000, 1.83559100, 0.12296900,
    -0.11943900, 1.83718200, 0.04989200,
    -0.10147800, 1.78995600, 0.05758600,
    -0.11634600, 1.83495700, -0.09247000,
    -0.09632100, 1.79187900, -0.05786400,
    -0.10057300, 1.79281600, -0.00707100,
    -0.11935400, 1.83811200, -0.02448000,
    -0.12655800, 2.00367500, 0.04766900,
    -0.12595100, 2.00353900, -0.04470700,
    -0.13331900, 1.97233400, -0.04459600,
    -0.13444000, 1.97191200, 0.04670700,
    -0.09909100, 1.78903700, 0.14801900,
    -0.11121900, 1.83415300, 0.14921500,
    -0.11840000, 1.83559100, 0.12296900,
    -0.10107400, 1.78738000, 0.12805900,
    -0.15407500, 1.93348000, 0.02872500,
    -0.14990500, 1.93974100, 0.02904200,
    -0.14990800, 1.93970600, -0.02756000,
    -0.15407500, 1.93346300, -0.02644200,
    0.02536000, 2.05876200, -0.10382900,
    0.02569500, 2.08721200, -0.03383200,
    0.05832000, 2.06953700, -0.03625800,
    0.05433400, 2.04088400, -0.10385500,
    -0.11121900, 1.83415300, 0.14921500,
    -0.11967000, 1.89281400, 0.14992700,
    -0.12827800, 1.88996300, 0.12149900,
    -0.11840000, 1.83559100, 0.12296900,
    -0.12047700, 1.90780400, 0.15234000,
    -0.12188400, 1.93769700, 0.15770600,
    -0.13134100, 1.93157500, 0.12759900,
    -0.12939500, 1.90386400, 0.12331600,
    -0.13134100, 1.93157500, 0.12759900,
    -0.13269200, 1.93071400, 0.04493300,
    -0.13001300, 1.90285200, 0.04444700,
    -0.12939500, 1.90386400, 0.12331600,
    -0.12188400, 1.93769700, 0.15770600,
    -0.12248300, 1.95260100, 0.16074300,
    -0.13216900, 1.94538400, 0.13006600,
    -0.13134100, 1.93157500, 0.12759900,
    -0.05277400, 1.81651900, 0.16247600,
    -0.05165300, 1.81910000, 0.16249900,
    -0.04671800, 1.82725100, 0.16260000,
    -0.03833900, 1.83842200, 0.16331700,
    -0.03838700, 1.89957500, 0.16683300,
    -0.06966200, 1.90290700, 0.16625600,
    -0.06781100, 1.82276700, 0.16273200,
    -0.00648800, 1.71646600, 0.12699200,
    -0.00648800, 1.75061700, 0.14949200,
    -0.03745700, 1.76874700, 0.15668000,
    -0.03696700, 1.73763300, 0.14103200,
    -0.00648800, 1.79646300, 0.16110800,
    -0.00648800, 1.84382400, 0.16432000,
    -0.02660500, 1.85080100, 0.16408600,
    -0.03291900, 1.84541800, 0.16350800,
    -0.03833900, 1.83842200, 0.16331700,
    -0.03806100, 1.81086000, 0.16224400,
    -0.00648800, 1.84382400, 0.16432000,
    -0.00648800, 1.85659700, 0.16497900,
    -0.01333300, 1.85566500, 0.16466800,
    -0.01934200, 1.85356900, 0.16438300,
    -0.02660500, 1.85080100, 0.16408600,
    -0.10270000, 1.83167000, -0.10512500,
    -0.08367000, 1.82643600, -0.10840200,
    -0.07852500, 1.78372600, -0.06369000,
    -0.09080100, 1.79452100, -0.06928600,
    -0.00648800, 1.89163000, 0.16746900,
    -0.00648800, 1.93981100, 0.17579400,
    -0.03123000, 1.94376500, 0.17515800,
    -0.02332900, 1.94122600, 0.17453200,
    -0.01608400, 1.93740000, 0.17368400,
    -0.01518900, 1.93665300, 0.17353500,
    -0.01742500, 1.93459400, 0.17313100,
    -0.02100300, 1.93131800, 0.17249600,
    -0.02645900, 1.92720000, 0.17168500,
    -0.03307800, 1.92411100, 0.17086200,
    -0.03796000, 1.92271500, 0.17040100,
    -0.03838700, 1.89957500, 0.16683300,
    -0.00648800, 1.93981100, 0.17579400,
    -0.00649400, 1.98441700, 0.18061200,
    -0.03735900, 1.98440100, 0.17940100,
    -0.03724700, 1.94530000, 0.17509500,
    -0.03123000, 1.94376500, 0.17515800,
    -0.03838700, 1.89957500, 0.16683300,
    -0.03796000, 1.92271500, 0.17040100,
    -0.04077000, 1.92242600, 0.17024800,
    -0.04524300, 1.92233300, 0.17006800,
    -0.05221900, 1.92467300, 0.17016200,
    -0.05874900, 1.92701300, 0.17028900,
    -0.06688800, 1.93075700, 0.17074200,
    -0.06904500, 1.93167900, 0.17087000,
    -0.06966200, 1.90290700, 0.16625600,
    -0.07852500, 1.78372600, -0.06369000,
    -0.08367000, 1.82643600, -0.10840200,
    -0.06064400, 1.81892500, -0.10637900,
    -0.05995800, 1.76625000, -0.05353900,
    -0.10856300, 1.88089700, -0.13244200,
    -0.08976300, 1.88052100, -0.14648800,
    -0.08367000, 1.82643600, -0.10840200,
    -0.10270000, 1.83167000, -0.10512500,
    -0.08367000, 1.82643600, -0.10840200,
    -0.08976300, 1.88052100, -0.14648800,
    -0.06523000, 1.87970600, -0.15299400,
    -0.06064400, 1.81892500, -0.10637900,
    -0.10427800, 1.94666800, -0.13290700,
    -0.08611700, 1.95273800, -0.14955400,
    -0.08807700, 1.91705400, -0.15371600,
    -0.10663700, 1.91331900, -0.13661200,
    -0.08611700, 1.95273800, -0.14955400,
    -0.06353300, 1.95827000, -0.16093200,
    -0.06477300, 1.92047000, -0.16481000,
    -0.08807700, 1.91705400, -0.15371600,
    -0.06064400, 1.81892500, -0.10637900,
    -0.03470300, 1.81054900, -0.10230700,
    -0.03643600, 1.74227300, -0.03691300,
    -0.05995800, 1.76625000, -0.05353900,
    -0.03643600, 1.74227300, -0.03691300,
    -0.03470300, 1.81054900, -0.10230700,
    -0.00656000, 1.80567900, -0.09963900,
    -0.00648800, 1.72060100, -0.01493100,
    -0.06523000, 1.87970600, -0.15299400,
    -0.03674300, 1.87822700, -0.15494300,
    -0.03470300, 1.81054900, -0.10230700,
    -0.06064400, 1.81892500, -0.10637900,
    -0.03470300, 1.81054900, -0.10230700,
    -0.03674300, 1.87822700, -0.15494300,
    -0.00645600, 1.87793600, -0.15624200,
    -0.00656000, 1.80567900, -0.09963900,
    -0.06353300, 1.95827000, -0.16093200,
    -0.03671200, 1.96191000, -0.16758100,
    -0.03686200, 1.92246500, -0.16987100,
    -0.06477300, 1.92047000, -0.16481000,
    -0.03671200, 1.96191000, -0.16758100,
    -0.00649100, 1.96225800, -0.16898000,
    -0.00646300, 1.92269100, -0.17110000,
    -0.03686200, 1.92246500, -0.16987100,
    -0.07024900, 1.76237700, 0.15169500,
    -0.06595300, 1.77856400, 0.15897900,
    -0.06781100, 1.82276700, 0.16273200,
    -0.09349800, 1.83031900, 0.16067800,
    -0.08653400, 1.77574500, 0.15346000,
    -0.06461800, 1.75775500, 0.15108500,
    -0.06595300, 1.77856400, 0.15897900,
    -0.07024900, 1.76237700, 0.15169500,
    -0.08653400, 1.77574500, 0.15346000,
    -0.09349800, 1.83031900, 0.16067800,
    -0.11121900, 1.83415300, 0.14921500,
    -0.09909100, 1.78903700, 0.14801900,
    -0.06966200, 1.90290700, 0.16625600,
    -0.09866600, 1.89895300, 0.16304500,
    -0.09349800, 1.83031900, 0.16067800,
    -0.06781100, 1.82276700, 0.16273200,
    -0.09349800, 1.83031900, 0.16067800,
    -0.09866600, 1.89895300, 0.16304500,
    -0.11967000, 1.89281400, 0.14992700,
    -0.11121900, 1.83415300, 0.14921500,
    -0.07271200, 1.96142700, 0.17628100,
    -0.09894000, 1.95130700, 0.17251300,
    -0.09878300, 1.91647600, 0.16592200,
    -0.09866600, 1.89895300, 0.16304500,
    -0.06966200, 1.90290700, 0.16625600,
    -0.06904500, 1.93167900, 0.17087000,
    -0.07914200, 1.93599800, 0.17104800,
    -0.07511700, 1.93841800, 0.17186000,
    -0.06893900, 1.94090200, 0.17289800,
    -0.09894000, 1.95130700, 0.17251300,
    -0.12188400, 1.93769700, 0.15770600,
    -0.12047700, 1.90780400, 0.15234000,
    -0.09878300, 1.91647600, 0.16592200,
    -0.07271200, 1.96142700, 0.17628100,
    -0.06857100, 1.98267100, 0.17835300,
    -0.09864900, 1.96916600, 0.17498900,
    -0.09894000, 1.95130700, 0.17251300,
    -0.09894000, 1.95130700, 0.17251300,
    -0.09864900, 1.96916600, 0.17498900,
    -0.12248300, 1.95260100, 0.16074300,
    -0.12188400, 1.93769700, 0.15770600,
    -0.09632100, 1.79187900, -0.05786400,
    -0.11634600, 1.83495700, -0.09247000,
    -0.10270000, 1.83167000, -0.10512500,
    -0.09080100, 1.79452100, -0.06928600,
    -0.11634600, 1.83495700, -0.09247000,
    -0.12105500, 1.88220600, -0.10930800,
    -0.10856300, 1.88089700, -0.13244200,
    -0.10270000, 1.83167000, -0.10512500,
    -0.13282200, 1.93079500, -0.04443200,
    -0.11813200, 1.94078700, -0.10993400,
    -0.12006100, 1.90967100, -0.11241900,
    -0.12932300, 1.90290500, -0.03927000,
    -0.11813200, 1.94078700, -0.10993400,
    -0.10427800, 1.94666800, -0.13290700,
    -0.10663700, 1.91331900, -0.13661200,
    -0.12006100, 1.90967100, -0.11241900,
    -0.11813200, 1.94078700, -0.10993400,
    -0.11249200, 1.97995400, -0.10453600,
    -0.10097600, 1.98385100, -0.12390400,
    -0.10427800, 1.94666800, -0.13290700,
    -0.06662000, 1.94186900, 0.17314800,
    -0.05105700, 1.94559500, 0.17451900,
    -0.04515300, 1.94607200, 0.17486700,
    -0.03916000, 1.94592000, 0.17510900,
    -0.03724700, 1.94530000, 0.17509500,
    -0.03735900, 1.98440100, 0.17940100,
    -0.06857100, 1.98267100, 0.17835300,
    -0.07271200, 1.96142700, 0.17628100,
    -0.06893900, 1.94090200, 0.17289800,
    -0.13022900, 1.88455100, -0.03686300,
    -0.12989600, 1.88445200, 0.01780800,
    -0.13409700, 1.88292000, 0.01780700,
    -0.13440200, 1.88301900, -0.03686300,
    -0.14651500, 1.94282800, -0.02756000,
    -0.14990800, 1.93970600, -0.02756000,
    -0.14990500, 1.93974100, 0.02904200,
    -0.14651300, 1.94286200, 0.02904200,
    -0.13952300, 1.89939500, -0.03750400,
    -0.14340000, 1.90037700, -0.02383200,
    -0.15407500, 1.93346300, -0.02644200,
    -0.14695000, 1.93063400, -0.04275300,
    -0.12932300, 1.90290500, -0.03927000,
    -0.12746100, 1.88872800, -0.03686300,
    -0.13022900, 1.88455100, -0.03686300,
    -0.13402600, 1.90050700, -0.03925200,
    -0.13269200, 1.93071400, 0.04493300,
    -0.13325600, 1.94435300, 0.02904300,
    -0.13990000, 1.94373900, 0.02904300,
    -0.13909900, 1.93010100, 0.01818900,
    -0.13269200, 1.93071400, 0.04493300,
    -0.13909900, 1.93010100, 0.01818900,
    -0.13391300, 1.90045700, 0.01774400,
    -0.13001300, 1.90285200, 0.04444700,
    -0.15407500, 1.93348000, 0.02872500,
    -0.15407500, 1.93346300, -0.02644200,
    -0.14340000, 1.90037700, -0.02383200,
    -0.14340000, 1.90032700, 0.02844700,
    -0.14645900, 1.93061000, 0.01818900,
    -0.15407500, 1.93348000, 0.02872500,
    -0.14340000, 1.90032700, 0.02844700,
    -0.13942400, 1.89934500, 0.01592500,
    -0.14645900, 1.93061000, 0.01818900,
    -0.14651300, 1.94286200, 0.02904200,
    -0.14990500, 1.93974100, 0.02904200,
    -0.15407500, 1.93348000, 0.02872500,
    -0.13909900, 1.93010100, 0.01818900,
    -0.14645900, 1.93061000, 0.01818900,
    -0.13942400, 1.89934500, 0.01592500,
    -0.13391300, 1.90045700, 0.01774400,
    -0.13409700, 1.88292000, 0.01780700,
    -0.14031700, 1.88550800, 0.02848600,
    -0.14031700, 1.88560800, -0.02234000,
    -0.13440200, 1.88301900, -0.03686300,
    -0.13134100, 1.93157500, 0.12759900,
    -0.13216900, 1.94538400, 0.13006600,
    -0.13325600, 1.94435300, 0.02904300,
    -0.13269200, 1.93071400, 0.04493300,
    -0.13444000, 1.97191200, 0.04670700,
    -0.13331900, 1.97233400, -0.04459600,
    -0.13325800, 1.94431800, -0.02756000,
    -0.13990200, 1.94370500, -0.02756000,
    -0.13990000, 1.94373900, 0.02904300,
    -0.13325600, 1.94435300, 0.02904300,
    -0.13909900, 1.93010100, 0.01818900,
    -0.13990000, 1.94373900, 0.02904300,
    -0.14651300, 1.94286200, 0.02904200,
    -0.14645900, 1.93061000, 0.01818900,
    -0.13952300, 1.89939500, -0.03750400,
    -0.13440200, 1.88301900, -0.03686300,
    -0.14031700, 1.88560800, -0.02234000,
    -0.14340000, 1.90037700, -0.02383200,
    -0.13957200, 1.93011900, -0.04288800,
    -0.13402600, 1.90050700, -0.03925200,
    -0.13952300, 1.89939500, -0.03750400,
    -0.14695000, 1.93063400, -0.04275300,
    -0.13990000, 1.94373900, 0.02904300,
    -0.13990200, 1.94370500, -0.02756000,
    -0.14651500, 1.94282800, -0.02756000,
    -0.14651300, 1.94286200, 0.02904200,
    -0.13990200, 1.94370500, -0.02756000,
    -0.13957200, 1.93011900, -0.04288800,
    -0.14695000, 1.93063400, -0.04275300,
    -0.14651500, 1.94282800, -0.02756000,
    -0.14651500, 1.94282800, -0.02756000,
    -0.14695000, 1.93063400, -0.04275300,
    -0.15407500, 1.93346300, -0.02644200,
    -0.14990800, 1.93970600, -0.02756000,
    -0.12989600, 1.88445200, 0.01780800,
    -0.13391300, 1.90045700, 0.01774400,
    -0.13942400, 1.89934500, 0.01592500,
    -0.13409700, 1.88292000, 0.01780700,
    -0.12939500, 1.90386400, 0.12331600,
    -0.13001300, 1.90285200, 0.04444700,
    -0.12819600, 1.88862900, 0.04326300,
    -0.12827800, 1.88996300, 0.12149900,
    -0.11967000, 1.89281400, 0.14992700,
    -0.12047700, 1.90780400, 0.15234000,
    -0.12939500, 1.90386400, 0.12331600,
    -0.12827800, 1.88996300, 0.12149900,
    -0.13325800, 1.94431800, -0.02756000,
    -0.13282200, 1.93079500, -0.04443200,
    -0.13957200, 1.93011900, -0.04288800,
    -0.13990200, 1.94370500, -0.02756000,
    -0.13402600, 1.90050700, -0.03925200,
    -0.13022900, 1.88455100, -0.03686300,
    -0.13440200, 1.88301900, -0.03686300,
    -0.13952300, 1.89939500, -0.03750400,
    -0.12932300, 1.90290500, -0.03927000,
    -0.12006100, 1.90967100, -0.11241900,
    -0.12105500, 1.88220600, -0.10930800,
    -0.12746100, 1.88872800, -0.03686300,
    -0.14340000, 1.90032700, 0.02844700,
    -0.14340000, 1.90037700, -0.02383200,
    -0.14031700, 1.88560800, -0.02234000,
    -0.14031700, 1.88550800, 0.02848600,
    -0.12819600, 1.88862900, 0.04326300,
    -0.13001300, 1.90285200, 0.04444700,
    -0.13391300, 1.90045700, 0.01774400,
    -0.12989600, 1.88445200, 0.01780800,
    -0.13409700, 1.88292000, 0.01780700,
    -0.13942400, 1.89934500, 0.01592500,
    -0.14340000, 1.90032700, 0.02844700,
    -0.14031700, 1.88550800, 0.02848600,
    -0.12105500, 1.88220600, -0.10930800,
    -0.12006100, 1.90967100, -0.11241900,
    -0.10663700, 1.91331900, -0.13661200,
    -0.10856300, 1.88089700, -0.13244200,
    -0.09866600, 1.89895300, 0.16304500,
    -0.09878300, 1.91647600, 0.16592200,
    -0.12047700, 1.90780400, 0.15234000,
    -0.11967000, 1.89281400, 0.14992700,
    -0.03674300, 1.87822700, -0.15494300,
    -0.03686200, 1.92246500, -0.16987100,
    -0.00646300, 1.92269100, -0.17110000,
    -0.00645600, 1.87793600, -0.15624200,
    -0.06523000, 1.87970600, -0.15299400,
    -0.06477300, 1.92047000, -0.16481000,
    -0.03686200, 1.92246500, -0.16987100,
    -0.03674300, 1.87822700, -0.15494300,
    -0.08976300, 1.88052100, -0.14648800,
    -0.08807700, 1.91705400, -0.15371600,
    -0.06477300, 1.92047000, -0.16481000,
    -0.06523000, 1.87970600, -0.15299400,
    -0.10856300, 1.88089700, -0.13244200,
    -0.10663700, 1.91331900, -0.13661200,
    -0.08807700, 1.91705400, -0.15371600,
    -0.08976300, 1.88052100, -0.14648800,
    -0.12746100, 1.88872800, -0.03686300,
    -0.12819600, 1.88862900, 0.04326300,
    -0.12989600, 1.88445200, 0.01780800,
    -0.13022900, 1.88455100, -0.03686300,
    0.09912800, 1.97897400, -0.10322000,
    0.08792500, 1.98263300, -0.12304000,
    0.08566500, 1.99662700, -0.11791400,
    0.09194200, 1.99929600, -0.10174900,
    0.08850200, 1.78995600, 0.05758600,
    0.08809300, 1.79209700, 0.02342200,
    0.08748500, 1.79281700, -0.00704600,
    0.10632400, 1.83813200, -0.02440400,
    0.10646300, 1.83718200, 0.04989200,
    0.05560100, 1.98274900, 0.18089500,
    0.08538700, 1.96962800, 0.17726500,
    0.08510400, 1.99705200, 0.17345500,
    0.05583400, 2.01111700, 0.17599600,
    0.05583400, 2.01111700, 0.17599600,
    0.08510400, 1.99705200, 0.17345500,
    0.08455700, 2.01841100, 0.15983100,
    0.05637000, 2.03541600, 0.16019400,
    0.08510400, 1.99705200, 0.17345500,
    0.10897200, 1.98133600, 0.16412800,
    0.10422600, 2.00194500, 0.15778900,
    0.08455700, 2.01841100, 0.15983100,
    0.08538700, 1.96962800, 0.17726500,
    0.10948600, 1.95263400, 0.16315500,
    0.10897200, 1.98133600, 0.16412800,
    0.08510400, 1.99705200, 0.17345500,
    0.10542400, 1.83559100, 0.12296900,
    0.10646300, 1.83718200, 0.04989200,
    0.11522000, 1.88862900, 0.04326300,
    0.11530200, 1.88996300, 0.12156000,
    0.05834700, 2.07447800, 0.04790000,
    0.05724100, 2.05202900, 0.13173300,
    0.08649400, 2.02959200, 0.13276600,
    0.09035700, 2.04141300, 0.04800000,
    0.08649400, 2.02959200, 0.13276600,
    0.08455700, 2.01841100, 0.15983100,
    0.10422600, 2.00194500, 0.15778900,
    0.10970700, 2.00251700, 0.13445400,
    0.05724100, 2.05202900, 0.13173300,
    0.05637000, 2.03541600, 0.16019400,
    0.08455700, 2.01841100, 0.15983100,
    0.08649400, 2.02959200, 0.13276600,
    0.05096200, 1.74638300, 0.09032000,
    0.05104700, 1.74664800, 0.12456000,
    0.02378400, 1.72503000, 0.11193800,
    0.02375500, 1.72464300, 0.07897400,
    0.05104700, 1.74664800, 0.12456000,
    0.05164300, 1.75775500, 0.15108500,
    0.02399100, 1.73763300, 0.14103200,
    0.02378400, 1.72503000, 0.11193800,
    0.02399600, 1.96114100, -0.16804400,
    -0.00649100, 1.96225800, -0.16898000,
    -0.00648500, 2.01689600, -0.15089100,
    0.02414500, 2.01236100, -0.14961700,
    0.05108900, 2.00213400, -0.14442000,
    0.02414500, 2.01236100, -0.14961700,
    0.02465200, 2.03785900, -0.13051900,
    0.05207300, 2.02344700, -0.12767300,
    0.02414500, 2.01236100, -0.14961700,
    -0.00648500, 2.01689600, -0.15089100,
    -0.00648900, 2.04436300, -0.13092000,
    0.02465200, 2.03785900, -0.13051900,
    0.09912800, 1.97897400, -0.10322000,
    0.12006100, 1.97233100, -0.04401800,
    0.12028200, 1.94432300, -0.02757300,
    0.11985100, 1.93083200, -0.04457300,
    0.10447900, 1.94064300, -0.10848400,
    0.07344100, 1.95190700, -0.14974600,
    0.05131000, 1.95735800, -0.16207700,
    0.05108900, 2.00213400, -0.14442000,
    0.07252600, 1.99114600, -0.13579900,
    0.08792500, 1.98263300, -0.12304000,
    0.07252600, 1.99114600, -0.13579900,
    0.07324900, 2.00809200, -0.12319600,
    0.08566500, 1.99662700, -0.11791400,
    0.07252600, 1.99114600, -0.13579900,
    0.05108900, 2.00213400, -0.14442000,
    0.05207300, 2.02344700, -0.12767300,
    0.07324900, 2.00809200, -0.12319600,
    0.05131000, 1.95735800, -0.16207700,
    0.02399600, 1.96114100, -0.16804400,
    0.02414500, 2.01236100, -0.14961700,
    0.05108900, 2.00213400, -0.14442000,
    0.08850100, 1.78791600, 0.09409500,
    0.08809800, 1.78738000, 0.12805900,
    0.07270600, 1.76699000, 0.12921300,
    0.07264400, 1.76691200, 0.09474800,
    0.07264400, 1.76691200, 0.09474800,
    0.07270600, 1.76699000, 0.12921300,
    0.05904700, 1.75416200, 0.12627900,
    0.05104700, 1.74664800, 0.12456000,
    0.05096200, 1.74638300, 0.09032000,
    0.07270600, 1.76699000, 0.12921300,
    0.07355800, 1.77574500, 0.15346000,
    0.05725200, 1.76235900, 0.15169300,
    0.05904700, 1.75416200, 0.12627900,
    0.08809800, 1.78738000, 0.12805900,
    0.08611600, 1.78903700, 0.14801900,
    0.07355800, 1.77574500, 0.15346000,
    0.07270600, 1.76699000, 0.12921300,
    0.02346100, 1.73075000, -0.01277100,
    0.02364900, 1.73237900, 0.01706700,
    -0.00648800, 1.71015300, 0.02391900,
    -0.00648800, 1.70777600, 0.00744100,
    -0.00648800, 2.10253200, 0.04804000,
    -0.00648800, 2.07312500, 0.13077200,
    0.02560600, 2.06718600, 0.13115800,
    0.02566500, 2.09305800, 0.04790600,
    0.02560600, 2.06718600, 0.13115800,
    0.02521800, 2.04732300, 0.16003800,
    0.05637000, 2.03541600, 0.16019400,
    0.05724100, 2.05202900, 0.13173300,
    -0.00648800, 2.07312500, 0.13077200,
    -0.00648800, 2.05140600, 0.15937500,
    0.02521800, 2.04732300, 0.16003800,
    0.02560600, 2.06718600, 0.13115800,
    -0.00649400, 1.98441700, 0.18061200,
    0.02435400, 1.98457900, 0.18138700,
    0.02474700, 2.01929700, 0.17626600,
    -0.00649200, 2.02184600, 0.17581800,
    -0.00649200, 2.02184600, 0.17581800,
    0.02474700, 2.01929700, 0.17626600,
    0.02521800, 2.04732300, 0.16003800,
    -0.00648800, 2.05140600, 0.15937500,
    0.02474700, 2.01929700, 0.17626600,
    0.05583400, 2.01111700, 0.17599600,
    0.05637000, 2.03541600, 0.16019400,
    0.02521800, 2.04732300, 0.16003800,
    0.02435400, 1.98457900, 0.18138700,
    0.05560100, 1.98274900, 0.18089500,
    0.05583400, 2.01111700, 0.17599600,
    0.02474700, 2.01929700, 0.17626600,
    -0.00648900, 2.04436300, -0.13092000,
    -0.00648600, 2.06562900, -0.10334400,
    0.02536000, 2.05876200, -0.10382900,
    0.02465200, 2.03785900, -0.13051900,
    0.02465200, 2.03785900, -0.13051900,
    0.02536000, 2.05876200, -0.10382900,
    0.05433400, 2.04088400, -0.10385500,
    0.05207300, 2.02344700, -0.12767300,
    -0.00648600, 2.06562900, -0.10334400,
    -0.00648800, 2.09688100, -0.03254600,
    0.02569500, 2.08721200, -0.03383200,
    0.02536000, 2.05876200, -0.10382900,
    0.02569500, 2.08721200, -0.03383200,
    0.02566500, 2.09305800, 0.04790600,
    0.05834700, 2.07447800, 0.04790000,
    0.05834700, 2.07594500, 0.00318600,
    0.05832000, 2.06953700, -0.03625800,
    -0.00648800, 2.09688100, -0.03254600,
    -0.00648800, 2.10253200, 0.04804000,
    0.02566500, 2.09305800, 0.04790600,
    0.02569500, 2.08721200, -0.03383200,
    0.02566500, 2.09305800, 0.04790600,
    0.02560600, 2.06718600, 0.13115800,
    0.05724100, 2.05202900, 0.13173300,
    0.05834700, 2.07447800, 0.04790000,
    0.07444000, 1.79586400, -0.06428600,
    0.07982700, 1.79352200, -0.05295300,
    0.06749500, 1.77454800, -0.04377700,
    0.06380100, 1.78420400, -0.06097400,
    0.06380100, 1.78420400, -0.06097400,
    0.06749500, 1.77454800, -0.04377700,
    0.04983900, 1.75238700, -0.03153600,
    0.04732700, 1.76522100, -0.05345100,
    0.06749500, 1.77454800, -0.04377700,
    0.07124300, 1.77179500, -0.02324700,
    0.04984300, 1.75199200, -0.01017900,
    0.04983900, 1.75238700, -0.03153600,
    0.07982700, 1.79352200, -0.05295300,
    0.08643700, 1.79199700, -0.03524700,
    0.07124300, 1.77179500, -0.02324700,
    0.06749500, 1.77454800, -0.04377700,
    0.08643700, 1.79199700, -0.03524700,
    0.08748500, 1.79281700, -0.00704600,
    0.07152600, 1.77279800, 0.00183000,
    0.07124300, 1.77179500, -0.02324700,
    0.07124300, 1.77179500, -0.02324700,
    0.07152600, 1.77279800, 0.00183000,
    0.05018400, 1.75312900, 0.00987600,
    0.04984300, 1.75199200, -0.01017900,
    0.07152600, 1.77279800, 0.00183000,
    0.07219300, 1.77207800, 0.02843700,
    0.05070100, 1.75238700, 0.03169200,
    0.05018400, 1.75312900, 0.00987600,
    0.08748500, 1.79281700, -0.00704600,
    0.08809300, 1.79209700, 0.02342200,
    0.07219300, 1.77207800, 0.02843700,
    0.07152600, 1.77279800, 0.00183000,
    0.08809300, 1.79209700, 0.02342200,
    0.08850200, 1.78995600, 0.05758600,
    0.07264400, 1.76953300, 0.05974700,
    0.07219300, 1.77207800, 0.02843700,
    0.07219300, 1.77207800, 0.02843700,
    0.07264400, 1.76953300, 0.05974700,
    0.05096200, 1.74946700, 0.05846100,
    0.05070100, 1.75238700, 0.03169200,
    0.07264400, 1.76953300, 0.05974700,
    0.07264400, 1.76691200, 0.09474800,
    0.05096200, 1.74638300, 0.09032000,
    0.05096200, 1.74946700, 0.05846100,
    0.08850200, 1.78995600, 0.05758600,
    0.08850100, 1.78791600, 0.09409500,
    0.07264400, 1.76691200, 0.09474800,
    0.07264400, 1.76953300, 0.05974700,
    0.04732700, 1.76522100, -0.05345100,
    0.04983900, 1.75238700, -0.03153600,
    0.02346100, 1.73075000, -0.01277100,
    0.02354900, 1.74163900, -0.03650900,
    0.02354900, 1.74163900, -0.03650900,
    0.02346100, 1.73075000, -0.01277100,
    -0.00648800, 1.70777600, 0.00744100,
    -0.00648800, 1.72060100, -0.01493100,
    0.04984300, 1.75199200, -0.01017900,
    0.05018400, 1.75312900, 0.00987600,
    0.02364900, 1.73237900, 0.01706700,
    0.02346100, 1.73075000, -0.01277100,
    0.04983900, 1.75238700, -0.03153600,
    0.02364900, 1.73237900, 0.01706700,
    0.02375500, 1.72794200, 0.05243600,
    -0.00648800, 1.70540400, 0.04363400,
    -0.00648800, 1.71015300, 0.02391900,
    0.05070100, 1.75238700, 0.03169200,
    0.05096200, 1.74946700, 0.05846100,
    0.02375500, 1.72794200, 0.05243600,
    0.02364900, 1.73237900, 0.01706700,
    0.05018400, 1.75312900, 0.00987600,
    0.07721200, 2.02000500, -0.10295100,
    0.09035700, 2.03887600, -0.03964000,
    0.11285500, 2.00272800, -0.04415800,
    0.09194200, 1.99929600, -0.10174900,
    0.02375500, 1.72794200, 0.05243600,
    0.02375500, 1.72464300, 0.07897400,
    -0.00648800, 1.70204400, 0.06358000,
    -0.00648800, 1.70540400, 0.04363400,
    0.05096200, 1.74946700, 0.05846100,
    0.05096200, 1.74638300, 0.09032000,
    0.02375500, 1.72464300, 0.07897400,
    0.02375500, 1.72794200, 0.05243600,
    0.05207300, 2.02344700, -0.12767300,
    0.05433400, 2.04088400, -0.10385500,
    0.07721200, 2.02000500, -0.10295100,
    0.07324900, 2.00809200, -0.12319600,
    0.07324900, 2.00809200, -0.12319600,
    0.07721200, 2.02000500, -0.10295100,
    0.09194200, 1.99929600, -0.10174900,
    0.08566500, 1.99662700, -0.11791400,
    0.05433400, 2.04088400, -0.10385500,
    0.05832000, 2.06953700, -0.03625800,
    0.09035700, 2.03887600, -0.03964000,
    0.07721200, 2.02000500, -0.10295100,
    0.09035700, 2.04141300, 0.04800000,
    0.08649400, 2.02959200, 0.13276600,
    0.10970700, 2.00251700, 0.13445400,
    0.11358200, 2.00367500, 0.04766900,
    0.09035700, 2.03887600, -0.03964000,
    0.09035700, 2.04240400, 0.00148300,
    0.11358200, 2.00410400, 0.00042300,
    0.11285500, 2.00272800, -0.04415800,
    0.05832000, 2.06953700, -0.03625800,
    0.05834700, 2.07594500, 0.00318600,
    0.09035700, 2.04240400, 0.00148300,
    0.09035700, 2.03887600, -0.03964000,
    0.05834700, 2.07594500, 0.00318600,
    0.05834700, 2.07447800, 0.04790000,
    0.09035700, 2.04141300, 0.04800000,
    0.09035700, 2.04240400, 0.00148300,
    0.09035700, 2.04240400, 0.00148300,
    0.09035700, 2.04141300, 0.04800000,
    0.11358200, 2.00367500, 0.04766900,
    0.11358200, 2.00410400, 0.00042300,
    0.10948600, 1.95263400, 0.16315500,
    0.11919300, 1.94538400, 0.13117700,
    0.11997200, 1.97291300, 0.13507900,
    0.10897200, 1.98133600, 0.16412800,
    0.10897200, 1.98133600, 0.16412800,
    0.11997200, 1.97291300, 0.13507900,
    0.10970700, 2.00251700, 0.13445400,
    0.10422600, 2.00194500, 0.15778900,
    0.12028000, 1.94435300, 0.02904300,
    0.12146400, 1.97191200, 0.04670700,
    0.11997200, 1.97291300, 0.13507900,
    0.11919300, 1.94538400, 0.13117700,
    0.12659300, 1.93013600, -0.04263400,
    0.12105100, 1.90051000, -0.03925200,
    0.11635000, 1.90290900, -0.03929500,
    0.11985100, 1.93083200, -0.04457300,
    0.10646300, 1.83718200, 0.04989200,
    0.10632400, 1.83813200, -0.02440400,
    0.11448500, 1.88872800, -0.03686300,
    0.11522000, 1.88862900, 0.04326300,
    0.11997200, 1.97291300, 0.13507900,
    0.12146400, 1.97191200, 0.04670700,
    0.11358200, 2.00367500, 0.04766900,
    0.10970700, 2.00251700, 0.13445400,
    0.12006100, 1.97233100, -0.04401800,
    0.09912800, 1.97897400, -0.10322000,
    0.09194200, 1.99929600, -0.10174900,
    0.11285500, 2.00272800, -0.04415800,
    0.10632400, 1.83813200, -0.02440400,
    0.09775300, 1.83520400, -0.08326300,
    0.10721200, 1.88163100, -0.10782800,
    0.11448500, 1.88872800, -0.03686300,
    0.09097900, 1.94613200, -0.13198600,
    0.07344100, 1.95190700, -0.14974600,
    0.07252600, 1.99114600, -0.13579900,
    0.08792500, 1.98263300, -0.12304000,
    0.08809800, 1.78738000, 0.12805900,
    0.08850100, 1.78791600, 0.09409500,
    0.08850200, 1.78995600, 0.05758600,
    0.10646300, 1.83718200, 0.04989200,
    0.10542400, 1.83559100, 0.12296900,
    0.08643700, 1.79199700, -0.03524700,
    0.07982700, 1.79352200, -0.05295300,
    0.09775300, 1.83520400, -0.08326300,
    0.10632400, 1.83813200, -0.02440400,
    0.08748500, 1.79281700, -0.00704600,
    0.12146400, 1.97191200, 0.04670700,
    0.12006100, 1.97233100, -0.04401800,
    0.11285500, 2.00272800, -0.04415800,
    0.11358200, 2.00410400, 0.00042300,
    0.11358200, 2.00367500, 0.04766900,
    0.10542400, 1.83559100, 0.12296900,
    0.09824400, 1.83415300, 0.14921500,
    0.09222300, 1.80726700, 0.15080600,
    0.08611600, 1.78903700, 0.14801900,
    0.08809800, 1.78738000, 0.12805900,
    0.14109900, 1.93348000, 0.02872500,
    0.14109900, 1.93346300, -0.02644200,
    0.13693200, 1.93970600, -0.02756000,
    0.13692900, 1.93974100, 0.02904200,
    -0.08562000, 1.76953300, 0.05974700,
    -0.06393800, 1.74946700, 0.05846100,
    -0.06393800, 1.74638300, 0.09032000,
    -0.07199600, 1.75401200, 0.09196600,
    -0.07197400, 1.75411600, 0.12626800,
    -0.08568200, 1.76699000, 0.12921300,
    0.11530200, 1.88996300, 0.12156000,
    0.10669400, 1.89281400, 0.15044000,
    0.10324600, 1.86313200, 0.14821800,
    0.09824400, 1.83415300, 0.14921500,
    0.10542400, 1.83559100, 0.12296900,
    0.11836500, 1.93157500, 0.12842800,
    0.10890800, 1.93769700, 0.15982900,
    0.10830900, 1.92279400, 0.15646600,
    0.10750100, 1.90780400, 0.15338900,
    0.11641900, 1.90386400, 0.12363300,
    0.11971600, 1.93071400, 0.04493300,
    0.11836500, 1.93157500, 0.12842800,
    0.11641900, 1.90386400, 0.12363300,
    0.11703700, 1.90285200, 0.04444700,
    0.10890800, 1.93769700, 0.15982900,
    0.11836500, 1.93157500, 0.12842800,
    0.11919300, 1.94538400, 0.13117700,
    0.10948600, 1.95263400, 0.16315500,
    -0.00648800, 1.85659700, 0.16497900,
    0.00091200, 1.85566500, 0.16484000,
    0.00914700, 1.85287000, 0.16435100,
    0.01219500, 1.85030300, 0.16410200,
    0.01827200, 1.84518500, 0.16354900,
    0.02531900, 1.83402300, 0.16314600,
    0.02541100, 1.89957500, 0.16820800,
    -0.00648800, 1.89163000, 0.16746900,
    -0.00648800, 1.71646600, 0.12699200,
    0.02399100, 1.73763300, 0.14103200,
    0.02448100, 1.76874700, 0.15668000,
    -0.00648800, 1.75061700, 0.14949200,
    -0.00648800, 1.79646300, 0.16110800,
    0.02508500, 1.81086000, 0.16224400,
    0.02531900, 1.83402300, 0.16314600,
    0.01827200, 1.84518500, 0.16354900,
    0.01219500, 1.85030300, 0.16410200,
    -0.00648800, 1.84382400, 0.16432000,
    -0.00648800, 1.84382400, 0.16432000,
    0.01219500, 1.85030300, 0.16410200,
    0.00914700, 1.85287000, 0.16435100,
    0.00091200, 1.85566500, 0.16484000,
    -0.00648800, 1.85659700, 0.16497900,
    0.06797500, 1.82671500, -0.10385000,
    0.08514900, 1.83218100, -0.09757200,
    0.07444000, 1.79586400, -0.06428600,
    0.06380100, 1.78420400, -0.06097400,
    -0.00648800, 1.89163000, 0.16746900,
    0.02541100, 1.89957500, 0.16820800,
    0.02498500, 1.92271500, 0.17260900,
    0.02010200, 1.92411100, 0.17316500,
    0.01348300, 1.92720000, 0.17409600,
    0.00802700, 1.93131800, 0.17497700,
    0.00444900, 1.93459400, 0.17564300,
    0.00221300, 1.93665300, 0.17605900,
    0.00310800, 1.93739900, 0.17621000,
    0.01035300, 1.94122100, 0.17705100,
    0.01829000, 1.94377700, 0.17765500,
    -0.00648800, 1.93981100, 0.17579400,
    -0.00648800, 1.93981100, 0.17579400,
    0.01829000, 1.94377700, 0.17765500,
    0.02436900, 1.94530900, 0.17801800,
    0.02435400, 1.98457900, 0.18138700,
    -0.00649400, 1.98441700, 0.18061200,
    0.02541100, 1.89957500, 0.16820800,
    0.05668600, 1.90290700, 0.16752800,
    0.05609400, 1.93169000, 0.17331400,
    0.05391300, 1.93075700, 0.17311300,
    0.04577300, 1.92701300, 0.17231400,
    0.03924400, 1.92467300, 0.17200200,
    0.03226700, 1.92233300, 0.17211000,
    0.02779500, 1.92242600, 0.17239500,
    0.02498500, 1.92271500, 0.17260900,
    0.06380100, 1.78420400, -0.06097400,
    0.04732700, 1.76522100, -0.05345100,
    0.04663200, 1.81911100, -0.10476900,
    0.06797500, 1.82671500, -0.10385000,
    0.07641900, 1.88041600, -0.14591600,
    0.09483300, 1.88049500, -0.13111100,
    0.08514900, 1.83218100, -0.09757200,
    0.06797500, 1.82671500, -0.10385000,
    0.06797500, 1.82671500, -0.10385000,
    0.04663200, 1.81911100, -0.10476900,
    0.05208000, 1.87979400, -0.15284500,
    0.07641900, 1.88041600, -0.14591600,
    0.07344100, 1.95190700, -0.14974600,
    0.09097900, 1.94613200, -0.13198600,
    0.09310900, 1.91320600, -0.13558700,
    0.07515400, 1.91690400, -0.15374400,
    0.05131000, 1.95735800, -0.16207700,
    0.07344100, 1.95190700, -0.14974600,
    0.07515400, 1.91690400, -0.15374400,
    0.05220000, 1.92052300, -0.16558700,
    0.02137300, 1.81081900, -0.10208000,
    0.04663200, 1.81911100, -0.10476900,
    0.04732700, 1.76522100, -0.05345100,
    0.02354900, 1.74163900, -0.03650900,
    0.02354900, 1.74163900, -0.03650900,
    -0.00648800, 1.72060100, -0.01493100,
    -0.00656000, 1.80567900, -0.09963900,
    0.02137300, 1.81081900, -0.10208000,
    0.02384700, 1.87870000, -0.15555100,
    0.05208000, 1.87979400, -0.15284500,
    0.04663200, 1.81911100, -0.10476900,
    0.02137300, 1.81081900, -0.10208000,
    0.02137300, 1.81081900, -0.10208000,
    -0.00656000, 1.80567900, -0.09963900,
    -0.00645600, 1.87793600, -0.15624200,
    0.02384700, 1.87870000, -0.15555100,
    0.02399600, 1.96114100, -0.16804400,
    0.05131000, 1.95735800, -0.16207700,
    0.05220000, 1.92052300, -0.16558700,
    0.02397200, 1.92238800, -0.17006100,
    -0.00649100, 1.96225800, -0.16898000,
    0.02399600, 1.96114100, -0.16804400,
    0.02397200, 1.92238800, -0.17006100,
    -0.00646300, 1.92269100, -0.17110000,
    0.07982700, 1.79352200, -0.05295300,
    0.07444000, 1.79586400, -0.06428600,
    0.08514900, 1.83218100, -0.09757200,
    0.09775300, 1.83520400, -0.08326300,
    0.05306300, 1.78525400, 0.16162500,
    0.07669200, 1.79859500, 0.16144900,
    0.08052200, 1.83031900, 0.16067800,
    0.05483500, 1.82276700, 0.16273200,
    0.07669200, 1.79859500, 0.16144900,
    0.09222300, 1.80726700, 0.15080600,
    0.09824400, 1.83415300, 0.14921500,
    0.08052200, 1.83031900, 0.16067800,
    0.07355800, 1.77574500, 0.15346000,
    0.08611600, 1.78903700, 0.14801900,
    0.09222300, 1.80726700, 0.15080600,
    0.07669200, 1.79859500, 0.16144900,
    0.05483500, 1.82276700, 0.16273200,
    0.08052200, 1.83031900, 0.16067800,
    0.08379000, 1.86428300, 0.16049300,
    0.05628000, 1.86250000, 0.16331300,
    0.05628000, 1.86250000, 0.16331300,
    0.08379000, 1.86428300, 0.16049300,
    0.08569000, 1.89895300, 0.16418100,
    0.05668600, 1.90290700, 0.16752800,
    0.08379000, 1.86428300, 0.16049300,
    0.10324600, 1.86313200, 0.14821800,
    0.10669400, 1.89281400, 0.15044000,
    0.08569000, 1.89895300, 0.16418100,
    0.08052200, 1.83031900, 0.16067800,
    0.09824400, 1.83415300, 0.14921500,
    0.10324600, 1.86313200, 0.14821800,
    0.08379000, 1.86428300, 0.16049300,
    0.05668600, 1.90290700, 0.16752800,
    0.08569000, 1.89895300, 0.16418100,
    0.08574900, 1.90771500, 0.16599300,
    0.08580800, 1.91647600, 0.16783800,
    0.08592500, 1.93399800, 0.17158900,
    0.05640500, 1.94385800, 0.17634700,
    0.05599900, 1.94089700, 0.17582100,
    0.06214200, 1.93842100, 0.17468600,
    0.06616700, 1.93599800, 0.17377700,
    0.05609400, 1.93169000, 0.17331400,
    0.06010500, 1.96131200, 0.17916700,
    0.08585100, 1.95127600, 0.17520000,
    0.08538700, 1.96962800, 0.17726500,
    0.05560100, 1.98274900, 0.18089500,
    0.08585100, 1.95127600, 0.17520000,
    0.10890800, 1.93769700, 0.15982900,
    0.10948600, 1.95263400, 0.16315500,
    0.08538700, 1.96962800, 0.17726500,
    0.08580800, 1.91647600, 0.16783800,
    0.10750100, 1.90780400, 0.15338900,
    0.10830900, 1.92279400, 0.15646600,
    0.08592500, 1.93399800, 0.17158900,
    0.09775300, 1.83520400, -0.08326300,
    0.08514900, 1.83218100, -0.09757200,
    0.09483300, 1.88049500, -0.13111100,
    0.10721200, 1.88163100, -0.10782800,
    0.10447900, 1.94064300, -0.10848400,
    0.11985100, 1.93083200, -0.04457300,
    0.11635000, 1.90290900, -0.03929500,
    0.10630900, 1.90975200, -0.11110400,
    0.09097900, 1.94613200, -0.13198600,
    0.10447900, 1.94064300, -0.10848400,
    0.10630900, 1.90975200, -0.11110400,
    0.09310900, 1.91320600, -0.13558700,
    0.10447900, 1.94064300, -0.10848400,
    0.09097900, 1.94613200, -0.13198600,
    0.08792500, 1.98263300, -0.12304000,
    0.09912800, 1.97897400, -0.10322000,
    0.05640500, 1.94385800, 0.17634700,
    0.06010500, 1.96131200, 0.17916700,
    0.05560100, 1.98274900, 0.18089500,
    0.02435400, 1.98457900, 0.18138700,
    0.02436900, 1.94530900, 0.17801800,
    0.02618500, 1.94590900, 0.17807200,
    0.03217700, 1.94606300, 0.17787800,
    0.03808100, 1.94558900, 0.17754900,
    0.05364400, 1.94187900, 0.17609700,
    0.05599900, 1.94089700, 0.17582100,
    0.11725300, 1.88455100, -0.03686300,
    0.12142600, 1.88301900, -0.03686300,
    0.12112200, 1.88292000, 0.01780700,
    0.11692100, 1.88445200, 0.01780800,
    0.13693200, 1.93970600, -0.02756000,
    0.13353900, 1.94282800, -0.02756000,
    0.13353700, 1.94286200, 0.02904200,
    0.13692900, 1.93974100, 0.02904200,
    0.14109900, 1.93346300, -0.02644200,
    0.13042400, 1.90037700, -0.02383200,
    0.12654700, 1.89939500, -0.03750400,
    0.13395300, 1.93067100, -0.04212500,
    0.11635000, 1.90290900, -0.03929500,
    0.12105100, 1.90051000, -0.03925200,
    0.11725300, 1.88455100, -0.03686300,
    0.11448500, 1.88872800, -0.03686300,
    0.11971600, 1.93071400, 0.04493300,
    0.12612300, 1.93010100, 0.01818900,
    0.12692400, 1.94373900, 0.02904300,
    0.12028000, 1.94435300, 0.02904300,
    0.12612300, 1.93010100, 0.01818900,
    0.11971600, 1.93071400, 0.04493300,
    0.11703700, 1.90285200, 0.04444700,
    0.12093700, 1.90045700, 0.01774400,
    0.14109900, 1.93346300, -0.02644200,
    0.14109900, 1.93348000, 0.02872500,
    0.13042400, 1.90032700, 0.02844700,
    0.13042400, 1.90037700, -0.02383200,
    0.14109900, 1.93348000, 0.02872500,
    0.13348300, 1.93061000, 0.01818900,
    0.12644800, 1.89934500, 0.01592500,
    0.13042400, 1.90032700, 0.02844700,
    0.13348300, 1.93061000, 0.01818900,
    0.14109900, 1.93348000, 0.02872500,
    0.13692900, 1.93974100, 0.02904200,
    0.13353700, 1.94286200, 0.02904200,
    0.13348300, 1.93061000, 0.01818900,
    0.12612300, 1.93010100, 0.01818900,
    0.12093700, 1.90045700, 0.01774400,
    0.12644800, 1.89934500, 0.01592500,
    0.12734100, 1.88560800, -0.02234000,
    0.12734100, 1.88550800, 0.02848600,
    0.12112200, 1.88292000, 0.01780700,
    0.12142600, 1.88301900, -0.03686300,
    0.11836500, 1.93157500, 0.12842800,
    0.11971600, 1.93071400, 0.04493300,
    0.12028000, 1.94435300, 0.02904300,
    0.11919300, 1.94538400, 0.13117700,
    0.12028200, 1.94432300, -0.02757300,
    0.12006100, 1.97233100, -0.04401800,
    0.12146400, 1.97191200, 0.04670700,
    0.12028000, 1.94435300, 0.02904300,
    0.12692400, 1.94373900, 0.02904300,
    0.12692600, 1.94370300, -0.02755800,
    0.12612300, 1.93010100, 0.01818900,
    0.13348300, 1.93061000, 0.01818900,
    0.13353700, 1.94286200, 0.02904200,
    0.12692400, 1.94373900, 0.02904300,
    0.12654700, 1.89939500, -0.03750400,
    0.13042400, 1.90037700, -0.02383200,
    0.12734100, 1.88560800, -0.02234000,
    0.12142600, 1.88301900, -0.03686300,
    0.12654700, 1.89939500, -0.03750400,
    0.12105100, 1.90051000, -0.03925200,
    0.12659300, 1.93013600, -0.04263400,
    0.13395300, 1.93067100, -0.04212500,
    0.12692400, 1.94373900, 0.02904300,
    0.13353700, 1.94286200, 0.02904200,
    0.13353900, 1.94282800, -0.02756000,
    0.12692600, 1.94370300, -0.02755800,
    0.12692600, 1.94370300, -0.02755800,
    0.13353900, 1.94282800, -0.02756000,
    0.13395300, 1.93067100, -0.04212500,
    0.12659300, 1.93013600, -0.04263400,
    0.13353900, 1.94282800, -0.02756000,
    0.13693200, 1.93970600, -0.02756000,
    0.14109900, 1.93346300, -0.02644200,
    0.13395300, 1.93067100, -0.04212500,
    0.11692100, 1.88445200, 0.01780800,
    0.12112200, 1.88292000, 0.01780700,
    0.12644800, 1.89934500, 0.01592500,
    0.12093700, 1.90045700, 0.01774400,
    0.11703700, 1.90285200, 0.04444700,
    0.11641900, 1.90386400, 0.12363300,
    0.11530200, 1.88996300, 0.12156000,
    0.11522000, 1.88862900, 0.04326300,
    0.08592500, 1.93399800, 0.17158900,
    0.10830900, 1.92279400, 0.15646600,
    0.10890800, 1.93769700, 0.15982900,
    0.08585100, 1.95127600, 0.17520000,
    0.05640500, 1.94385800, 0.17634700,
    0.08592500, 1.93399800, 0.17158900,
    0.08585100, 1.95127600, 0.17520000,
    0.06010500, 1.96131200, 0.17916700,
    0.10669400, 1.89281400, 0.15044000,
    0.11530200, 1.88996300, 0.12156000,
    0.11641900, 1.90386400, 0.12363300,
    0.10750100, 1.90780400, 0.15338900,
    0.10709800, 1.90030900, 0.15189600,
    0.12028200, 1.94432300, -0.02757300,
    0.12692600, 1.94370300, -0.02755800,
    0.12659300, 1.93013600, -0.04263400,
    0.11985100, 1.93083200, -0.04457300,
    0.12105100, 1.90051000, -0.03925200,
    0.12654700, 1.89939500, -0.03750400,
    0.12142600, 1.88301900, -0.03686300,
    0.11725300, 1.88455100, -0.03686300,
    0.10630900, 1.90975200, -0.11110400,
    0.11635000, 1.90290900, -0.03929500,
    0.11448500, 1.88872800, -0.03686300,
    0.10721200, 1.88163100, -0.10782800,
    0.13042400, 1.90037700, -0.02383200,
    0.13042400, 1.90032700, 0.02844700,
    0.12734100, 1.88550800, 0.02848600,
    0.12734100, 1.88560800, -0.02234000,
    0.11522000, 1.88862900, 0.04326300,
    0.11692100, 1.88445200, 0.01780800,
    0.12093700, 1.90045700, 0.01774400,
    0.11703700, 1.90285200, 0.04444700,
    0.12112200, 1.88292000, 0.01780700,
    0.12734100, 1.88550800, 0.02848600,
    0.13042400, 1.90032700, 0.02844700,
    0.12644800, 1.89934500, 0.01592500,
    0.08574900, 1.90771500, 0.16599300,
    0.10709800, 1.90030900, 0.15189600,
    0.10750100, 1.90780400, 0.15338900,
    0.08580800, 1.91647600, 0.16783800,
    0.10721200, 1.88163100, -0.10782800,
    0.09483300, 1.88049500, -0.13111100,
    0.09310900, 1.91320600, -0.13558700,
    0.10630900, 1.90975200, -0.11110400,
    0.02384700, 1.87870000, -0.15555100,
    -0.00645600, 1.87793600, -0.15624200,
    -0.00646300, 1.92269100, -0.17110000,
    0.02397200, 1.92238800, -0.17006100,
    0.05208000, 1.87979400, -0.15284500,
    0.02384700, 1.87870000, -0.15555100,
    0.02397200, 1.92238800, -0.17006100,
    0.05220000, 1.92052300, -0.16558700,
    0.07641900, 1.88041600, -0.14591600,
    0.05208000, 1.87979400, -0.15284500,
    0.05220000, 1.92052300, -0.16558700,
    0.07515400, 1.91690400, -0.15374400,
    0.09483300, 1.88049500, -0.13111100,
    0.07641900, 1.88041600, -0.14591600,
    0.07515400, 1.91690400, -0.15374400,
    0.09310900, 1.91320600, -0.13558700,
    0.11448500, 1.88872800, -0.03686300,
    0.11725300, 1.88455100, -0.03686300,
    0.11692100, 1.88445200, 0.01780800,
    0.11522000, 1.88862900, 0.04326300,
    0.08569000, 1.89895300, 0.16418100,
    0.10669400, 1.89281400, 0.15044000,
    0.10709800, 1.90030900, 0.15189600,
    0.08574900, 1.90771500, 0.16599300,
    0.02531900, 1.83402300, 0.16314600,
    0.03534400, 1.81496600, 0.16241300,
    0.05483500, 1.82276700, 0.16273200,
    0.05628000, 1.86250000, 0.16331300,
    0.05668600, 1.90290700, 0.16752800,
    0.02541100, 1.89957500, 0.16820800,
    0.05253800, 1.77509800, 0.15773200,
    0.05566400, 1.76786100, 0.15415200,
    0.05725200, 1.76235900, 0.15169300,
    0.07355800, 1.77574500, 0.15346000,
    0.07669200, 1.79859500, 0.16144900,
    0.05306300, 1.78525400, 0.16162500,
    -0.06595300, 1.77856400, 0.15897900,
    -0.06435200, 1.78446800, 0.16117600,
    -0.06225200, 1.79076000, 0.16091000,
    -0.05701700, 1.80630300, 0.16100200,
    -0.05277400, 1.81651900, 0.16247600,
    -0.06781100, 1.82276700, 0.16273200,
    0.04913300, 1.78298400, 0.16094500,
    0.05253800, 1.77509800, 0.15773200,
    0.05306300, 1.78525400, 0.16162500,
    0.05483500, 1.82276700, 0.16273200,
    0.03534400, 1.81496600, 0.16241300,
    0.03696800, 1.81188000, 0.16194300,
    0.04520300, 1.79208300, 0.16051400,
    -0.15755100, 0.94152200, -0.06494900,
    -0.15201300, 0.97067900, -0.05087400,
    -0.15201300, 0.97067900, -0.13086400,
    -0.15755100, 0.94152200, -0.15172300,
    0.04427700, 1.59810600, 0.11691800,
    0.04215200, 1.68493000, 0.11738400,
    0.00188100, 1.68695600, 0.10853600,
    0.00188100, 1.59878100, 0.10785200,
    0.00218300, 0.84998500, 0.11004600,
    0.00000000, 0.75591500, 0.10897500,
    0.03903900, 0.75808000, 0.11765200,
    0.03851400, 0.84998500, 0.11824300,
    -0.03607000, 0.91350100, -0.18192500,
    0.00204400, 0.91350100, -0.17129300,
    0.00218300, 0.84998500, -0.18203000,
    -0.03851500, 0.84998500, -0.19422500,
    0.00218300, 0.84998500, -0.18203000,
    0.00000000, 0.75591500, -0.18043600,
    -0.03903900, 0.75808000, -0.19334600,
    -0.03851500, 0.84998500, -0.19422500,
    -0.09708800, 0.94152200, 0.11947100,
    -0.09367500, 0.97067900, 0.11967100,
    -0.15201300, 0.97067900, 0.10745600,
    -0.15755100, 0.94152200, 0.10704300,
    -0.15755100, 0.94152200, -0.06494900,
    -0.15755100, 0.94152200, -0.15172300,
    -0.16518200, 0.91350100, -0.16499400,
    -0.16518200, 0.91350100, -0.07414300,
    -0.10179100, 0.91350100, 0.11918800,
    -0.16518200, 0.91350100, 0.10657800,
    -0.17637800, 0.84998500, 0.10613900,
    -0.10869000, 0.84998500, 0.11875800,
    -0.09708800, 0.94152200, 0.11947100,
    -0.15755100, 0.94152200, 0.10704300,
    -0.16518200, 0.91350100, 0.10657800,
    -0.10179100, 0.91350100, 0.11918800,
    -0.16518200, 0.91350100, -0.07414300,
    -0.16518200, 0.91350100, -0.16499400,
    -0.17637800, 0.84998500, -0.17621700,
    -0.17637800, 0.84998500, -0.08202200,
    -0.03319400, 0.97067900, 0.11926200,
    0.00188100, 0.97067900, 0.11222800,
    0.00188100, 1.00866400, 0.11124500,
    -0.03538900, 1.00866300, 0.11882700,
    -0.11976300, 0.45484200, 0.11921700,
    -0.18285900, 0.45484200, 0.10661900,
    -0.18604900, 0.35934500, 0.10656200,
    -0.12254300, 0.35934500, 0.11917600,
    -0.17637800, 0.84998500, 0.01200000,
    -0.17637800, 0.84998500, -0.08202200,
    -0.18717400, 0.76629400, -0.08202200,
    -0.18717400, 0.76629400, 0.01200000,
    0.00195000, 0.94152200, -0.15860600,
    -0.03440300, 0.94152200, -0.16769100,
    -0.03319400, 0.97067900, -0.14447700,
    0.00188100, 0.97067900, -0.13708600,
    -0.03607000, 0.91350100, 0.11872200,
    0.00204400, 0.91350100, 0.11101900,
    0.00195000, 0.94152200, 0.11171200,
    -0.03440300, 0.94152200, 0.11903800,
    -0.03903900, 0.75808000, -0.19334600,
    0.00000000, 0.75591500, -0.18043600,
    -0.00530900, 0.70502000, -0.17103700,
    -0.04367500, 0.70502000, -0.18263500,
    -0.03319400, 0.97067900, 0.11926200,
    -0.03440300, 0.94152200, 0.11903800,
    0.00195000, 0.94152200, 0.11171200,
    0.00188100, 0.97067900, 0.11222800,
    0.00188100, 1.00866400, 0.11124500,
    0.00188100, 1.06221600, 0.10898700,
    -0.04093300, 1.06221600, 0.11766000,
    -0.03538900, 1.00866300, 0.11882700,
    -0.03440300, 0.94152200, -0.16769100,
    0.00195000, 0.94152200, -0.15860600,
    0.00204400, 0.91350100, -0.17129300,
    -0.03607000, 0.91350100, -0.18192500,
    -0.00530900, 0.70502000, 0.01517600,
    -0.00530900, 0.70502000, 0.10924400,
    -0.02646200, 0.55034000, 0.11134300,
    -0.02646200, 0.55034000, 0.02899700,
    -0.18717400, 0.76629400, -0.08202200,
    -0.18717400, 0.76629400, -0.17604500,
    -0.18925800, 0.70502000, -0.16467300,
    -0.18925800, 0.70502000, -0.07444100,
    0.00000000, 0.75591500, 0.01200000,
    0.00000000, 0.75591500, 0.10897500,
    -0.00530900, 0.70502000, 0.10924400,
    -0.00530900, 0.70502000, 0.01517600,
    -0.11444300, 0.76226100, 0.11822700,
    -0.18717400, 0.76629400, 0.10602300,
    -0.18925800, 0.70502000, 0.10602300,
    -0.11778000, 0.70502000, 0.11836800,
    -0.04367500, 0.70502000, -0.18263500,
    -0.00530900, 0.70502000, -0.17103700,
    -0.02646200, 0.55034000, -0.13057800,
    -0.05974700, 0.55034000, -0.13839300,
    -0.10869000, 0.84998500, 0.11875800,
    -0.11444300, 0.76226100, 0.11822700,
    -0.03903900, 0.75808000, 0.11765200,
    -0.03851500, 0.84998500, 0.11824300,
    -0.18925800, 0.70502000, -0.07444100,
    -0.18925800, 0.70502000, -0.16467300,
    -0.18604900, 0.55034000, -0.12584300,
    -0.18604900, 0.55034000, -0.04802900,
    -0.11778000, 0.70502000, 0.11836800,
    -0.18925800, 0.70502000, 0.10602300,
    -0.18604900, 0.55034000, 0.10678200,
    -0.12403700, 0.55034000, 0.11932200,
    -0.18285900, 0.45484200, -0.04802900,
    -0.18604900, 0.35934500, -0.04802900,
    -0.18604900, 0.35934500, 0.02899700,
    -0.18285900, 0.45484200, 0.02899700,
    -0.02048000, 0.45484200, 0.02899700,
    -0.02261600, 0.35934500, 0.02899700,
    -0.02261600, 0.35934500, -0.04802900,
    -0.02048000, 0.45484200, -0.04802900,
    0.17637800, 0.84998500, 0.10613900,
    0.18717400, 0.76629400, 0.10602300,
    0.18717400, 0.76629400, 0.01200100,
    0.17637800, 0.84998500, 0.01200000,
    -0.12254300, 0.35934500, 0.11917600,
    -0.18604900, 0.35934500, 0.10656200,
    -0.19003700, 0.32796100, 0.10673300,
    -0.12771500, 0.32796100, 0.11929200,
    -0.18604900, 0.35934500, -0.04802900,
    -0.18604900, 0.35934500, -0.12561500,
    -0.19003700, 0.32796100, -0.12579300,
    -0.19003700, 0.32796100, -0.04802900,
    -0.02261600, 0.35934500, 0.02899700,
    -0.02261600, 0.35934500, 0.11099200,
    -0.02965200, 0.32796100, 0.11127000,
    -0.02965200, 0.32796100, 0.02899700,
    -0.05670300, 0.35934500, -0.13822400,
    -0.02261600, 0.35934500, -0.13021400,
    -0.02965200, 0.32796100, -0.13050200,
    -0.06310300, 0.32796100, -0.13835800,
    -0.05974700, 0.55034000, -0.13839300,
    -0.02646200, 0.55034000, -0.13057800,
    -0.02373500, 0.50259100, -0.13040800,
    -0.05739300, 0.50259100, -0.13831500,
    -0.05739300, 0.50259100, -0.13831500,
    -0.02373500, 0.50259100, -0.13040800,
    -0.02048000, 0.45484200, -0.13031300,
    -0.05434800, 0.45484200, -0.13827100,
    -0.02646200, 0.55034000, 0.02899700,
    -0.02646200, 0.55034000, 0.11134300,
    -0.02373500, 0.50259100, 0.11117900,
    -0.02373500, 0.50259100, 0.02899700,
    -0.02373500, 0.50259100, 0.02899700,
    -0.02373500, 0.50259100, 0.11117900,
    -0.02048000, 0.45484200, 0.11108800,
    -0.02048000, 0.45484200, 0.02899700,
    -0.18604900, 0.55034000, -0.04802900,
    -0.18604900, 0.55034000, -0.12584300,
    -0.18511000, 0.50259100, -0.12573300,
    -0.18511000, 0.50259100, -0.04802900,
    -0.18511000, 0.50259100, -0.04802900,
    -0.18511000, 0.50259100, -0.12573300,
    -0.18285900, 0.45484200, -0.12567400,
    -0.18285900, 0.45484200, -0.04802900,
    -0.12771500, 0.32796100, 0.11929200,
    -0.19003700, 0.32796100, 0.10673300,
    -0.14746200, 0.12889500, 0.11659000,
    -0.11822700, 0.12889500, 0.12187800,
    -0.12403700, 0.55034000, 0.11932200,
    -0.18604900, 0.55034000, 0.10678200,
    -0.18511000, 0.50259100, 0.10667600,
    -0.12240300, 0.50259100, 0.11925500,
    -0.12240300, 0.50259100, 0.11925500,
    -0.18511000, 0.50259100, 0.10667600,
    -0.18285900, 0.45484200, 0.10661900,
    -0.11976300, 0.45484200, 0.11921700,
    -0.07222600, 0.12889500, 0.03115300,
    -0.07222600, 0.12889500, 0.11924900,
    -0.08315000, 0.09676300, 0.06044800,
    -0.08315000, 0.09676300, 0.01217400,
    -0.19003700, 0.32796100, -0.04802900,
    -0.19003700, 0.32796100, -0.12579300,
    -0.14746200, 0.12889500, -0.13602400,
    -0.14746200, 0.12889500, -0.04971900,
    -0.02965200, 0.32796100, 0.02899700,
    -0.02965200, 0.32796100, 0.11127000,
    -0.07222600, 0.12889500, 0.11924900,
    -0.07222600, 0.12889500, 0.03115300,
    -0.06310300, 0.32796100, -0.13835800,
    -0.02965200, 0.32796100, -0.13050200,
    -0.07222600, 0.12889500, -0.13878400,
    -0.08791800, 0.12889500, -0.14138600,
    -0.09401900, 0.09676300, -0.08079100,
    -0.08315000, 0.09676300, -0.08004800,
    -0.08315000, 0.05544300, -0.08004800,
    -0.09401900, 0.05544300, -0.08079100,
    -0.08791800, 0.12889500, -0.14138600,
    -0.07222600, 0.12889500, -0.13878400,
    -0.08315000, 0.09676300, -0.08004800,
    -0.09401900, 0.09676300, -0.08079100,
    -0.14746200, 0.12889500, -0.04971900,
    -0.14746200, 0.12889500, -0.13602400,
    -0.13526100, 0.09676300, -0.07920300,
    -0.13526100, 0.09676300, -0.03105900,
    0.00188100, 1.48970200, -0.16192600,
    0.00188100, 1.59878100, -0.16258600,
    0.04427700, 1.59810600, -0.17456500,
    0.04597900, 1.48970200, -0.17404800,
    -0.04093300, 1.06221600, 0.11766000,
    0.00188100, 1.06221600, 0.10898700,
    0.00188100, 1.35971700, 0.10703700,
    -0.04725600, 1.35971700, 0.11624200,
    -0.15201300, 0.97067900, 0.02757500,
    -0.15201300, 0.97067900, 0.10745600,
    -0.16253500, 1.00866300, 0.10671700,
    -0.16253500, 1.00866400, 0.02757500,
    -0.11822700, 0.12889500, 0.12187800,
    -0.14746200, 0.12889500, 0.11659000,
    -0.13526100, 0.09676300, 0.05966000,
    -0.11501200, 0.09676300, 0.06117400,
    -0.18911900, 1.06221600, 0.02757500,
    -0.18911900, 1.06221600, 0.10602300,
    -0.21943600, 1.35971700, 0.10602300,
    -0.21934600, 1.35974500, 0.02912500,
    -0.04093300, 1.06221600, -0.14274100,
    -0.04725600, 1.35971700, -0.14120600,
    0.00188100, 1.35971700, -0.13145500,
    0.00188100, 1.06221600, -0.13357100,
    -0.03538900, 1.00866400, -0.14400500,
    -0.04093300, 1.06221600, -0.14274100,
    0.00188100, 1.06221600, -0.13357100,
    0.00188100, 1.00866400, -0.13602000,
    -0.16253500, 1.00866400, 0.02757500,
    -0.16253500, 1.00866300, 0.10671700,
    -0.18911900, 1.06221600, 0.10602300,
    -0.18911900, 1.06221600, 0.02757500,
    -0.09367500, 0.97067900, -0.14445300,
    -0.15201300, 0.97067900, -0.13086400,
    -0.16253500, 1.00866400, -0.13006900,
    -0.10010900, 1.00866400, -0.14403200,
    -0.04725600, 1.35971700, 0.11624200,
    0.00188100, 1.35971700, 0.10703700,
    0.00188100, 1.48970200, 0.10736200,
    -0.04597900, 1.48970200, 0.11653400,
    0.00188100, 1.59878100, -0.16258600,
    0.00188100, 1.68695600, -0.13308200,
    0.04215200, 1.68493000, -0.14244200,
    0.04427700, 1.59810600, -0.17456500,
    -0.10010900, 1.00866400, -0.14403200,
    -0.16253500, 1.00866400, -0.13006900,
    -0.18911900, 1.06221600, -0.12932200,
    -0.11636300, 1.06221600, -0.14290100,
    -0.20516000, 1.59547400, -0.07220700,
    -0.22140900, 1.59717200, -0.07817900,
    -0.21139800, 1.67665500, -0.05680800,
    -0.19504700, 1.67621400, -0.05252200,
    -0.04215200, 1.68493000, 0.11738400,
    0.00188100, 1.68695600, 0.10853600,
    0.00248500, 1.71532800, 0.03456800,
    -0.03865800, 1.71330200, 0.03747500,
    -0.21943600, 1.35971700, 0.10602300,
    -0.21331200, 1.48970200, 0.10602300,
    -0.21331100, 1.48970200, 0.01816100,
    -0.21934600, 1.35974500, 0.02912500,
    -0.11636300, 1.06221600, -0.14290100,
    -0.18911900, 1.06221600, -0.12932200,
    -0.21943600, 1.35971700, -0.12932200,
    -0.13490000, 1.35971700, -0.14151300,
    -0.21943600, 1.35971700, -0.12932200,
    -0.21331100, 1.48970200, -0.15908800,
    -0.13115500, 1.48970200, -0.17450500,
    -0.13490000, 1.35971700, -0.14151300,
    -0.05953900, 1.74003100, -0.05291700,
    -0.06726400, 1.73931800, -0.02813500,
    -0.05469800, 1.76132400, -0.02819300,
    -0.05167100, 1.75782000, -0.04803300,
    -0.11998700, 1.68038800, 0.02858900,
    -0.19504700, 1.67621400, 0.02954600,
    -0.19496400, 1.67724200, 0.10602300,
    -0.11993700, 1.68101600, 0.11798400,
    0.19496400, 1.67724200, -0.12932200,
    0.19504700, 1.67621400, -0.05252200,
    0.20515900, 1.59547400, -0.07220700,
    0.20515400, 1.59554300, -0.15908800,
    0.20516100, 1.59545000, 0.01854900,
    0.20515400, 1.59554300, 0.10602300,
    0.21331100, 1.48970200, 0.10602300,
    0.21331100, 1.48970200, 0.01816100,
    -0.12616700, 1.59680100, -0.17497300,
    -0.11993700, 1.68101600, -0.14263200,
    -0.08242300, 1.68290400, -0.14798600,
    -0.04215200, 1.68493000, -0.14244200,
    -0.04427800, 1.59810600, -0.17456500,
    -0.13115500, 1.48970200, -0.17450500,
    -0.12616700, 1.59680100, -0.17497300,
    -0.04427800, 1.59810600, -0.17456500,
    -0.04597900, 1.48970200, -0.17404800,
    -0.20516000, 1.59547400, -0.07220700,
    -0.21331100, 1.48970200, -0.07158200,
    -0.22955600, 1.49146300, -0.07706700,
    -0.22140900, 1.59717200, -0.07817900,
    0.00188100, 1.48970200, 0.10736200,
    0.00188100, 1.59878100, 0.10785200,
    -0.04427800, 1.59810600, 0.11691800,
    -0.04597900, 1.48970200, 0.11653400,
    0.00248500, 1.71532800, 0.03456800,
    0.00308900, 1.74369900, 0.03170800,
    -0.03516300, 1.74167300, 0.03384800,
    -0.03865800, 1.71330200, 0.03747500,
    -0.20516200, 1.59545000, 0.01854900,
    -0.20515400, 1.59554300, 0.10602300,
    -0.19496400, 1.67724200, 0.10602300,
    -0.19504700, 1.67621400, 0.02954600,
    -0.37118400, 1.50019900, -0.07103200,
    -0.37111500, 1.50014400, 0.01783800,
    -0.34995900, 1.58809100, 0.01833800,
    -0.35070900, 1.58892300, -0.07182800,
    -0.21943600, 1.35971700, -0.12932200,
    -0.21934600, 1.35974500, -0.05218000,
    -0.21331100, 1.48970200, -0.07158200,
    -0.21331100, 1.48970200, -0.15908800,
    -0.35165700, 1.49899400, -0.07706700,
    -0.36457300, 1.37600100, -0.05391700,
    -0.38671500, 1.37785400, -0.05087400,
    -0.37118400, 1.50019900, -0.07103200,
    -0.21331200, 1.48970200, 0.10602300,
    -0.20515400, 1.59554300, 0.10602300,
    -0.20516200, 1.59545000, 0.01854900,
    -0.21331100, 1.48970200, 0.01816100,
    -0.21934600, 1.35974500, 0.02912500,
    -0.21331100, 1.48970200, 0.01816100,
    -0.22955600, 1.49146300, 0.02137700,
    -0.22705400, 1.35928800, 0.03118600,
    -0.21331100, 1.48970200, -0.07158200,
    -0.21934600, 1.35974500, -0.05218000,
    -0.22705400, 1.35928800, -0.05391700,
    -0.22955600, 1.49146300, -0.07706700,
    -0.03171800, 1.76964600, 0.03622500,
    0.00369300, 1.77207100, 0.03638700,
    0.00505100, 1.77194600, 0.00404400,
    -0.03168400, 1.76985900, 0.00407100,
    -0.06726400, 1.73931800, -0.02813500,
    -0.06726700, 1.73928900, 0.00342200,
    -0.05602000, 1.76298800, 0.00395700,
    -0.05469800, 1.76132400, -0.02819300,
    -0.11993700, 1.68101600, -0.14263200,
    -0.19496400, 1.67724200, -0.12932200,
    -0.19504700, 1.67621400, -0.05252200,
    -0.11998700, 1.68039900, -0.05243100,
    -0.19504700, 1.67621400, 0.02954600,
    -0.19504700, 1.67621400, -0.05252200,
    -0.21139800, 1.67665500, -0.05680800,
    -0.21139800, 1.67665500, 0.03463700,
    -0.16253500, 1.00866400, -0.13006900,
    -0.16253500, 1.00866400, -0.05087400,
    -0.18911900, 1.06221600, -0.05087400,
    -0.18911900, 1.06221600, -0.12932200,
    -0.18911900, 1.06221600, -0.12932200,
    -0.18911900, 1.06221600, -0.05087400,
    -0.21934600, 1.35974500, -0.05218000,
    -0.21943600, 1.35971700, -0.12932200,
    -0.18911900, 1.06221600, -0.05087400,
    -0.18911900, 1.06221600, 0.02757500,
    -0.21934600, 1.35974500, 0.02912500,
    -0.21934600, 1.35974500, -0.05218000,
    -0.15201300, 0.97067900, -0.13086400,
    -0.15201300, 0.97067900, -0.05087400,
    -0.16253500, 1.00866400, -0.05087400,
    -0.16253500, 1.00866400, -0.13006900,
    -0.14746200, 0.12889500, 0.11659000,
    -0.14746200, 0.12889500, 0.03050700,
    -0.13526100, 0.09676300, 0.01186600,
    -0.13526100, 0.09676300, 0.05966000,
    -0.13526100, 0.09676300, 0.05966000,
    -0.13526100, 0.09676300, 0.01186600,
    -0.13526100, 0.05544300, 0.01186600,
    -0.13526100, 0.05544300, 0.05966000,
    -0.08315000, 0.09676300, -0.08004800,
    -0.08315000, 0.09676300, -0.03143800,
    -0.08315000, 0.05544300, -0.03143800,
    -0.08315000, 0.05544300, -0.08004800,
    -0.02965200, 0.32796100, -0.13050200,
    -0.02965200, 0.32796100, -0.04802900,
    -0.07222600, 0.12889500, -0.05044100,
    -0.07222600, 0.12889500, -0.13878400,
    -0.19003700, 0.32796100, 0.10673300,
    -0.19003700, 0.32796100, 0.02899700,
    -0.14746200, 0.12889500, 0.03050700,
    -0.14746200, 0.12889500, 0.11659000,
    -0.07222600, 0.12889500, -0.13878400,
    -0.07222600, 0.12889500, -0.05044100,
    -0.08315000, 0.09676300, -0.03143800,
    -0.08315000, 0.09676300, -0.08004800,
    -0.02048000, 0.45484200, 0.11108800,
    -0.05434800, 0.45484200, 0.11875400,
    -0.05670300, 0.35934500, 0.11870900,
    -0.02261600, 0.35934500, 0.11099200,
    -0.03851500, 0.84998500, -0.19422500,
    -0.03903900, 0.75808000, -0.19334600,
    -0.11444300, 0.76226100, -0.19420000,
    -0.10869000, 0.84998500, -0.19499100,
    -0.18511000, 0.50259100, 0.10667600,
    -0.18511000, 0.50259100, 0.02899700,
    -0.18285900, 0.45484200, 0.02899700,
    -0.18285900, 0.45484200, 0.10661900,
    -0.18604900, 0.55034000, 0.10678200,
    -0.18604900, 0.55034000, 0.02899700,
    -0.18511000, 0.50259100, 0.02899700,
    -0.18511000, 0.50259100, 0.10667600,
    -0.18604900, 0.35934500, 0.10656200,
    -0.18285900, 0.45484200, 0.10661900,
    -0.18285900, 0.45484200, -0.12567400,
    -0.18604900, 0.35934500, -0.12561500,
    -0.02373500, 0.50259100, -0.13040800,
    -0.02373500, 0.50259100, -0.04802900,
    -0.02048000, 0.45484200, -0.04802900,
    -0.02048000, 0.45484200, -0.13031300,
    -0.02646200, 0.55034000, -0.13057800,
    -0.02646200, 0.55034000, -0.04802900,
    -0.02373500, 0.50259100, -0.04802900,
    -0.02373500, 0.50259100, -0.13040800,
    -0.02261600, 0.35934500, -0.13021400,
    -0.02261600, 0.35934500, -0.04802900,
    -0.02965200, 0.32796100, -0.04802900,
    -0.02965200, 0.32796100, -0.13050200,
    -0.18604900, 0.35934500, 0.10656200,
    -0.18604900, 0.35934500, 0.02899700,
    -0.19003700, 0.32796100, 0.02899700,
    -0.19003700, 0.32796100, 0.10673300,
    -0.18925800, 0.70502000, 0.10602300,
    -0.18925800, 0.70502000, 0.01579100,
    -0.18604900, 0.55034000, 0.02899700,
    -0.18604900, 0.55034000, 0.10678200,
    0.00000000, 0.75591500, -0.18043600,
    0.00000000, 0.75591500, -0.08202200,
    -0.00530900, 0.70502000, -0.07567100,
    -0.00530900, 0.70502000, -0.17103700,
    -0.18717400, 0.76629400, 0.10602300,
    -0.18717400, 0.76629400, 0.01200000,
    -0.18925800, 0.70502000, 0.01579100,
    -0.18925800, 0.70502000, 0.10602300,
    -0.00530900, 0.70502000, -0.17103700,
    -0.00530900, 0.70502000, -0.07567100,
    -0.02646200, 0.55034000, -0.04802900,
    -0.02646200, 0.55034000, -0.13057800,
    -0.02261600, 0.35934500, -0.13021400,
    -0.02048000, 0.45484200, -0.13031300,
    -0.02048000, 0.45484200, 0.11108800,
    -0.02261600, 0.35934500, 0.11099200,
    -0.16518200, 0.91350100, 0.10657800,
    -0.16518200, 0.91350100, 0.01594000,
    -0.17637800, 0.84998500, 0.01200000,
    -0.17637800, 0.84998500, 0.10613900,
    -0.15755100, 0.94152200, 0.10704300,
    -0.15755100, 0.94152200, 0.02053700,
    -0.16518200, 0.91350100, 0.01594000,
    -0.16518200, 0.91350100, 0.10657800,
    -0.15755100, 0.94152200, 0.10704300,
    -0.15201300, 0.97067900, 0.10745600,
    -0.15201300, 0.97067900, 0.02757500,
    -0.15755100, 0.94152200, 0.02053700,
    -0.27682300, 1.59323800, 0.03079800,
    -0.25871000, 1.66552500, 0.04471500,
    -0.30602200, 1.65439500, 0.03463700,
    -0.33223500, 1.58933900, 0.02206300,
    -0.33288200, 1.59006000, -0.07817900,
    -0.35165700, 1.49899400, -0.07706700,
    -0.37118400, 1.50019900, -0.07103200,
    -0.35070900, 1.58892300, -0.07182800,
    -0.21331100, 1.48970200, 0.01816100,
    -0.20516200, 1.59545000, 0.01854900,
    -0.22141200, 1.59713800, 0.02206300,
    -0.22955600, 1.49146300, 0.02137700,
    -0.30631800, 1.65463400, -0.05680800,
    -0.33288200, 1.59006000, -0.07817900,
    -0.35070900, 1.58892300, -0.07182800,
    -0.32149800, 1.65111300, -0.05270300,
    -0.21934600, 1.35974500, -0.05218000,
    -0.21934600, 1.35974500, 0.02912500,
    -0.22705400, 1.35928800, 0.03118600,
    -0.22705400, 1.35928800, -0.05391700,
    -0.20516200, 1.59545000, 0.01854900,
    -0.19504700, 1.67621400, 0.02954600,
    -0.21139800, 1.67665500, 0.03463700,
    -0.22141200, 1.59713800, 0.02206300,
    -0.34995900, 1.58809100, 0.01833800,
    -0.32115500, 1.65083400, 0.02977200,
    -0.32149800, 1.65111300, -0.05270300,
    -0.35070900, 1.58892300, -0.07182800,
    -0.33223500, 1.58933900, 0.02206300,
    -0.30602200, 1.65439500, 0.03463700,
    -0.32115500, 1.65083400, 0.02977200,
    -0.34995900, 1.58809100, 0.01833800,
    -0.38671500, 1.37785400, -0.05087400,
    -0.38671500, 1.37785400, 0.02757500,
    -0.37111500, 1.50014400, 0.01783800,
    -0.37118400, 1.50019900, -0.07103200,
    -0.33223500, 1.58933900, 0.02206300,
    -0.34995900, 1.58809100, 0.01833800,
    -0.37111500, 1.50014400, 0.01783800,
    -0.35159800, 1.49894700, 0.02137700,
    -0.36457300, 1.37600100, -0.05391700,
    -0.36457300, 1.37600100, 0.03118600,
    -0.38671500, 1.37785400, 0.02757500,
    -0.38671500, 1.37785400, -0.05087400,
    -0.29581300, 1.36764400, 0.04471500,
    -0.29057700, 1.49520500, 0.03079800,
    -0.35159800, 1.49894700, 0.02137700,
    -0.36457300, 1.37600100, 0.03118600,
    -0.35159800, 1.49894700, 0.02137700,
    -0.37111500, 1.50014400, 0.01783800,
    -0.38671500, 1.37785400, 0.02757500,
    -0.36457300, 1.37600100, 0.03118600,
    -0.30602200, 1.65439500, 0.03463700,
    -0.30631800, 1.65463400, -0.05680800,
    -0.32149800, 1.65111300, -0.05270300,
    -0.32115500, 1.65083400, 0.02977200,
    -0.03319400, 0.97067900, -0.14447700,
    -0.03538900, 1.00866400, -0.14400500,
    0.00188100, 1.00866400, -0.13602000,
    0.00188100, 0.97067900, -0.13708600,
    -0.29057700, 1.49520500, 0.03079800,
    -0.27682300, 1.59323800, 0.03079800,
    -0.33223500, 1.58933900, 0.02206300,
    -0.35159800, 1.49894700, 0.02137700,
    -0.04427800, 1.59810600, 0.11691800,
    -0.04215200, 1.68493000, 0.11738400,
    -0.08242300, 1.68290400, 0.12273200,
    -0.11993700, 1.68101600, 0.11798400,
    -0.12616700, 1.59680100, 0.11756200,
    -0.21139800, 1.67665500, -0.05680800,
    -0.25885800, 1.66564500, -0.06531600,
    -0.25871000, 1.66552500, 0.04471500,
    -0.21139800, 1.67665500, 0.03463700,
    -0.22705400, 1.35928800, -0.05391700,
    -0.29581300, 1.36764400, -0.06531600,
    -0.29060600, 1.49522900, -0.09315000,
    -0.22955600, 1.49146300, -0.07706700,
    -0.25885800, 1.66564500, -0.06531600,
    -0.27714600, 1.59361600, -0.09315000,
    -0.33288200, 1.59006000, -0.07817900,
    -0.30631800, 1.65463400, -0.05680800,
    -0.36457300, 1.37600100, -0.05391700,
    -0.29581300, 1.36764400, -0.06531600,
    -0.29956300, 1.29384200, -0.06531600,
    -0.36582300, 1.29809000, -0.05427300,
    -0.29060600, 1.49522900, -0.09315000,
    -0.29581300, 1.36764400, -0.06531600,
    -0.36457300, 1.37600100, -0.05391700,
    -0.35165700, 1.49899400, -0.07706700,
    -0.27714600, 1.59361600, -0.09315000,
    -0.29060600, 1.49522900, -0.09315000,
    -0.35165700, 1.49899400, -0.07706700,
    -0.33288200, 1.59006000, -0.07817900,
    -0.36582300, 1.29809000, -0.05427300,
    -0.29956300, 1.29384200, -0.06531600,
    -0.29314100, 1.27993900, -0.05537400,
    -0.35051900, 1.28161400, -0.04869000,
    -0.22705400, 1.35928800, -0.05391700,
    -0.22705400, 1.35928800, 0.03118600,
    -0.23330400, 1.28959400, 0.03160900,
    -0.23330400, 1.28959400, -0.05427300,
    -0.36457300, 1.37600100, 0.03118600,
    -0.36457300, 1.37600100, -0.05391700,
    -0.36582300, 1.29809000, -0.05427300,
    -0.36582300, 1.29809000, 0.03160900,
    -0.36170200, 1.24820700, 0.02367800,
    -0.36170200, 1.24820700, -0.04637400,
    -0.38539500, 1.17742500, -0.04593800,
    -0.38539500, 1.17742500, 0.02314000,
    -0.23330400, 1.28959400, -0.05427300,
    -0.23330400, 1.28959400, 0.03160900,
    -0.23576200, 1.27826400, 0.02502800,
    -0.23576200, 1.27826400, -0.04746900,
    -0.36582300, 1.29809000, 0.03160900,
    -0.36582300, 1.29809000, -0.05427300,
    -0.35051900, 1.28161400, -0.04869000,
    -0.35051900, 1.28161400, 0.02653300,
    -0.22705400, 1.35928800, 0.03118600,
    -0.29581300, 1.36764400, 0.04471500,
    -0.29956300, 1.29384200, 0.04471500,
    -0.23330400, 1.28959400, 0.03160900,
    -0.23330400, 1.28959400, 0.03160900,
    -0.29956300, 1.29384200, 0.04471500,
    -0.29314100, 1.27993900, 0.03477300,
    -0.23576200, 1.27826400, 0.02502800,
    -0.38539500, 1.17742500, -0.04593800,
    -0.31340100, 1.17380400, -0.05537400,
    -0.31430000, 1.05960300, -0.05537400,
    -0.35378000, 1.06322500, -0.04999000,
    -0.22641900, 1.24101400, 0.02367800,
    -0.29406000, 1.24461100, 0.03477300,
    -0.31340100, 1.17380400, 0.03477300,
    -0.24140800, 1.17018200, 0.02314000,
    -0.22641900, 1.24101400, -0.04637400,
    -0.22641900, 1.24101400, 0.02367800,
    -0.24140800, 1.17018200, 0.02314000,
    -0.24140800, 1.17018200, -0.04593800,
    -0.23576200, 1.27826400, -0.04746900,
    -0.23576200, 1.27826400, 0.02502800,
    -0.22641900, 1.24101400, 0.02367800,
    -0.22641900, 1.24101400, -0.04637400,
    -0.36170200, 1.24820700, -0.04637400,
    -0.29406000, 1.24461100, -0.05537400,
    -0.31340100, 1.17380400, -0.05537400,
    -0.38539500, 1.17742500, -0.04593800,
    -0.35051900, 1.28161400, -0.04869000,
    -0.29314100, 1.27993900, -0.05537400,
    -0.29406000, 1.24461100, -0.05537400,
    -0.36170200, 1.24820700, -0.04637400,
    -0.35051900, 1.28161400, 0.02653300,
    -0.35051900, 1.28161400, -0.04869000,
    -0.35378000, 1.06322500, 0.02812900,
    -0.35378000, 1.06322500, -0.04999000,
    -0.34185600, 0.94628200, -0.04864200,
    -0.34185600, 0.94628200, 0.02750400,
    -0.24140800, 1.17018200, -0.04593800,
    -0.24140800, 1.17018200, 0.02314000,
    -0.27482100, 1.05598200, 0.02812900,
    -0.27482100, 1.05598200, -0.04999000,
    -0.38539500, 1.17742500, 0.02314000,
    -0.38539500, 1.17742500, -0.04593800,
    -0.35378000, 1.06322500, -0.04999000,
    -0.35378000, 1.06322500, 0.02812900,
    -0.23576200, 1.27826400, 0.02502800,
    -0.29314100, 1.27993900, 0.03477300,
    -0.29406000, 1.24461100, 0.03477300,
    -0.22641900, 1.24101400, 0.02367800,
    -0.24140800, 1.17018200, 0.02314000,
    -0.31340100, 1.17380400, 0.03477300,
    -0.31430000, 1.05960300, 0.03477300,
    -0.27482100, 1.05598200, 0.02812900,
    -0.34185600, 0.94628200, -0.04864200,
    -0.31917000, 0.94509400, -0.05067600,
    -0.32057000, 0.91131600, -0.06696100,
    -0.35240500, 0.91298400, -0.06185400,
    -0.27482100, 1.05598200, 0.02812900,
    -0.31430000, 1.05960300, 0.03477300,
    -0.31917000, 0.94509400, 0.03007600,
    -0.29648500, 0.94390500, 0.02750400,
    -0.27482100, 1.05598200, -0.04999000,
    -0.27482100, 1.05598200, 0.02812900,
    -0.29648500, 0.94390500, 0.02750400,
    -0.29648500, 0.94390500, -0.04864200,
    -0.35240500, 0.91298400, 0.04032200,
    -0.35240500, 0.91298400, -0.06185400,
    -0.35917600, 0.89071100, -0.06953800,
    -0.35917600, 0.89071100, 0.04774600,
    -0.29648500, 0.94390500, -0.04864200,
    -0.29648500, 0.94390500, 0.02750400,
    -0.28873500, 0.90964900, 0.04032200,
    -0.28873500, 0.90964900, -0.06185400,
    -0.34185600, 0.94628200, 0.02750400,
    -0.34185600, 0.94628200, -0.04864200,
    -0.35240500, 0.91298400, -0.06185400,
    -0.35240500, 0.91298400, 0.04032200,
    -0.35378000, 1.06322500, -0.04999000,
    -0.31430000, 1.05960300, -0.05537400,
    -0.31917000, 0.94509400, -0.05067600,
    -0.34185600, 0.94628200, -0.04864200,
    -0.29648500, 0.94390500, 0.02750400,
    -0.31917000, 0.94509400, 0.03007600,
    -0.32057000, 0.91131600, 0.04636000,
    -0.28873500, 0.90964900, 0.04032200,
    -0.28383500, 0.88676500, 0.04774600,
    -0.32150500, 0.88873800, 0.05674600,
    -0.32783700, 0.84265700, 0.07537800,
    -0.28412100, 0.84013600, 0.06164000,
    -0.28873500, 0.90964900, 0.04032200,
    -0.32057000, 0.91131600, 0.04636000,
    -0.32150500, 0.88873800, 0.05674600,
    -0.28383500, 0.88676500, 0.04774600,
    -0.28873500, 0.90964900, -0.06185400,
    -0.28873500, 0.90964900, 0.04032200,
    -0.28383500, 0.88676500, 0.04774600,
    -0.28383500, 0.88676500, -0.06953800,
    -0.35240500, 0.91298400, -0.06185400,
    -0.32057000, 0.91131600, -0.06696100,
    -0.32150500, 0.88873800, -0.07734600,
    -0.35917600, 0.89071100, -0.06953800,
    -0.37155300, 0.84517900, -0.08368900,
    -0.32783700, 0.84265700, -0.09597900,
    -0.33280000, 0.82027200, -0.08200800,
    -0.37335100, 0.82194300, -0.07275900,
    -0.28383500, 0.88676500, -0.06953800,
    -0.28383500, 0.88676500, 0.04774600,
    -0.28412100, 0.84013600, 0.06164000,
    -0.28412100, 0.84013600, -0.08368900,
    -0.35917600, 0.89071100, 0.04774600,
    -0.35917600, 0.89071100, -0.06953800,
    -0.37155300, 0.84517900, -0.08368900,
    -0.37155300, 0.84517900, 0.06164000,
    -0.37335100, 0.82194300, 0.05084500,
    -0.37335100, 0.82194300, -0.07275900,
    -0.35468400, 0.80655400, -0.07006500,
    -0.35468400, 0.80655400, 0.04897400,
    -0.28412100, 0.84013600, -0.08368900,
    -0.28412100, 0.84013600, 0.06164000,
    -0.29224800, 0.81860100, 0.05084500,
    -0.29224800, 0.81860100, -0.07275900,
    -0.37155300, 0.84517900, 0.06164000,
    -0.37155300, 0.84517900, -0.08368900,
    -0.37335100, 0.82194300, -0.07275900,
    -0.37335100, 0.82194300, 0.05084500,
    -0.35917600, 0.89071100, -0.06953800,
    -0.32150500, 0.88873800, -0.07734600,
    -0.32783700, 0.84265700, -0.09597900,
    -0.37155300, 0.84517900, -0.08368900,
    -0.28412100, 0.84013600, 0.06164000,
    -0.32783700, 0.84265700, 0.07537800,
    -0.33280000, 0.82027200, 0.06140700,
    -0.29224800, 0.81860100, 0.05084500,
    -0.35468400, 0.80655400, -0.07006500,
    -0.33330100, 0.80488300, -0.07307100,
    -0.33483300, 0.79558000, -0.02690100,
    -0.34108500, 0.79606800, -0.02683700,
    -0.29224800, 0.81860100, 0.05084500,
    -0.33280000, 0.82027200, 0.06140700,
    -0.33330100, 0.80488300, 0.05247000,
    -0.31191900, 0.80321300, 0.04897400,
    -0.29224800, 0.81860100, -0.07275900,
    -0.29224800, 0.81860100, 0.05084500,
    -0.31191900, 0.80321300, 0.04897400,
    -0.31191900, 0.80321300, -0.07006500,
    -0.37335100, 0.82194300, -0.07275900,
    -0.33280000, 0.82027200, -0.08200800,
    -0.33330100, 0.80488300, -0.07307100,
    -0.35468400, 0.80655400, -0.07006500,
    -0.31191900, 0.80321300, -0.07006500,
    -0.31191900, 0.80321300, 0.04897400,
    -0.32858000, 0.79509100, 0.00618700,
    -0.32858000, 0.79509100, -0.02683700,
    -0.35468400, 0.80655400, 0.04897400,
    -0.35468400, 0.80655400, -0.07006500,
    -0.34108500, 0.79606800, -0.02683700,
    -0.34108500, 0.79606800, 0.00618700,
    -0.32858000, 0.79509100, 0.00618700,
    -0.33483300, 0.79558000, 0.00630000,
    -0.33483300, 0.79558000, -0.02690100,
    -0.32858000, 0.79509100, -0.02683700,
    -0.08315000, 0.09676300, 0.01217400,
    -0.08315000, 0.09676300, 0.06044800,
    -0.08315000, 0.05544300, 0.06044800,
    -0.08315000, 0.05544300, 0.01217400,
    -0.13526100, 0.09676300, -0.03105900,
    -0.13526100, 0.05544300, -0.03105900,
    -0.03516000, 1.74166500, -0.05947400,
    -0.05953900, 1.74003100, -0.05291700,
    -0.05167100, 1.75782000, -0.04803300,
    -0.03238100, 1.76267100, -0.05193600,
    -0.13490000, 1.35971700, -0.14151300,
    -0.13115500, 1.48970200, -0.17450500,
    -0.04597900, 1.48970200, -0.17404800,
    -0.04725600, 1.35971700, -0.14120600,
    -0.20515400, 1.59554300, 0.10602300,
    -0.12616700, 1.59680100, 0.11756200,
    -0.11993700, 1.68101600, 0.11798400,
    -0.19496400, 1.67724200, 0.10602300,
    -0.13115500, 1.48970200, 0.11721400,
    -0.12616700, 1.59680100, 0.11756200,
    -0.20515400, 1.59554300, 0.10602300,
    -0.21331200, 1.48970200, 0.10602300,
    -0.13490000, 1.35971700, 0.11694800,
    -0.13115500, 1.48970200, 0.11721400,
    -0.21331200, 1.48970200, 0.10602300,
    -0.21943600, 1.35971700, 0.10602300,
    0.21331100, 1.48970200, -0.15908800,
    0.20515400, 1.59554300, -0.15908800,
    0.20515900, 1.59547400, -0.07220700,
    0.21331100, 1.48970200, -0.07158200,
    -0.04427800, 1.59810600, 0.11691800,
    0.00188100, 1.59878100, 0.10785200,
    0.00188100, 1.68695600, 0.10853600,
    -0.04215200, 1.68493000, 0.11738400,
    -0.06726700, 1.73928900, 0.00342200,
    -0.06617500, 1.73970000, 0.03432000,
    -0.05863200, 1.76668700, 0.03569900,
    -0.05602000, 1.76298800, 0.00395700,
    -0.04093300, 1.06221600, 0.11766000,
    -0.04725600, 1.35971700, 0.11624200,
    -0.13490000, 1.35971700, 0.11694800,
    -0.11636300, 1.06221600, 0.11823300,
    -0.11636300, 1.06221600, -0.14290100,
    -0.13490000, 1.35971700, -0.14151300,
    -0.04725600, 1.35971700, -0.14120600,
    -0.04093300, 1.06221600, -0.14274100,
    -0.10010900, 1.00866400, -0.14403200,
    -0.11636300, 1.06221600, -0.14290100,
    -0.04093300, 1.06221600, -0.14274100,
    -0.03538900, 1.00866400, -0.14400500,
    -0.09367500, 0.97067900, -0.14445300,
    -0.10010900, 1.00866400, -0.14403200,
    -0.03538900, 1.00866400, -0.14400500,
    -0.03319400, 0.97067900, -0.14447700,
    -0.03538900, 1.00866300, 0.11882700,
    -0.04093300, 1.06221600, 0.11766000,
    -0.11636300, 1.06221600, 0.11823300,
    -0.10010900, 1.00866300, 0.11928200,
    -0.11822700, 0.12889500, 0.12187800,
    -0.11501200, 0.09676300, 0.06117400,
    -0.09401900, 0.09676300, 0.06114200,
    -0.08791800, 0.12889500, 0.12175500,
    -0.08791800, 0.12889500, -0.14138600,
    -0.09401900, 0.09676300, -0.08079100,
    -0.11501200, 0.09676300, -0.08082600,
    -0.11822700, 0.12889500, -0.14151300,
    -0.11501200, 0.09676300, 0.06117400,
    -0.11501200, 0.05544300, 0.06117400,
    -0.09401800, 0.05544300, 0.06114200,
    -0.09401900, 0.09676300, 0.06114200,
    -0.06310300, 0.32796100, -0.13835800,
    -0.08791800, 0.12889500, -0.14138600,
    -0.11822700, 0.12889500, -0.14151300,
    -0.12771500, 0.32796100, -0.13882900,
    -0.05434800, 0.45484200, -0.13827100,
    -0.02048000, 0.45484200, -0.13031300,
    -0.02261600, 0.35934500, -0.13021400,
    -0.05670300, 0.35934500, -0.13822400,
    -0.12240300, 0.50259100, 0.11925500,
    -0.11976300, 0.45484200, 0.11921700,
    -0.05434800, 0.45484200, 0.11875400,
    -0.05739300, 0.50259100, 0.11879600,
    -0.12403700, 0.55034000, 0.11932200,
    -0.12240300, 0.50259100, 0.11925500,
    -0.05739300, 0.50259100, 0.11879600,
    -0.05974700, 0.55034000, 0.11887200,
    -0.18285900, 0.45484200, -0.12567400,
    -0.11976300, 0.45484200, -0.13875100,
    -0.12254300, 0.35934500, -0.13870900,
    -0.18604900, 0.35934500, -0.12561500,
    -0.05739300, 0.50259100, -0.13831500,
    -0.05434800, 0.45484200, -0.13827100,
    -0.11976300, 0.45484200, -0.13875100,
    -0.12240400, 0.50259100, -0.13879000,
    -0.05974700, 0.55034000, -0.13839300,
    -0.05739300, 0.50259100, -0.13831500,
    -0.12240400, 0.50259100, -0.13879000,
    -0.12403700, 0.55034000, -0.13886000,
    -0.05670300, 0.35934500, -0.13822400,
    -0.06310300, 0.32796100, -0.13835800,
    -0.12771500, 0.32796100, -0.13882900,
    -0.12254300, 0.35934500, -0.13870900,
    -0.12771500, 0.32796100, 0.11929200,
    -0.11822700, 0.12889500, 0.12187800,
    -0.08791800, 0.12889500, 0.12175500,
    -0.06310300, 0.32796100, 0.11883800,
    -0.12254300, 0.35934500, 0.11917600,
    -0.12771500, 0.32796100, 0.11929200,
    -0.06310300, 0.32796100, 0.11883800,
    -0.05670300, 0.35934500, 0.11870900,
    -0.11778000, 0.70502000, 0.11836800,
    -0.12403700, 0.55034000, 0.11932200,
    -0.05974700, 0.55034000, 0.11887200,
    -0.04367500, 0.70502000, 0.11780900,
    -0.04367500, 0.70502000, -0.18263500,
    -0.05974700, 0.55034000, -0.13839300,
    -0.12403700, 0.55034000, -0.13886000,
    -0.11778000, 0.70502000, -0.18259400,
    -0.11444300, 0.76226100, 0.11822700,
    -0.11778000, 0.70502000, 0.11836800,
    -0.04367500, 0.70502000, 0.11780900,
    -0.03903900, 0.75808000, 0.11765200,
    -0.03319400, 0.97067900, 0.11926200,
    -0.03538900, 1.00866300, 0.11882700,
    -0.10010900, 1.00866300, 0.11928200,
    -0.09367500, 0.97067900, 0.11967100,
    -0.03440300, 0.94152200, -0.16769100,
    -0.03607000, 0.91350100, -0.18192500,
    -0.10179100, 0.91350100, -0.18250400,
    -0.09708800, 0.94152200, -0.16781500,
    -0.09367500, 0.97067900, -0.14445300,
    -0.03319400, 0.97067900, -0.14447700,
    -0.03440300, 0.94152200, -0.16769100,
    -0.09708800, 0.94152200, -0.16781500,
    -0.03607000, 0.91350100, -0.18192500,
    -0.03851500, 0.84998500, -0.19422500,
    -0.10869000, 0.84998500, -0.19499100,
    -0.10179100, 0.91350100, -0.18250400,
    -0.17637800, 0.84998500, -0.17621700,
    -0.10869000, 0.84998500, -0.19499100,
    -0.11444300, 0.76226100, -0.19420000,
    -0.18717400, 0.76629400, -0.17604500,
    -0.03903900, 0.75808000, -0.19334600,
    -0.04367500, 0.70502000, -0.18263500,
    -0.11778000, 0.70502000, -0.18259400,
    -0.11444300, 0.76226100, -0.19420000,
    -0.11976300, 0.45484200, 0.11921700,
    -0.12254300, 0.35934500, 0.11917600,
    -0.05670300, 0.35934500, 0.11870900,
    -0.05434800, 0.45484200, 0.11875400,
    -0.09708800, 0.94152200, 0.11947100,
    -0.10179100, 0.91350100, 0.11918800,
    -0.03607000, 0.91350100, 0.11872200,
    -0.03440300, 0.94152200, 0.11903800,
    -0.10179100, 0.91350100, 0.11918800,
    -0.10869000, 0.84998500, 0.11875800,
    -0.03851500, 0.84998500, 0.11824300,
    -0.03607000, 0.91350100, 0.11872200,
    -0.03319400, 0.97067900, 0.11926200,
    -0.09367500, 0.97067900, 0.11967100,
    -0.09708800, 0.94152200, 0.11947100,
    -0.03440300, 0.94152200, 0.11903800,
    -0.09401900, 0.03284700, -0.08948600,
    -0.08773800, 0.01059500, -0.10862000,
    -0.11792500, 0.01059500, -0.10871600,
    -0.11501200, 0.03284700, -0.08952500,
    -0.03168200, 1.76987600, -0.02824800,
    -0.03168400, 1.76985900, 0.00407100,
    0.00505100, 1.77194600, 0.00404400,
    0.00720400, 1.77174700, -0.02829300,
    -0.03516300, 1.74167300, 0.03384800,
    0.00308900, 1.74369900, 0.03170800,
    0.00369300, 1.77207100, 0.03638700,
    -0.03171800, 1.76964600, 0.03622500,
    -0.04215200, 1.68493000, -0.14244200,
    -0.03865800, 1.71330100, -0.07318800,
    0.00469200, 1.71519500, -0.06388000,
    0.00188100, 1.68695600, -0.13308200,
    -0.03168200, 1.76987600, -0.02824800,
    -0.05469800, 1.76132400, -0.02819300,
    -0.05602000, 1.76298800, 0.00395700,
    -0.03168400, 1.76985900, 0.00407100,
    -0.03238100, 1.76267100, -0.05193600,
    -0.05167100, 1.75782000, -0.04803300,
    -0.05469800, 1.76132400, -0.02819300,
    -0.03168200, 1.76987600, -0.02824800,
    -0.03168400, 1.76985900, 0.00407100,
    -0.05602000, 1.76298800, 0.00395700,
    -0.05863200, 1.76668700, 0.03569900,
    -0.03171800, 1.76964600, 0.03622500,
    -0.08315000, 0.03284700, -0.08865500,
    -0.08315000, 0.03284700, -0.03123100,
    -0.07210900, 0.01059500, -0.04060900,
    -0.07210900, 0.01059500, -0.10673400,
    -0.08127900, 0.00478200, -0.11125900,
    -0.08003800, -0.00201300, -0.10485500,
    -0.12185600, -0.00201300, -0.10502300,
    -0.12056200, 0.00470000, -0.11372700,
    -0.13526100, 0.03284700, 0.01186600,
    -0.13526100, 0.03284700, -0.03087300,
    -0.14704200, 0.01059500, -0.04010100,
    -0.14704200, 0.01059500, 0.02144400,
    -0.11501200, 0.03284700, 0.06117400,
    -0.09401800, 0.03284700, 0.06114200,
    -0.13526100, 0.03284700, -0.08770900,
    -0.11501200, 0.03284700, -0.08952500,
    -0.11792500, 0.01059500, -0.10871600,
    -0.14704200, 0.01059500, -0.10459500,
    -0.13526100, 0.03284700, -0.08770900,
    -0.14704200, 0.01059500, -0.10459500,
    -0.11501200, 0.03284700, 0.06117400,
    -0.13526100, 0.03284700, 0.05966000,
    -0.14704200, 0.01059500, 0.08799700,
    -0.11792500, 0.01059500, 0.09203900,
    -0.13526100, 0.09676300, -0.07920300,
    -0.13526100, 0.05544300, -0.07920300,
    -0.11785000, 0.00729600, 0.14383600,
    -0.12081800, 0.00503000, 0.18689800,
    -0.08226800, 0.00503000, 0.18661100,
    -0.08817000, 0.00729600, 0.14369800,
    -0.08737900, 0.00716000, -0.11377100,
    -0.07155200, 0.00717900, -0.11156600,
    -0.06127000, 0.00503000, -0.10197500,
    -0.08127900, 0.00478200, -0.11125900,
    -0.07120700, 0.00714700, 0.02592000,
    -0.07280400, 0.00729600, 0.14086900,
    -0.06231000, 0.00503000, 0.18098700,
    -0.06127000, 0.00503000, 0.02326000,
    -0.07155200, 0.00717900, -0.11156600,
    -0.06936300, 0.00697600, -0.03896800,
    -0.06127000, 0.00503000, -0.03015200,
    -0.06127000, 0.00503000, -0.10197500,
    -0.08737900, 0.00716000, -0.11377100,
    -0.08127900, 0.00478200, -0.11125900,
    -0.12056200, 0.00470000, -0.11372700,
    -0.11804500, 0.00715700, -0.11385100,
    -0.14807800, 0.00715700, 0.02529000,
    -0.14997900, 0.00699300, -0.03839900,
    -0.15911200, 0.00503000, -0.02961400,
    -0.15911200, 0.00503000, 0.02253500,
    -0.09401900, 0.05544300, -0.08079100,
    -0.09401900, 0.03284700, -0.08948600,
    -0.11501200, 0.03284700, -0.08952500,
    -0.11501200, 0.05544300, -0.08082600,
    -0.08315000, 0.03284700, 0.01217400,
    -0.08315000, 0.03284700, 0.06044800,
    -0.07210900, 0.01059500, 0.09003000,
    -0.07210900, 0.01059500, 0.02192400,
    -0.09401900, 0.03284700, -0.08948600,
    -0.08315000, 0.03284700, -0.08865500,
    -0.07210900, 0.01059500, -0.10673400,
    -0.08773800, 0.01059500, -0.10862000,
    -0.13526100, 0.03284700, 0.05966000,
    -0.14704200, 0.01059500, 0.08799700,
    -0.08315000, 0.03284700, 0.01217400,
    -0.08315000, 0.03284700, -0.03123100,
    -0.13526100, 0.03284700, 0.01186600,
    -0.13526100, 0.03284700, 0.05966000,
    -0.09401900, 0.05544300, -0.08079100,
    -0.08315000, 0.05544300, -0.08004800,
    -0.08315000, 0.03284700, -0.08865500,
    -0.09401900, 0.03284700, -0.08948600,
    -0.08315000, 0.03284700, 0.06044800,
    -0.13526100, 0.03284700, -0.08770900,
    -0.13526100, 0.03284700, -0.03087300,
    -0.14772300, 0.00718800, -0.10920900,
    -0.11804500, 0.00715700, -0.11385100,
    -0.12056200, 0.00470000, -0.11372700,
    -0.15911200, 0.00503000, -0.09929700,
    -0.11501200, 0.03284700, 0.06117400,
    -0.11792500, 0.01059500, 0.09203900,
    -0.08773800, 0.01059500, 0.09194500,
    -0.09401800, 0.03284700, 0.06114200,
    -0.09401900, 0.09676300, -0.08079100,
    -0.09401900, 0.05544300, -0.08079100,
    -0.11501200, 0.05544300, -0.08082600,
    -0.11501200, 0.09676300, -0.08082600,
    -0.08315000, 0.03284700, -0.08865500,
    -0.16217100, -0.01609700, -0.03034100,
    -0.16217100, -0.01609700, -0.09856100,
    -0.15907500, -0.02313900, -0.09920100,
    -0.15907500, -0.02313900, -0.03064400,
    -0.05840600, -0.01609700, -0.03098900,
    -0.05840600, -0.01609700, 0.02440900,
    -0.06130300, -0.02313900, 0.02481600,
    -0.06130300, -0.02313900, -0.03128600,
    -0.16217100, -0.01609700, 0.17832600,
    -0.16217100, -0.01609700, 0.02353700,
    -0.15907500, -0.02313900, 0.02395200,
    -0.15794200, -0.02313900, 0.17539300,
    -0.08004800, -0.01609700, -0.10481200,
    -0.05840600, -0.01609700, -0.10159800,
    -0.06130300, -0.02313900, -0.10200300,
    -0.08169500, -0.02313900, -0.10493200,
    -0.05840600, -0.01609700, 0.02440900,
    -0.05840600, -0.01609700, 0.18451000,
    -0.06236400, -0.02313900, 0.18089900,
    -0.06130300, -0.02313900, 0.02481600,
    -0.05840600, -0.01609700, -0.10159800,
    -0.06130300, -0.02313900, -0.10200300,
    -0.14647800, 0.00729600, 0.13785300,
    -0.14807800, 0.00715700, 0.02529000,
    -0.15911200, 0.00503000, 0.02253500,
    -0.15800000, 0.00503000, 0.17547100,
    -0.06936300, 0.00697600, -0.03896800,
    -0.07120700, 0.00714700, 0.02592000,
    -0.06127000, 0.00503000, 0.02326000,
    -0.06127000, 0.00503000, -0.03015200,
    -0.14997900, 0.00699300, -0.03839900,
    -0.14772300, 0.00718800, -0.10920900,
    -0.15911200, 0.00503000, -0.09929700,
    -0.15911200, 0.00503000, -0.02961400,
    -0.13526100, 0.05544300, -0.07920300,
    -0.11501200, 0.05544300, -0.08082600,
    -0.11501200, 0.03284700, -0.08952500,
    -0.13526100, 0.03284700, -0.08770900,
    -0.15907500, -0.02313900, -0.03064400,
    -0.15907500, -0.02313900, -0.09920100,
    -0.15488600, -0.02494000, -0.09697500,
    -0.15582500, -0.02494000, -0.02966500,
    -0.06130300, -0.02313900, -0.03128600,
    -0.06130300, -0.02313900, 0.02481600,
    -0.06404700, -0.02494000, 0.02465800,
    -0.06423900, -0.02494000, -0.03025600,
    -0.15794200, -0.02313900, 0.17539300,
    -0.15907500, -0.02313900, 0.02395200,
    -0.15602400, -0.02494000, 0.02383000,
    -0.15205300, -0.02494000, 0.17008900,
    -0.08169500, -0.02313900, -0.10493200,
    -0.06130300, -0.02313900, -0.10200300,
    -0.06513800, -0.02494000, -0.09949200,
    -0.08385500, -0.02494000, -0.10195000,
    -0.06130300, -0.02313900, 0.02481600,
    -0.06236400, -0.02313900, 0.18089900,
    -0.06781600, -0.02494000, 0.17462600,
    -0.06404700, -0.02494000, 0.02465800,
    -0.06130300, -0.02313900, -0.10200300,
    -0.06130300, -0.02313900, -0.03128600,
    -0.06423900, -0.02494000, -0.03025600,
    -0.06513800, -0.02494000, -0.09949200,
    -0.11785000, 0.00729600, 0.14383600,
    -0.14647800, 0.00729600, 0.13785300,
    -0.15800000, 0.00503000, 0.17547100,
    -0.12081800, 0.00503000, 0.18689800,
    -0.16219100, -0.00201200, -0.09859900,
    -0.12185600, -0.00201300, -0.10502300,
    -0.12185100, -0.01609700, -0.10497800,
    -0.16217100, -0.01609700, -0.09856100,
    -0.16217100, -0.01609700, 0.02353700,
    -0.15907500, -0.02313900, 0.02395200,
    -0.05840600, -0.01609700, -0.10159800,
    -0.08004800, -0.01609700, -0.10481200,
    -0.08003800, -0.00201300, -0.10485500,
    -0.05838800, -0.00201200, -0.10163600,
    -0.08350800, -0.02494000, 0.02557500,
    -0.06404700, -0.02494000, 0.02465800,
    -0.06781600, -0.02494000, 0.17462600,
    -0.08538400, -0.02494000, 0.17908300,
    -0.08385500, -0.02494000, -0.10195000,
    -0.06513800, -0.02494000, -0.09949200,
    -0.06423900, -0.02494000, -0.03025600,
    -0.08360500, -0.02494000, -0.03090600,
    -0.12058800, -0.02494000, -0.03094900,
    -0.12001000, -0.02494000, -0.10205400,
    -0.11932000, -0.02494000, 0.17931400,
    -0.12065500, -0.02494000, 0.02563600,
    -0.12080300, -0.02313900, 0.18679500,
    -0.11932000, -0.02494000, 0.17931400,
    -0.08538400, -0.02494000, 0.17908300,
    -0.08229800, -0.02313900, 0.18651000,
    -0.15602400, -0.02494000, 0.02383000,
    -0.15205300, -0.02494000, 0.17008900,
    -0.12081800, 0.00503000, 0.18689800,
    -0.12185600, -0.00201200, 0.19144400,
    -0.08003800, -0.00201200, 0.19110500,
    -0.08226800, 0.00503000, 0.18661100,
    -0.15907500, -0.02313900, 0.02395200,
    -0.15907500, -0.02313900, -0.03064400,
    -0.15582500, -0.02494000, -0.02966500,
    -0.15602400, -0.02494000, 0.02383000,
    -0.11792500, 0.01059500, 0.09203900,
    -0.11785000, 0.00729600, 0.14383600,
    -0.08817000, 0.00729600, 0.14369800,
    -0.08773800, 0.01059500, 0.09194500,
    -0.15907500, -0.02313900, -0.09920100,
    -0.12108300, -0.02313900, -0.10510300,
    -0.12001000, -0.02494000, -0.10205400,
    -0.15488600, -0.02494000, -0.09697500,
    -0.14704200, 0.01059500, -0.04010100,
    -0.14704200, 0.01059500, -0.10459500,
    -0.14772300, 0.00718800, -0.10920900,
    -0.14997900, 0.00699300, -0.03839900,
    -0.07210900, 0.01059500, -0.04060900,
    -0.07210900, 0.01059500, 0.02192400,
    -0.07120700, 0.00714700, 0.02592000,
    -0.06936300, 0.00697600, -0.03896800,
    -0.14704200, 0.01059500, 0.08799700,
    -0.14704200, 0.01059500, 0.02144400,
    -0.14807800, 0.00715700, 0.02529000,
    -0.14647800, 0.00729600, 0.13785300,
    -0.08004800, -0.01609700, -0.10481200,
    -0.08169500, -0.02313900, -0.10493200,
    -0.12108300, -0.02313900, -0.10510300,
    -0.12185100, -0.01609700, -0.10497800,
    -0.14704200, 0.01059500, 0.02144400,
    -0.14704200, 0.01059500, -0.04010100,
    -0.14997900, 0.00699300, -0.03839900,
    -0.14807800, 0.00715700, 0.02529000,
    -0.08773800, 0.01059500, -0.10862000,
    -0.08737900, 0.00716000, -0.11377100,
    -0.11804500, 0.00715700, -0.11385100,
    -0.11792500, 0.01059500, -0.10871600,
    -0.07210900, 0.01059500, -0.10673400,
    -0.07210900, 0.01059500, -0.04060900,
    -0.06936300, 0.00697600, -0.03896800,
    -0.07155200, 0.00717900, -0.11156600,
    -0.07210900, 0.01059500, 0.02192400,
    -0.07210900, 0.01059500, 0.09003000,
    -0.07280400, 0.00729600, 0.14086900,
    -0.07120700, 0.00714700, 0.02592000,
    -0.08773800, 0.01059500, -0.10862000,
    -0.07210900, 0.01059500, -0.10673400,
    -0.07155200, 0.00717900, -0.11156600,
    -0.08737900, 0.00716000, -0.11377100,
    -0.12185600, -0.00201200, 0.19144400,
    -0.12185100, -0.01609700, 0.19139200,
    -0.08004800, -0.01609700, 0.19105400,
    -0.08003800, -0.00201200, 0.19110500,
    -0.15911200, 0.00503000, 0.02253500,
    -0.15911200, 0.00503000, -0.02961400,
    -0.16219100, -0.00201200, -0.02984600,
    -0.16219100, -0.00201200, 0.02285500,
    -0.05838800, -0.00201200, -0.03044100,
    -0.05840600, -0.01609700, -0.03098900,
    -0.05840600, -0.01609700, -0.10159800,
    -0.05838800, -0.00201200, -0.10163600,
    -0.08169500, -0.02313900, -0.10493200,
    -0.08385500, -0.02494000, -0.10195000,
    -0.12001000, -0.02494000, -0.10205400,
    -0.12108300, -0.02313900, -0.10510300,
    -0.12185100, -0.01609700, 0.19139200,
    -0.12080300, -0.02313900, 0.18679500,
    -0.08229800, -0.02313900, 0.18651000,
    -0.08004800, -0.01609700, 0.19105400,
    -0.12185600, -0.00201200, 0.19144400,
    -0.16219100, -0.00201200, 0.17836800,
    -0.16217100, -0.01609700, 0.17832600,
    -0.12185100, -0.01609700, 0.19139200,
    -0.12081800, 0.00503000, 0.18689800,
    -0.15800000, 0.00503000, 0.17547100,
    -0.16219100, -0.00201200, 0.17836800,
    -0.12185600, -0.00201200, 0.19144400,
    -0.06127000, 0.00503000, -0.10197500,
    -0.06127000, 0.00503000, -0.03015200,
    -0.05838800, -0.00201200, -0.03044100,
    -0.05838800, -0.00201200, -0.10163600,
    -0.05838800, -0.00201200, 0.18455600,
    -0.05840600, -0.01609700, 0.18451000,
    -0.05840600, -0.01609700, 0.02440900,
    -0.05838800, -0.00201200, 0.02365700,
    -0.06127000, 0.00503000, 0.02326000,
    -0.06231000, 0.00503000, 0.18098700,
    -0.05838800, -0.00201200, 0.18455600,
    -0.05838800, -0.00201200, 0.02365700,
    -0.16219100, -0.00201200, 0.02285500,
    -0.16217100, -0.01609700, 0.02353700,
    -0.16217100, -0.01609700, 0.17832600,
    -0.16219100, -0.00201200, 0.17836800,
    -0.08127900, 0.00478200, -0.11125900,
    -0.06127000, 0.00503000, -0.10197500,
    -0.05838800, -0.00201200, -0.10163600,
    -0.08003800, -0.00201300, -0.10485500,
    0.05838800, -0.00201200, 0.18455600,
    0.05840600, -0.01609700, 0.18451000,
    0.08004800, -0.01609700, 0.19105400,
    0.08003800, -0.00201200, 0.19110500,
    -0.15800000, 0.00503000, 0.17547100,
    -0.15911200, 0.00503000, 0.02253500,
    -0.16219100, -0.00201200, 0.02285500,
    -0.16219100, -0.00201200, 0.17836800,
    -0.06127000, 0.00503000, 0.02326000,
    -0.05838800, -0.00201200, 0.02365700,
    -0.16219100, -0.00201200, -0.09859900,
    -0.16217100, -0.01609700, -0.09856100,
    -0.16217100, -0.01609700, -0.03034100,
    -0.16219100, -0.00201200, -0.02984600,
    -0.15911200, 0.00503000, -0.09929700,
    -0.16219100, -0.00201200, -0.09859900,
    -0.08003800, -0.00201300, -0.10485500,
    -0.08004800, -0.01609700, -0.10481200,
    -0.12185100, -0.01609700, -0.10497800,
    -0.12185600, -0.00201300, -0.10502300,
    -0.33330100, 0.80488300, 0.05247000,
    -0.35468400, 0.80655400, 0.04897400,
    -0.34108500, 0.79606800, 0.00618700,
    -0.33483300, 0.79558000, 0.00630000,
    -0.34108500, 0.79606800, 0.00618700,
    -0.34108500, 0.79606800, -0.02683700,
    -0.33280000, 0.82027200, -0.08200800,
    -0.29224800, 0.81860100, -0.07275900,
    -0.31191900, 0.80321300, -0.07006500,
    -0.33330100, 0.80488300, -0.07307100,
    -0.33280000, 0.82027200, 0.06140700,
    -0.37335100, 0.82194300, 0.05084500,
    -0.35468400, 0.80655400, 0.04897400,
    -0.33330100, 0.80488300, 0.05247000,
    -0.33330100, 0.80488300, -0.07307100,
    -0.31191900, 0.80321300, -0.07006500,
    -0.32858000, 0.79509100, -0.02683700,
    -0.33483300, 0.79558000, -0.02690100,
    -0.32783700, 0.84265700, 0.07537800,
    -0.37155300, 0.84517900, 0.06164000,
    -0.37335100, 0.82194300, 0.05084500,
    -0.33280000, 0.82027200, 0.06140700,
    -0.32150500, 0.88873800, -0.07734600,
    -0.28383500, 0.88676500, -0.06953800,
    -0.28412100, 0.84013600, -0.08368900,
    -0.32783700, 0.84265700, -0.09597900,
    -0.32783700, 0.84265700, -0.09597900,
    -0.28412100, 0.84013600, -0.08368900,
    -0.29224800, 0.81860100, -0.07275900,
    -0.33280000, 0.82027200, -0.08200800,
    -0.32057000, 0.91131600, -0.06696100,
    -0.28873500, 0.90964900, -0.06185400,
    -0.28383500, 0.88676500, -0.06953800,
    -0.32150500, 0.88873800, -0.07734600,
    -0.32057000, 0.91131600, 0.04636000,
    -0.35240500, 0.91298400, 0.04032200,
    -0.35917600, 0.89071100, 0.04774600,
    -0.32150500, 0.88873800, 0.05674600,
    -0.32150500, 0.88873800, 0.05674600,
    -0.35917600, 0.89071100, 0.04774600,
    -0.37155300, 0.84517900, 0.06164000,
    -0.32783700, 0.84265700, 0.07537800,
    -0.31917000, 0.94509400, 0.03007600,
    -0.34185600, 0.94628200, 0.02750400,
    -0.35240500, 0.91298400, 0.04032200,
    -0.32057000, 0.91131600, 0.04636000,
    -0.31430000, 1.05960300, -0.05537400,
    -0.27482100, 1.05598200, -0.04999000,
    -0.29648500, 0.94390500, -0.04864200,
    -0.31917000, 0.94509400, -0.05067600,
    -0.31430000, 1.05960300, 0.03477300,
    -0.35378000, 1.06322500, 0.02812900,
    -0.34185600, 0.94628200, 0.02750400,
    -0.31917000, 0.94509400, 0.03007600,
    -0.31917000, 0.94509400, -0.05067600,
    -0.29648500, 0.94390500, -0.04864200,
    -0.28873500, 0.90964900, -0.06185400,
    -0.32057000, 0.91131600, -0.06696100,
    -0.31340100, 1.17380400, 0.03477300,
    -0.38539500, 1.17742500, 0.02314000,
    -0.35378000, 1.06322500, 0.02812900,
    -0.31430000, 1.05960300, 0.03477300,
    -0.29314100, 1.27993900, 0.03477300,
    -0.35051900, 1.28161400, 0.02653300,
    -0.36170200, 1.24820700, 0.02367800,
    -0.29406000, 1.24461100, 0.03477300,
    -0.29314100, 1.27993900, -0.05537400,
    -0.23576200, 1.27826400, -0.04746900,
    -0.22641900, 1.24101400, -0.04637400,
    -0.29406000, 1.24461100, -0.05537400,
    -0.29406000, 1.24461100, -0.05537400,
    -0.22641900, 1.24101400, -0.04637400,
    -0.24140800, 1.17018200, -0.04593800,
    -0.31340100, 1.17380400, -0.05537400,
    -0.29406000, 1.24461100, 0.03477300,
    -0.36170200, 1.24820700, 0.02367800,
    -0.38539500, 1.17742500, 0.02314000,
    -0.31340100, 1.17380400, 0.03477300,
    -0.31340100, 1.17380400, -0.05537400,
    -0.24140800, 1.17018200, -0.04593800,
    -0.27482100, 1.05598200, -0.04999000,
    -0.31430000, 1.05960300, -0.05537400,
    -0.29956300, 1.29384200, 0.04471500,
    -0.36582300, 1.29809000, 0.03160900,
    -0.35051900, 1.28161400, 0.02653300,
    -0.29314100, 1.27993900, 0.03477300,
    -0.29581300, 1.36764400, 0.04471500,
    -0.36457300, 1.37600100, 0.03118600,
    -0.36582300, 1.29809000, 0.03160900,
    -0.29956300, 1.29384200, 0.04471500,
    -0.29956300, 1.29384200, -0.06531600,
    -0.23330400, 1.28959400, -0.05427300,
    -0.23576200, 1.27826400, -0.04746900,
    -0.29314100, 1.27993900, -0.05537400,
    -0.22140900, 1.59717200, -0.07817900,
    -0.27714600, 1.59361600, -0.09315000,
    -0.25885800, 1.66564500, -0.06531600,
    -0.21139800, 1.67665500, -0.05680800,
    -0.29581300, 1.36764400, 0.04471500,
    -0.22705400, 1.35928800, 0.03118600,
    -0.22955600, 1.49146300, 0.02137700,
    -0.29057700, 1.49520500, 0.03079800,
    -0.29057700, 1.49520500, 0.03079800,
    -0.22955600, 1.49146300, 0.02137700,
    -0.22141200, 1.59713800, 0.02206300,
    -0.27682300, 1.59323800, 0.03079800,
    -0.21139800, 1.67665500, 0.03463700,
    -0.25871000, 1.66552500, 0.04471500,
    -0.27682300, 1.59323800, 0.03079800,
    -0.22141200, 1.59713800, 0.02206300,
    -0.29581300, 1.36764400, -0.06531600,
    -0.22705400, 1.35928800, -0.05391700,
    -0.23330400, 1.28959400, -0.05427300,
    -0.29956300, 1.29384200, -0.06531600,
    -0.22955600, 1.49146300, -0.07706700,
    -0.29060600, 1.49522900, -0.09315000,
    -0.27714600, 1.59361600, -0.09315000,
    -0.22140900, 1.59717200, -0.07817900,
    -0.04597900, 1.48970200, 0.11653400,
    -0.04427800, 1.59810600, 0.11691800,
    -0.12616700, 1.59680100, 0.11756200,
    -0.13115500, 1.48970200, 0.11721400,
    -0.25871000, 1.66552500, 0.04471500,
    -0.25885800, 1.66564500, -0.06531600,
    -0.30631800, 1.65463400, -0.05680800,
    -0.30602200, 1.65439500, 0.03463700,
    -0.15911200, 0.00503000, -0.09929700,
    -0.12056200, 0.00470000, -0.11372700,
    -0.12185600, -0.00201300, -0.10502300,
    -0.16219100, -0.00201200, -0.09859900,
    -0.14704200, 0.01059500, -0.10459500,
    -0.11792500, 0.01059500, -0.10871600,
    -0.11804500, 0.00715700, -0.11385100,
    -0.14772300, 0.00718800, -0.10920900,
    -0.11792500, 0.01059500, 0.09203900,
    -0.14704200, 0.01059500, 0.08799700,
    -0.14647800, 0.00729600, 0.13785300,
    -0.11785000, 0.00729600, 0.14383600,
    -0.12080300, -0.02313900, 0.18679500,
    -0.15794200, -0.02313900, 0.17539300,
    -0.15205300, -0.02494000, 0.17008900,
    -0.11932000, -0.02494000, 0.17931400,
    -0.15488600, -0.02494000, -0.09697500,
    -0.15582500, -0.02494000, -0.02966500,
    -0.16217100, -0.01609700, -0.09856100,
    -0.12185100, -0.01609700, -0.10497800,
    -0.12108300, -0.02313900, -0.10510300,
    -0.15907500, -0.02313900, -0.09920100,
    -0.12185100, -0.01609700, 0.19139200,
    -0.16217100, -0.01609700, 0.17832600,
    -0.15794200, -0.02313900, 0.17539300,
    -0.12080300, -0.02313900, 0.18679500,
    -0.11501200, 0.05544300, 0.06117400,
    -0.13526100, 0.05544300, 0.05966000,
    -0.13526100, 0.03284700, 0.05966000,
    -0.11501200, 0.03284700, 0.06117400,
    -0.13526100, 0.09676300, -0.07920300,
    -0.11501200, 0.09676300, -0.08082600,
    -0.11501200, 0.05544300, -0.08082600,
    -0.13526100, 0.05544300, -0.07920300,
    -0.11501200, 0.09676300, 0.06117400,
    -0.13526100, 0.09676300, 0.05966000,
    -0.05434800, 0.45484200, -0.13827100,
    -0.05670300, 0.35934500, -0.13822400,
    -0.12254300, 0.35934500, -0.13870900,
    -0.11976300, 0.45484200, -0.13875100,
    -0.18717400, 0.76629400, -0.17604500,
    -0.11444300, 0.76226100, -0.19420000,
    -0.11778000, 0.70502000, -0.18259400,
    -0.18925800, 0.70502000, -0.16467300,
    -0.16518200, 0.91350100, -0.16499400,
    -0.10179100, 0.91350100, -0.18250400,
    -0.10869000, 0.84998500, -0.19499100,
    -0.17637800, 0.84998500, -0.17621700,
    -0.15201300, 0.97067900, -0.13086400,
    -0.09367500, 0.97067900, -0.14445300,
    -0.09708800, 0.94152200, -0.16781500,
    -0.15755100, 0.94152200, -0.15172300,
    -0.15755100, 0.94152200, -0.15172300,
    -0.09708800, 0.94152200, -0.16781500,
    -0.10179100, 0.91350100, -0.18250400,
    -0.16518200, 0.91350100, -0.16499400,
    -0.15201300, 0.97067900, 0.10745600,
    -0.09367500, 0.97067900, 0.11967100,
    -0.10010900, 1.00866300, 0.11928200,
    -0.16253500, 1.00866300, 0.10671700,
    -0.18925800, 0.70502000, -0.16467300,
    -0.11778000, 0.70502000, -0.18259400,
    -0.12403700, 0.55034000, -0.13886000,
    -0.18604900, 0.55034000, -0.12584300,
    -0.17637800, 0.84998500, 0.10613900,
    -0.18717400, 0.76629400, 0.10602300,
    -0.11444300, 0.76226100, 0.11822700,
    -0.10869000, 0.84998500, 0.11875800,
    -0.18604900, 0.35934500, -0.12561500,
    -0.12254300, 0.35934500, -0.13870900,
    -0.12771500, 0.32796100, -0.13882900,
    -0.19003700, 0.32796100, -0.12579300,
    -0.18604900, 0.55034000, -0.12584300,
    -0.12403700, 0.55034000, -0.13886000,
    -0.12240400, 0.50259100, -0.13879000,
    -0.18511000, 0.50259100, -0.12573300,
    -0.18511000, 0.50259100, -0.12573300,
    -0.12240400, 0.50259100, -0.13879000,
    -0.11976300, 0.45484200, -0.13875100,
    -0.18285900, 0.45484200, -0.12567400,
    -0.19003700, 0.32796100, -0.12579300,
    -0.12771500, 0.32796100, -0.13882900,
    -0.11822700, 0.12889500, -0.14151300,
    -0.14746200, 0.12889500, -0.13602400,
    -0.14746200, 0.12889500, -0.13602400,
    -0.11822700, 0.12889500, -0.14151300,
    -0.11501200, 0.09676300, -0.08082600,
    -0.13526100, 0.09676300, -0.07920300,
    -0.16253500, 1.00866300, 0.10671700,
    -0.10010900, 1.00866300, 0.11928200,
    -0.11636300, 1.06221600, 0.11823300,
    -0.18911900, 1.06221600, 0.10602300,
    -0.04725600, 1.35971700, 0.11624200,
    -0.04597900, 1.48970200, 0.11653400,
    -0.13115500, 1.48970200, 0.11721400,
    -0.13490000, 1.35971700, 0.11694800,
    -0.18911900, 1.06221600, 0.10602300,
    -0.11636300, 1.06221600, 0.11823300,
    -0.13490000, 1.35971700, 0.11694800,
    -0.21943600, 1.35971700, 0.10602300,
    -0.12616700, 1.59680100, -0.17497300,
    -0.20515400, 1.59554300, -0.15908800,
    -0.19496400, 1.67724200, -0.12932200,
    -0.11993700, 1.68101600, -0.14263200,
    -0.20515400, 1.59554300, -0.15908800,
    -0.12616700, 1.59680100, -0.17497300,
    -0.13115500, 1.48970200, -0.17450500,
    -0.21331100, 1.48970200, -0.15908800,
    -0.11998700, 1.68039900, -0.05243100,
    -0.19504700, 1.67621400, -0.05252200,
    -0.19504700, 1.67621400, 0.02954600,
    -0.11998700, 1.68038800, 0.02858900,
    -0.08470200, 1.68448000, -0.05113600,
    -0.11998700, 1.68039900, -0.05243100,
    -0.11998700, 1.68038800, 0.02858900,
    -0.08245800, 1.68247500, 0.02741500,
    -0.08242300, 1.68290400, -0.14798600,
    -0.11993700, 1.68101600, -0.14263200,
    -0.11998700, 1.68039900, -0.05243100,
    -0.08470200, 1.68448000, -0.05113600,
    -0.08245800, 1.68247500, 0.02741500,
    -0.11998700, 1.68038800, 0.02858900,
    -0.11993700, 1.68101600, 0.11798400,
    -0.08242300, 1.68290400, 0.12273200,
    -0.06231000, 0.00503000, 0.18098700,
    -0.08226800, 0.00503000, 0.18661100,
    -0.08003800, -0.00201200, 0.19110500,
    -0.05838800, -0.00201200, 0.18455600,
    -0.07210900, 0.01059500, 0.09003000,
    -0.08773800, 0.01059500, 0.09194500,
    -0.08817000, 0.00729600, 0.14369800,
    -0.07280400, 0.00729600, 0.14086900,
    -0.06236400, -0.02313900, 0.18089900,
    -0.08229800, -0.02313900, 0.18651000,
    -0.08538400, -0.02494000, 0.17908300,
    -0.06781600, -0.02494000, 0.17462600,
    -0.05840600, -0.01609700, 0.18451000,
    -0.08004800, -0.01609700, 0.19105400,
    -0.08229800, -0.02313900, 0.18651000,
    -0.06236400, -0.02313900, 0.18089900,
    -0.08315000, 0.05544300, 0.06044800,
    -0.09401800, 0.05544300, 0.06114200,
    -0.09401800, 0.03284700, 0.06114200,
    -0.08315000, 0.03284700, 0.06044800,
    -0.07280400, 0.00729600, 0.14086900,
    -0.08817000, 0.00729600, 0.14369800,
    -0.08226800, 0.00503000, 0.18661100,
    -0.06231000, 0.00503000, 0.18098700,
    -0.08315000, 0.03284700, 0.06044800,
    -0.09401800, 0.03284700, 0.06114200,
    -0.08773800, 0.01059500, 0.09194500,
    -0.07210900, 0.01059500, 0.09003000,
    -0.06617500, 1.73970000, 0.03432000,
    -0.03516300, 1.74167300, 0.03384800,
    -0.03171800, 1.76964600, 0.03622500,
    -0.05863200, 1.76668700, 0.03569900,
    -0.03238100, 1.76267100, -0.05193600,
    -0.03168200, 1.76987600, -0.02824800,
    0.00720400, 1.77174700, -0.02829300,
    0.00976300, 1.76402500, -0.05116000,
    -0.03607000, 0.91350100, 0.11872200,
    -0.03851500, 0.84998500, 0.11824300,
    0.00218300, 0.84998500, 0.11004600,
    0.00204400, 0.91350100, 0.11101900,
    0.00000000, 0.75591500, 0.10897500,
    -0.03903900, 0.75808000, 0.11765200,
    -0.04367500, 0.70502000, 0.11780900,
    -0.00530900, 0.70502000, 0.10924400,
    -0.17637800, 0.84998500, -0.17621700,
    -0.18717400, 0.76629400, -0.17604500,
    -0.00530900, 0.70502000, 0.10924400,
    -0.04367500, 0.70502000, 0.11780900,
    -0.05974700, 0.55034000, 0.11887200,
    -0.02646200, 0.55034000, 0.11134300,
    -0.02261600, 0.35934500, 0.11099200,
    -0.05670300, 0.35934500, 0.11870900,
    -0.06310300, 0.32796100, 0.11883800,
    -0.02965200, 0.32796100, 0.11127000,
    -0.02965200, 0.32796100, 0.11127000,
    -0.06310300, 0.32796100, 0.11883800,
    -0.08791800, 0.12889500, 0.12175500,
    -0.07222600, 0.12889500, 0.11924900,
    -0.02646200, 0.55034000, 0.11134300,
    -0.05974700, 0.55034000, 0.11887200,
    -0.05739300, 0.50259100, 0.11879600,
    -0.02373500, 0.50259100, 0.11117900,
    -0.02373500, 0.50259100, 0.11117900,
    -0.05739300, 0.50259100, 0.11879600,
    -0.05434800, 0.45484200, 0.11875400,
    -0.02048000, 0.45484200, 0.11108800,
    -0.08315000, 0.09676300, 0.06044800,
    -0.09401900, 0.09676300, 0.06114200,
    -0.07222600, 0.12889500, 0.11924900,
    -0.08791800, 0.12889500, 0.12175500,
    -0.09401900, 0.09676300, 0.06114200,
    -0.08315000, 0.09676300, 0.06044800,
    -0.03865800, 1.71330100, -0.07318800,
    -0.03516000, 1.74166500, -0.05947400,
    0.00754000, 1.74325200, -0.05751200,
    0.00469200, 1.71519500, -0.06388000,
    -0.08242300, 1.68290400, 0.12273200,
    -0.04215200, 1.68493000, 0.11738400,
    -0.03865800, 1.71330200, 0.03747500,
    -0.07479600, 1.71127700, 0.03937200,
    -0.07479600, 1.71127700, 0.03937200,
    -0.03865800, 1.71330200, 0.03747500,
    -0.03516300, 1.74167300, 0.03384800,
    -0.06617500, 1.73970000, 0.03432000,
    -0.03238100, 1.76267100, -0.05193600,
    0.00976300, 1.76402500, -0.05116000,
    0.00754000, 1.74325200, -0.05751200,
    -0.03516000, 1.74166500, -0.05947400,
    -0.08245800, 1.68247500, 0.02741500,
    -0.08242300, 1.68290400, 0.12273200,
    -0.07479600, 1.71127700, 0.03937200,
    -0.07486200, 1.71088600, 0.00598500,
    -0.07486200, 1.71088600, 0.00598500,
    -0.07479600, 1.71127700, 0.03937200,
    -0.06617500, 1.73970000, 0.03432000,
    -0.06726700, 1.73928900, 0.00342200,
    -0.04215200, 1.68493000, -0.14244200,
    -0.08242300, 1.68290400, -0.14798600,
    -0.06842400, 1.71155900, -0.07137500,
    -0.03865800, 1.71330100, -0.07318800,
    -0.03865800, 1.71330100, -0.07318800,
    -0.06842400, 1.71155900, -0.07137500,
    -0.05953900, 1.74003100, -0.05291700,
    -0.03516000, 1.74166500, -0.05947400,
    -0.08470200, 1.68448000, -0.05113600,
    -0.08245800, 1.68247500, 0.02741500,
    -0.07486200, 1.71088600, 0.00598500,
    -0.07485900, 1.71092200, -0.03258600,
    -0.07485900, 1.71092200, -0.03258600,
    -0.07486200, 1.71088600, 0.00598500,
    -0.06726700, 1.73928900, 0.00342200,
    -0.06726400, 1.73931800, -0.02813500,
    -0.08242300, 1.68290400, -0.14798600,
    -0.08470200, 1.68448000, -0.05113600,
    -0.07485900, 1.71092200, -0.03258600,
    -0.06842400, 1.71155900, -0.07137500,
    -0.06842400, 1.71155900, -0.07137500,
    -0.07485900, 1.71092200, -0.03258600,
    -0.06726400, 1.73931800, -0.02813500,
    -0.05953900, 1.74003100, -0.05291700,
    0.15755100, 0.94152200, -0.06494900,
    0.15755100, 0.94152200, -0.15172300,
    0.15201300, 0.97067900, -0.13086400,
    0.15201300, 0.97067900, -0.05087400,
    0.09708800, 0.94152200, 0.11947100,
    0.15755100, 0.94152200, 0.10704300,
    0.15201300, 0.97067900, 0.10745600,
    0.09367500, 0.97067900, 0.11967100,
    0.15755100, 0.94152200, -0.06494900,
    0.16518200, 0.91350100, -0.07414300,
    0.16518200, 0.91350100, -0.16499400,
    0.15755100, 0.94152200, -0.15172300,
    0.10179100, 0.91350100, 0.11918800,
    0.10869000, 0.84998500, 0.11875800,
    0.17637800, 0.84998500, 0.10613900,
    0.16518200, 0.91350100, 0.10657800,
    0.09708800, 0.94152200, 0.11947100,
    0.10179100, 0.91350100, 0.11918800,
    0.16518200, 0.91350100, 0.10657800,
    0.15755100, 0.94152200, 0.10704300,
    0.16518200, 0.91350100, -0.07414300,
    0.17637800, 0.84998500, -0.08202200,
    0.17637800, 0.84998500, -0.17621700,
    0.16518200, 0.91350100, -0.16499400,
    0.11976300, 0.45484300, 0.11921700,
    0.12254300, 0.35934500, 0.11917600,
    0.18604900, 0.35934500, 0.10656200,
    0.18285900, 0.45484300, 0.10661900,
    0.18717400, 0.76629400, -0.08202200,
    0.17637800, 0.84998500, -0.08202200,
    0.05434700, 0.45484300, -0.13827100,
    0.05670300, 0.35934500, -0.13822400,
    0.02261600, 0.35934500, -0.13021400,
    0.02048000, 0.45484300, -0.13031300,
    0.03903900, 0.75808000, -0.19334600,
    0.04367500, 0.70502000, -0.18263500,
    0.00530900, 0.70502000, -0.17103700,
    0.00000000, 0.75591500, -0.18043600,
    0.03607000, 0.91350100, -0.18192500,
    0.03851400, 0.84998500, -0.19422500,
    0.00218300, 0.84998500, -0.18203000,
    0.00204400, 0.91350100, -0.17129300,
    0.03440300, 0.94152200, -0.16769100,
    0.00195000, 0.94152200, -0.15860600,
    0.00188100, 0.97067900, -0.13708600,
    0.03319400, 0.97067900, -0.14447700,
    0.03440300, 0.94152200, -0.16769100,
    0.03607000, 0.91350100, -0.18192500,
    0.00204400, 0.91350100, -0.17129300,
    0.00195000, 0.94152200, -0.15860600,
    0.03319400, 0.97067900, 0.11926200,
    0.03538900, 1.00866400, 0.11882700,
    0.00188100, 1.00866400, 0.11124500,
    0.00188100, 0.97067900, 0.11222800,
    0.00530900, 0.70502000, 0.01517600,
    0.02646200, 0.55034000, 0.02899700,
    0.02646200, 0.55034000, 0.11134300,
    0.00530900, 0.70502000, 0.10924400,
    0.18717400, 0.76629400, -0.08202200,
    0.18925800, 0.70502000, -0.07444100,
    0.18925800, 0.70502000, -0.16467300,
    0.18717400, 0.76629400, -0.17604500,
    0.00000000, 0.75591500, 0.01200000,
    0.00530900, 0.70502000, 0.01517600,
    0.00530900, 0.70502000, 0.10924400,
    0.00000000, 0.75591500, 0.10897500,
    0.11444300, 0.76226100, 0.11822700,
    0.11778000, 0.70502000, 0.11836800,
    0.18925800, 0.70502000, 0.10602300,
    0.18717400, 0.76629400, 0.10602300,
    0.04367500, 0.70502000, -0.18263500,
    0.05974700, 0.55034000, -0.13839300,
    0.02646200, 0.55034000, -0.13057800,
    0.00530900, 0.70502000, -0.17103700,
    0.11444300, 0.76226100, 0.11822700,
    0.10869000, 0.84998500, 0.11875800,
    0.03851400, 0.84998500, 0.11824300,
    0.03903900, 0.75808000, 0.11765200,
    0.18925800, 0.70502000, -0.07444100,
    0.18604900, 0.55034000, -0.04802900,
    0.18604900, 0.55034000, -0.12584300,
    0.18925800, 0.70502000, -0.16467300,
    0.11778000, 0.70502000, 0.11836800,
    0.12403700, 0.55034000, 0.11932200,
    0.18604900, 0.55034000, 0.10678200,
    0.18925800, 0.70502000, 0.10602300,
    0.18285900, 0.45484300, 0.02899700,
    0.18604900, 0.35934500, 0.02899700,
    0.18604900, 0.35934500, -0.04802900,
    0.18285900, 0.45484300, -0.04802900,
    0.02048000, 0.45484300, -0.04802900,
    0.02261600, 0.35934500, -0.04802900,
    0.02261600, 0.35934500, 0.02899700,
    0.02048000, 0.45484300, 0.02899700,
    0.12254300, 0.35934500, 0.11917600,
    0.12771500, 0.32796100, 0.11929200,
    0.19003700, 0.32796100, 0.10673300,
    0.18604900, 0.35934500, 0.10656200,
    0.18604900, 0.35934500, -0.04802900,
    0.19003700, 0.32796100, -0.04802900,
    0.19003700, 0.32796100, -0.12579300,
    0.18604900, 0.35934500, -0.12561500,
    0.02261600, 0.35934500, 0.02899700,
    0.02965200, 0.32796100, 0.02899700,
    0.02965200, 0.32796100, 0.11127000,
    0.02261600, 0.35934500, 0.11099200,
    0.05670300, 0.35934500, -0.13822400,
    0.06310300, 0.32796100, -0.13835800,
    0.02965200, 0.32796100, -0.13050200,
    0.02261600, 0.35934500, -0.13021400,
    0.05974700, 0.55034000, -0.13839300,
    0.05739300, 0.50259100, -0.13831500,
    0.02373500, 0.50259100, -0.13040800,
    0.02646200, 0.55034000, -0.13057800,
    0.05739300, 0.50259100, -0.13831500,
    0.05434700, 0.45484300, -0.13827100,
    0.02048000, 0.45484300, -0.13031300,
    0.02373500, 0.50259100, -0.13040800,
    0.02646200, 0.55034000, 0.02899700,
    0.02373500, 0.50259100, 0.02899700,
    0.02373500, 0.50259100, 0.11117900,
    0.02646200, 0.55034000, 0.11134300,
    0.02373500, 0.50259100, 0.02899700,
    0.02048000, 0.45484300, 0.02899700,
    0.02048000, 0.45484300, 0.11108800,
    0.02373500, 0.50259100, 0.11117900,
    0.18604900, 0.55034000, -0.04802900,
    0.18510900, 0.50259100, -0.04802900,
    0.18510900, 0.50259100, -0.12573300,
    0.18604900, 0.55034000, -0.12584300,
    0.18510900, 0.50259100, -0.04802900,
    0.18285900, 0.45484300, -0.04802900,
    0.18285900, 0.45484300, -0.12567400,
    0.18510900, 0.50259100, -0.12573300,
    0.12771500, 0.32796100, 0.11929200,
    0.11822700, 0.12889500, 0.12187800,
    0.14746200, 0.12889500, 0.11659000,
    0.19003700, 0.32796100, 0.10673300,
    0.12403700, 0.55034000, 0.11932200,
    0.12240300, 0.50259100, 0.11925500,
    0.18510900, 0.50259100, 0.10667600,
    0.18604900, 0.55034000, 0.10678200,
    0.12240300, 0.50259100, 0.11925500,
    0.11976300, 0.45484300, 0.11921700,
    0.18285900, 0.45484300, 0.10661900,
    0.18510900, 0.50259100, 0.10667600,
    0.07222600, 0.12889500, 0.03115300,
    0.08315000, 0.09676300, 0.01217400,
    0.08315000, 0.09676300, 0.06044800,
    0.07222600, 0.12889500, 0.11924900,
    0.19003700, 0.32796100, -0.04802900,
    0.14746200, 0.12889500, -0.04971900,
    0.14746200, 0.12889500, -0.13602400,
    0.19003700, 0.32796100, -0.12579300,
    0.02965200, 0.32796100, 0.02899700,
    0.07222600, 0.12889500, 0.03115300,
    0.07222600, 0.12889500, 0.11924900,
    0.02965200, 0.32796100, 0.11127000,
    0.06310300, 0.32796100, -0.13835800,
    0.08791800, 0.12889500, -0.14138600,
    0.07222600, 0.12889500, -0.13878400,
    0.02965200, 0.32796100, -0.13050200,
    0.09401800, 0.09676300, -0.08079100,
    0.09401800, 0.05544300, -0.08079100,
    0.08315000, 0.05544300, -0.08004800,
    0.08315000, 0.09676300, -0.08004800,
    0.08791800, 0.12889500, -0.14138600,
    0.09401800, 0.09676300, -0.08079100,
    0.08315000, 0.09676300, -0.08004800,
    0.07222600, 0.12889500, -0.13878400,
    0.14746200, 0.12889500, -0.04971900,
    0.13526100, 0.09676300, -0.03105900,
    0.13526100, 0.09676300, -0.07920300,
    0.14746200, 0.12889500, -0.13602400,
    0.03538900, 1.00866400, 0.11882700,
    0.04093300, 1.06221600, 0.11766000,
    0.00188100, 1.06221600, 0.10898700,
    0.00188100, 1.00866400, 0.11124500,
    0.15201300, 0.97067900, 0.02757500,
    0.16253500, 1.00866400, 0.02757500,
    0.16253500, 1.00866400, 0.10671700,
    0.15201300, 0.97067900, 0.10745600,
    0.11822700, 0.12889500, 0.12187800,
    0.11501200, 0.09676300, 0.06117400,
    0.13526100, 0.09676300, 0.05966000,
    0.14746200, 0.12889500, 0.11659000,
    0.18911900, 1.06221600, 0.02757500,
    0.21934600, 1.35974500, 0.02912500,
    0.21943600, 1.35971700, 0.10602300,
    0.18911900, 1.06221600, 0.10602300,
    0.16253500, 1.00866400, 0.02757500,
    0.18911900, 1.06221600, 0.02757500,
    0.18911900, 1.06221600, 0.10602300,
    0.16253500, 1.00866400, 0.10671700,
    0.09367500, 0.97067900, -0.14445300,
    0.10010900, 1.00866400, -0.14403200,
    0.16253500, 1.00866400, -0.13006900,
    0.15201300, 0.97067900, -0.13086400,
    0.04597900, 1.48970200, 0.11653400,
    0.00188100, 1.48970200, 0.10736200,
    0.00188100, 1.35971700, 0.10703700,
    0.04725600, 1.35971700, 0.11624200,
    0.10010900, 1.00866400, -0.14403200,
    0.11636300, 1.06221600, -0.14290100,
    0.18911800, 1.06221600, -0.12932200,
    0.16253500, 1.00866400, -0.13006900,
    0.04093300, 1.06221600, 0.11766000,
    0.04725600, 1.35971700, 0.11624200,
    0.00188100, 1.35971700, 0.10703700,
    0.00188100, 1.06221600, 0.10898700,
    0.22140900, 1.59717200, -0.07817900,
    0.20515900, 1.59547400, -0.07220700,
    0.19504700, 1.67621400, -0.05252200,
    0.21139800, 1.67665500, -0.05680800,
    0.21331100, 1.48970200, 0.01816100,
    0.21331100, 1.48970200, 0.10602300,
    0.21943600, 1.35971700, 0.10602300,
    0.21934600, 1.35974500, 0.02912500,
    0.11636300, 1.06221600, -0.14290100,
    0.13490000, 1.35971700, -0.14151300,
    0.21943600, 1.35971700, -0.12932200,
    0.18911800, 1.06221600, -0.12932200,
    0.13115500, 1.48970200, -0.17450500,
    0.21331100, 1.48970200, -0.15908800,
    0.21943600, 1.35971700, -0.12932200,
    0.13490000, 1.35971700, -0.14151300,
    0.05953800, 1.74003100, -0.05291700,
    0.05167000, 1.75782000, -0.04803400,
    0.05469700, 1.76132400, -0.02819300,
    0.06726400, 1.73931800, -0.02813500,
    0.11998700, 1.68038800, 0.02858900,
    0.11993700, 1.68101600, 0.11798400,
    0.19496400, 1.67724200, 0.10602300,
    0.19504700, 1.67621400, 0.02954600,
    0.08242300, 1.68290400, -0.14798600,
    0.11993700, 1.68101600, -0.14263200,
    0.12616700, 1.59680100, -0.17497300,
    0.04427700, 1.59810600, -0.17456500,
    0.04215200, 1.68493000, -0.14244200,
    0.12616700, 1.59680100, -0.17497300,
    0.13115500, 1.48970200, -0.17450500,
    0.04597900, 1.48970200, -0.17404800,
    0.04427700, 1.59810600, -0.17456500,
    0.20515900, 1.59547400, -0.07220700,
    0.22140900, 1.59717200, -0.07817900,
    0.22955600, 1.49146300, -0.07706700,
    0.21331100, 1.48970200, -0.07158200,
    -0.20516000, 1.59547400, -0.07220700,
    -0.19504700, 1.67621400, -0.05252200,
    -0.19496400, 1.67724200, -0.12932200,
    -0.20515400, 1.59554300, -0.15908800,
    0.20516100, 1.59545000, 0.01854900,
    0.19504700, 1.67621400, 0.02954600,
    0.19496400, 1.67724200, 0.10602300,
    0.20515400, 1.59554300, 0.10602300,
    0.37118400, 1.50019900, -0.07103200,
    0.35070900, 1.58892300, -0.07182800,
    0.34995900, 1.58809100, 0.01833800,
    0.37111500, 1.50014400, 0.01783800,
    -0.04597900, 1.48970200, -0.17404800,
    -0.04427800, 1.59810600, -0.17456500,
    0.00188100, 1.59878100, -0.16258600,
    0.00188100, 1.48970200, -0.16192600,
    0.35165600, 1.49899500, -0.07706700,
    0.37118400, 1.50019900, -0.07103200,
    0.38671500, 1.37785500, -0.05087400,
    0.36457300, 1.37600100, -0.05391600,
    -0.04725600, 1.35971700, -0.14120600,
    -0.04597900, 1.48970200, -0.17404800,
    0.00188100, 1.48970200, -0.16192600,
    0.00188100, 1.35971700, -0.13145500,
    0.21934600, 1.35974500, 0.02912500,
    0.22705400, 1.35928800, 0.03118600,
    0.22955600, 1.49146300, 0.02137700,
    0.21331100, 1.48970200, 0.01816100,
    0.22955600, 1.49146300, -0.07706700,
    0.22705400, 1.35928800, -0.05391600,
    0.21934600, 1.35974500, -0.05218000,
    0.21331100, 1.48970200, -0.07158200,
    0.06726400, 1.73931800, -0.02813500,
    0.05469700, 1.76132400, -0.02819300,
    0.05602000, 1.76298800, 0.00395700,
    0.06726600, 1.73928900, 0.00342200,
    0.11993700, 1.68101600, -0.14263200,
    0.11998600, 1.68039900, -0.05243100,
    0.19504700, 1.67621400, -0.05252200,
    0.19496400, 1.67724200, -0.12932200,
    0.19504700, 1.67621400, 0.02954600,
    0.21139800, 1.67665500, 0.03463700,
    0.21139800, 1.67665500, -0.05680800,
    0.19504700, 1.67621400, -0.05252200,
    0.16253500, 1.00866400, -0.13006900,
    0.18911800, 1.06221600, -0.12932200,
    0.18911800, 1.06221600, -0.05087400,
    0.16253500, 1.00866400, -0.05087400,
    0.18911800, 1.06221600, -0.12932200,
    0.21943600, 1.35971700, -0.12932200,
    0.21934600, 1.35974500, -0.05218000,
    0.18911800, 1.06221600, -0.05087400,
    0.18911800, 1.06221600, -0.05087400,
    0.21934600, 1.35974500, -0.05218000,
    0.21934600, 1.35974500, 0.02912500,
    0.18911900, 1.06221600, 0.02757500,
    0.15201300, 0.97067900, -0.13086400,
    0.16253500, 1.00866400, -0.13006900,
    0.16253500, 1.00866400, -0.05087400,
    0.15201300, 0.97067900, -0.05087400,
    0.14746200, 0.12889500, 0.11659000,
    0.13526100, 0.09676300, 0.05966000,
    0.13526100, 0.09676300, 0.01186600,
    0.14746200, 0.12889500, 0.03050700,
    0.13526100, 0.09676300, 0.05966000,
    0.13526100, 0.05544300, 0.05966000,
    0.13526100, 0.05544300, 0.01186600,
    0.13526100, 0.09676300, 0.01186600,
    0.08315000, 0.09676300, -0.08004800,
    0.08315000, 0.05544300, -0.08004800,
    0.08315000, 0.05544400, -0.03143800,
    0.08315000, 0.09676300, -0.03143800,
    0.02965200, 0.32796100, -0.13050200,
    0.07222600, 0.12889500, -0.13878400,
    0.07222600, 0.12889500, -0.05044100,
    0.02965200, 0.32796100, -0.04802900,
    0.19003700, 0.32796100, 0.10673300,
    0.14746200, 0.12889500, 0.11659000,
    0.14746200, 0.12889500, 0.03050700,
    0.19003700, 0.32796100, 0.02899700,
    0.07222600, 0.12889500, -0.13878400,
    0.08315000, 0.09676300, -0.08004800,
    0.08315000, 0.09676300, -0.03143800,
    0.07222600, 0.12889500, -0.05044100,
    0.02048000, 0.45484300, 0.11108800,
    0.02261600, 0.35934500, 0.11099200,
    0.05670300, 0.35934500, 0.11870900,
    0.05434700, 0.45484300, 0.11875400,
    0.03903900, 0.75808000, -0.19334600,
    0.03851400, 0.84998500, -0.19422500,
    0.10869000, 0.84998500, -0.19499100,
    0.11444300, 0.76226100, -0.19420000,
    0.18510900, 0.50259100, 0.10667600,
    0.18285900, 0.45484300, 0.10661900,
    0.18285900, 0.45484300, 0.02899700,
    0.18510900, 0.50259100, 0.02899700,
    0.18604900, 0.55034000, 0.10678200,
    0.18510900, 0.50259100, 0.10667600,
    0.18510900, 0.50259100, 0.02899700,
    0.18604900, 0.55034000, 0.02899700,
    0.18604900, 0.35934500, 0.10656200,
    0.18285900, 0.45484300, 0.10661900,
    0.18604900, 0.35934500, -0.12561500,
    0.18285900, 0.45484300, -0.12567400,
    0.02373500, 0.50259100, -0.13040800,
    0.02048000, 0.45484300, -0.13031300,
    0.02048000, 0.45484300, -0.04802900,
    0.02373500, 0.50259100, -0.04802900,
    0.02646200, 0.55034000, -0.13057800,
    0.02373500, 0.50259100, -0.13040800,
    0.02373500, 0.50259100, -0.04802900,
    0.02646200, 0.55034000, -0.04802900,
    0.02261600, 0.35934500, -0.13021400,
    0.02965200, 0.32796100, -0.13050200,
    0.02965200, 0.32796100, -0.04802900,
    0.02261600, 0.35934500, -0.04802900,
    0.18604900, 0.35934500, 0.10656200,
    0.19003700, 0.32796100, 0.10673300,
    0.19003700, 0.32796100, 0.02899700,
    0.18604900, 0.35934500, 0.02899700,
    0.18925800, 0.70502000, 0.10602300,
    0.18604900, 0.55034000, 0.10678200,
    0.18604900, 0.55034000, 0.02899700,
    0.18925800, 0.70502000, 0.01579100,
    0.00000000, 0.75591500, -0.18043600,
    0.00530900, 0.70502000, -0.17103700,
    0.00530900, 0.70502000, -0.07567100,
    0.00000000, 0.75591500, -0.08202200,
    0.18717400, 0.76629400, 0.10602300,
    0.18925800, 0.70502000, 0.10602300,
    0.18925800, 0.70502000, 0.01579100,
    0.18717400, 0.76629400, 0.01200100,
    0.00530900, 0.70502000, -0.17103700,
    0.02646200, 0.55034000, -0.13057800,
    0.02646200, 0.55034000, -0.04802900,
    0.00530900, 0.70502000, -0.07567100,
    -0.03851500, 0.84998500, 0.11824300,
    -0.03903900, 0.75808000, 0.11765200,
    0.00000000, 0.75591500, 0.10897500,
    0.00218300, 0.84998500, 0.11004600,
    0.02261600, 0.35934500, 0.11099200,
    0.02048000, 0.45484300, 0.11108800,
    0.16518200, 0.91350100, 0.10657800,
    0.17637800, 0.84998500, 0.10613900,
    0.17637800, 0.84998500, 0.01200000,
    0.16518200, 0.91350100, 0.01594000,
    0.15755100, 0.94152200, 0.10704300,
    0.16518200, 0.91350100, 0.10657800,
    0.16518200, 0.91350100, 0.01594000,
    0.15755100, 0.94152200, 0.02053700,
    0.15755100, 0.94152200, 0.10704300,
    0.15755100, 0.94152200, 0.02053700,
    0.15201300, 0.97067900, 0.02757500,
    0.15201300, 0.97067900, 0.10745600,
    0.27682300, 1.59323900, 0.03079900,
    0.33223500, 1.58933900, 0.02206300,
    0.30602200, 1.65439500, 0.03463700,
    0.25871000, 1.66552500, 0.04471500,
    0.33288200, 1.59006000, -0.07817900,
    0.35070900, 1.58892300, -0.07182800,
    0.37118400, 1.50019900, -0.07103200,
    0.35165600, 1.49899500, -0.07706700,
    0.21331100, 1.48970200, 0.01816100,
    0.22955600, 1.49146300, 0.02137700,
    0.22141200, 1.59713800, 0.02206300,
    0.20516100, 1.59545000, 0.01854900,
    0.30631800, 1.65463500, -0.05680800,
    0.32149800, 1.65111300, -0.05270300,
    0.35070900, 1.58892300, -0.07182800,
    0.33288200, 1.59006000, -0.07817900,
    0.21934600, 1.35974500, -0.05218000,
    0.22705400, 1.35928800, -0.05391600,
    0.22705400, 1.35928800, 0.03118600,
    0.21934600, 1.35974500, 0.02912500,
    0.20516100, 1.59545000, 0.01854900,
    0.22141200, 1.59713800, 0.02206300,
    0.21139800, 1.67665500, 0.03463700,
    0.19504700, 1.67621400, 0.02954600,
    0.35070900, 1.58892300, -0.07182800,
    0.32149800, 1.65111300, -0.05270300,
    0.32115500, 1.65083500, 0.02977200,
    0.34995900, 1.58809100, 0.01833800,
    0.33223500, 1.58933900, 0.02206300,
    0.34995900, 1.58809100, 0.01833800,
    0.32115500, 1.65083500, 0.02977200,
    0.30602200, 1.65439500, 0.03463700,
    0.38671500, 1.37785500, -0.05087400,
    0.37118400, 1.50019900, -0.07103200,
    0.37111500, 1.50014400, 0.01783800,
    0.38671500, 1.37785500, 0.02757500,
    0.34995900, 1.58809100, 0.01833800,
    0.33223500, 1.58933900, 0.02206300,
    0.35159800, 1.49894700, 0.02137700,
    0.37111500, 1.50014400, 0.01783800,
    0.36457300, 1.37600100, -0.05391600,
    0.38671500, 1.37785500, -0.05087400,
    0.38671500, 1.37785500, 0.02757500,
    0.36457300, 1.37600100, 0.03118600,
    0.35159800, 1.49894700, 0.02137700,
    0.29057700, 1.49520500, 0.03079900,
    0.29581300, 1.36764500, 0.04471500,
    0.36457300, 1.37600100, 0.03118600,
    0.37111500, 1.50014400, 0.01783800,
    0.35159800, 1.49894700, 0.02137700,
    0.36457300, 1.37600100, 0.03118600,
    0.38671500, 1.37785500, 0.02757500,
    0.30602200, 1.65439500, 0.03463700,
    0.32115500, 1.65083500, 0.02977200,
    0.32149800, 1.65111300, -0.05270300,
    0.30631800, 1.65463500, -0.05680800,
    -0.31191900, 0.80321300, 0.04897400,
    -0.33330100, 0.80488300, 0.05247000,
    -0.33483300, 0.79558000, 0.00630000,
    -0.32858000, 0.79509100, 0.00618700,
    0.33223500, 1.58933900, 0.02206300,
    0.27682300, 1.59323900, 0.03079900,
    0.29057700, 1.49520500, 0.03079900,
    0.35159800, 1.49894700, 0.02137700,
    0.08242300, 1.68290400, 0.12273200,
    0.04215200, 1.68493000, 0.11738400,
    0.04427700, 1.59810600, 0.11691800,
    0.12616700, 1.59680100, 0.11756200,
    0.11993700, 1.68101600, 0.11798400,
    0.21139800, 1.67665500, 0.03463700,
    0.25871000, 1.66552500, 0.04471500,
    0.25885800, 1.66564500, -0.06531600,
    0.21139800, 1.67665500, -0.05680800,
    0.29581300, 1.36764500, -0.06531600,
    0.22705400, 1.35928800, -0.05391600,
    0.22955600, 1.49146300, -0.07706700,
    0.29060600, 1.49522900, -0.09315000,
    0.25885800, 1.66564500, -0.06531600,
    0.30631800, 1.65463500, -0.05680800,
    0.33288200, 1.59006000, -0.07817900,
    0.27714500, 1.59361600, -0.09315000,
    0.36582300, 1.29809100, -0.05427300,
    0.29956300, 1.29384200, -0.06531600,
    0.29581300, 1.36764500, -0.06531600,
    0.36457300, 1.37600100, -0.05391600,
    0.29060600, 1.49522900, -0.09315000,
    0.35165600, 1.49899500, -0.07706700,
    0.36457300, 1.37600100, -0.05391600,
    0.29581300, 1.36764500, -0.06531600,
    0.27714500, 1.59361600, -0.09315000,
    0.33288200, 1.59006000, -0.07817900,
    0.35165600, 1.49899500, -0.07706700,
    0.29060600, 1.49522900, -0.09315000,
    0.35051900, 1.28161400, -0.04869000,
    0.29314100, 1.27993900, -0.05537400,
    0.29956300, 1.29384200, -0.06531600,
    0.36582300, 1.29809100, -0.05427300,
    0.22705400, 1.35928800, -0.05391600,
    0.23330400, 1.28959400, -0.05427300,
    0.23330400, 1.28959400, 0.03161000,
    0.22705400, 1.35928800, 0.03118600,
    0.36457300, 1.37600100, 0.03118600,
    0.36582300, 1.29809100, 0.03161000,
    0.36582300, 1.29809100, -0.05427300,
    0.36457300, 1.37600100, -0.05391600,
    0.36170200, 1.24820700, 0.02367800,
    0.38539500, 1.17742500, 0.02314000,
    0.38539500, 1.17742500, -0.04593800,
    0.36170200, 1.24820700, -0.04637400,
    0.23330400, 1.28959400, -0.05427300,
    0.23576200, 1.27826400, -0.04746900,
    0.23576200, 1.27826400, 0.02502800,
    0.23330400, 1.28959400, 0.03161000,
    0.36582300, 1.29809100, 0.03161000,
    0.35051900, 1.28161400, 0.02653300,
    0.35051900, 1.28161400, -0.04869000,
    0.36582300, 1.29809100, -0.05427300,
    0.23330400, 1.28959400, 0.03161000,
    0.29956300, 1.29384200, 0.04471500,
    0.29581300, 1.36764500, 0.04471500,
    0.22705400, 1.35928800, 0.03118600,
    0.23576200, 1.27826400, 0.02502800,
    0.29314100, 1.27993900, 0.03477300,
    0.29956300, 1.29384200, 0.04471500,
    0.23330400, 1.28959400, 0.03161000,
    0.35378000, 1.06322400, -0.04999000,
    0.31430000, 1.05960300, -0.05537400,
    0.31340100, 1.17380400, -0.05537400,
    0.38539500, 1.17742500, -0.04593800,
    0.24140800, 1.17018200, 0.02314000,
    0.31340100, 1.17380400, 0.03477300,
    0.29406000, 1.24461100, 0.03477300,
    0.22641900, 1.24101400, 0.02367800,
    0.22641900, 1.24101400, -0.04637400,
    0.24140800, 1.17018200, -0.04593800,
    0.24140800, 1.17018200, 0.02314000,
    0.22641900, 1.24101400, 0.02367800,
    0.23576200, 1.27826400, -0.04746900,
    0.22641900, 1.24101400, -0.04637400,
    0.22641900, 1.24101400, 0.02367800,
    0.23576200, 1.27826400, 0.02502800,
    0.38539500, 1.17742500, -0.04593800,
    0.31340100, 1.17380400, -0.05537400,
    0.29406000, 1.24461100, -0.05537400,
    0.36170200, 1.24820700, -0.04637400,
    0.36170200, 1.24820700, -0.04637400,
    0.29406000, 1.24461100, -0.05537400,
    0.29314100, 1.27993900, -0.05537400,
    0.35051900, 1.28161400, -0.04869000,
    0.35051900, 1.28161400, 0.02653300,
    0.35051900, 1.28161400, -0.04869000,
    0.35378000, 1.06322400, 0.02812900,
    0.34185600, 0.94628200, 0.02750400,
    0.34185600, 0.94628200, -0.04864200,
    0.35378000, 1.06322400, -0.04999000,
    0.24140800, 1.17018200, -0.04593800,
    0.27482000, 1.05598200, -0.04999000,
    0.27482000, 1.05598200, 0.02812900,
    0.24140800, 1.17018200, 0.02314000,
    0.38539500, 1.17742500, 0.02314000,
    0.35378000, 1.06322400, 0.02812900,
    0.35378000, 1.06322400, -0.04999000,
    0.38539500, 1.17742500, -0.04593800,
    0.22641900, 1.24101400, 0.02367800,
    0.29406000, 1.24461100, 0.03477300,
    0.29314100, 1.27993900, 0.03477300,
    0.23576200, 1.27826400, 0.02502800,
    0.27482000, 1.05598200, 0.02812900,
    0.31430000, 1.05960300, 0.03477300,
    0.31340100, 1.17380400, 0.03477300,
    0.24140800, 1.17018200, 0.02314000,
    0.35240500, 0.91298400, -0.06185400,
    0.32057000, 0.91131600, -0.06696100,
    0.31917000, 0.94509300, -0.05067600,
    0.34185600, 0.94628200, -0.04864200,
    0.29648500, 0.94390500, 0.02750400,
    0.31917000, 0.94509300, 0.03007600,
    0.31430000, 1.05960300, 0.03477300,
    0.27482000, 1.05598200, 0.02812900,
    0.27482000, 1.05598200, -0.04999000,
    0.29648500, 0.94390500, -0.04864200,
    0.29648500, 0.94390500, 0.02750400,
    0.27482000, 1.05598200, 0.02812900,
    0.35240500, 0.91298400, 0.04032200,
    0.35917500, 0.89071100, 0.04774600,
    0.35917500, 0.89071100, -0.06953800,
    0.35240500, 0.91298400, -0.06185400,
    0.29648500, 0.94390500, -0.04864200,
    0.28873500, 0.90964900, -0.06185400,
    0.28873500, 0.90964900, 0.04032200,
    0.29648500, 0.94390500, 0.02750400,
    0.34185600, 0.94628200, 0.02750400,
    0.35240500, 0.91298400, 0.04032200,
    0.35240500, 0.91298400, -0.06185400,
    0.34185600, 0.94628200, -0.04864200,
    0.34185600, 0.94628200, -0.04864200,
    0.31917000, 0.94509300, -0.05067600,
    0.31430000, 1.05960300, -0.05537400,
    0.35378000, 1.06322400, -0.04999000,
    0.28873500, 0.90964900, 0.04032200,
    0.32057000, 0.91131600, 0.04636000,
    0.31917000, 0.94509300, 0.03007600,
    0.29648500, 0.94390500, 0.02750400,
    0.28412100, 0.84013600, 0.06164000,
    0.32783700, 0.84265700, 0.07537800,
    0.32150500, 0.88873800, 0.05674600,
    0.28383500, 0.88676400, 0.04774600,
    0.28383500, 0.88676400, 0.04774600,
    0.32150500, 0.88873800, 0.05674600,
    0.32057000, 0.91131600, 0.04636000,
    0.28873500, 0.90964900, 0.04032200,
    0.28873500, 0.90964900, -0.06185400,
    0.28383500, 0.88676400, -0.06953800,
    0.28383500, 0.88676400, 0.04774600,
    0.28873500, 0.90964900, 0.04032200,
    0.35917500, 0.89071100, -0.06953800,
    0.32150500, 0.88873800, -0.07734600,
    0.32057000, 0.91131600, -0.06696100,
    0.35240500, 0.91298400, -0.06185400,
    0.37335100, 0.82194300, -0.07275900,
    0.33280000, 0.82027200, -0.08200800,
    0.32783700, 0.84265700, -0.09597900,
    0.37155300, 0.84517900, -0.08368900,
    0.28383500, 0.88676400, -0.06953800,
    0.28412100, 0.84013600, -0.08368900,
    0.28412100, 0.84013600, 0.06164000,
    0.28383500, 0.88676400, 0.04774600,
    0.35917500, 0.89071100, 0.04774600,
    0.37155300, 0.84517900, 0.06164000,
    0.37155300, 0.84517900, -0.08368900,
    0.35917500, 0.89071100, -0.06953800,
    0.37335100, 0.82194300, 0.05084500,
    0.35468400, 0.80655400, 0.04897400,
    0.35468400, 0.80655400, -0.07006500,
    0.37335100, 0.82194300, -0.07275900,
    0.28412100, 0.84013600, -0.08368900,
    0.29224800, 0.81860100, -0.07275900,
    0.29224800, 0.81860100, 0.05084500,
    0.28412100, 0.84013600, 0.06164000,
    0.37155300, 0.84517900, 0.06164000,
    0.37335100, 0.82194300, 0.05084500,
    0.37335100, 0.82194300, -0.07275900,
    0.37155300, 0.84517900, -0.08368900,
    0.37155300, 0.84517900, -0.08368900,
    0.32783700, 0.84265700, -0.09597900,
    0.32150500, 0.88873800, -0.07734600,
    0.35917500, 0.89071100, -0.06953800,
    0.29224800, 0.81860100, 0.05084500,
    0.33280000, 0.82027200, 0.06140700,
    0.32783700, 0.84265700, 0.07537800,
    0.28412100, 0.84013600, 0.06164000,
    0.34108500, 0.79606800, -0.02683700,
    0.33483200, 0.79558000, -0.02690100,
    0.33330100, 0.80488300, -0.07307100,
    0.35468400, 0.80655400, -0.07006500,
    0.31191900, 0.80321200, 0.04897400,
    0.33330100, 0.80488300, 0.05247000,
    0.33280000, 0.82027200, 0.06140700,
    0.29224800, 0.81860100, 0.05084500,
    0.29224800, 0.81860100, -0.07275900,
    0.31191900, 0.80321200, -0.07006500,
    0.31191900, 0.80321200, 0.04897400,
    0.29224800, 0.81860100, 0.05084500,
    0.35468400, 0.80655400, -0.07006500,
    0.33330100, 0.80488300, -0.07307100,
    0.33280000, 0.82027200, -0.08200800,
    0.37335100, 0.82194300, -0.07275900,
    0.31191900, 0.80321200, -0.07006500,
    0.32858000, 0.79509100, -0.02683700,
    0.32858000, 0.79509100, 0.00618700,
    0.31191900, 0.80321200, 0.04897400,
    0.35468400, 0.80655400, 0.04897400,
    0.34108500, 0.79606800, 0.00618700,
    0.34108500, 0.79606800, -0.02683700,
    0.35468400, 0.80655400, -0.07006500,
    0.32858000, 0.79509100, -0.02683700,
    0.33483200, 0.79558000, -0.02690100,
    0.33483300, 0.79558000, 0.00630000,
    0.32858000, 0.79509100, 0.00618700,
    0.08315000, 0.09676300, 0.01217400,
    0.08315000, 0.05544300, 0.01217400,
    0.08315000, 0.05544300, 0.06044800,
    0.08315000, 0.09676300, 0.06044800,
    0.13526100, 0.05544400, -0.03105900,
    0.13526100, 0.09676300, -0.03105900,
    0.03515900, 1.74166500, -0.05947400,
    0.03237100, 1.76268000, -0.05194600,
    0.05167000, 1.75782000, -0.04803400,
    0.05953800, 1.74003100, -0.05291700,
    0.13115500, 1.48970200, -0.17450500,
    0.13490000, 1.35971700, -0.14151300,
    0.04725600, 1.35971700, -0.14120600,
    0.04597900, 1.48970200, -0.17404800,
    0.11993700, 1.68101600, 0.11798400,
    0.12616700, 1.59680100, 0.11756200,
    0.20515400, 1.59554300, 0.10602300,
    0.19496400, 1.67724200, 0.10602300,
    0.20515400, 1.59554300, 0.10602300,
    0.12616700, 1.59680100, 0.11756200,
    0.13115500, 1.48970200, 0.11721400,
    0.21331100, 1.48970200, 0.10602300,
    0.21331100, 1.48970200, 0.10602300,
    0.13115500, 1.48970200, 0.11721400,
    0.13490000, 1.35971700, 0.11694800,
    0.21943600, 1.35971700, 0.10602300,
    0.04427700, 1.59810600, 0.11691800,
    0.00188100, 1.59878100, 0.10785200,
    0.00188100, 1.48970200, 0.10736200,
    0.04597900, 1.48970200, 0.11653400,
    0.06726600, 1.73928900, 0.00342200,
    0.05602000, 1.76298800, 0.00395700,
    0.05863200, 1.76668700, 0.03569900,
    0.06617400, 1.73970000, 0.03432000,
    0.04725600, 1.35971700, 0.11624200,
    0.04093300, 1.06221600, 0.11766000,
    0.11636300, 1.06221600, 0.11823300,
    0.13490000, 1.35971700, 0.11694800,
    0.13490000, 1.35971700, -0.14151300,
    0.11636300, 1.06221600, -0.14290100,
    0.04093300, 1.06221600, -0.14274100,
    0.04725600, 1.35971700, -0.14120600,
    0.11636300, 1.06221600, -0.14290100,
    0.10010900, 1.00866400, -0.14403200,
    0.03538900, 1.00866400, -0.14400500,
    0.04093300, 1.06221600, -0.14274100,
    0.10010900, 1.00866400, -0.14403200,
    0.09367500, 0.97067900, -0.14445300,
    0.03319400, 0.97067900, -0.14447700,
    0.03538900, 1.00866400, -0.14400500,
    0.04093300, 1.06221600, 0.11766000,
    0.03538900, 1.00866400, 0.11882700,
    0.10010900, 1.00866400, 0.11928200,
    0.11636300, 1.06221600, 0.11823300,
    0.11501200, 0.09676300, 0.06117400,
    0.11822700, 0.12889500, 0.12187800,
    0.08791800, 0.12889500, 0.12175500,
    0.09401800, 0.09676300, 0.06114200,
    0.09401800, 0.09676300, -0.08079100,
    0.08791800, 0.12889500, -0.14138600,
    0.11822700, 0.12889500, -0.14151300,
    0.11501200, 0.09676300, -0.08082600,
    0.11501200, 0.05544300, 0.06117400,
    0.11501200, 0.09676300, 0.06117400,
    0.09401800, 0.09676300, 0.06114200,
    0.09401800, 0.05544300, 0.06114200,
    0.08791800, 0.12889500, -0.14138600,
    0.06310300, 0.32796100, -0.13835800,
    0.12771500, 0.32796100, -0.13882900,
    0.11822700, 0.12889500, -0.14151300,
    0.03851400, 0.84998500, -0.19422500,
    0.03903900, 0.75808000, -0.19334600,
    0.00000000, 0.75591500, -0.18043600,
    0.00218300, 0.84998500, -0.18203000,
    0.11976300, 0.45484300, 0.11921700,
    0.12240300, 0.50259100, 0.11925500,
    0.05739300, 0.50259100, 0.11879600,
    0.05434700, 0.45484300, 0.11875400,
    0.12240300, 0.50259100, 0.11925500,
    0.12403700, 0.55034000, 0.11932200,
    0.05974700, 0.55034000, 0.11887200,
    0.05739300, 0.50259100, 0.11879600,
    0.12254300, 0.35934500, -0.13870900,
    0.11976300, 0.45484300, -0.13875100,
    0.18285900, 0.45484300, -0.12567400,
    0.18604900, 0.35934500, -0.12561500,
    0.05434700, 0.45484300, -0.13827100,
    0.05739300, 0.50259100, -0.13831500,
    0.12240300, 0.50259100, -0.13879000,
    0.11976300, 0.45484300, -0.13875100,
    0.05739300, 0.50259100, -0.13831500,
    0.05974700, 0.55034000, -0.13839300,
    0.12403700, 0.55034000, -0.13886000,
    0.12240300, 0.50259100, -0.13879000,
    0.06310300, 0.32796100, -0.13835800,
    0.05670300, 0.35934500, -0.13822400,
    0.12254300, 0.35934500, -0.13870900,
    0.12771500, 0.32796100, -0.13882900,
    0.11822700, 0.12889500, 0.12187800,
    0.12771500, 0.32796100, 0.11929200,
    0.06310300, 0.32796100, 0.11883800,
    0.08791800, 0.12889500, 0.12175500,
    0.12771500, 0.32796100, 0.11929200,
    0.12254300, 0.35934500, 0.11917600,
    0.05670300, 0.35934500, 0.11870900,
    0.06310300, 0.32796100, 0.11883800,
    0.12403700, 0.55034000, 0.11932200,
    0.11778000, 0.70502000, 0.11836800,
    0.04367500, 0.70502000, 0.11780900,
    0.05974700, 0.55034000, 0.11887200,
    0.05974700, 0.55034000, -0.13839300,
    0.04367500, 0.70502000, -0.18263500,
    0.11778000, 0.70502000, -0.18259400,
    0.12403700, 0.55034000, -0.13886000,
    0.11778000, 0.70502000, 0.11836800,
    0.11444300, 0.76226100, 0.11822700,
    0.03903900, 0.75808000, 0.11765200,
    0.04367500, 0.70502000, 0.11780900,
    0.03538900, 1.00866400, 0.11882700,
    0.03319400, 0.97067900, 0.11926200,
    0.09367500, 0.97067900, 0.11967100,
    0.10010900, 1.00866400, 0.11928200,
    0.03607000, 0.91350100, -0.18192500,
    0.03440300, 0.94152200, -0.16769100,
    0.09708800, 0.94152200, -0.16781500,
    0.10179100, 0.91350100, -0.18250400,
    0.03440300, 0.94152200, -0.16769100,
    0.03319400, 0.97067900, -0.14447700,
    0.09367500, 0.97067900, -0.14445300,
    0.09708800, 0.94152200, -0.16781500,
    0.03851400, 0.84998500, -0.19422500,
    0.03607000, 0.91350100, -0.18192500,
    0.10179100, 0.91350100, -0.18250400,
    0.10869000, 0.84998500, -0.19499100,
    0.11444300, 0.76226100, -0.19420000,
    0.10869000, 0.84998500, -0.19499100,
    0.17637800, 0.84998500, -0.17621700,
    0.18717400, 0.76629400, -0.17604500,
    0.04367500, 0.70502000, -0.18263500,
    0.03903900, 0.75808000, -0.19334600,
    0.11444300, 0.76226100, -0.19420000,
    0.11778000, 0.70502000, -0.18259400,
    0.12254300, 0.35934500, 0.11917600,
    0.11976300, 0.45484300, 0.11921700,
    0.05434700, 0.45484300, 0.11875400,
    0.05670300, 0.35934500, 0.11870900,
    0.10179100, 0.91350100, 0.11918800,
    0.09708800, 0.94152200, 0.11947100,
    0.03440300, 0.94152200, 0.11903800,
    0.03607000, 0.91350100, 0.11872200,
    0.10869000, 0.84998500, 0.11875800,
    0.10179100, 0.91350100, 0.11918800,
    0.03607000, 0.91350100, 0.11872200,
    0.03851400, 0.84998500, 0.11824300,
    0.09708800, 0.94152200, 0.11947100,
    0.09367500, 0.97067900, 0.11967100,
    0.03319400, 0.97067900, 0.11926200,
    0.03440300, 0.94152200, 0.11903800,
    0.08773800, 0.01059500, -0.10862000,
    0.09401800, 0.03284700, -0.08948600,
    0.11501200, 0.03284700, -0.08952500,
    0.11792500, 0.01059500, -0.10871600,
    0.03168200, 1.76987600, -0.02824800,
    0.03168400, 1.76985900, 0.00407100,
    0.05602000, 1.76298800, 0.00395700,
    0.05469700, 1.76132400, -0.02819300,
    0.03237100, 1.76268000, -0.05194600,
    0.03168200, 1.76987600, -0.02824800,
    0.05469700, 1.76132400, -0.02819300,
    0.05167000, 1.75782000, -0.04803400,
    0.03168400, 1.76985900, 0.00407100,
    0.03171800, 1.76964600, 0.03622500,
    0.05863200, 1.76668700, 0.03569900,
    0.05602000, 1.76298800, 0.00395700,
    0.03516300, 1.74167300, 0.03384800,
    0.03171800, 1.76964600, 0.03622500,
    0.00369300, 1.77207100, 0.03638700,
    0.00308900, 1.74369900, 0.03170800,
    0.08315000, 0.03284700, -0.08865500,
    0.07210900, 0.01059500, -0.10673400,
    0.07210900, 0.01059500, -0.04060900,
    0.08315000, 0.03284700, -0.03123100,
    0.08003800, -0.00201300, -0.10485500,
    0.08127900, 0.00478200, -0.11125900,
    0.12056200, 0.00470000, -0.11372700,
    0.12185500, -0.00201300, -0.10502300,
    0.13526100, 0.03284700, 0.01186600,
    0.14704200, 0.01059500, 0.02144400,
    0.14704200, 0.01059500, -0.04010100,
    0.13526100, 0.03284700, -0.03087300,
    0.11501200, 0.03284700, 0.06117400,
    0.09401800, 0.03284700, 0.06114200,
    0.14704200, 0.01059500, -0.10459500,
    0.11792500, 0.01059500, -0.10871600,
    0.11501200, 0.03284700, -0.08952500,
    0.13526100, 0.03284700, -0.08770900,
    0.14704200, 0.01059500, -0.10459500,
    0.13526100, 0.03284700, -0.08770900,
    0.11501200, 0.03284700, 0.06117400,
    0.11792500, 0.01059500, 0.09203900,
    0.14704200, 0.01059500, 0.08799700,
    0.13526100, 0.03284700, 0.05966000,
    0.13526100, 0.05544300, -0.07920300,
    0.13526100, 0.09676300, -0.07920300,
    0.12081700, 0.00503000, 0.18689800,
    0.11785000, 0.00729600, 0.14383600,
    0.08817000, 0.00729600, 0.14369800,
    0.08226800, 0.00503000, 0.18661100,
    0.08737900, 0.00716000, -0.11377100,
    0.08127900, 0.00478200, -0.11125900,
    0.06127000, 0.00503000, -0.10197500,
    0.07155200, 0.00717900, -0.11156600,
    0.07120700, 0.00714700, 0.02592000,
    0.06127000, 0.00503000, 0.02326000,
    0.06231000, 0.00503000, 0.18098700,
    0.07280400, 0.00729600, 0.14086900,
    0.07155200, 0.00717900, -0.11156600,
    0.06127000, 0.00503000, -0.10197500,
    0.06127000, 0.00503000, -0.03015200,
    0.06936300, 0.00697600, -0.03896800,
    0.08127900, 0.00478200, -0.11125900,
    0.08737900, 0.00716000, -0.11377100,
    0.11804500, 0.00715700, -0.11385100,
    0.12056200, 0.00470000, -0.11372700,
    0.14807700, 0.00715700, 0.02529000,
    0.15911200, 0.00503000, 0.02253500,
    0.15911200, 0.00503000, -0.02961400,
    0.14997900, 0.00699300, -0.03839900,
    0.09401800, 0.03284700, -0.08948600,
    0.09401800, 0.05544300, -0.08079100,
    0.11501200, 0.05544300, -0.08082600,
    0.11501200, 0.03284700, -0.08952500,
    0.08315000, 0.03284700, 0.01217400,
    0.07210900, 0.01059500, 0.02192400,
    0.07210900, 0.01059500, 0.09003000,
    0.08315000, 0.03284700, 0.06044800,
    0.09401800, 0.03284700, -0.08948600,
    0.08773800, 0.01059500, -0.10862000,
    0.07210900, 0.01059500, -0.10673400,
    0.08315000, 0.03284700, -0.08865500,
    0.13526100, 0.03284700, 0.05966000,
    0.14704200, 0.01059500, 0.08799700,
    0.08315000, 0.03284700, -0.03123100,
    0.08315000, 0.03284700, 0.01217400,
    0.13526100, 0.03284700, 0.05966000,
    0.13526100, 0.03284700, 0.01186600,
    0.09401800, 0.05544300, -0.08079100,
    0.09401800, 0.03284700, -0.08948600,
    0.08315000, 0.03284700, -0.08865500,
    0.08315000, 0.05544300, -0.08004800,
    0.08315000, 0.03284700, 0.06044800,
    0.13526100, 0.03284700, -0.03087300,
    0.13526100, 0.03284700, -0.08770900,
    0.15911200, 0.00503000, -0.09929700,
    0.12056200, 0.00470000, -0.11372700,
    0.11804500, 0.00715700, -0.11385100,
    0.14772300, 0.00718800, -0.10920900,
    0.11792500, 0.01059500, 0.09203900,
    0.11501200, 0.03284700, 0.06117400,
    0.09401800, 0.03284700, 0.06114200,
    0.08773800, 0.01059500, 0.09194500,
    0.09401800, 0.05544300, -0.08079100,
    0.09401800, 0.09676300, -0.08079100,
    0.11501200, 0.09676300, -0.08082600,
    0.11501200, 0.05544300, -0.08082600,
    0.08315000, 0.03284700, -0.08865500,
    0.16217100, -0.01609700, -0.03034100,
    0.15907500, -0.02313900, -0.03064400,
    0.15907500, -0.02313900, -0.09920100,
    0.16217100, -0.01609700, -0.09856100,
    0.05840600, -0.01609700, -0.03098900,
    0.06130300, -0.02313900, -0.03128600,
    0.06130300, -0.02313900, 0.02481600,
    0.05840600, -0.01609700, 0.02440900,
    0.16217100, -0.01609700, 0.17832600,
    0.15794200, -0.02313900, 0.17539300,
    0.15907500, -0.02313900, 0.02395200,
    0.16217100, -0.01609700, 0.02353700,
    0.08004800, -0.01609700, -0.10481200,
    0.08169500, -0.02313900, -0.10493200,
    0.06130300, -0.02313900, -0.10200300,
    0.05840600, -0.01609700, -0.10159800,
    0.05840600, -0.01609700, 0.02440900,
    0.06130300, -0.02313900, 0.02481600,
    0.06236400, -0.02313900, 0.18089900,
    0.05840600, -0.01609700, 0.18451000,
    0.05840600, -0.01609700, -0.10159800,
    0.06130300, -0.02313900, -0.10200300,
    0.14647800, 0.00729600, 0.13785300,
    0.15800000, 0.00503000, 0.17547100,
    0.15911200, 0.00503000, 0.02253500,
    0.14807700, 0.00715700, 0.02529000,
    0.06936300, 0.00697600, -0.03896800,
    0.06127000, 0.00503000, -0.03015200,
    0.06127000, 0.00503000, 0.02326000,
    0.07120700, 0.00714700, 0.02592000,
    0.14997900, 0.00699300, -0.03839900,
    0.15911200, 0.00503000, -0.02961400,
    0.15911200, 0.00503000, -0.09929700,
    0.14772300, 0.00718800, -0.10920900,
    0.13526100, 0.03284700, -0.08770900,
    0.11501200, 0.03284700, -0.08952500,
    0.11501200, 0.05544300, -0.08082600,
    0.13526100, 0.05544300, -0.07920300,
    0.15907500, -0.02313900, -0.03064400,
    0.15582500, -0.02494000, -0.02966500,
    0.15488600, -0.02494000, -0.09697500,
    0.15907500, -0.02313900, -0.09920100,
    0.06130300, -0.02313900, -0.03128600,
    0.06423900, -0.02494000, -0.03025600,
    0.06404700, -0.02494000, 0.02465800,
    0.06130300, -0.02313900, 0.02481600,
    0.15794200, -0.02313900, 0.17539300,
    0.15205300, -0.02494000, 0.17008900,
    0.15602400, -0.02494000, 0.02383000,
    0.15907500, -0.02313900, 0.02395200,
    0.08169500, -0.02313900, -0.10493200,
    0.08385500, -0.02494000, -0.10195000,
    0.06513800, -0.02494000, -0.09949200,
    0.06130300, -0.02313900, -0.10200300,
    0.06130300, -0.02313900, 0.02481600,
    0.06404700, -0.02494000, 0.02465800,
    0.06781600, -0.02494000, 0.17462600,
    0.06236400, -0.02313900, 0.18089900,
    0.06130300, -0.02313900, -0.10200300,
    0.06513800, -0.02494000, -0.09949200,
    0.06423900, -0.02494000, -0.03025600,
    0.06130300, -0.02313900, -0.03128600,
    0.11785000, 0.00729600, 0.14383600,
    0.12081700, 0.00503000, 0.18689800,
    0.15800000, 0.00503000, 0.17547100,
    0.14647800, 0.00729600, 0.13785300,
    0.12185100, -0.01609700, -0.10497800,
    0.12185500, -0.00201300, -0.10502300,
    0.16219100, -0.00201200, -0.09859900,
    0.16217100, -0.01609700, -0.09856100,
    0.16217100, -0.01609700, 0.02353700,
    0.15907500, -0.02313900, 0.02395200,
    0.08004800, -0.01609700, -0.10481200,
    0.05840600, -0.01609700, -0.10159800,
    0.05838800, -0.00201200, -0.10163600,
    0.08003800, -0.00201300, -0.10485500,
    0.08350800, -0.02494000, 0.02557500,
    0.08538400, -0.02494000, 0.17908300,
    0.06781600, -0.02494000, 0.17462600,
    0.06404700, -0.02494000, 0.02465800,
    0.08385500, -0.02494000, -0.10195000,
    0.08360500, -0.02494000, -0.03090600,
    0.06423900, -0.02494000, -0.03025600,
    0.06513800, -0.02494000, -0.09949200,
    0.12000900, -0.02494000, -0.10205400,
    0.12058800, -0.02494000, -0.03094900,
    0.11931900, -0.02494000, 0.17931400,
    0.12065400, -0.02494000, 0.02563600,
    0.11931900, -0.02494000, 0.17931400,
    0.12080200, -0.02313900, 0.18679500,
    0.08229800, -0.02313900, 0.18651000,
    0.08538400, -0.02494000, 0.17908300,
    0.15205300, -0.02494000, 0.17008900,
    0.15602400, -0.02494000, 0.02383000,
    0.12185600, -0.00201200, 0.19144400,
    0.12081700, 0.00503000, 0.18689800,
    0.08226800, 0.00503000, 0.18661100,
    0.08003800, -0.00201200, 0.19110500,
    0.15907500, -0.02313900, 0.02395200,
    0.15602400, -0.02494000, 0.02383000,
    0.15582500, -0.02494000, -0.02966500,
    0.15907500, -0.02313900, -0.03064400,
    0.11785000, 0.00729600, 0.14383600,
    0.11792500, 0.01059500, 0.09203900,
    0.08773800, 0.01059500, 0.09194500,
    0.08817000, 0.00729600, 0.14369800,
    0.15488600, -0.02494000, -0.09697500,
    0.12000900, -0.02494000, -0.10205400,
    0.12108300, -0.02313900, -0.10510300,
    0.15907500, -0.02313900, -0.09920100,
    0.14704200, 0.01059500, -0.04010100,
    0.14997900, 0.00699300, -0.03839900,
    0.14772300, 0.00718800, -0.10920900,
    0.14704200, 0.01059500, -0.10459500,
    0.07210900, 0.01059500, -0.04060900,
    0.06936300, 0.00697600, -0.03896800,
    0.07120700, 0.00714700, 0.02592000,
    0.07210900, 0.01059500, 0.02192400,
    0.14704200, 0.01059500, 0.08799700,
    0.14647800, 0.00729600, 0.13785300,
    0.14807700, 0.00715700, 0.02529000,
    0.14704200, 0.01059500, 0.02144400,
    0.08169500, -0.02313900, -0.10493200,
    0.08004800, -0.01609700, -0.10481200,
    0.12185100, -0.01609700, -0.10497800,
    0.12108300, -0.02313900, -0.10510300,
    0.14704200, 0.01059500, 0.02144400,
    0.14807700, 0.00715700, 0.02529000,
    0.14997900, 0.00699300, -0.03839900,
    0.14704200, 0.01059500, -0.04010100,
    0.08737900, 0.00716000, -0.11377100,
    0.08773800, 0.01059500, -0.10862000,
    0.11792500, 0.01059500, -0.10871600,
    0.11804500, 0.00715700, -0.11385100,
    0.07210900, 0.01059500, -0.10673400,
    0.07155200, 0.00717900, -0.11156600,
    0.06936300, 0.00697600, -0.03896800,
    0.07210900, 0.01059500, -0.04060900,
    0.07210900, 0.01059500, 0.02192400,
    0.07120700, 0.00714700, 0.02592000,
    0.07280400, 0.00729600, 0.14086900,
    0.07210900, 0.01059500, 0.09003000,
    0.08773800, 0.01059500, -0.10862000,
    0.08737900, 0.00716000, -0.11377100,
    0.07155200, 0.00717900, -0.11156600,
    0.07210900, 0.01059500, -0.10673400,
    0.12185100, -0.01609700, 0.19139200,
    0.12185600, -0.00201200, 0.19144400,
    0.08003800, -0.00201200, 0.19110500,
    0.08004800, -0.01609700, 0.19105400,
    0.15911200, 0.00503000, 0.02253500,
    0.16219100, -0.00201200, 0.02285500,
    0.16219100, -0.00201200, -0.02984600,
    0.15911200, 0.00503000, -0.02961400,
    0.05840600, -0.01609700, -0.10159800,
    0.05840600, -0.01609700, -0.03098900,
    0.05838800, -0.00201200, -0.03044100,
    0.05838800, -0.00201200, -0.10163600,
    0.08385500, -0.02494000, -0.10195000,
    0.08169500, -0.02313900, -0.10493200,
    0.12108300, -0.02313900, -0.10510300,
    0.12000900, -0.02494000, -0.10205400,
    0.12080200, -0.02313900, 0.18679500,
    0.12185100, -0.01609700, 0.19139200,
    0.08004800, -0.01609700, 0.19105400,
    0.08229800, -0.02313900, 0.18651000,
    0.12185600, -0.00201200, 0.19144400,
    0.12185100, -0.01609700, 0.19139200,
    0.16217100, -0.01609700, 0.17832600,
    0.16219100, -0.00201200, 0.17836800,
    0.12081700, 0.00503000, 0.18689800,
    0.12185600, -0.00201200, 0.19144400,
    0.16219100, -0.00201200, 0.17836800,
    0.15800000, 0.00503000, 0.17547100,
    0.06127000, 0.00503000, -0.10197500,
    0.05838800, -0.00201200, -0.10163600,
    0.05838800, -0.00201200, -0.03044100,
    0.06127000, 0.00503000, -0.03015200,
    0.05840600, -0.01609700, 0.02440900,
    0.05840600, -0.01609700, 0.18451000,
    0.05838800, -0.00201200, 0.18455600,
    0.05838800, -0.00201200, 0.02365700,
    0.06127000, 0.00503000, 0.02326000,
    0.05838800, -0.00201200, 0.02365700,
    0.05838800, -0.00201200, 0.18455600,
    0.06231000, 0.00503000, 0.18098700,
    0.16217100, -0.01609700, 0.17832600,
    0.16217100, -0.01609700, 0.02353700,
    0.16219100, -0.00201200, 0.02285500,
    0.16219100, -0.00201200, 0.17836800,
    0.08127900, 0.00478200, -0.11125900,
    0.08003800, -0.00201300, -0.10485500,
    0.05838800, -0.00201200, -0.10163600,
    0.06127000, 0.00503000, -0.10197500,
    0.15800000, 0.00503000, 0.17547100,
    0.16219100, -0.00201200, 0.17836800,
    0.16219100, -0.00201200, 0.02285500,
    0.15911200, 0.00503000, 0.02253500,
    0.05838800, -0.00201200, 0.02365700,
    0.06127000, 0.00503000, 0.02326000,
    0.16217100, -0.01609700, -0.03034100,
    0.16217100, -0.01609700, -0.09856100,
    0.16219100, -0.00201200, -0.09859900,
    0.16219100, -0.00201200, -0.02984600,
    0.16219100, -0.00201200, -0.09859900,
    0.15911200, 0.00503000, -0.09929700,
    0.08004800, -0.01609700, -0.10481200,
    0.08003800, -0.00201300, -0.10485500,
    0.12185500, -0.00201300, -0.10502300,
    0.12185100, -0.01609700, -0.10497800,
    0.33330100, 0.80488300, 0.05247000,
    0.33483300, 0.79558000, 0.00630000,
    0.34108500, 0.79606800, 0.00618700,
    0.35468400, 0.80655400, 0.04897400,
    0.34108500, 0.79606800, -0.02683700,
    0.34108500, 0.79606800, 0.00618700,
    0.33280000, 0.82027200, -0.08200800,
    0.33330100, 0.80488300, -0.07307100,
    0.31191900, 0.80321200, -0.07006500,
    0.29224800, 0.81860100, -0.07275900,
    0.33280000, 0.82027200, 0.06140700,
    0.33330100, 0.80488300, 0.05247000,
    0.35468400, 0.80655400, 0.04897400,
    0.37335100, 0.82194300, 0.05084500,
    0.33330100, 0.80488300, -0.07307100,
    0.33483200, 0.79558000, -0.02690100,
    0.32858000, 0.79509100, -0.02683700,
    0.31191900, 0.80321200, -0.07006500,
    0.32783700, 0.84265700, 0.07537800,
    0.33280000, 0.82027200, 0.06140700,
    0.37335100, 0.82194300, 0.05084500,
    0.37155300, 0.84517900, 0.06164000,
    0.32150500, 0.88873800, -0.07734600,
    0.32783700, 0.84265700, -0.09597900,
    0.28412100, 0.84013600, -0.08368900,
    0.28383500, 0.88676400, -0.06953800,
    0.32783700, 0.84265700, -0.09597900,
    0.33280000, 0.82027200, -0.08200800,
    0.29224800, 0.81860100, -0.07275900,
    0.28412100, 0.84013600, -0.08368900,
    0.32057000, 0.91131600, -0.06696100,
    0.32150500, 0.88873800, -0.07734600,
    0.28383500, 0.88676400, -0.06953800,
    0.28873500, 0.90964900, -0.06185400,
    0.32057000, 0.91131600, 0.04636000,
    0.32150500, 0.88873800, 0.05674600,
    0.35917500, 0.89071100, 0.04774600,
    0.35240500, 0.91298400, 0.04032200,
    0.32150500, 0.88873800, 0.05674600,
    0.32783700, 0.84265700, 0.07537800,
    0.37155300, 0.84517900, 0.06164000,
    0.35917500, 0.89071100, 0.04774600,
    0.31917000, 0.94509300, 0.03007600,
    0.32057000, 0.91131600, 0.04636000,
    0.35240500, 0.91298400, 0.04032200,
    0.34185600, 0.94628200, 0.02750400,
    0.31430000, 1.05960300, -0.05537400,
    0.31917000, 0.94509300, -0.05067600,
    0.29648500, 0.94390500, -0.04864200,
    0.27482000, 1.05598200, -0.04999000,
    0.31430000, 1.05960300, 0.03477300,
    0.31917000, 0.94509300, 0.03007600,
    0.34185600, 0.94628200, 0.02750400,
    0.35378000, 1.06322400, 0.02812900,
    0.31917000, 0.94509300, -0.05067600,
    0.32057000, 0.91131600, -0.06696100,
    0.28873500, 0.90964900, -0.06185400,
    0.29648500, 0.94390500, -0.04864200,
    0.31340100, 1.17380400, 0.03477300,
    0.31430000, 1.05960300, 0.03477300,
    0.35378000, 1.06322400, 0.02812900,
    0.38539500, 1.17742500, 0.02314000,
    0.29314100, 1.27993900, 0.03477300,
    0.29406000, 1.24461100, 0.03477300,
    0.36170200, 1.24820700, 0.02367800,
    0.35051900, 1.28161400, 0.02653300,
    0.29314100, 1.27993900, -0.05537400,
    0.29406000, 1.24461100, -0.05537400,
    0.22641900, 1.24101400, -0.04637400,
    0.23576200, 1.27826400, -0.04746900,
    0.29406000, 1.24461100, -0.05537400,
    0.31340100, 1.17380400, -0.05537400,
    0.24140800, 1.17018200, -0.04593800,
    0.22641900, 1.24101400, -0.04637400,
    0.29406000, 1.24461100, 0.03477300,
    0.31340100, 1.17380400, 0.03477300,
    0.38539500, 1.17742500, 0.02314000,
    0.36170200, 1.24820700, 0.02367800,
    0.31340100, 1.17380400, -0.05537400,
    0.31430000, 1.05960300, -0.05537400,
    0.27482000, 1.05598200, -0.04999000,
    0.24140800, 1.17018200, -0.04593800,
    0.29956300, 1.29384200, 0.04471500,
    0.29314100, 1.27993900, 0.03477300,
    0.35051900, 1.28161400, 0.02653300,
    0.36582300, 1.29809100, 0.03161000,
    0.29581300, 1.36764500, 0.04471500,
    0.29956300, 1.29384200, 0.04471500,
    0.36582300, 1.29809100, 0.03161000,
    0.36457300, 1.37600100, 0.03118600,
    0.29956300, 1.29384200, -0.06531600,
    0.29314100, 1.27993900, -0.05537400,
    0.23576200, 1.27826400, -0.04746900,
    0.23330400, 1.28959400, -0.05427300,
    0.27714500, 1.59361600, -0.09315000,
    0.22140900, 1.59717200, -0.07817900,
    0.21139800, 1.67665500, -0.05680800,
    0.25885800, 1.66564500, -0.06531600,
    0.22705400, 1.35928800, 0.03118600,
    0.29581300, 1.36764500, 0.04471500,
    0.29057700, 1.49520500, 0.03079900,
    0.22955600, 1.49146300, 0.02137700,
    0.22955600, 1.49146300, 0.02137700,
    0.29057700, 1.49520500, 0.03079900,
    0.27682300, 1.59323900, 0.03079900,
    0.22141200, 1.59713800, 0.02206300,
    0.25871000, 1.66552500, 0.04471500,
    0.21139800, 1.67665500, 0.03463700,
    0.22141200, 1.59713800, 0.02206300,
    0.27682300, 1.59323900, 0.03079900,
    0.29581300, 1.36764500, -0.06531600,
    0.29956300, 1.29384200, -0.06531600,
    0.23330400, 1.28959400, -0.05427300,
    0.22705400, 1.35928800, -0.05391600,
    0.29060600, 1.49522900, -0.09315000,
    0.22955600, 1.49146300, -0.07706700,
    0.22140900, 1.59717200, -0.07817900,
    0.27714500, 1.59361600, -0.09315000,
    0.04427700, 1.59810600, 0.11691800,
    0.04597900, 1.48970200, 0.11653400,
    0.13115500, 1.48970200, 0.11721400,
    0.12616700, 1.59680100, 0.11756200,
    0.25871000, 1.66552500, 0.04471500,
    0.30602200, 1.65439500, 0.03463700,
    0.30631800, 1.65463500, -0.05680800,
    0.25885800, 1.66564500, -0.06531600,
    0.16219100, -0.00201200, -0.09859900,
    0.12185500, -0.00201300, -0.10502300,
    0.12056200, 0.00470000, -0.11372700,
    0.15911200, 0.00503000, -0.09929700,
    0.14772300, 0.00718800, -0.10920900,
    0.11804500, 0.00715700, -0.11385100,
    0.11792500, 0.01059500, -0.10871600,
    0.14704200, 0.01059500, -0.10459500,
    0.11792500, 0.01059500, 0.09203900,
    0.11785000, 0.00729600, 0.14383600,
    0.14647800, 0.00729600, 0.13785300,
    0.14704200, 0.01059500, 0.08799700,
    0.12080200, -0.02313900, 0.18679500,
    0.11931900, -0.02494000, 0.17931400,
    0.15205300, -0.02494000, 0.17008900,
    0.15794200, -0.02313900, 0.17539300,
    0.15582500, -0.02494000, -0.02966500,
    0.15488600, -0.02494000, -0.09697500,
    0.15907500, -0.02313900, -0.09920100,
    0.12108300, -0.02313900, -0.10510300,
    0.12185100, -0.01609700, -0.10497800,
    0.16217100, -0.01609700, -0.09856100,
    0.12185100, -0.01609700, 0.19139200,
    0.12080200, -0.02313900, 0.18679500,
    0.15794200, -0.02313900, 0.17539300,
    0.16217100, -0.01609700, 0.17832600,
    0.11501200, 0.05544300, 0.06117400,
    0.11501200, 0.03284700, 0.06117400,
    0.13526100, 0.03284700, 0.05966000,
    0.13526100, 0.05544300, 0.05966000,
    0.13526100, 0.05544300, -0.07920300,
    0.11501200, 0.05544300, -0.08082600,
    0.11501200, 0.09676300, -0.08082600,
    0.13526100, 0.09676300, -0.07920300,
    0.11501200, 0.09676300, 0.06117400,
    0.13526100, 0.09676300, 0.05966000,
    0.05670300, 0.35934500, -0.13822400,
    0.05434700, 0.45484300, -0.13827100,
    0.11976300, 0.45484300, -0.13875100,
    0.12254300, 0.35934500, -0.13870900,
    0.18925800, 0.70502000, -0.16467300,
    0.11778000, 0.70502000, -0.18259400,
    0.11444300, 0.76226100, -0.19420000,
    0.18717400, 0.76629400, -0.17604500,
    0.17637800, 0.84998500, -0.17621700,
    0.10869000, 0.84998500, -0.19499100,
    0.10179100, 0.91350100, -0.18250400,
    0.16518200, 0.91350100, -0.16499400,
    0.15755100, 0.94152200, -0.15172300,
    0.09708800, 0.94152200, -0.16781500,
    0.09367500, 0.97067900, -0.14445300,
    0.15201300, 0.97067900, -0.13086400,
    0.16518200, 0.91350100, -0.16499400,
    0.10179100, 0.91350100, -0.18250400,
    0.09708800, 0.94152200, -0.16781500,
    0.15755100, 0.94152200, -0.15172300,
    0.16253500, 1.00866400, 0.10671700,
    0.10010900, 1.00866400, 0.11928200,
    0.09367500, 0.97067900, 0.11967100,
    0.15201300, 0.97067900, 0.10745600,
    0.18604900, 0.55034000, -0.12584300,
    0.12403700, 0.55034000, -0.13886000,
    0.11778000, 0.70502000, -0.18259400,
    0.18925800, 0.70502000, -0.16467300,
    0.11444300, 0.76226100, 0.11822700,
    0.18717400, 0.76629400, 0.10602300,
    0.17637800, 0.84998500, 0.10613900,
    0.10869000, 0.84998500, 0.11875800,
    0.19003700, 0.32796100, -0.12579300,
    0.12771500, 0.32796100, -0.13882900,
    0.12254300, 0.35934500, -0.13870900,
    0.18604900, 0.35934500, -0.12561500,
    0.18510900, 0.50259100, -0.12573300,
    0.12240300, 0.50259100, -0.13879000,
    0.12403700, 0.55034000, -0.13886000,
    0.18604900, 0.55034000, -0.12584300,
    0.18285900, 0.45484300, -0.12567400,
    0.11976300, 0.45484300, -0.13875100,
    0.12240300, 0.50259100, -0.13879000,
    0.18510900, 0.50259100, -0.12573300,
    0.14746200, 0.12889500, -0.13602400,
    0.11822700, 0.12889500, -0.14151300,
    0.12771500, 0.32796100, -0.13882900,
    0.19003700, 0.32796100, -0.12579300,
    0.13526100, 0.09676300, -0.07920300,
    0.11501200, 0.09676300, -0.08082600,
    0.11822700, 0.12889500, -0.14151300,
    0.14746200, 0.12889500, -0.13602400,
    0.18911900, 1.06221600, 0.10602300,
    0.11636300, 1.06221600, 0.11823300,
    0.10010900, 1.00866400, 0.11928200,
    0.16253500, 1.00866400, 0.10671700,
    0.04597900, 1.48970200, 0.11653400,
    0.04725600, 1.35971700, 0.11624200,
    0.13490000, 1.35971700, 0.11694800,
    0.13115500, 1.48970200, 0.11721400,
    0.21943600, 1.35971700, 0.10602300,
    0.13490000, 1.35971700, 0.11694800,
    0.11636300, 1.06221600, 0.11823300,
    0.18911900, 1.06221600, 0.10602300,
    0.12616700, 1.59680100, -0.17497300,
    0.11993700, 1.68101600, -0.14263200,
    0.19496400, 1.67724200, -0.12932200,
    0.20515400, 1.59554300, -0.15908800,
    0.12616700, 1.59680100, -0.17497300,
    0.20515400, 1.59554300, -0.15908800,
    0.21331100, 1.48970200, -0.15908800,
    0.13115500, 1.48970200, -0.17450500,
    0.11998600, 1.68039900, -0.05243100,
    0.11998700, 1.68038800, 0.02858900,
    0.19504700, 1.67621400, 0.02954600,
    0.19504700, 1.67621400, -0.05252200,
    0.08470200, 1.68448000, -0.05113600,
    0.08245800, 1.68247500, 0.02741500,
    0.11998700, 1.68038800, 0.02858900,
    0.11998600, 1.68039900, -0.05243100,
    0.08242300, 1.68290400, -0.14798600,
    0.08470200, 1.68448000, -0.05113600,
    0.11998600, 1.68039900, -0.05243100,
    0.11993700, 1.68101600, -0.14263200,
    0.08245800, 1.68247500, 0.02741500,
    0.08242300, 1.68290400, 0.12273200,
    0.11993700, 1.68101600, 0.11798400,
    0.11998700, 1.68038800, 0.02858900,
    0.06231000, 0.00503000, 0.18098700,
    0.05838800, -0.00201200, 0.18455600,
    0.08003800, -0.00201200, 0.19110500,
    0.08226800, 0.00503000, 0.18661100,
    0.07210900, 0.01059500, 0.09003000,
    0.07280400, 0.00729600, 0.14086900,
    0.08817000, 0.00729600, 0.14369800,
    0.08773800, 0.01059500, 0.09194500,
    0.06236400, -0.02313900, 0.18089900,
    0.06781600, -0.02494000, 0.17462600,
    0.08538400, -0.02494000, 0.17908300,
    0.08229800, -0.02313900, 0.18651000,
    0.05840600, -0.01609700, 0.18451000,
    0.06236400, -0.02313900, 0.18089900,
    0.08229800, -0.02313900, 0.18651000,
    0.08004800, -0.01609700, 0.19105400,
    0.08315000, 0.05544300, 0.06044800,
    0.08315000, 0.03284700, 0.06044800,
    0.09401800, 0.03284700, 0.06114200,
    0.09401800, 0.05544300, 0.06114200,
    0.07280400, 0.00729600, 0.14086900,
    0.06231000, 0.00503000, 0.18098700,
    0.08226800, 0.00503000, 0.18661100,
    0.08817000, 0.00729600, 0.14369800,
    0.08315000, 0.03284700, 0.06044800,
    0.07210900, 0.01059500, 0.09003000,
    0.08773800, 0.01059500, 0.09194500,
    0.09401800, 0.03284700, 0.06114200,
    0.06617400, 1.73970000, 0.03432000,
    0.05863200, 1.76668700, 0.03569900,
    0.03171800, 1.76964600, 0.03622500,
    0.03516300, 1.74167300, 0.03384800,
    0.00505100, 1.77194600, 0.00404400,
    0.00369300, 1.77207100, 0.03638700,
    0.03171800, 1.76964600, 0.03622500,
    0.03168400, 1.76985900, 0.00407100,
    0.00976300, 1.76402500, -0.05116000,
    0.00720400, 1.77174700, -0.02829300,
    0.03168200, 1.76987600, -0.02824800,
    0.03237100, 1.76268000, -0.05194600,
    0.00720400, 1.77174700, -0.02829300,
    0.00505100, 1.77194600, 0.00404400,
    0.03168400, 1.76985900, 0.00407100,
    0.03168200, 1.76987600, -0.02824800,
    0.00195000, 0.94152200, 0.11171200,
    0.03440300, 0.94152200, 0.11903800,
    0.03319400, 0.97067900, 0.11926200,
    0.00188100, 0.97067900, 0.11222800,
    0.00204400, 0.91350100, 0.11101900,
    0.00218300, 0.84998500, 0.11004600,
    0.03851400, 0.84998500, 0.11824300,
    0.03607000, 0.91350100, 0.11872200,
    0.00195000, 0.94152200, 0.11171200,
    0.00204400, 0.91350100, 0.11101900,
    0.03607000, 0.91350100, 0.11872200,
    0.03440300, 0.94152200, 0.11903800,
    0.02261600, 0.35934500, -0.13021400,
    0.02048000, 0.45484300, -0.13031300,
    0.00000000, 0.75591500, 0.10897500,
    0.00530900, 0.70502000, 0.10924400,
    0.04367500, 0.70502000, 0.11780900,
    0.03903900, 0.75808000, 0.11765200,
    0.18717400, 0.76629400, -0.17604500,
    0.17637800, 0.84998500, -0.17621700,
    0.00530900, 0.70502000, 0.10924400,
    0.02646200, 0.55034000, 0.11134300,
    0.05974700, 0.55034000, 0.11887200,
    0.04367500, 0.70502000, 0.11780900,
    0.02261600, 0.35934500, 0.11099200,
    0.02965200, 0.32796100, 0.11127000,
    0.06310300, 0.32796100, 0.11883800,
    0.05670300, 0.35934500, 0.11870900,
    0.02965200, 0.32796100, 0.11127000,
    0.07222600, 0.12889500, 0.11924900,
    0.08791800, 0.12889500, 0.12175500,
    0.06310300, 0.32796100, 0.11883800,
    0.02646200, 0.55034000, 0.11134300,
    0.02373500, 0.50259100, 0.11117900,
    0.05739300, 0.50259100, 0.11879600,
    0.05974700, 0.55034000, 0.11887200,
    0.02373500, 0.50259100, 0.11117900,
    0.02048000, 0.45484300, 0.11108800,
    0.05434700, 0.45484300, 0.11875400,
    0.05739300, 0.50259100, 0.11879600,
    0.08315000, 0.09676300, 0.06044800,
    0.09401800, 0.09676300, 0.06114200,
    0.07222600, 0.12889500, 0.11924900,
    0.08315000, 0.09676300, 0.06044800,
    0.09401800, 0.09676300, 0.06114200,
    0.08791800, 0.12889500, 0.12175500,
    0.00188100, 0.97067900, -0.13708600,
    0.00188100, 1.00866400, -0.13602000,
    0.03538900, 1.00866400, -0.14400500,
    0.03319400, 0.97067900, -0.14447700,
    0.00188100, 1.00866400, -0.13602000,
    0.00188100, 1.06221600, -0.13357100,
    0.04093300, 1.06221600, -0.14274100,
    0.03538900, 1.00866400, -0.14400500,
    0.00188100, 1.06221600, -0.13357100,
    0.00188100, 1.35971700, -0.13145500,
    0.04725600, 1.35971700, -0.14120600,
    0.04093300, 1.06221600, -0.14274100,
    0.00188100, 1.35971700, -0.13145500,
    0.00188100, 1.48970200, -0.16192600,
    0.04597900, 1.48970200, -0.17404800,
    0.04725600, 1.35971700, -0.14120600,
    -0.04427800, 1.59810600, -0.17456500,
    -0.04215200, 1.68493000, -0.14244200,
    0.00188100, 1.68695600, -0.13308200,
    0.00188100, 1.59878100, -0.16258600,
    0.21943600, 1.35971700, -0.12932200,
    0.21331100, 1.48970200, -0.15908800,
    0.21331100, 1.48970200, -0.07158200,
    0.21934600, 1.35974500, -0.05218000,
    0.00754000, 1.74325200, -0.05751200,
    0.00976300, 1.76402500, -0.05116000,
    0.03237100, 1.76268000, -0.05194600,
    0.03515900, 1.74166500, -0.05947400,
    0.00188100, 1.68695600, -0.13308200,
    0.00469200, 1.71519500, -0.06388000,
    0.03865800, 1.71330200, -0.07318800,
    0.04215200, 1.68493000, -0.14244200,
    0.00469200, 1.71519500, -0.06388000,
    0.00754000, 1.74325200, -0.05751200,
    0.03515900, 1.74166500, -0.05947400,
    0.03865800, 1.71330200, -0.07318800,
    0.08242300, 1.68290400, 0.12273200,
    0.07479600, 1.71127700, 0.03937200,
    0.03865800, 1.71330200, 0.03747500,
    0.04215200, 1.68493000, 0.11738400,
    0.07479600, 1.71127700, 0.03937200,
    0.06617400, 1.73970000, 0.03432000,
    0.03516300, 1.74167300, 0.03384800,
    0.03865800, 1.71330200, 0.03747500,
    0.04215200, 1.68493000, 0.11738400,
    0.03865800, 1.71330200, 0.03747500,
    0.00248500, 1.71532800, 0.03456800,
    0.00188100, 1.68695600, 0.10853600,
    0.03865800, 1.71330200, 0.03747500,
    0.03516300, 1.74167300, 0.03384800,
    0.00308900, 1.74369900, 0.03170800,
    0.00248500, 1.71532800, 0.03456800,
    0.08245800, 1.68247500, 0.02741500,
    0.07486200, 1.71088600, 0.00598500,
    0.07479600, 1.71127700, 0.03937200,
    0.08242300, 1.68290400, 0.12273200,
    0.07486200, 1.71088600, 0.00598500,
    0.06726600, 1.73928900, 0.00342200,
    0.06617400, 1.73970000, 0.03432000,
    0.07479600, 1.71127700, 0.03937200,
    0.04215200, 1.68493000, -0.14244200,
    0.03865800, 1.71330200, -0.07318800,
    0.06842400, 1.71155900, -0.07137500,
    0.08242300, 1.68290400, -0.14798600,
    0.03865800, 1.71330200, -0.07318800,
    0.03515900, 1.74166500, -0.05947400,
    0.05953800, 1.74003100, -0.05291700,
    0.06842400, 1.71155900, -0.07137500,
    0.08470200, 1.68448000, -0.05113600,
    0.07485900, 1.71092200, -0.03258600,
    0.07486200, 1.71088600, 0.00598500,
    0.08245800, 1.68247500, 0.02741500,
    0.07485900, 1.71092200, -0.03258600,
    0.06726400, 1.73931800, -0.02813500,
    0.06726600, 1.73928900, 0.00342200,
    0.07486200, 1.71088600, 0.00598500,
    0.08242300, 1.68290400, -0.14798600,
    0.06842400, 1.71155900, -0.07137500,
    0.07485900, 1.71092200, -0.03258600,
    0.08470200, 1.68448000, -0.05113600,
    0.06842400, 1.71155900, -0.07137500,
    0.05953800, 1.74003100, -0.05291700,
    0.06726400, 1.73931800, -0.02813500,
    0.07485900, 1.71092200, -0.03258600,
    -0.06430800, 1.94125500, 0.16242900,
    -0.06938300, 1.93853500, 0.16155700,
    -0.07262600, 1.93602400, 0.16088600,
    -0.06447500, 1.93155900, 0.16099000,
    -0.06275200, 1.93061500, 0.16090900,
    -0.05619300, 1.92675100, 0.16056000,
    -0.05093100, 1.92433700, 0.16032200,
    -0.04530900, 1.92192200, 0.16006200,
    -0.04170600, 1.92201800, 0.16012000,
    -0.03944100, 1.92231700, 0.16018800,
    -0.03550700, 1.92375700, 0.16048300,
    -0.03017400, 1.92694400, 0.16103700,
    -0.02577700, 1.93119400, 0.16156800,
    -0.02289400, 1.93457500, 0.16199100,
    -0.02109200, 1.93670000, 0.16225700,
    -0.02181300, 1.93747300, 0.16235300,
    -0.02765100, 1.94152900, 0.16285800,
    -0.03408200, 1.94445800, 0.16322200,
    -0.03909900, 1.94634800, 0.16347200,
    -0.04040800, 1.94684200, 0.16353900,
    -0.04523700, 1.94674500, 0.16346900,
    -0.04999400, 1.94606900, 0.16331200,
    -0.05748600, 1.94446300, 0.16298400,
    -0.06253500, 1.94220500, 0.16261500,
    0.05164600, 1.94125500, 0.16242900,
    0.04981000, 1.94220500, 0.16261500,
    0.04457900, 1.94446300, 0.16298400,
    0.03681800, 1.94606900, 0.16331200,
    0.03189000, 1.94674500, 0.16346900,
    0.02688800, 1.94684200, 0.16353900,
    0.02553100, 1.94634800, 0.16347200,
    0.02033400, 1.94445800, 0.16322200,
    0.01367200, 1.94152900, 0.16285800,
    0.00762400, 1.93747300, 0.16235300,
    0.00687800, 1.93670000, 0.16225700,
    0.00874400, 1.93457500, 0.16199100,
    0.01173100, 1.93119400, 0.16156800,
    0.01628600, 1.92694400, 0.16103700,
    0.02181100, 1.92375700, 0.16048300,
    0.02588600, 1.92231700, 0.16018800,
    0.02823200, 1.92201800, 0.16012000,
    0.03196500, 1.92192200, 0.16006200,
    0.03778900, 1.92433700, 0.16032200,
    0.04323900, 1.92675100, 0.16056000,
    0.05003400, 1.93061500, 0.16090900,
    0.05181900, 1.93155900, 0.16099000,
    0.06026300, 1.93602400, 0.16088600,
    0.05690300, 1.93853500, 0.16155700,
    0.32858000, 0.79509100, 0.00618700,
    0.33483300, 0.79558000, 0.00630000,
    0.33330100, 0.80488300, 0.05247000,
    0.31191900, 0.80321200, 0.04897400,
    -0.06697400, 2.04217400, -0.10417100,
    -0.07131300, 2.07108800, -0.03696600,
    -0.03866200, 2.08844500, -0.03445800,
    -0.03823400, 2.05896800, -0.10414400,
    -0.21331100, 1.48970200, -0.15908800,
    -0.21331100, 1.48970200, -0.07158200,
    -0.20516000, 1.59547400, -0.07220700,
    -0.20515400, 1.59554300, -0.15908800,
    -0.17637800, 0.84998500, 0.10613900,
    -0.18717400, 0.76629400, 0.10602300,
    -0.05838800, -0.00201200, 0.18455600,
    -0.08003800, -0.00201200, 0.19110500,
    -0.08004800, -0.01609700, 0.19105400,
    -0.05840600, -0.01609700, 0.18451000,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7,
    8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15,
    16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23,
    24, 25, 26, 24, 26, 27, 24, 27, 28, 24, 28, 29,
    30, 31, 32, 30, 32, 33, 30, 33, 34, 35, 36, 37,
    35, 37, 38, 35, 38, 39, 35, 39, 40, 41, 42, 43,
    41, 43, 44, 41, 44, 45, 46, 47, 48, 46, 48, 49,
    46, 49, 50, 51, 52, 53, 54, 55, 56, 54, 56, 57,
    58, 59, 60, 58, 60, 61, 62, 63, 64, 62, 64, 65,
    66, 67, 68, 66, 68, 69, 70, 71, 72, 70, 72, 73,
    74, 75, 76, 74, 76, 77, 78, 79, 80, 78, 80, 81,
    78, 81, 82, 78, 82, 83, 84, 85, 86, 84, 86, 87,
    84, 87, 88, 89, 90, 91, 89, 91, 92, 89, 92, 93,
    89, 93, 94, 95, 96, 97, 95, 97, 98, 95, 98, 99,
    100, 101, 102, 103, 104, 105, 103, 105, 106, 107, 108, 109,
    107, 109, 110, 111, 112, 113, 111, 113, 114, 115, 116, 117,
    115, 117, 118, 119, 120, 121, 119, 121, 122, 123, 124, 125,
    123, 125, 126, 127, 128, 129, 127, 129, 130, 131, 132, 133,
    131, 133, 134, 135, 136, 137, 135, 137, 138, 139, 140, 141,
    139, 141, 142, 139, 142, 143, 139, 143, 144, 145, 146, 147,
    145, 147, 148, 145, 148, 149, 150, 151, 152, 150, 152, 153,
    150, 153, 154, 150, 154, 155, 156, 157, 158, 156, 158, 159,
    156, 159, 160, 161, 162, 163, 161, 163, 164, 161, 164, 165,
    166, 167, 168, 166, 168, 169, 170, 171, 172, 170, 172, 173,
    174, 175, 176, 174, 176, 177, 178, 179, 180, 178, 180, 181,
    178, 181, 182, 178, 182, 183, 184, 185, 186, 184, 186, 187,
    184, 187, 188, 189, 190, 191, 189, 191, 192, 189, 192, 193,
    189, 193, 194, 195, 196, 197, 195, 197, 198, 195, 198, 199,
    200, 201, 202, 203, 204, 205, 203, 205, 206, 207, 208, 209,
    207, 209, 210, 211, 212, 213, 211, 213, 214, 215, 216, 217,
    215, 217, 218, 219, 220, 221, 219, 221, 222, 223, 224, 225,
    223, 225, 226, 227, 228, 229, 227, 229, 230, 231, 232, 233,
    231, 233, 234, 235, 236, 237, 235, 237, 238, 239, 240, 241,
    239, 241, 242, 243, 244, 245, 243, 245, 246, 247, 248, 249,
    247, 249, 250, 251, 252, 253, 251, 253, 254, 255, 256, 257,
    255, 257, 258, 259, 260, 261, 259, 261, 262, 263, 264, 265,
    263, 265, 266, 267, 268, 269, 267, 269, 270, 271, 272, 273,
    271, 273, 274, 275, 276, 277, 275, 277, 278, 279, 280, 281,
    279, 281, 282, 283, 284, 285, 283, 285, 286, 287, 288, 289,
    287, 289, 290, 291, 292, 293, 291, 293, 294, 295, 296, 297,
    295, 297, 298, 299, 300, 301, 299, 301, 302, 303, 304, 305,
    303, 305, 306, 307, 308, 309, 307, 309, 310, 311, 312, 313,
    311, 313, 314, 315, 316, 317, 315, 317, 318, 319, 320, 321,
    319, 321, 322, 323, 324, 325, 323, 325, 326, 327, 328, 329,
    327, 329, 330, 331, 332, 333, 331, 333, 334, 335, 336, 337,
    335, 337, 338, 339, 340, 341, 339, 341, 342, 343, 344, 345,
    343, 345, 346, 347, 348, 349, 347, 349, 350, 351, 352, 353,
    351, 353, 354, 355, 356, 357, 355, 357, 358, 359, 360, 361,
    359, 361, 362, 363, 364, 365, 363, 365, 366, 367, 368, 369,
    367, 369, 370, 371, 372, 373, 371, 373, 374, 375, 376, 377,
    375, 377, 378, 379, 380, 381, 379, 381, 382, 383, 384, 385,
    383, 385, 386, 387, 388, 389, 387, 389, 390, 391, 392, 393,
    391, 393, 394, 395, 396, 397, 395, 397, 398, 399, 400, 401,
    399, 401, 402, 403, 404, 405, 403, 405, 406, 407, 408, 409,
    407, 409, 410, 411, 412, 413, 411, 413, 414, 411, 414, 415,
    416, 417, 418, 416, 418, 419, 420, 421, 422, 420, 422, 423,
    424, 425, 426, 424, 426, 427, 428, 429, 430, 428, 430, 431,
    432, 433, 434, 432, 434, 435, 436, 437, 438, 436, 438, 439,
    436, 439, 440, 436, 440, 441, 436, 441, 442, 436, 442, 443,
    444, 445, 446, 444, 446, 447, 448, 449, 450, 448, 450, 451,
    452, 453, 454, 452, 454, 455, 456, 457, 458, 456, 458, 459,
    460, 461, 462, 460, 462, 463, 464, 465, 466, 464, 466, 467,
    468, 469, 470, 468, 470, 471, 472, 473, 474, 472, 474, 475,
    476, 477, 478, 476, 478, 479, 480, 481, 482, 480, 482, 483,
    484, 485, 486, 484, 486, 487, 488, 489, 490, 488, 490, 491,
    492, 493, 494, 492, 494, 495, 496, 497, 498, 496, 498, 499,
    500, 501, 502, 500, 502, 503, 504, 505, 506, 504, 506, 507,
    508, 509, 510, 508, 510, 511, 512, 513, 514, 512, 514, 515,
    516, 517, 518, 516, 518, 519, 520, 521, 522, 520, 522, 523,
    524, 525, 526, 524, 526, 527, 528, 529, 530, 528, 530, 531,
    532, 533, 534, 532, 534, 535, 536, 537, 538, 536, 538, 539,
    540, 541, 542, 540, 542, 543, 544, 545, 546, 544, 546, 547,
    548, 549, 550, 548, 550, 551, 552, 553, 554, 552, 554, 555,
    556, 557, 558, 556, 558, 559, 560, 561, 562, 560, 562, 563,
    564, 565, 566, 564, 566, 567, 568, 569, 570, 568, 570, 571,
    572, 573, 574, 572, 574, 575, 576, 577, 578, 576, 578, 579,
    580, 581, 582, 580, 582, 583, 584, 585, 586, 584, 586, 587,
    588, 589, 590, 588, 590, 591, 592, 593, 594, 592, 594, 595,
    596, 597, 598, 596, 598, 599, 600, 601, 602, 600, 602, 603,
    604, 605, 606, 604, 606, 607, 608, 609, 610, 608, 610, 611,
    612, 613, 614, 612, 614, 615, 616, 617, 618, 616, 618, 619,
    620, 621, 622, 620, 622, 623, 624, 625, 626, 624, 626, 627,
    628, 629, 630, 628, 630, 631, 632, 633, 634, 632, 634, 635,
    636, 637, 638, 636, 638, 639, 640, 641, 642, 640, 642, 643,
    644, 645, 646, 644, 646, 647, 648, 649, 650, 648, 650, 651,
    652, 653, 654, 652, 654, 655, 656, 657, 658, 656, 658, 659,
    660, 661, 662, 660, 662, 663, 664, 665, 666, 664, 666, 667,
    664, 667, 668, 664, 668, 669, 664, 669, 670, 671, 672, 673,
    671, 673, 674, 675, 676, 677, 675, 677, 678, 675, 678, 679,
    675, 679, 680, 681, 682, 683, 681, 683, 684, 681, 684, 685,
    686, 687, 688, 686, 688, 689, 690, 691, 692, 690, 692, 693,
    690, 693, 694, 690, 694, 695, 690, 695, 696, 690, 696, 697,
    690, 697, 698, 690, 698, 699, 690, 699, 700, 690, 700, 701,
    702, 703, 704, 702, 704, 705, 702, 705, 706, 707, 708, 709,
    707, 709, 710, 707, 710, 711, 707, 711, 712, 707, 712, 713,
    707, 713, 714, 707, 714, 715, 716, 717, 718, 716, 718, 719,
    720, 721, 722, 720, 722, 723, 724, 725, 726, 724, 726, 727,
    728, 729, 730, 728, 730, 731, 732, 733, 734, 732, 734, 735,
    736, 737, 738, 736, 738, 739, 740, 741, 742, 740, 742, 743,
    744, 745, 746, 744, 746, 747, 748, 749, 750, 748, 750, 751,
    752, 753, 754, 752, 754, 755, 756, 757, 758, 756, 758, 759,
    760, 761, 762, 760, 762, 763, 760, 763, 764, 765, 766, 767,
    768, 769, 770, 768, 770, 771, 772, 773, 774, 772, 774, 775,
    776, 777, 778, 776, 778, 779, 780, 781, 782, 780, 782, 783,
    780, 783, 784, 780, 784, 785, 780, 785, 786, 780, 786, 787,
    780, 787, 788, 789, 790, 791, 789, 791, 792, 793, 794, 795,
    793, 795, 796, 797, 798, 799, 797, 799, 800, 801, 802, 803,
    801, 803, 804, 805, 806, 807, 805, 807, 808, 809, 810, 811,
    809, 811, 812, 813, 814, 815, 813, 815, 816, 817, 818, 819,
    817, 819, 820, 821, 822, 823, 821, 823, 824, 821, 824, 825,
    821, 825, 826, 821, 826, 827, 821, 827, 828, 821, 828, 829,
    830, 831, 832, 830, 832, 833, 834, 835, 836, 834, 836, 837,
    838, 839, 840, 838, 840, 841, 842, 843, 844, 842, 844, 845,
    846, 847, 848, 846, 848, 849, 850, 851, 852, 850, 852, 853,
    854, 855, 856, 854, 856, 857, 858, 859, 860, 858, 860, 861,
    862, 863, 864, 862, 864, 865, 866, 867, 868, 866, 868, 869,
    870, 871, 872, 870, 872, 873, 874, 875, 876, 874, 876, 877,
    878, 879, 880, 878, 880, 881, 878, 881, 882, 878, 882, 883,
    884, 885, 886, 884, 886, 887, 888, 889, 890, 888, 890, 891,
    892, 893, 894, 892, 894, 895, 896, 897, 898, 896, 898, 899,
    900, 901, 902, 900, 902, 903, 904, 905, 906, 904, 906, 907,
    908, 909, 910, 908, 910, 911, 912, 913, 914, 912, 914, 915,
    916, 917, 918, 916, 918, 919, 920, 921, 922, 920, 922, 923,
    924, 925, 926, 924, 926, 927, 928, 929, 930, 928, 930, 931,
    932, 933, 934, 932, 934, 935, 936, 937, 938, 936, 938, 939,
    940, 941, 942, 940, 942, 943, 944, 945, 946, 944, 946, 947,
    948, 949, 950, 948, 950, 951, 952, 953, 954, 952, 954, 955,
    956, 957, 958, 956, 958, 959, 960, 961, 962, 960, 962, 963,
    964, 965, 966, 964, 966, 967, 968, 969, 970, 968, 970, 971,
    972, 973, 974, 972, 974, 975, 976, 977, 978, 976, 978, 979,
    976, 979, 980, 981, 982, 983, 981, 983, 984, 985, 986, 987,
    985, 987, 988, 989, 990, 991, 989, 991, 992, 993, 994, 995,
    993, 995, 996, 997, 998, 999, 997, 999, 1000, 1001, 1002, 1003,
    1001, 1003, 1004, 1005, 1006, 1007, 1005, 1007, 1008, 1009, 1010, 1011,
    1009, 1011, 1012, 1013, 1014, 1015, 1013, 1015, 1016, 1017, 1018, 1019,
    1017, 1019, 1020, 1021, 1022, 1023, 1021, 1023, 1024, 1025, 1026, 1027,
    1025, 1027, 1028, 1029, 1030, 1031, 1029, 1031, 1032, 1033, 1034, 1035,
    1033, 1035, 1036, 1033, 1036, 1037, 1038, 1039, 1040, 1038, 1040, 1041,
    1042, 1043, 1044, 1042, 1044, 1045, 1046, 1047, 1048, 1046, 1048, 1049,
    1050, 1051, 1052, 1050, 1052, 1053, 1054, 1055, 1056, 1054, 1056, 1057,
    1058, 1059, 1060, 1058, 1060, 1061, 1058, 1061, 1062, 1063, 1064, 1065,
    1063, 1065, 1066, 1067, 1068, 1069, 1067, 1069, 1070, 1071, 1072, 1073,
    1071, 1073, 1074, 1075, 1076, 1077, 1075, 1077, 1078, 1079, 1080, 1081,
    1079, 1081, 1082, 1083, 1084, 1085, 1083, 1085, 1086, 1087, 1088, 1089,
    1087, 1089, 1090, 1091, 1092, 1093, 1091, 1093, 1094, 1095, 1096, 1097,
    1095, 1097, 1098, 1099, 1100, 1101, 1099, 1101, 1102, 1103, 1104, 1105,
    1103, 1105, 1106, 1107, 1108, 1109, 1107, 1109, 1110, 1111, 1112, 1113,
    1111, 1113, 1114, 1115, 1116, 1117, 1115, 1117, 1118, 1115, 1118, 1119,
    1120, 1121, 1122, 1120, 1122, 1123, 1124, 1125, 1126, 1124, 1126, 1127,
    1128, 1129, 1130, 1128, 1130, 1131, 1132, 1133, 1134, 1132, 1134, 1135,
    1136, 1137, 1138, 1136, 1138, 1139, 1140, 1141, 1142, 1140, 1142, 1143,
    1144, 1145, 1146, 1144, 1146, 1147, 1148, 1149, 1150, 1148, 1150, 1151,
    1152, 1153, 1154, 1152, 1154, 1155, 1156, 1157, 1158, 1156, 1158, 1159,
    1160, 1161, 1162, 1160, 1162, 1163, 1164, 1165, 1166, 1164, 1166, 1167,
    1168, 1169, 1170, 1168, 1170, 1171, 1172, 1173, 1174, 1172, 1174, 1175,
    1176, 1177, 1178, 1176, 1178, 1179, 1180, 1181, 1182, 1180, 1182, 1183,
    1184, 1185, 1186, 1184, 1186, 1187, 1184, 1187, 1188, 1189, 1190, 1191,
    1189, 1191, 1192, 1193, 1194, 1195, 1193, 1195, 1196, 1193, 1196, 1197,
    1198, 1199, 1200, 1198, 1200, 1201, 1202, 1203, 1204, 1202, 1204, 1205,
    1206, 1207, 1208, 1206, 1208, 1209, 1210, 1211, 1212, 1210, 1212, 1213,
    1214, 1215, 1216, 1214, 1216, 1217, 1218, 1219, 1220, 1218, 1220, 1221,
    1222, 1223, 1224, 1222, 1224, 1225, 1226, 1227, 1228, 1226, 1228, 1229,
    1230, 1231, 1232, 1230, 1232, 1233, 1234, 1235, 1236, 1234, 1236, 1237,
    1238, 1239, 1240, 1238, 1240, 1241, 1242, 1243, 1244, 1242, 1244, 1245,
    1246, 1247, 1248, 1246, 1248, 1249, 1250, 1251, 1252, 1250, 1252, 1253,
    1254, 1255, 1256, 1254, 1256, 1257, 1258, 1259, 1260, 1258, 1260, 1261,
    1262, 1263, 1264, 1262, 1264, 1265, 1266, 1267, 1268, 1266, 1268, 1269,
    1270, 1271, 1272, 1270, 1272, 1273, 1274, 1275, 1276, 1274, 1276, 1277,
    1278, 1279, 1280, 1278, 1280, 1281, 1278, 1281, 1282, 1283, 1284, 1285,
    1283, 1285, 1286, 1283, 1286, 1287, 1288, 1289, 1290, 1288, 1290, 1291,
    1288, 1291, 1292, 1293, 1294, 1295, 1293, 1295, 1296, 1293, 1296, 1297,
    1298, 1299, 1300, 1298, 1300, 1301, 1302, 1303, 1304, 1302, 1304, 1305,
    1302, 1305, 1306, 1302, 1306, 1307, 1308, 1309, 1310, 1308, 1310, 1311,
    1308, 1311, 1312, 1313, 1314, 1315, 1313, 1315, 1316, 1313, 1316, 1317,
    1318, 1319, 1320, 1318, 1320, 1321, 1322, 1323, 1324, 1322, 1324, 1325,
    1326, 1327, 1328, 1326, 1328, 1329, 1326, 1329, 1330, 1326, 1330, 1331,
    1326, 1331, 1332, 1326, 1332, 1333, 1334, 1335, 1336, 1334, 1336, 1337,
    1338, 1339, 1340, 1338, 1340, 1341, 1338, 1341, 1342, 1338, 1342, 1343,
    1344, 1345, 1346, 1344, 1346, 1347, 1344, 1347, 1348, 1349, 1350, 1351,
    1349, 1351, 1352, 1353, 1354, 1355, 1353, 1355, 1356, 1353, 1356, 1357,
    1353, 1357, 1358, 1353, 1358, 1359, 1353, 1359, 1360, 1353, 1360, 1361,
    1353, 1361, 1362, 1353, 1362, 1363, 1353, 1363, 1364, 1365, 1366, 1367,
    1365, 1367, 1368, 1365, 1368, 1369, 1370, 1371, 1372, 1370, 1372, 1373,
    1370, 1373, 1374, 1370, 1374, 1375, 1370, 1375, 1376, 1370, 1376, 1377,
    1370, 1377, 1378, 1379, 1380, 1381, 1379, 1381, 1382, 1383, 1384, 1385,
    1383, 1385, 1386, 1387, 1388, 1389, 1387, 1389, 1390, 1391, 1392, 1393,
    1391, 1393, 1394, 1395, 1396, 1397, 1395, 1397, 1398, 1399, 1400, 1401,
    1399, 1401, 1402, 1403, 1404, 1405, 1403, 1405, 1406, 1407, 1408, 1409,
    1407, 1409, 1410, 1411, 1412, 1413, 1411, 1413, 1414, 1415, 1416, 1417,
    1415, 1417, 1418, 1419, 1420, 1421, 1419, 1421, 1422, 1423, 1424, 1425,
    1423, 1425, 1426, 1427, 1428, 1429, 1427, 1429, 1430, 1431, 1432, 1433,
    1431, 1433, 1434, 1435, 1436, 1437, 1435, 1437, 1438, 1439, 1440, 1441,
    1439, 1441, 1442, 1443, 1444, 1445, 1443, 1445, 1446, 1447, 1448, 1449,
    1447, 1449, 1450, 1451, 1452, 1453, 1451, 1453, 1454, 1455, 1456, 1457,
    1455, 1457, 1458, 1455, 1458, 1459, 1455, 1459, 1460, 1455, 1460, 1461,
    1455, 1461, 1462, 1455, 1462, 1463, 1455, 1463, 1464, 1465, 1466, 1467,
    1465, 1467, 1468, 1469, 1470, 1471, 1469, 1471, 1472, 1473, 1474, 1475,
    1473, 1475, 1476, 1477, 1478, 1479, 1477, 1479, 1480, 1481, 1482, 1483,
    1481, 1483, 1484, 1485, 1486, 1487, 1485, 1487, 1488, 1489, 1490, 1491,
    1489, 1491, 1492, 1493, 1494, 1495, 1493, 1495, 1496, 1493, 1496, 1497,
    1493, 1497, 1498, 1493, 1498, 1499, 1493, 1499, 1500, 1493, 1500, 1501,
    1493, 1501, 1502, 1503, 1504, 1505, 1503, 1505, 1506, 1507, 1508, 1509,
    1507, 1509, 1510, 1511, 1512, 1513, 1511, 1513, 1514, 1515, 1516, 1517,
    1515, 1517, 1518, 1519, 1520, 1521, 1519, 1521, 1522, 1523, 1524, 1525,
    1523, 1525, 1526, 1527, 1528, 1529, 1527, 1529, 1530, 1531, 1532, 1533,
    1531, 1533, 1534, 1535, 1536, 1537, 1535, 1537, 1538, 1539, 1540, 1541,
    1539, 1541, 1542, 1543, 1544, 1545, 1543, 1545, 1546, 1547, 1548, 1549,
    1547, 1549, 1550, 1551, 1552, 1553, 1551, 1553, 1554, 1551, 1554, 1555,
    1551, 1555, 1556, 1557, 1558, 1559, 1557, 1559, 1560, 1561, 1562, 1563,
    1561, 1563, 1564, 1565, 1566, 1567, 1565, 1567, 1568, 1569, 1570, 1571,
    1569, 1571, 1572, 1573, 1574, 1575, 1573, 1575, 1576, 1577, 1578, 1579,
    1577, 1579, 1580, 1581, 1582, 1583, 1581, 1583, 1584, 1585, 1586, 1587,
    1585, 1587, 1588, 1589, 1590, 1591, 1589, 1591, 1592, 1593, 1594, 1595,
    1593, 1595, 1596, 1597, 1598, 1599, 1597, 1599, 1600, 1597, 1600, 1601,
    1602, 1603, 1604, 1602, 1604, 1605, 1606, 1607, 1608, 1606, 1608, 1609,
    1610, 1611, 1612, 1610, 1612, 1613, 1614, 1615, 1616, 1614, 1616, 1617,
    1618, 1619, 1620, 1618, 1620, 1621, 1622, 1623, 1624, 1622, 1624, 1625,
    1626, 1627, 1628, 1626, 1628, 1629, 1630, 1631, 1632, 1630, 1632, 1633,
    1634, 1635, 1636, 1634, 1636, 1637, 1638, 1639, 1640, 1638, 1640, 1641,
    1642, 1643, 1644, 1642, 1644, 1645, 1646, 1647, 1648, 1646, 1648, 1649,
    1650, 1651, 1652, 1650, 1652, 1653, 1654, 1655, 1656, 1654, 1656, 1657,
    1658, 1659, 1660, 1658, 1660, 1661, 1658, 1661, 1662, 1658, 1662, 1663,
    1664, 1665, 1666, 1664, 1666, 1667, 1664, 1667, 1668, 1664, 1668, 1669,
    1670, 1671, 1672, 1670, 1672, 1673, 1670, 1673, 1674, 1670, 1674, 1675,
    1676, 1677, 1678, 1676, 1678, 1679, 1676, 1679, 1680, 1676, 1680, 1681,
    1676, 1681, 1682, 1683, 1684, 1685, 1683, 1685, 1686, 1687, 1688, 1689,
    1687, 1689, 1690, 1691, 1692, 1693, 1691, 1693, 1694, 1695, 1696, 1697,
    1695, 1697, 1698, 1699, 1700, 1701, 1699, 1701, 1702, 1703, 1704, 1705,
    1703, 1705, 1706, 1707, 1708, 1709, 1707, 1709, 1710, 1711, 1712, 1713,
    1711, 1713, 1714, 1715, 1716, 1717, 1715, 1717, 1718, 1719, 1720, 1721,
    1719, 1721, 1722, 1723, 1724, 1725, 1723, 1725, 1726, 1727, 1728, 1729,
    1727, 1729, 1730, 1731, 1732, 1733, 1731, 1733, 1734, 1735, 1736, 1737,
    1735, 1737, 1738, 1739, 1740, 1741, 1739, 1741, 1742, 1743, 1744, 1745,
    1743, 1745, 1746, 1747, 1748, 1749, 1747, 1749, 1750, 1751, 1752, 1753,
    1751, 1753, 1754, 1755, 1756, 1757, 1755, 1757, 1758, 1759, 1760, 1761,
    1759, 1761, 1762, 1763, 1764, 1765, 1763, 1765, 1766, 1767, 1768, 1769,
    1767, 1769, 1770, 1771, 1772, 1773, 1771, 1773, 1774, 1775, 1776, 1777,
    1775, 1777, 1778, 1779, 1780, 1781, 1779, 1781, 1782, 1783, 1784, 1785,
    1783, 1785, 1786, 1787, 1788, 1789, 1787, 1789, 1790, 1791, 1792, 1793,
    1791, 1793, 1794, 1795, 1796, 1797, 1795, 1797, 1798, 1799, 1800, 1801,
    1799, 1801, 1802, 1803, 1804, 1805, 1803, 1805, 1806, 1807, 1808, 1809,
    1807, 1809, 1810, 1811, 1812, 1813, 1811, 1813, 1814, 1815, 1816, 1817,
    1815, 1817, 1818, 1819, 1820, 1821, 1819, 1821, 1822, 1823, 1824, 1825,
    1823, 1825, 1826, 1827, 1828, 1829, 1827, 1829, 1830, 1831, 1832, 1833,
    1831, 1833, 1834, 1835, 1836, 1837, 1835, 1837, 1838, 1839, 1840, 1841,
    1839, 1841, 1842, 1843, 1844, 1845, 1843, 1845, 1846, 1847, 1848, 1849,
    1847, 1849, 1850, 1851, 1852, 1853, 1851, 1853, 1854, 1855, 1856, 1857,
    1855, 1857, 1858, 1859, 1860, 1861, 1859, 1861, 1862, 1863, 1864, 1865,
    1863, 1865, 1866, 1867, 1868, 1869, 1867, 1869, 1870, 1871, 1872, 1873,
    1871, 1873, 1874, 1875, 1876, 1877, 1875, 1877, 1878, 1879, 1880, 1881,
    1879, 1881, 1882, 1883, 1884, 1885, 1883, 1885, 1886, 1887, 1888, 1889,
    1887, 1889, 1890, 1891, 1892, 1893, 1891, 1893, 1894, 1895, 1896, 1897,
    1895, 1897, 1898, 1899, 1900, 1901, 1899, 1901, 1902, 1903, 1904, 1905,
    1903, 1905, 1906, 1907, 1908, 1909, 1907, 1909, 1910, 1911, 1912, 1913,
    1911, 1913, 1914, 1915, 1916, 1917, 1915, 1917, 1918, 1919, 1920, 1921,
    1919, 1921, 1922, 1923, 1924, 1925, 1923, 1925, 1926, 1927, 1928, 1929,
    1927, 1929, 1930, 1931, 1932, 1933, 1931, 1933, 1934, 1935, 1936, 1937,
    1935, 1937, 1938, 1939, 1940, 1941, 1939, 1941, 1942, 1943, 1944, 1945,
    1943, 1945, 1946, 1947, 1948, 1949, 1947, 1949, 1950, 1951, 1952, 1953,
    1951, 1953, 1954, 1955, 1956, 1957, 1955, 1957, 1958, 1959, 1960, 1961,
    1959, 1961, 1962, 1963, 1964, 1965, 1963, 1965, 1966, 1967, 1968, 1969,
    1967, 1969, 1970, 1967, 1970, 1971, 1972, 1973, 1974, 1972, 1974, 1975,
    1976, 1977, 1978, 1976, 1978, 1979, 1980, 1981, 1982, 1980, 1982, 1983,
    1984, 1985, 1986, 1984, 1986, 1987, 1988, 1989, 1990, 1988, 1990, 1991,
    1992, 1993, 1994, 1992, 1994, 1995, 1996, 1997, 1998, 1996, 1998, 1999,
    2000, 2001, 2002, 2000, 2002, 2003, 2004, 2005, 2006, 2004, 2006, 2007,
    2008, 2009, 2010, 2008, 2010, 2011, 2012, 2013, 2014, 2012, 2014, 2015,
    2016, 2017, 2018, 2016, 2018, 2019, 2020, 2021, 2022, 2020, 2022, 2023,
    2024, 2025, 2026, 2024, 2026, 2027, 2028, 2029, 2030, 2028, 2030, 2031,
    2032, 2033, 2034, 2032, 2034, 2035, 2033, 1911, 1914, 2033, 1914, 2034,
    2036, 2037, 2038, 2036, 2038, 2039, 2040, 2041, 2042, 2040, 2042, 2043,
    2044, 2045, 2046, 2044, 2046, 2047, 2045, 1891, 1894, 2045, 1894, 2046,
    2048, 2049, 2050, 2048, 2050, 2051, 2049, 1879, 1882, 2049, 1882, 2050,
    2052, 2053, 2054, 2052, 2054, 2055, 2056, 2057, 2058, 2056, 2058, 2059,
    2060, 2061, 2062, 2060, 2062, 2063, 2061, 1863, 1866, 2061, 1866, 2062,
    2064, 2065, 2066, 2064, 2066, 2067, 2065, 1859, 1862, 2065, 1862, 2066,
    2068, 2069, 2070, 2068, 2070, 2071, 2069, 1855, 1858, 2069, 1858, 2070,
    2072, 2073, 2074, 2072, 2074, 2075, 2076, 2077, 2078, 2076, 2078, 2079,
    2080, 2081, 2082, 2080, 2082, 2083, 2081, 1839, 1842, 2081, 1842, 2082,
    2084, 2085, 2086, 2084, 2086, 2087, 2085, 1835, 1838, 2085, 1838, 2086,
    1794, 1793, 2088, 1794, 2088, 2089, 1791, 2090, 2091, 1791, 2091, 1792,
    2092, 2093, 2094, 2092, 2094, 2095, 2093, 1831, 1834, 2093, 1834, 2094,
    2096, 2097, 2098, 2096, 2098, 2099, 2097, 1827, 1830, 2097, 1830, 2098,
    2100, 2101, 2102, 2100, 2102, 2103, 2101, 1811, 1814, 2101, 1814, 2102,
    2104, 2105, 2106, 2104, 2106, 2107, 2105, 1807, 1810, 2105, 1810, 2106,
    2108, 2109, 2110, 2108, 2110, 2111, 2109, 1783, 1786, 2109, 1786, 2110,
    2112, 2113, 2114, 2112, 2114, 2115, 2113, 1767, 1770, 2113, 1770, 2114,
    2116, 2117, 2118, 2116, 2118, 2119, 2117, 1763, 1766, 2117, 1766, 2118,
    2120, 2121, 2122, 2120, 2122, 2123, 2121, 1759, 1762, 2121, 1762, 2122,
    1798, 1797, 2124, 1798, 2124, 2125, 1795, 2126, 2127, 1795, 2127, 1796,
    2128, 2129, 2130, 2128, 2130, 2131, 2129, 1719, 1722, 2129, 1722, 2130,
    2132, 2133, 2134, 2132, 2134, 2135, 2133, 1707, 1710, 2133, 1710, 2134,
    2136, 2137, 2138, 2136, 2138, 2139, 2139, 2138, 1684, 2139, 1684, 1683,
    2140, 2141, 2142, 2140, 2142, 2143, 2144, 2145, 2146, 2144, 2146, 2147,
    2148, 2149, 2150, 2148, 2150, 2151, 2152, 2153, 2154, 2152, 2154, 2155,
    2156, 2157, 2158, 2156, 2158, 2159, 2160, 2161, 2162, 2160, 2162, 2163,
    2164, 2165, 2166, 2164, 2166, 2167, 2168, 2169, 2170, 2168, 2170, 2171,
    2172, 2173, 2174, 2172, 2174, 2175, 2176, 2177, 2178, 2176, 2178, 2179,
    2180, 2181, 2182, 2180, 2182, 2183, 2184, 2185, 2186, 2184, 2186, 2187,
    2188, 2189, 2190, 2188, 2190, 2191, 2192, 2193, 2194, 2192, 2194, 2195,
    2196, 2197, 2198, 2196, 2198, 2199, 2200, 2201, 2202, 2200, 2202, 2203,
    2204, 2205, 2206, 2204, 2206, 2207, 2204, 2207, 2208, 2209, 2210, 2211,
    2209, 2211, 2212, 2213, 2214, 2215, 2213, 2215, 2216, 2217, 2218, 2219,
    2217, 2219, 2220, 2221, 2222, 2223, 2221, 2223, 2224, 2225, 2226, 2227,
    2225, 2227, 2228, 2229, 2230, 2231, 2229, 2231, 2232, 2233, 2234, 2235,
    2233, 2235, 2236, 2237, 2238, 2239, 2237, 2239, 2240, 2241, 2242, 2243,
    2241, 2243, 2244, 2245, 2246, 2247, 2245, 2247, 2248, 2249, 2250, 2251,
    2249, 2251, 2252, 2253, 2254, 2255, 2253, 2255, 2256, 2257, 2258, 2259,
    2257, 2259, 2260, 2261, 2262, 2263, 2261, 2263, 2264, 2265, 2266, 2267,
    2265, 2267, 2268, 2269, 2270, 2271, 2269, 2271, 2272, 2273, 2274, 2275,
    2273, 2275, 2276, 2277, 2278, 2279, 2277, 2279, 2280, 2281, 2282, 2283,
    2281, 2283, 2284, 2285, 2286, 2287, 2285, 2287, 2288, 2289, 2290, 2246,
    2289, 2246, 2245, 2291, 2292, 2293, 2291, 2293, 2294, 2295, 2296, 2297,
    2295, 2297, 2298, 2299, 2300, 2301, 2299, 2301, 2302, 2303, 2304, 2305,
    2303, 2305, 2306, 2307, 2308, 2309, 2307, 2309, 2310, 2311, 2312, 2313,
    2311, 2313, 2314, 2315, 2316, 2317, 2315, 2317, 2318, 2319, 2320, 2321,
    2319, 2321, 2322, 2323, 2324, 2325, 2323, 2325, 2326, 2327, 2328, 2329,
    2327, 2329, 2330, 2331, 2332, 2333, 2331, 2333, 2334, 2335, 2336, 2337,
    2335, 2337, 2338, 2339, 2340, 2341, 2339, 2341, 2342, 2343, 2344, 2345,
    2343, 2345, 2346, 2347, 2348, 2349, 2347, 2349, 2350, 2351, 2352, 2353,
    2351, 2353, 2354, 2355, 2356, 2357, 2355, 2357, 2358, 2359, 2360, 2361,
    2359, 2361, 2362, 2363, 2364, 2365, 2363, 2365, 2366, 2367, 2368, 2369,
    2367, 2369, 2370, 2371, 2372, 2373, 2371, 2373, 2374, 2375, 2376, 2377,
    2375, 2377, 2378, 2379, 2380, 2381, 2379, 2381, 2382, 2383, 2384, 2385,
    2383, 2385, 2386, 2387, 2388, 2389, 2387, 2389, 2390, 2391, 2392, 2393,
    2391, 2393, 2394, 2395, 2396, 2397, 2395, 2397, 2398, 2399, 2400, 2401,
    2399, 2401, 2402, 2403, 2404, 2405, 2403, 2405, 2406, 2407, 2408, 2409,
    2407, 2409, 2410, 2411, 2412, 2413, 2411, 2413, 2414, 2415, 2416, 2417,
    2415, 2417, 2418, 2419, 2420, 2421, 2419, 2421, 2422, 2053, 2423, 2424,
    2053, 2424, 2054, 2425, 2426, 2427, 2425, 2427, 2428, 2429, 2430, 2431,
    2429, 2431, 2432, 2433, 2434, 2435, 2433, 2435, 2436, 2437, 2438, 2439,
    2437, 2439, 2440, 2441, 2442, 2443, 2441, 2443, 2444, 2445, 2446, 2447,
    2445, 2447, 2448, 2449, 2450, 2451, 2449, 2451, 2452, 2453, 2454, 2455,
    2453, 2455, 2456, 2457, 2458, 2459, 2457, 2459, 2460, 2461, 2462, 2463,
    2461, 2463, 2464, 2465, 2466, 2467, 2465, 2467, 2468, 2469, 2470, 2471,
    2469, 2471, 2472, 2473, 2474, 2475, 2473, 2475, 2476, 2477, 2478, 2479,
    2477, 2479, 2480, 2481, 2482, 2483, 2481, 2483, 2484, 2485, 2486, 2487,
    2485, 2487, 2488, 2489, 2490, 2491, 2489, 2491, 2492, 2493, 2494, 2495,
    2493, 2495, 2496, 2497, 2498, 2499, 2497, 2499, 2500, 2501, 2502, 2503,
    2501, 2503, 2504, 2505, 2506, 2507, 2505, 2507, 2508, 2509, 2510, 2511,
    2509, 2511, 2512, 2513, 2514, 2515, 2513, 2515, 2516, 2517, 2518, 2519,
    2517, 2519, 2520, 2521, 2522, 2523, 2521, 2523, 2524, 2525, 2526, 2527,
    2525, 2527, 2528, 2529, 2530, 2531, 2529, 2531, 2532, 2533, 2534, 2535,
    2533, 2535, 2536, 2537, 2538, 2539, 2537, 2539, 2540, 2541, 2542, 2543,
    2541, 2543, 2544, 2545, 2546, 2547, 2545, 2547, 2548, 2549, 2550, 2551,
    2549, 2551, 2552, 2553, 2554, 2555, 2553, 2555, 2556, 2557, 2558, 2559,
    2557, 2559, 2560, 2561, 2562, 2563, 2561, 2563, 2564, 2565, 2566, 2567,
    2565, 2567, 2568, 2569, 2570, 2571, 2569, 2571, 2572, 2573, 2574, 2575,
    2573, 2575, 2576, 2577, 2578, 2579, 2577, 2579, 2580, 2581, 2582, 2583,
    2581, 2583, 2584, 2585, 2586, 2587, 2585, 2587, 2588, 2589, 2590, 2591,
    2589, 2591, 2592, 2593, 2594, 2595, 2593, 2595, 2596, 2597, 2598, 2599,
    2597, 2599, 2600, 2601, 2602, 2603, 2601, 2603, 2604, 2605, 2606, 2607,
    2605, 2607, 2608, 2609, 2610, 2611, 2609, 2611, 2612, 2613, 2614, 2615,
    2613, 2615, 2616, 2617, 2618, 2619, 2617, 2619, 2620, 2486, 2621, 2622,
    2486, 2622, 2487, 2623, 2624, 2625, 2623, 2625, 2626, 2618, 2627, 2628,
    2618, 2628, 2619, 2057, 2419, 2422, 2057, 2422, 2058, 2629, 2630, 2631,
    2629, 2631, 2632, 2423, 2633, 2634, 2423, 2634, 2424, 2635, 2636, 2637,
    2635, 2637, 2638, 2639, 2640, 2641, 2639, 2641, 2642, 2643, 2644, 2645,
    2643, 2645, 2646, 2647, 2648, 2649, 2647, 2649, 2650, 2651, 2652, 2653,
    2651, 2653, 2654, 2655, 2656, 2657, 2655, 2657, 2658, 2659, 2660, 2661,
    2659, 2661, 2662, 2663, 2664, 2665, 2663, 2665, 2666, 2667, 2668, 2669,
    2667, 2669, 2670, 2671, 2617, 2620, 2671, 2620, 2672, 2610, 2663, 2666,
    2610, 2666, 2611, 2058, 2422, 2673, 2058, 2673, 2674, 2055, 2054, 2675,
    2055, 2675, 2676, 2677, 2678, 2679, 2677, 2679, 2680, 2422, 2421, 2681,
    2422, 2681, 2673, 2424, 2634, 2682, 2424, 2682, 2683, 2684, 2685, 2686,
    2684, 2686, 2687, 2688, 2689, 2690, 2688, 2690, 2691, 2054, 2424, 2683,
    2054, 2683, 2675, 2692, 2693, 2694, 2692, 2694, 2695, 2059, 2058, 2674,
    2059, 2674, 2696, 2697, 2698, 2699, 2697, 2699, 2700, 2701, 2702, 2703,
    2701, 2703, 2704, 2705, 2706, 2707, 2705, 2707, 2708, 2709, 2710, 2711,
    2709, 2711, 2712, 2713, 2714, 2715, 2713, 2715, 2716, 2717, 2701, 2704,
    2717, 2704, 2718, 2719, 2720, 2721, 2719, 2721, 2722, 2723, 2724, 2725,
    2723, 2725, 2726, 2727, 2728, 2729, 2727, 2729, 2730, 2731, 2732, 2733,
    2731, 2733, 2734, 2735, 2736, 2737, 2735, 2737, 2738, 2739, 2740, 2741,
    2739, 2741, 2742, 2743, 2744, 2745, 2743, 2745, 2746, 2747, 2748, 2749,
    2747, 2749, 2750, 2751, 2752, 2753, 2751, 2753, 2754, 2755, 2756, 2757,
    2755, 2757, 2758, 2759, 2760, 2761, 2759, 2761, 2762, 2763, 2764, 2765,
    2763, 2765, 2766, 2767, 2697, 2700, 2767, 2700, 2768, 2769, 2770, 2771,
    2769, 2771, 2772, 2773, 2774, 2775, 2773, 2775, 2776, 2777, 2778, 2779,
    2777, 2779, 2780, 2780, 2779, 2774, 2780, 2774, 2773, 2777, 2780, 2781,
    2777, 2781, 2782, 2773, 2776, 2783, 2773, 2783, 2784, 2785, 2786, 2787,
    2785, 2787, 2788, 2789, 2784, 2783, 2789, 2783, 2790, 2791, 2792, 2793,
    2791, 2793, 2794, 2795, 2796, 2797, 2795, 2797, 2798, 2799, 2800, 2801,
    2799, 2801, 2802, 2803, 2804, 2805, 2803, 2805, 2806, 2807, 2808, 2809,
    2807, 2809, 2810, 2811, 2812, 2813, 2811, 2813, 2814, 2815, 2816, 2817,
    2815, 2817, 2818, 2819, 2820, 2821, 2819, 2821, 2822, 2823, 2824, 2825,
    2823, 2825, 2826, 2827, 2828, 2829, 2827, 2829, 2830, 2831, 2832, 2833,
    2831, 2833, 2834, 2835, 2836, 2837, 2835, 2837, 2838, 2839, 2840, 2841,
    2839, 2841, 2842, 2780, 2773, 2784, 2780, 2784, 2781, 2843, 2844, 2845,
    2843, 2845, 2846, 2847, 2848, 2849, 2847, 2849, 2850, 2851, 2852, 2853,
    2851, 2853, 2854, 2855, 2856, 2857, 2855, 2857, 2858, 2859, 2860, 2861,
    2859, 2861, 2862, 2863, 2864, 2865, 2863, 2865, 2866, 2867, 2868, 2869,
    2867, 2869, 2870, 2871, 2872, 2873, 2871, 2873, 2874, 2875, 2876, 2877,
    2875, 2877, 2878, 2879, 2880, 2881, 2879, 2881, 2882, 2883, 2884, 2885,
    2883, 2885, 2886, 2887, 2888, 2889, 2887, 2889, 2890, 2891, 2892, 2893,
    2891, 2893, 2894, 2895, 2896, 2897, 2895, 2897, 2898, 2877, 2852, 2851,
    2877, 2851, 2878, 2872, 2899, 2900, 2872, 2900, 2873, 2901, 2902, 2903,
    2901, 2903, 2904, 2848, 2905, 2906, 2848, 2906, 2849, 2907, 2908, 2909,
    2907, 2909, 2910, 2911, 2912, 2913, 2911, 2913, 2914, 2417, 2416, 2915,
    2417, 2915, 2916, 2917, 2918, 2919, 2917, 2919, 2920, 2921, 2922, 2923,
    2921, 2923, 2924, 2925, 2926, 2927, 2925, 2927, 2928, 2929, 2930, 2931,
    2929, 2931, 2932, 2933, 2934, 2935, 2933, 2935, 2936, 2937, 2938, 2939,
    2937, 2939, 2940, 2941, 2942, 2943, 2941, 2943, 2944, 2945, 2946, 2947,
    2945, 2947, 2948, 2949, 2950, 2951, 2949, 2951, 2952, 2953, 2954, 2955,
    2953, 2955, 2956, 2957, 2958, 2959, 2957, 2959, 2960, 2961, 2962, 2963,
    2961, 2963, 2964, 2965, 2966, 2967, 2965, 2967, 2968, 2969, 2970, 2971,
    2969, 2971, 2972, 2973, 2974, 2975, 2973, 2975, 2976, 2977, 2978, 2979,
    2977, 2979, 2980, 2981, 2982, 2983, 2981, 2983, 2984, 2985, 2986, 2987,
    2985, 2987, 2988, 2989, 2990, 2991, 2989, 2991, 2992, 2993, 2994, 2995,
    2993, 2995, 2996, 2997, 2998, 2999, 2997, 2999, 3000, 3001, 3002, 3003,
    3001, 3003, 3004, 3005, 3006, 3007, 3005, 3007, 3008, 3009, 3010, 3011,
    3009, 3011, 3012, 3013, 3014, 3015, 3013, 3015, 3016, 3017, 3018, 3019,
    3017, 3019, 3020, 3021, 3022, 3023, 3021, 3023, 3024, 3025, 3026, 3027,
    3025, 3027, 3028, 3029, 3030, 3031, 3029, 3031, 3032, 3033, 3034, 3035,
    3033, 3035, 3036, 3037, 3038, 3039, 3037, 3039, 3040, 3041, 3042, 3043,
    3041, 3043, 3044, 3045, 3046, 3047, 3045, 3047, 3048, 3049, 3050, 3051,
    3049, 3051, 3052, 3053, 2782, 2781, 3053, 2781, 3054, 3054, 2781, 2784,
    3054, 2784, 2789, 3055, 3056, 3057, 3055, 3057, 3058, 3059, 3060, 3061,
    3059, 3061, 3062, 3063, 3064, 3065, 3063, 3065, 3066, 3067, 3068, 3069,
    3067, 3069, 3070, 3071, 3072, 3064, 3071, 3064, 3063, 3073, 3074, 3075,
    3073, 3075, 3076, 3077, 3078, 3079, 3077, 3079, 3080, 3081, 3082, 3083,
    3081, 3083, 3084, 3085, 3086, 3087, 3085, 3087, 3088, 3089, 3090, 3091,
    3089, 3091, 3092, 3093, 3094, 3095, 3093, 3095, 3096, 3097, 3098, 3099,
    3097, 3099, 3100, 3101, 3102, 3103, 3101, 3103, 3104, 3105, 3106, 3107,
    3105, 3107, 3108, 3109, 3110, 3111, 3109, 3111, 3112, 3113, 3114, 3115,
    3113, 3115, 3116, 3117, 3118, 3119, 3117, 3119, 3120, 3121, 3122, 3123,
    3121, 3123, 3124, 3125, 3126, 3127, 3125, 3127, 3128, 3129, 3130, 3131,
    3129, 3131, 3132, 3133, 3134, 3135, 3133, 3135, 3136, 3137, 3138, 3139,
    3137, 3139, 3140, 3141, 3142, 3143, 3141, 3143, 3144, 3145, 3146, 3147,
    3145, 3147, 3148, 3149, 3150, 3151, 3149, 3151, 3152, 3153, 3154, 3155,
    3153, 3155, 3156, 3157, 3158, 3159, 3157, 3159, 3160, 2903, 2884, 2883,
    2903, 2883, 2904, 3161, 3162, 3163, 3161, 3163, 3164, 3165, 3166, 3167,
    3165, 3167, 3168, 3169, 3170, 3171, 3169, 3171, 3172, 3173, 3174, 3175,
    3173, 3175, 3176, 3177, 3178, 3179, 3177, 3179, 3180, 3181, 3182, 3183,
    3181, 3183, 3184, 3185, 3186, 3187, 3185, 3187, 3188, 3189, 3190, 3191,
    3189, 3191, 3192, 3193, 3194, 3195, 3193, 3195, 3196, 3197, 3198, 3199,
    3197, 3199, 3200, 3201, 3202, 3203, 3201, 3203, 3204, 3205, 3206, 1733,
    3205, 1733, 1732, 3207, 3208, 3209, 3207, 3209, 3210, 3211, 3212, 3213,
    3211, 3213, 3214, 3215, 3216, 3217, 3215, 3217, 3218, 3219, 3220, 3221,
    3219, 3221, 3222, 3223, 3224, 3225, 3223, 3225, 3226, 3227, 3228, 3178,
    3227, 3178, 3177, 3229, 3230, 3231, 3229, 3231, 3232, 3233, 3234, 3235,
    3233, 3235, 3236, 3237, 3238, 3239, 3237, 3239, 3240, 3241, 3242, 3243,
    3241, 3243, 3244, 3245, 3246, 3247, 3245, 3247, 3248, 3249, 3250, 3251,
    3249, 3251, 3252, 3253, 3254, 3255, 3253, 3255, 3256, 3257, 3258, 3259,
    3257, 3259, 3260, 3261, 3262, 3263, 3261, 3263, 3264, 3265, 3266, 3267,
    3265, 3267, 3268, 3269, 3270, 3271, 3269, 3271, 3272, 3273, 3274, 3275,
    3273, 3275, 3276, 3277, 3278, 3279, 3277, 3279, 3280, 3281, 3282, 3283,
    3281, 3283, 3284, 3285, 3286, 3287, 3285, 3287, 3288, 3289, 3290, 3291,
    3289, 3291, 3292, 3293, 3294, 3295, 3293, 3295, 3296, 3297, 3298, 3299,
    3297, 3299, 3300, 3301, 3302, 3303, 3301, 3303, 3304, 3305, 3306, 3307,
    3305, 3307, 3308, 1802, 1801, 3309, 1802, 3309, 3310, 3311, 3312, 3313,
    3311, 3313, 3314, 3315, 3316, 3317, 3315, 3317, 3318, 3319, 3320, 3321,
    3319, 3321, 3322, 3323, 3324, 3325, 3323, 3325, 3326, 3327, 3328, 3329,
    3327, 3329, 3330, 3331, 3332, 3333, 3331, 3333, 3334, 3335, 3336, 3337,
    3335, 3337, 3338, 3339, 3340, 3341, 3339, 3341, 3342, 3343, 3344, 3345,
    3343, 3345, 3346, 3347, 3348, 3349, 3347, 3349, 3350, 3351, 3352, 3353,
    3351, 3353, 3354, 3355, 3356, 3357, 3355, 3357, 3358, 3359, 3360, 3361,
    3359, 3361, 3362, 3363, 3364, 3365, 3363, 3365, 3366, 3367, 3368, 3369,
    3367, 3369, 3370, 3371, 3372, 3373, 3371, 3373, 3374, 3375, 3376, 3377,
    3375, 3377, 3378, 3379, 3380, 3381, 3379, 3381, 3382, 3383, 3384, 3385,
    3383, 3385, 3386, 3387, 3388, 3389, 3387, 3389, 3390, 3391, 3392, 3393,
    3391, 3393, 3394, 3395, 3396, 3397, 3395, 3397, 3398, 3399, 3400, 3401,
    3399, 3401, 3402, 3403, 3404, 3405, 3403, 3405, 3406, 3407, 3408, 3409,
    3407, 3409, 3410, 3411, 3412, 3413, 3411, 3413, 3414, 3415, 3416, 3417,
    3415, 3417, 3418, 3419, 3420, 3421, 3419, 3421, 3422, 3423, 3424, 3425,
    3423, 3425, 3426, 3427, 3428, 3429, 3427, 3429, 3430, 3431, 3432, 3433,
    3431, 3433, 3434, 3435, 3436, 3437, 3435, 3437, 3438, 3439, 3440, 3441,
    3439, 3441, 3442, 3443, 3444, 3445, 3443, 3445, 3446, 3447, 3448, 3449,
    3447, 3449, 3450, 3451, 3452, 3453, 3451, 3453, 3454, 3455, 3456, 3457,
    3455, 3457, 3458, 3459, 3460, 3461, 3459, 3461, 3462, 3463, 3464, 3465,
    3463, 3465, 3466, 3467, 3468, 3469, 3467, 3469, 3470, 3471, 3472, 3473,
    3471, 3473, 3474, 3475, 3476, 3477, 3475, 3477, 3478, 3479, 3480, 3481,
    3479, 3481, 3482, 3483, 3484, 3485, 3483, 3485, 3486, 3487, 3488, 3489,
    3487, 3489, 3490, 3491, 3492, 3493, 3491, 3493, 3494, 3495, 3496, 3497,
    3495, 3497, 3498, 3499, 3500, 3501, 3499, 3501, 3502, 3503, 3504, 3505,
    3503, 3505, 3506, 3507, 3508, 3509, 3507, 3509, 3510, 3511, 3512, 3513,
    3511, 3513, 3514, 3515, 3516, 3517, 3515, 3517, 3518, 3515, 3518, 3519,
    3520, 3521, 3522, 3520, 3522, 3523, 3524, 3525, 3526, 3524, 3526, 3527,
    3528, 3529, 3530, 3528, 3530, 3531, 3532, 3533, 3534, 3532, 3534, 3535,
    3536, 3537, 3538, 3536, 3538, 3539, 3540, 3541, 3542, 3540, 3542, 3543,
    3544, 3545, 3546, 3544, 3546, 3547, 3548, 3549, 3550, 3548, 3550, 3551,
    3552, 3553, 3554, 3552, 3554, 3555, 3556, 3557, 3558, 3556, 3558, 3559,
    3560, 3561, 3562, 3560, 3562, 3563, 3564, 3565, 3566, 3564, 3566, 3567,
    3568, 3569, 3570, 3568, 3570, 3571, 3572, 3573, 3574, 3572, 3574, 3575,
    3575, 3574, 3472, 3575, 3472, 3471, 3576, 3577, 3578, 3576, 3578, 3579,
    3580, 3581, 3582, 3580, 3582, 3583, 3584, 3585, 3586, 3584, 3586, 3587,
    3587, 3586, 3460, 3587, 3460, 3459, 3588, 3589, 3590, 3588, 3590, 3591,
    3591, 3590, 3452, 3591, 3452, 3451, 3592, 3593, 3594, 3592, 3594, 3595,
    3596, 3597, 3598, 3596, 3598, 3599, 3600, 3601, 3602, 3600, 3602, 3603,
    3603, 3602, 3436, 3603, 3436, 3435, 3604, 3605, 3606, 3604, 3606, 3607,
    3607, 3606, 3432, 3607, 3432, 3431, 3608, 3609, 3610, 3608, 3610, 3611,
    3611, 3610, 3428, 3611, 3428, 3427, 3612, 3613, 3614, 3612, 3614, 3615,
    3616, 3617, 3618, 3616, 3618, 3619, 3620, 3621, 3622, 3620, 3622, 3623,
    3623, 3622, 3412, 3623, 3412, 3411, 3624, 3625, 3626, 3624, 3626, 3627,
    3627, 3626, 3408, 3627, 3408, 3407, 3628, 3368, 3367, 3628, 3367, 3629,
    3370, 3369, 3630, 3370, 3630, 3631, 3632, 3633, 3634, 3632, 3634, 3635,
    3635, 3634, 3404, 3635, 3404, 3403, 3636, 3637, 3638, 3636, 3638, 3639,
    3639, 3638, 3400, 3639, 3400, 3399, 3640, 3641, 3642, 3640, 3642, 3643,
    3643, 3642, 3384, 3643, 3384, 3383, 3644, 3645, 3646, 3644, 3646, 3647,
    3647, 3646, 3380, 3647, 3380, 3379, 3648, 3649, 3650, 3648, 3650, 3651,
    3651, 3650, 3360, 3651, 3360, 3359, 3652, 3653, 3654, 3652, 3654, 3655,
    3655, 3654, 3344, 3655, 3344, 3343, 3656, 3657, 3658, 3656, 3658, 3659,
    3659, 3658, 3340, 3659, 3340, 3339, 3660, 3661, 3662, 3660, 3662, 3663,
    3663, 3662, 3336, 3663, 3336, 3335, 3664, 3665, 3666, 3664, 3666, 3667,
    3374, 3373, 3668, 3374, 3668, 3669, 3670, 3671, 3672, 3670, 3672, 3673,
    3673, 3672, 3302, 3673, 3302, 3301, 3674, 3675, 3676, 3674, 3676, 3677,
    3677, 3676, 3290, 3677, 3290, 3289, 3678, 3679, 3680, 3678, 3680, 3681,
    3679, 3281, 3284, 3679, 3284, 3680, 3682, 3683, 3684, 3682, 3684, 3685,
    3686, 3687, 3688, 3686, 3688, 3689, 3690, 3691, 3692, 3690, 3692, 3693,
    3694, 3695, 3696, 3694, 3696, 3697, 3698, 3699, 3700, 3698, 3700, 3701,
    3702, 3703, 3704, 3702, 3704, 3705, 3706, 3707, 3708, 3706, 3708, 3709,
    3710, 3711, 3712, 3710, 3712, 3713, 3714, 3715, 3716, 3714, 3716, 3717,
    3718, 3719, 3720, 3718, 3720, 3721, 3722, 3723, 3724, 3722, 3724, 3725,
    3726, 3727, 3728, 3726, 3728, 3729, 3730, 3731, 3732, 3730, 3732, 3733,
    3734, 3735, 3736, 3734, 3736, 3737, 3738, 3739, 3740, 3738, 3740, 3741,
    3742, 3743, 3744, 3742, 3744, 3745, 3746, 3747, 3748, 3746, 3748, 3749,
    3746, 3749, 3750, 3751, 3752, 3753, 3751, 3753, 3754, 3755, 3756, 3757,
    3755, 3757, 3758, 3759, 3760, 3761, 3759, 3761, 3762, 3763, 3764, 3765,
    3763, 3765, 3766, 3767, 3768, 3769, 3767, 3769, 3770, 3771, 3772, 3773,
    3771, 3773, 3774, 3775, 3776, 3777, 3775, 3777, 3778, 3779, 3780, 3781,
    3779, 3781, 3782, 3783, 3784, 3785, 3783, 3785, 3786, 3787, 3788, 3789,
    3787, 3789, 3790, 3791, 3792, 3793, 3791, 3793, 3794, 3795, 3796, 3797,
    3795, 3797, 3798, 3799, 3800, 3801, 3799, 3801, 3802, 3803, 3804, 3805,
    3803, 3805, 3806, 3807, 3808, 3809, 3807, 3809, 3810, 3811, 3812, 3813,
    3811, 3813, 3814, 3815, 3816, 3817, 3815, 3817, 3818, 3819, 3820, 3821,
    3819, 3821, 3822, 3823, 3824, 3825, 3823, 3825, 3826, 3827, 3828, 3829,
    3827, 3829, 3830, 3831, 3787, 3790, 3831, 3790, 3832, 3833, 3834, 3835,
    3833, 3835, 3836, 3837, 3838, 3839, 3837, 3839, 3840, 3841, 3842, 3843,
    3841, 3843, 3844, 3845, 3846, 3847, 3845, 3847, 3848, 3849, 3850, 3851,
    3849, 3851, 3852, 3853, 3854, 3855, 3853, 3855, 3856, 3857, 3858, 3859,
    3857, 3859, 3860, 3861, 3862, 3863, 3861, 3863, 3864, 3865, 3866, 3867,
    3865, 3867, 3868, 3869, 3870, 3871, 3869, 3871, 3872, 3873, 3874, 3875,
    3873, 3875, 3876, 3877, 3878, 3879, 3877, 3879, 3880, 3881, 3882, 3883,
    3881, 3883, 3884, 3885, 3886, 3887, 3885, 3887, 3888, 3889, 3890, 3891,
    3889, 3891, 3892, 3893, 3894, 3895, 3893, 3895, 3896, 3897, 3898, 3899,
    3897, 3899, 3900, 3901, 3902, 3903, 3901, 3903, 3904, 3905, 3906, 3907,
    3905, 3907, 3908, 3909, 3910, 3911, 3909, 3911, 3912, 3913, 3914, 3915,
    3913, 3915, 3916, 3917, 3918, 3919, 3917, 3919, 3920, 3921, 3922, 3923,
    3921, 3923, 3924, 3925, 3926, 3927, 3925, 3927, 3928, 3929, 3930, 3931,
    3929, 3931, 3932, 3933, 3934, 3935, 3933, 3935, 3936, 3937, 3938, 3939,
    3937, 3939, 3940, 3941, 3942, 3943, 3941, 3943, 3944, 3945, 3946, 3947,
    3945, 3947, 3948, 3949, 3950, 3951, 3949, 3951, 3952, 3953, 3954, 3955,
    3953, 3955, 3956, 3957, 3958, 3959, 3957, 3959, 3960, 3961, 3962, 3963,
    3961, 3963, 3964, 3595, 3594, 3965, 3595, 3965, 3966, 3967, 3968, 3969,
    3967, 3969, 3970, 3971, 3972, 3973, 3971, 3973, 3974, 3975, 3976, 3977,
    3975, 3977, 3978, 3979, 3980, 3981, 3979, 3981, 3982, 3983, 3984, 3985,
    3983, 3985, 3986, 3987, 3988, 3989, 3987, 3989, 3990, 3991, 3992, 3993,
    3991, 3993, 3994, 3995, 3996, 3997, 3995, 3997, 3998, 3999, 4000, 4001,
    3999, 4001, 4002, 4003, 4004, 4005, 4003, 4005, 4006, 4007, 4008, 4009,
    4007, 4009, 4010, 4011, 4012, 4013, 4011, 4013, 4014, 4015, 4016, 4017,
    4015, 4017, 4018, 4019, 4020, 4021, 4019, 4021, 4022, 4023, 4024, 4025,
    4023, 4025, 4026, 4027, 4028, 4029, 4027, 4029, 4030, 4031, 4032, 4033,
    4031, 4033, 4034, 4035, 4036, 4037, 4035, 4037, 4038, 4039, 4040, 4041,
    4039, 4041, 4042, 4043, 4044, 4045, 4043, 4045, 4046, 4047, 4048, 4049,
    4047, 4049, 4050, 4051, 4052, 4053, 4051, 4053, 4054, 4055, 4056, 4057,
    4055, 4057, 4058, 4059, 4060, 4061, 4059, 4061, 4062, 4063, 4064, 4065,
    4063, 4065, 4066, 4067, 4068, 4069, 4067, 4069, 4070, 4071, 4072, 4073,
    4071, 4073, 4074, 4075, 4076, 4077, 4075, 4077, 4078, 4079, 4080, 4081,
    4079, 4081, 4082, 4083, 4084, 4085, 4083, 4085, 4086, 4087, 4088, 4089,
    4087, 4089, 4090, 4091, 4092, 4093, 4091, 4093, 4094, 4095, 4096, 4097,
    4095, 4097, 4098, 4099, 4100, 4101, 4099, 4101, 4102, 4103, 4104, 4105,
    4103, 4105, 4106, 4107, 4108, 4109, 4107, 4109, 4110, 4111, 4112, 4113,
    4111, 4113, 4114, 4115, 4116, 4117, 4115, 4117, 4118, 4119, 4120, 4121,
    4119, 4121, 4122, 4123, 4124, 4125, 4123, 4125, 4126, 4127, 4128, 4129,
    4127, 4129, 4130, 4131, 4132, 4133, 4131, 4133, 4134, 4135, 4136, 4137,
    4135, 4137, 4138, 4139, 4140, 4141, 4139, 4141, 4142, 4143, 4144, 4145,
    4143, 4145, 4146, 4147, 4148, 4149, 4147, 4149, 4150, 4151, 4023, 4026,
    4151, 4026, 4152, 4153, 4154, 4155, 4153, 4155, 4156, 4150, 4149, 4157,
    4150, 4157, 4158, 3599, 3598, 3962, 3599, 3962, 3961, 4159, 4160, 4161,
    4159, 4161, 4162, 3966, 3965, 4163, 3966, 4163, 4164, 4165, 4166, 4167,
    4165, 4167, 4168, 4169, 4170, 4171, 4169, 4171, 4172, 4173, 4174, 4175,
    4173, 4175, 4176, 4177, 4178, 4179, 4177, 4179, 4180, 4181, 4182, 4183,
    4181, 4183, 4184, 4185, 4186, 4187, 4185, 4187, 4188, 4189, 4190, 4191,
    4189, 4191, 4192, 4193, 4194, 4195, 4193, 4195, 4196, 4197, 4198, 4199,
    4197, 4199, 4200, 4201, 4202, 4148, 4201, 4148, 4147, 4142, 4141, 4194,
    4142, 4194, 4193, 3598, 4203, 4204, 3598, 4204, 3962, 3593, 4205, 4206,
    3593, 4206, 3594, 4207, 4208, 4209, 4207, 4209, 4210, 3962, 4204, 4211,
    3962, 4211, 3963, 3965, 4212, 4213, 3965, 4213, 4163, 4214, 4215, 4216,
    4214, 4216, 4217, 4218, 4219, 4220, 4218, 4220, 4221, 3594, 4206, 4212,
    3594, 4212, 3965, 4222, 4223, 4224, 4222, 4224, 4225, 3597, 4226, 4203,
    3597, 4203, 3598, 4227, 4228, 4229, 4227, 4229, 4230, 4231, 4232, 4233,
    4231, 4233, 4234, 4235, 4236, 4237, 4235, 4237, 4238, 4239, 4240, 4241,
    4239, 4241, 4242, 4243, 4244, 4245, 4243, 4245, 4246, 4247, 4248, 4232,
    4247, 4232, 4231, 4249, 4250, 4251, 4249, 4251, 4252, 4253, 4254, 4255,
    4253, 4255, 4256, 4257, 4258, 4259, 4257, 4259, 4260, 4261, 4262, 4263,
    4261, 4263, 4264, 4265, 4266, 4267, 4265, 4267, 4268, 4269, 4270, 4271,
    4269, 4271, 4272, 4273, 4274, 4275, 4273, 4275, 4276, 4277, 4278, 4279,
    4277, 4279, 4280, 4281, 4282, 4283, 4281, 4283, 4284, 4285, 4286, 4287,
    4285, 4287, 4288, 4289, 4290, 4291, 4289, 4291, 4292, 4293, 4294, 4295,
    4293, 4295, 4296, 4297, 4298, 4228, 4297, 4228, 4227, 4299, 4300, 4301,
    4299, 4301, 4302, 4303, 4304, 4305, 4303, 4305, 4306, 4307, 4308, 4309,
    4307, 4309, 4310, 4308, 4303, 4306, 4308, 4306, 4309, 4308, 4307, 4311,
    4308, 4311, 4312, 4313, 4304, 4303, 4313, 4303, 4314, 4315, 4316, 4317,
    4315, 4317, 4318, 4319, 4313, 4314, 4319, 4314, 4320, 4321, 4322, 4323,
    4321, 4323, 4324, 4325, 4326, 4327, 4325, 4327, 4328, 4329, 4330, 4331,
    4329, 4331, 4332, 4333, 4334, 4335, 4333, 4335, 4336, 4337, 4338, 4339,
    4337, 4339, 4340, 4341, 4342, 4343, 4341, 4343, 4344, 4345, 4346, 4347,
    4345, 4347, 4348, 4349, 4350, 4351, 4349, 4351, 4352, 4353, 4354, 4355,
    4353, 4355, 4356, 4357, 4358, 4359, 4357, 4359, 4360, 4361, 4362, 4363,
    4361, 4363, 4364, 4365, 4366, 4367, 4365, 4367, 4368, 4369, 4370, 4371,
    4369, 4371, 4372, 4303, 4308, 4312, 4303, 4312, 4314, 4373, 4374, 4375,
    4373, 4375, 4376, 4377, 4378, 4379, 4377, 4379, 4380, 4381, 4382, 4383,
    4381, 4383, 4384, 4385, 4386, 4387, 4385, 4387, 4388, 4389, 4390, 4391,
    4389, 4391, 4392, 4393, 4394, 4395, 4393, 4395, 4396, 4397, 4398, 4399,
    4397, 4399, 4400, 4401, 4402, 4403, 4401, 4403, 4404, 4405, 4406, 4407,
    4405, 4407, 4408, 4409, 4410, 4411, 4409, 4411, 4412, 4413, 4414, 4415,
    4413, 4415, 4416, 4417, 4418, 4419, 4417, 4419, 4420, 4421, 4422, 4423,
    4421, 4423, 4424, 4383, 4382, 4405, 4383, 4405, 4408, 4404, 4403, 4425,
    4404, 4425, 4426, 4427, 4428, 4429, 4427, 4429, 4430, 4380, 4379, 4431,
    4380, 4431, 4432, 4433, 4434, 4435, 4433, 4435, 4436, 4437, 4438, 4439,
    4437, 4439, 4440, 3958, 4441, 4442, 3958, 4442, 3959, 4443, 4444, 4445,
    4443, 4445, 4446, 4447, 4448, 4449, 4447, 4449, 4450, 4451, 4452, 4453,
    4451, 4453, 4454, 4455, 4456, 4457, 4455, 4457, 4458, 4459, 4460, 4461,
    4459, 4461, 4462, 4463, 4464, 4465, 4463, 4465, 4466, 4467, 4468, 4469,
    4467, 4469, 4470, 4471, 4472, 4473, 4471, 4473, 4474, 4475, 4476, 4477,
    4475, 4477, 4478, 4479, 4480, 4481, 4479, 4481, 4482, 4483, 4484, 4485,
    4483, 4485, 4486, 4487, 4488, 4489, 4487, 4489, 4490, 4491, 4492, 4493,
    4491, 4493, 4494, 4495, 4496, 4497, 4495, 4497, 4498, 4499, 4500, 4501,
    4499, 4501, 4502, 4503, 4504, 4505, 4503, 4505, 4506, 4507, 4508, 4509,
    4507, 4509, 4510, 4511, 4512, 4513, 4511, 4513, 4514, 4515, 4516, 4517,
    4515, 4517, 4518, 4519, 4520, 4521, 4519, 4521, 4522, 4523, 4524, 4525,
    4523, 4525, 4526, 4527, 4528, 4529, 4527, 4529, 4530, 4531, 4532, 4533,
    4531, 4533, 4534, 4535, 4536, 4537, 4535, 4537, 4538, 4539, 4540, 4541,
    4539, 4541, 4542, 4543, 4544, 4545, 4543, 4545, 4546, 4547, 4548, 4549,
    4547, 4549, 4550, 4551, 4552, 4553, 4551, 4553, 4554, 4555, 4556, 4557,
    4555, 4557, 4558, 4559, 4560, 4561, 4559, 4561, 4562, 4563, 4564, 4565,
    4563, 4565, 4566, 4567, 4568, 4569, 4567, 4569, 4570, 4571, 4572, 4573,
    4571, 4573, 4574, 4575, 4576, 4577, 4575, 4577, 4578, 4579, 4312, 4311,
    4579, 4311, 4580, 4320, 4314, 4312, 4320, 4312, 4579, 4581, 4582, 4583,
    4581, 4583, 4584, 4585, 4586, 4587, 4585, 4587, 4588, 4589, 4590, 4591,
    4589, 4591, 4592, 4593, 4594, 4595, 4593, 4595, 4596, 4597, 4589, 4592,
    4597, 4592, 4598, 4599, 4600, 4601, 4599, 4601, 4602, 4603, 4604, 4605,
    4603, 4605, 4606, 4607, 4608, 4609, 4607, 4609, 4610, 4611, 4612, 4613,
    4611, 4613, 4614, 4615, 4616, 4617, 4615, 4617, 4618, 4619, 4620, 4621,
    4619, 4621, 4622, 4623, 4624, 4625, 4623, 4625, 4626, 4627, 4628, 4629,
    4627, 4629, 4630, 4631, 4632, 4633, 4631, 4633, 4634, 4635, 4636, 4637,
    4635, 4637, 4638, 4639, 4640, 4641, 4639, 4641, 4642, 4643, 4644, 4645,
    4643, 4645, 4646, 4647, 4648, 4649, 4647, 4649, 4650, 4651, 4652, 4653,
    4651, 4653, 4654, 4655, 4656, 4657, 4655, 4657, 4658, 4659, 4660, 4661,
    4659, 4661, 4662, 4663, 4664, 4665, 4663, 4665, 4666, 4667, 4668, 4669,
    4667, 4669, 4670, 4671, 4672, 4673, 4671, 4673, 4674, 4675, 4676, 4677,
    4675, 4677, 4678, 4679, 4680, 4681, 4679, 4681, 4682, 4683, 4684, 4685,
    4683, 4685, 4686, 4415, 4414, 4427, 4415, 4427, 4430, 4687, 4688, 4689,
    4687, 4689, 4690, 4691, 4692, 4693, 4691, 4693, 4694, 4695, 4696, 4697,
    4695, 4697, 4698, 4699, 4700, 4701, 4699, 4701, 4702, 4703, 4704, 4705,
    4703, 4705, 4706, 4707, 4708, 4709, 4707, 4709, 4710, 4711, 4712, 4713,
    4711, 4713, 4714, 4715, 4716, 4717, 4715, 4717, 4718, 4719, 4720, 4721,
    4719, 4721, 4722, 4723, 4724, 4725, 4723, 4725, 4726, 4727, 4728, 4729,
    4727, 4729, 4730, 4731, 4732, 4733, 4731, 4733, 4734, 4735, 4736, 4737,
    4735, 4737, 4738, 4739, 4740, 4741, 4739, 4741, 4742, 4743, 3372, 3371,
    4743, 3371, 4744, 4745, 4746, 4747, 4745, 4747, 4748, 3309, 4749, 4750,
    3309, 4750, 3310, 4751, 4752, 4753, 4751, 4753, 4754, 4755, 4756, 4757,
    4755, 4757, 4758, 4759, 4760, 4761, 4759, 4761, 4762, 4763, 4764, 4765,
    4763, 4765, 4766, 4767, 4768, 4769, 4767, 4769, 4770, 4771, 4703, 4706,
    4771, 4706, 4772, 4773, 4774, 4775, 4773, 4775, 4776, 4777, 4778, 4779,
    4777, 4779, 4780, 4781, 4782, 4783, 4781, 4783, 4784, 4785, 4786, 4787,
    4785, 4787, 4788, 4789, 4790, 4791, 4789, 4791, 4792, 4793, 4794, 4795,
    4793, 4795, 4796, 4797, 4798, 4799, 4797, 4799, 4800, 4801, 4802, 4803,
    4801, 4803, 4804, 4805, 4806, 4807, 4805, 4807, 4808, 4809, 4810, 4811,
    4809, 4811, 4812, 4813, 4814, 4815, 4813, 4815, 4816, 4817, 4818, 4819,
    4817, 4819, 4820, 4821, 4822, 4823, 4821, 4823, 4824, 4825, 4826, 4827,
    4825, 4827, 4828, 4829, 4830, 4831, 4829, 4831, 4832, 4833, 4834, 4835,
    4833, 4835, 4836, 4837, 4838, 4839, 4837, 4839, 4840, 4841, 4842, 4843,
    4841, 4843, 4844, 4845, 4846, 4847, 4845, 4847, 4848, 4849, 4850, 4851,
    4849, 4851, 4852, 4853, 4854, 4855, 4853, 4855, 4856, 4857, 4858, 4859,
    4857, 4859, 4860, 4861, 4862, 4863, 4861, 4863, 4864, 4861, 4864, 4865,
    4861, 4865, 4866, 4861, 4866, 4867, 4861, 4867, 4868, 4861, 4868, 4869,
    4861, 4869, 4870, 4861, 4870, 4871, 4861, 4871, 4872, 4861, 4872, 4873,
    4861, 4873, 4874, 4861, 4874, 4875, 4861, 4875, 4876, 4861, 4876, 4877,
    4861, 4877, 4878, 4861, 4878, 4879, 4861, 4879, 4880, 4861, 4880, 4881,
    4861, 4881, 4882, 4861, 4882, 4883, 4861, 4883, 4884, 4885, 4886, 4887,
    4885, 4887, 4888, 4885, 4888, 4889, 4885, 4889, 4890, 4885, 4890, 4891,
    4885, 4891, 4892, 4885, 4892, 4893, 4885, 4893, 4894, 4885, 4894, 4895,
    4885, 4895, 4896, 4885, 4896, 4897, 4885, 4897, 4898, 4885, 4898, 4899,
    4885, 4899, 4900, 4885, 4900, 4901, 4885, 4901, 4902, 4885, 4902, 4903,
    4885, 4903, 4904, 4885, 4904, 4905, 4885, 4905, 4906, 4885, 4906, 4907,
    4885, 4907, 4908, 4909, 4910, 4911, 4909, 4911, 4912, 4913, 4914, 4915,
    4913, 4915, 4916, 4917, 4918, 4919, 4917, 4919, 4920, 4921, 1731, 1734,
    4921, 1734, 4922, 4923, 4924, 4925, 4923, 4925, 4926,
  ]),
  normals: new Float32Array([
    -0.62008761, -0.78448433, 0.00869983,
    -0.62008761, -0.78448433, 0.00869983,
    -0.62008761, -0.78448433, 0.00869983,
    -0.62008761, -0.78448433, 0.00869983,
    -0.57642952, -0.81704185, 0.01310067,
    -0.57642952, -0.81704185, 0.01310067,
    -0.57642952, -0.81704185, 0.01310067,
    -0.57642952, -0.81704185, 0.01310067,
    -0.40628907, -0.83837744, 0.36339022,
    -0.40628907, -0.83837744, 0.36339022,
    -0.40628907, -0.83837744, 0.36339022,
    -0.40628907, -0.83837744, 0.36339022,
    -0.47220661, -0.80941133, 0.34910489,
    -0.47220661, -0.80941133, 0.34910489,
    -0.47220661, -0.80941133, 0.34910489,
    -0.47220661, -0.80941133, 0.34910489,
    -0.02880035, -0.51030618, 0.85951041,
    -0.02880035, -0.51030618, 0.85951041,
    -0.02880035, -0.51030618, 0.85951041,
    -0.02880035, -0.51030618, 0.85951041,
    0.03150100, -0.19280611, 0.98073110,
    0.03150100, -0.19280611, 0.98073110,
    0.03150100, -0.19280611, 0.98073110,
    0.03150100, -0.19280611, 0.98073110,
    0.03949899, -0.09519755, 0.99467445,
    0.03949899, -0.09519755, 0.99467445,
    0.03949899, -0.09519755, 0.99467445,
    0.03949899, -0.09519755, 0.99467445,
    0.03949899, -0.09519755, 0.99467445,
    0.03949899, -0.09519755, 0.99467445,
    -0.02870008, -0.41580118, 0.90900258,
    -0.02870008, -0.41580118, 0.90900258,
    -0.02870008, -0.41580118, 0.90900258,
    -0.02870008, -0.41580118, 0.90900258,
    -0.02870008, -0.41580118, 0.90900258,
    -0.00870003, -0.05400016, 0.99850303,
    -0.00870003, -0.05400016, 0.99850303,
    -0.00870003, -0.05400016, 0.99850303,
    -0.00870003, -0.05400016, 0.99850303,
    -0.00870003, -0.05400016, 0.99850303,
    -0.00870003, -0.05400016, 0.99850303,
    -0.02379950, -0.03839919, 0.99897902,
    -0.02379950, -0.03839919, 0.99897902,
    -0.02379950, -0.03839919, 0.99897902,
    -0.02379950, -0.03839919, 0.99897902,
    -0.02379950, -0.03839919, 0.99897902,
    -0.01349972, -0.02929940, 0.99947952,
    -0.01349972, -0.02929940, 0.99947952,
    -0.01349972, -0.02929940, 0.99947952,
    -0.01349972, -0.02929940, 0.99947952,
    -0.01349972, -0.02929940, 0.99947952,
    -0.19540172, -0.37010326, 0.90820799,
    -0.19540172, -0.37010326, 0.90820799,
    -0.19540172, -0.37010326, 0.90820799,
    0.62052260, -0.78412856, 0.00970035,
    0.62052260, -0.78412856, 0.00970035,
    0.62052260, -0.78412856, 0.00970035,
    0.62052260, -0.78412856, 0.00970035,
    0.57642952, -0.81704185, 0.01310067,
    0.57642952, -0.81704185, 0.01310067,
    0.57642952, -0.81704185, 0.01310067,
    0.57642952, -0.81704185, 0.01310067,
    0.40628907, -0.83837744, 0.36339022,
    0.40628907, -0.83837744, 0.36339022,
    0.40628907, -0.83837744, 0.36339022,
    0.40628907, -0.83837744, 0.36339022,
    0.47091627, -0.80972797, 0.35011209,
    0.47091627, -0.80972797, 0.35011209,
    0.47091627, -0.80972797, 0.35011209,
    0.47091627, -0.80972797, 0.35011209,
    0.02880035, -0.51030618, 0.85951041,
    0.02880035, -0.51030618, 0.85951041,
    0.02880035, -0.51030618, 0.85951041,
    0.02880035, -0.51030618, 0.85951041,
    -0.03150100, -0.19280611, 0.98073110,
    -0.03150100, -0.19280611, 0.98073110,
    -0.03150100, -0.19280611, 0.98073110,
    -0.03150100, -0.19280611, 0.98073110,
    -0.04930221, -0.10020450, 0.99374461,
    -0.04930221, -0.10020450, 0.99374461,
    -0.04930221, -0.10020450, 0.99374461,
    -0.04930221, -0.10020450, 0.99374461,
    -0.04930221, -0.10020450, 0.99374461,
    -0.04930221, -0.10020450, 0.99374461,
    0.02750055, -0.42040840, 0.90691813,
    0.02750055, -0.42040840, 0.90691813,
    0.02750055, -0.42040840, 0.90691813,
    0.02750055, -0.42040840, 0.90691813,
    0.02750055, -0.42040840, 0.90691813,
    0.00859989, -0.05429933, 0.99848767,
    0.00859989, -0.05429933, 0.99848767,
    0.00859989, -0.05429933, 0.99848767,
    0.00859989, -0.05429933, 0.99848767,
    0.00859989, -0.05429933, 0.99848767,
    0.00859989, -0.05429933, 0.99848767,
    0.01979903, -0.05199744, 0.99845093,
    0.01979903, -0.05199744, 0.99845093,
    0.01979903, -0.05199744, 0.99845093,
    0.01979903, -0.05199744, 0.99845093,
    0.01979903, -0.05199744, 0.99845093,
    -0.00100003, -0.03920121, 0.99923084,
    -0.00100003, -0.03920121, 0.99923084,
    -0.00100003, -0.03920121, 0.99923084,
    0.18428998, -0.37997934, 0.90645072,
    0.18428998, -0.37997934, 0.90645072,
    0.18428998, -0.37997934, 0.90645072,
    0.18428998, -0.37997934, 0.90645072,
    -0.68449680, -0.72899660, 0.00529998,
    -0.68449680, -0.72899660, 0.00529998,
    -0.68449680, -0.72899660, 0.00529998,
    -0.68449680, -0.72899660, 0.00529998,
    -0.60478911, -0.73508676, 0.30639448,
    -0.60478911, -0.73508676, 0.30639448,
    -0.60478911, -0.73508676, 0.30639448,
    -0.60478911, -0.73508676, 0.30639448,
    0.60319493, -0.73589381, 0.30759741,
    0.60319493, -0.73589381, 0.30759741,
    0.60319493, -0.73589381, 0.30759741,
    0.60319493, -0.73589381, 0.30759741,
    0.62099202, 0.78378993, -0.00649992,
    0.62099202, 0.78378993, -0.00649992,
    0.62099202, 0.78378993, -0.00649992,
    0.62099202, 0.78378993, -0.00649992,
    0.59307522, 0.80506636, -0.01139952,
    0.59307522, 0.80506636, -0.01139952,
    0.59307522, 0.80506636, -0.01139952,
    0.59307522, 0.80506636, -0.01139952,
    0.41510703, 0.83581415, -0.35930608,
    0.41510703, 0.83581415, -0.35930608,
    0.41510703, 0.83581415, -0.35930608,
    0.41510703, 0.83581415, -0.35930608,
    0.47658899, 0.81118126, -0.33889217,
    0.47658899, 0.81118126, -0.33889217,
    0.47658899, 0.81118126, -0.33889217,
    0.47658899, 0.81118126, -0.33889217,
    -0.03100068, 0.19140421, -0.98102160,
    -0.03100068, 0.19140421, -0.98102160,
    -0.03100068, 0.19140421, -0.98102160,
    -0.03100068, 0.19140421, -0.98102160,
    -0.03750093, 0.09230228, -0.99502461,
    -0.03750093, 0.09230228, -0.99502461,
    -0.03750093, 0.09230228, -0.99502461,
    -0.03750093, 0.09230228, -0.99502461,
    -0.03750093, 0.09230228, -0.99502461,
    -0.03750093, 0.09230228, -0.99502461,
    0.02250014, 0.40530252, -0.91390569,
    0.02250014, 0.40530252, -0.91390569,
    0.02250014, 0.40530252, -0.91390569,
    0.02250014, 0.40530252, -0.91390569,
    0.02250014, 0.40530252, -0.91390569,
    0.00900015, 0.05370089, -0.99851651,
    0.00900015, 0.05370089, -0.99851651,
    0.00900015, 0.05370089, -0.99851651,
    0.00900015, 0.05370089, -0.99851651,
    0.00900015, 0.05370089, -0.99851651,
    0.00900015, 0.05370089, -0.99851651,
    0.02389962, 0.03819940, -0.99898429,
    0.02389962, 0.03819940, -0.99898429,
    0.02389962, 0.03819940, -0.99898429,
    0.02389962, 0.03819940, -0.99898429,
    0.02389962, 0.03819940, -0.99898429,
    0.01409976, 0.02889950, -0.99948287,
    0.01409976, 0.02889950, -0.99948287,
    0.01409976, 0.02889950, -0.99948287,
    0.01409976, 0.02889950, -0.99948287,
    0.01409976, 0.02889950, -0.99948287,
    -0.59307522, 0.80506636, -0.01139952,
    -0.59307522, 0.80506636, -0.01139952,
    -0.59307522, 0.80506636, -0.01139952,
    -0.59307522, 0.80506636, -0.01139952,
    -0.41510703, 0.83581415, -0.35930608,
    -0.41510703, 0.83581415, -0.35930608,
    -0.41510703, 0.83581415, -0.35930608,
    -0.41510703, 0.83581415, -0.35930608,
    0.03100068, 0.19140421, -0.98102160,
    0.03100068, 0.19140421, -0.98102160,
    0.03100068, 0.19140421, -0.98102160,
    0.03100068, 0.19140421, -0.98102160,
    0.04740213, 0.09710437, -0.99414475,
    0.04740213, 0.09710437, -0.99414475,
    0.04740213, 0.09710437, -0.99414475,
    0.04740213, 0.09710437, -0.99414475,
    0.04740213, 0.09710437, -0.99414475,
    0.04740213, 0.09710437, -0.99414475,
    -0.02209995, 0.40959906, -0.91199792,
    -0.02209995, 0.40959906, -0.91199792,
    -0.02209995, 0.40959906, -0.91199792,
    -0.02209995, 0.40959906, -0.91199792,
    -0.02209995, 0.40959906, -0.91199792,
    -0.00880002, 0.05400012, -0.99850215,
    -0.00880002, 0.05400012, -0.99850215,
    -0.00880002, 0.05400012, -0.99850215,
    -0.00880002, 0.05400012, -0.99850215,
    -0.00880002, 0.05400012, -0.99850215,
    -0.00880002, 0.05400012, -0.99850215,
    -0.01980090, 0.05210237, -0.99844543,
    -0.01980090, 0.05210237, -0.99844543,
    -0.01980090, 0.05210237, -0.99844543,
    -0.01980090, 0.05210237, -0.99844543,
    -0.01980090, 0.05210237, -0.99844543,
    0.00080003, 0.03890166, -0.99924272,
    0.00080003, 0.03890166, -0.99924272,
    0.00080003, 0.03890166, -0.99924272,
    -0.20260943, 0.35731663, -0.91174242,
    -0.20260943, 0.35731663, -0.91174242,
    -0.20260943, 0.35731663, -0.91174242,
    -0.20260943, 0.35731663, -0.91174242,
    0.68568842, 0.72788770, -0.00329994,
    0.68568842, 0.72788770, -0.00329994,
    0.68568842, 0.72788770, -0.00329994,
    0.68568842, 0.72788770, -0.00329994,
    0.60857924, 0.73907479, -0.28879015,
    0.60857924, 0.73907479, -0.28879015,
    0.60857924, 0.73907479, -0.28879015,
    0.60857924, 0.73907479, -0.28879015,
    -0.60870475, 0.73900577, -0.28870225,
    -0.60870475, 0.73900577, -0.28870225,
    -0.60870475, 0.73900577, -0.28870225,
    -0.60870475, 0.73900577, -0.28870225,
    -0.38038353, 0.09379594, -0.92006016,
    -0.38038353, 0.09379594, -0.92006016,
    -0.38038353, 0.09379594, -0.92006016,
    -0.38038353, 0.09379594, -0.92006016,
    -0.26529820, 0.16179890, -0.95049355,
    -0.26529820, 0.16179890, -0.95049355,
    -0.26529820, 0.16179890, -0.95049355,
    -0.26529820, 0.16179890, -0.95049355,
    0.86134044, 0.50802385, -0.00210010,
    0.86134044, 0.50802385, -0.00210010,
    0.86134044, 0.50802385, -0.00210010,
    0.86134044, 0.50802385, -0.00210010,
    0.38038353, 0.09379594, -0.92006016,
    0.38038353, 0.09379594, -0.92006016,
    0.38038353, 0.09379594, -0.92006016,
    0.38038353, 0.09379594, -0.92006016,
    0.26950431, 0.15760252, -0.95001520,
    0.26950431, 0.15760252, -0.95001520,
    0.26950431, 0.15760252, -0.95001520,
    0.26950431, 0.15760252, -0.95001520,
    0.64649586, 0.76159512, 0.04489971,
    0.64649586, 0.76159512, 0.04489971,
    0.64649586, 0.76159512, 0.04489971,
    0.64649586, 0.76159512, 0.04489971,
    0.84569383, 0.53289611, 0.02869979,
    0.84569383, 0.53289611, 0.02869979,
    0.84569383, 0.53289611, 0.02869979,
    0.84569383, 0.53289611, 0.02869979,
    0.91151881, 0.40220830, 0.08580177,
    0.91151881, 0.40220830, 0.08580177,
    0.91151881, 0.40220830, 0.08580177,
    0.91151881, 0.40220830, 0.08580177,
    0.93017155, 0.35548913, -0.09169720,
    0.93017155, 0.35548913, -0.09169720,
    0.93017155, 0.35548913, -0.09169720,
    0.93017155, 0.35548913, -0.09169720,
    0.12659445, 0.99015659, 0.05969738,
    0.12659445, 0.99015659, 0.05969738,
    0.12659445, 0.99015659, 0.05969738,
    0.12659445, 0.99015659, 0.05969738,
    0.32340660, 0.94461927, 0.05570114,
    0.32340660, 0.94461927, 0.05570114,
    0.32340660, 0.94461927, 0.05570114,
    0.32340660, 0.94461927, 0.05570114,
    0.64841599, 0.76021874, 0.04030099,
    0.64841599, 0.76021874, 0.04030099,
    0.64841599, 0.76021874, 0.04030099,
    0.64841599, 0.76021874, 0.04030099,
    0.89677790, 0.43518928, 0.07999803,
    0.89677790, 0.43518928, 0.07999803,
    0.89677790, 0.43518928, 0.07999803,
    0.89677790, 0.43518928, 0.07999803,
    0.92181885, 0.37690771, 0.09050185,
    0.92181885, 0.37690771, 0.09050185,
    0.92181885, 0.37690771, 0.09050185,
    0.92181885, 0.37690771, 0.09050185,
    0.91429676, 0.38819862, 0.11559959,
    0.91429676, 0.38819862, 0.11559959,
    0.91429676, 0.38819862, 0.11559959,
    0.91429676, 0.38819862, 0.11559959,
    0.92979324, 0.34309751, 0.13329903,
    0.92979324, 0.34309751, 0.13329903,
    0.92979324, 0.34309751, 0.13329903,
    0.92979324, 0.34309751, 0.13329903,
    0.88690537, 0.45980278, 0.04450027,
    0.88690537, 0.45980278, 0.04450027,
    0.88690537, 0.45980278, 0.04450027,
    0.88690537, 0.45980278, 0.04450027,
    -0.79862062, 0.60151553, 0.01960051,
    -0.79862062, 0.60151553, 0.01960051,
    -0.79862062, 0.60151553, 0.01960051,
    -0.79862062, 0.60151553, 0.01960051,
    -0.85548088, 0.51778843, 0.00689985,
    -0.85548088, 0.51778843, 0.00689985,
    -0.85548088, 0.51778843, 0.00689985,
    -0.85548088, 0.51778843, 0.00689985,
    -0.93013405, 0.36661342, 0.02110077,
    -0.93013405, 0.36661342, 0.02110077,
    -0.93013405, 0.36661342, 0.02110077,
    -0.93013405, 0.36661342, 0.02110077,
    -0.65162403, 0.75732792, 0.04290158,
    -0.65162403, 0.75732792, 0.04290158,
    -0.65162403, 0.75732792, 0.04290158,
    -0.65162403, 0.75732792, 0.04290158,
    -0.78968224, 0.61268622, 0.03189928,
    -0.78968224, 0.61268622, 0.03189928,
    -0.78968224, 0.61268622, 0.03189928,
    -0.78968224, 0.61268622, 0.03189928,
    -0.95218377, 0.30429481, -0.02739953,
    -0.95218377, 0.30429481, -0.02739953,
    -0.95218377, 0.30429481, -0.02739953,
    -0.95218377, 0.30429481, -0.02739953,
    -0.13230294, 0.98992200, 0.05050112,
    -0.13230294, 0.98992200, 0.05050112,
    -0.13230294, 0.98992200, 0.05050112,
    -0.13230294, 0.98992200, 0.05050112,
    -0.33039619, 0.94308913, 0.03769957,
    -0.33039619, 0.94308913, 0.03769957,
    -0.33039619, 0.94308913, 0.03769957,
    -0.33039619, 0.94308913, 0.03769957,
    -0.36240219, 0.93090562, 0.04560028,
    -0.36240219, 0.93090562, 0.04560028,
    -0.36240219, 0.93090562, 0.04560028,
    -0.36240219, 0.93090562, 0.04560028,
    -0.92768537, 0.36849419, 0.06009905,
    -0.92768537, 0.36849419, 0.06009905,
    -0.92768537, 0.36849419, 0.06009905,
    -0.92768537, 0.36849419, 0.06009905,
    -0.94528558, 0.31799515, 0.07289889,
    -0.94528558, 0.31799515, 0.07289889,
    -0.94528558, 0.31799515, 0.07289889,
    -0.94528558, 0.31799515, 0.07289889,
    -0.94726525, 0.30818869, 0.08779678,
    -0.94726525, 0.30818869, 0.08779678,
    -0.94726525, 0.30818869, 0.08779678,
    -0.94726525, 0.30818869, 0.08779678,
    -0.96945911, 0.23089026, 0.08269651,
    -0.96945911, 0.23089026, 0.08269651,
    -0.96945911, 0.23089026, 0.08269651,
    -0.96945911, 0.23089026, 0.08269651,
    -0.12179538, 0.08199689, -0.98916247,
    -0.12179538, 0.08199689, -0.98916247,
    -0.12179538, 0.08199689, -0.98916247,
    -0.12179538, 0.08199689, -0.98916247,
    -0.81218941, 0.58339239, 0.00129998,
    -0.81218941, 0.58339239, 0.00129998,
    -0.81218941, 0.58339239, 0.00129998,
    -0.81218941, 0.58339239, 0.00129998,
    -0.86267560, 0.49768592, -0.08999745,
    -0.86267560, 0.49768592, -0.08999745,
    -0.86267560, 0.49768592, -0.08999745,
    -0.86267560, 0.49768592, -0.08999745,
    0.29310307, -0.08370088, -0.95240997,
    0.29310307, -0.08370088, -0.95240997,
    0.29310307, -0.08370088, -0.95240997,
    0.29310307, -0.08370088, -0.95240997,
    0.87137290, 0.48318497, -0.08509735,
    0.87137290, 0.48318497, -0.08509735,
    0.87137290, 0.48318497, -0.08509735,
    0.87137290, 0.48318497, -0.08509735,
    -0.84885592, 0.31998339, -0.42077815,
    -0.84885592, 0.31998339, -0.42077815,
    -0.84885592, 0.31998339, -0.42077815,
    -0.84885592, 0.31998339, -0.42077815,
    -0.92768213, -0.37299281, -0.01679968,
    -0.92768213, -0.37299281, -0.01679968,
    -0.92768213, -0.37299281, -0.01679968,
    -0.92768213, -0.37299281, -0.01679968,
    -0.14249511, 0.12659565, 0.98166628,
    -0.14249511, 0.12659565, 0.98166628,
    -0.14249511, 0.12659565, 0.98166628,
    -0.14249511, 0.12659565, 0.98166628,
    -0.28279642, 0.50819356, 0.81348970,
    -0.28279642, 0.50819356, 0.81348970,
    -0.28279642, 0.50819356, 0.81348970,
    -0.28279642, 0.50819356, 0.81348970,
    -0.47899650, 0.40559704, 0.77849431,
    -0.47899650, 0.40559704, 0.77849431,
    -0.47899650, 0.40559704, 0.77849431,
    -0.47899650, 0.40559704, 0.77849431,
    -0.43319733, 0.00289998, 0.90129444,
    -0.43319733, 0.00289998, 0.90129444,
    -0.43319733, 0.00289998, 0.90129444,
    -0.43319733, 0.00289998, 0.90129444,
    -0.98490403, -0.17300071, 0.00590002,
    -0.98490403, -0.17300071, 0.00590002,
    -0.98490403, -0.17300071, 0.00590002,
    -0.98490403, -0.17300071, 0.00590002,
    -0.65381740, 0.73881966, 0.16330435,
    -0.65381740, 0.73881966, 0.16330435,
    -0.65381740, 0.73881966, 0.16330435,
    -0.65381740, 0.73881966, 0.16330435,
    -0.68101657, 0.68251661, 0.26530645,
    -0.68101657, 0.68251661, 0.26530645,
    -0.68101657, 0.68251661, 0.26530645,
    -0.68101657, 0.68251661, 0.26530645,
    -0.48929074, 0.76438553, 0.41989205,
    -0.48929074, 0.76438553, 0.41989205,
    -0.48929074, 0.76438553, 0.41989205,
    -0.48929074, 0.76438553, 0.41989205,
    -0.08370044, 0.33130175, -0.93980497,
    -0.08370044, 0.33130175, -0.93980497,
    -0.08370044, 0.33130175, -0.93980497,
    -0.08370044, 0.33130175, -0.93980497,
    -0.33198265, 0.55947077, -0.75946032,
    -0.33198265, 0.55947077, -0.75946032,
    -0.33198265, 0.55947077, -0.75946032,
    -0.33198265, 0.55947077, -0.75946032,
    -0.15290451, 0.58481725, -0.79662350,
    -0.15290451, 0.58481725, -0.79662350,
    -0.15290451, 0.58481725, -0.79662350,
    -0.15290451, 0.58481725, -0.79662350,
    -0.96996151, 0.06789731, -0.23359073,
    -0.96996151, 0.06789731, -0.23359073,
    -0.96996151, 0.06789731, -0.23359073,
    -0.96996151, 0.06789731, -0.23359073,
    -0.96996151, 0.06789731, -0.23359073,
    -0.47278467, 0.30699005, -0.82597322,
    -0.47278467, 0.30699005, -0.82597322,
    -0.47278467, 0.30699005, -0.82597322,
    -0.47278467, 0.30699005, -0.82597322,
    -0.65429518, 0.39399710, -0.64549524,
    -0.65429518, 0.39399710, -0.64549524,
    -0.65429518, 0.39399710, -0.64549524,
    -0.65429518, 0.39399710, -0.64549524,
    -0.49589716, 0.50239712, -0.70829594,
    -0.49589716, 0.50239712, -0.70829594,
    -0.49589716, 0.50239712, -0.70829594,
    -0.49589716, 0.50239712, -0.70829594,
    -0.27479444, 0.34079310, -0.89908180,
    -0.27479444, 0.34079310, -0.89908180,
    -0.27479444, 0.34079310, -0.89908180,
    -0.27479444, 0.34079310, -0.89908180,
    -0.61990379, -0.78260479, 0.05700035,
    -0.61990379, -0.78260479, 0.05700035,
    -0.61990379, -0.78260479, 0.05700035,
    -0.61990379, -0.78260479, 0.05700035,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.02420031, -0.06620085, 0.99751280,
    -0.61068944, -0.74578711, 0.26619540,
    -0.61068944, -0.74578711, 0.26619540,
    -0.61068944, -0.74578711, 0.26619540,
    -0.61068944, -0.74578711, 0.26619540,
    -0.77468667, -0.61078949, 0.16369718,
    -0.77468667, -0.61078949, 0.16369718,
    -0.77468667, -0.61078949, 0.16369718,
    -0.77468667, -0.61078949, 0.16369718,
    -0.70130712, -0.71250723, -0.02240023,
    -0.70130712, -0.71250723, -0.02240023,
    -0.70130712, -0.71250723, -0.02240023,
    -0.70130712, -0.71250723, -0.02240023,
    -0.22668884, 0.92335454, 0.30988474,
    -0.22668884, 0.92335454, 0.30988474,
    -0.22668884, 0.92335454, 0.30988474,
    -0.22668884, 0.92335454, 0.30988474,
    -0.32918646, 0.78806758, 0.52017860,
    -0.32918646, 0.78806758, 0.52017860,
    -0.32918646, 0.78806758, 0.52017860,
    -0.32918646, 0.78806758, 0.52017860,
    -0.13820150, 0.80040869, 0.58330633,
    -0.13820150, 0.80040869, 0.58330633,
    -0.13820150, 0.80040869, 0.58330633,
    -0.13820150, 0.80040869, 0.58330633,
    -0.04310160, 0.13030482, 0.99053668,
    -0.04310160, 0.13030482, 0.99053668,
    -0.04310160, 0.13030482, 0.99053668,
    -0.04310160, 0.13030482, 0.99053668,
    -0.07659950, 0.48689679, 0.87009427,
    -0.07659950, 0.48689679, 0.87009427,
    -0.07659950, 0.48689679, 0.87009427,
    -0.07659950, 0.48689679, 0.87009427,
    -0.17300697, 0.50192024, 0.84743416,
    -0.17300697, 0.50192024, 0.84743416,
    -0.17300697, 0.50192024, 0.84743416,
    -0.17300697, 0.50192024, 0.84743416,
    -0.05140081, 0.14280226, 0.98841564,
    -0.05140081, 0.14280226, 0.98841564,
    -0.05140081, 0.14280226, 0.98841564,
    -0.05140081, 0.14280226, 0.98841564,
    -0.16930346, 0.76691568, -0.61901266,
    -0.16930346, 0.76691568, -0.61901266,
    -0.16930346, 0.76691568, -0.61901266,
    -0.16930346, 0.76691568, -0.61901266,
    -0.39818076, 0.70266606, -0.58967151,
    -0.39818076, 0.70266606, -0.58967151,
    -0.39818076, 0.70266606, -0.58967151,
    -0.39818076, 0.70266606, -0.58967151,
    -0.19599763, 0.89988912, -0.38959529,
    -0.19599763, 0.89988912, -0.38959529,
    -0.19599763, 0.89988912, -0.38959529,
    -0.19599763, 0.89988912, -0.38959529,
    -0.48018422, 0.87617121, -0.04179863,
    -0.48018422, 0.87617121, -0.04179863,
    -0.48018422, 0.87617121, -0.04179863,
    -0.48018422, 0.87617121, -0.04179863,
    -0.26611151, 0.96204163, -0.06050262,
    -0.26611151, 0.96204163, -0.06050262,
    -0.26611151, 0.96204163, -0.06050262,
    -0.26611151, 0.96204163, -0.06050262,
    -0.44270734, 0.86011425, 0.25340420,
    -0.44270734, 0.86011425, 0.25340420,
    -0.44270734, 0.86011425, 0.25340420,
    -0.44270734, 0.86011425, 0.25340420,
    -0.49030868, -0.73131295, -0.47410839,
    -0.49030868, -0.73131295, -0.47410839,
    -0.49030868, -0.73131295, -0.47410839,
    -0.49030868, -0.73131295, -0.47410839,
    -0.42297681, -0.74405921, -0.51717165,
    -0.42297681, -0.74405921, -0.51717165,
    -0.42297681, -0.74405921, -0.51717165,
    -0.42297681, -0.74405921, -0.51717165,
    -0.77040870, -0.63550718, -0.05100058,
    -0.77040870, -0.63550718, -0.05100058,
    -0.77040870, -0.63550718, -0.05100058,
    -0.77040870, -0.63550718, -0.05100058,
    -0.67180331, -0.73830364, -0.05990030,
    -0.67180331, -0.73830364, -0.05990030,
    -0.67180331, -0.73830364, -0.05990030,
    -0.67180331, -0.73830364, -0.05990030,
    -0.77850021, -0.62610017, -0.04400001,
    -0.77850021, -0.62610017, -0.04400001,
    -0.77850021, -0.62610017, -0.04400001,
    -0.77850021, -0.62610017, -0.04400001,
    -0.79299195, -0.60889382, -0.02029979,
    -0.79299195, -0.60889382, -0.02029979,
    -0.79299195, -0.60889382, -0.02029979,
    -0.79299195, -0.60889382, -0.02029979,
    -0.39959406, -0.79488818, -0.45659321,
    -0.39959406, -0.79488818, -0.45659321,
    -0.39959406, -0.79488818, -0.45659321,
    -0.39959406, -0.79488818, -0.45659321,
    -0.32348894, -0.84027128, -0.43508513,
    -0.32348894, -0.84027128, -0.43508513,
    -0.32348894, -0.84027128, -0.43508513,
    -0.32348894, -0.84027128, -0.43508513,
    -0.62676675, -0.77905868, 0.01519919,
    -0.62676675, -0.77905868, 0.01519919,
    -0.62676675, -0.77905868, 0.01519919,
    -0.62676675, -0.77905868, 0.01519919,
    -0.59278027, -0.79427356, -0.13319557,
    -0.59278027, -0.79427356, -0.13319557,
    -0.59278027, -0.79427356, -0.13319557,
    -0.59278027, -0.79427356, -0.13319557,
    -0.61537515, -0.78396834, -0.08189669,
    -0.61537515, -0.78396834, -0.08189669,
    -0.61537515, -0.78396834, -0.08189669,
    -0.61537515, -0.78396834, -0.08189669,
    -0.78320360, 0.53700247, -0.31340144,
    -0.78320360, 0.53700247, -0.31340144,
    -0.78320360, 0.53700247, -0.31340144,
    -0.78320360, 0.53700247, -0.31340144,
    -0.62250394, -0.77470490, -0.11100070,
    -0.62250394, -0.77470490, -0.11100070,
    -0.62250394, -0.77470490, -0.11100070,
    -0.62250394, -0.77470490, -0.11100070,
    -0.63639693, -0.76679630, -0.08379960,
    -0.63639693, -0.76679630, -0.08379960,
    -0.63639693, -0.76679630, -0.08379960,
    -0.63639693, -0.76679630, -0.08379960,
    -0.56426381, 0.63735912, -0.52476634,
    -0.56426381, 0.63735912, -0.52476634,
    -0.56426381, 0.63735912, -0.52476634,
    -0.56426381, 0.63735912, -0.52476634,
    -0.71826612, 0.54287439, -0.43517947,
    -0.71826612, 0.54287439, -0.43517947,
    -0.71826612, 0.54287439, -0.43517947,
    -0.71826612, 0.54287439, -0.43517947,
    -0.63728326, 0.69338179, -0.33629117,
    -0.63728326, 0.69338179, -0.33629117,
    -0.63728326, 0.69338179, -0.33629117,
    -0.63728326, 0.69338179, -0.33629117,
    -0.84981995, 0.52701237, -0.00800019,
    -0.84981995, 0.52701237, -0.00800019,
    -0.84981995, 0.52701237, -0.00800019,
    -0.84981995, 0.52701237, -0.00800019,
    -0.70820854, 0.70570851, -0.02040025,
    -0.70820854, 0.70570851, -0.02040025,
    -0.70820854, 0.70570851, -0.02040025,
    -0.70820854, 0.70570851, -0.02040025,
    -0.80798508, 0.58528919, 0.06779875,
    -0.80798508, 0.58528919, 0.06779875,
    -0.80798508, 0.58528919, 0.06779875,
    -0.80798508, 0.58528919, 0.06779875,
    -0.94337085, -0.06149810, 0.32598993,
    -0.94337085, -0.06149810, 0.32598993,
    -0.94337085, -0.06149810, 0.32598993,
    -0.94337085, -0.06149810, 0.32598993,
    -0.93302999, 0.26840863, 0.23960770,
    -0.93302999, 0.26840863, 0.23960770,
    -0.93302999, 0.26840863, 0.23960770,
    -0.93302999, 0.26840863, 0.23960770,
    -0.99898389, -0.04299931, 0.01349978,
    -0.99898389, -0.04299931, 0.01349978,
    -0.99898389, -0.04299931, 0.01349978,
    -0.99898389, -0.04299931, 0.01349978,
    -0.08989898, -0.16439814, -0.98228887,
    -0.08989898, -0.16439814, -0.98228887,
    -0.08989898, -0.16439814, -0.98228887,
    -0.08989898, -0.16439814, -0.98228887,
    -0.98640676, -0.16420113, -0.00630004,
    -0.98640676, -0.16420113, -0.00630004,
    -0.98640676, -0.16420113, -0.00630004,
    -0.98640676, -0.16420113, -0.00630004,
    -0.96500998, 0.26140270, 0.02060021,
    -0.96500998, 0.26140270, 0.02060021,
    -0.96500998, 0.26140270, 0.02060021,
    -0.96500998, 0.26140270, 0.02060021,
    -0.91148620, 0.26909593, -0.31109529,
    -0.91148620, 0.26909593, -0.31109529,
    -0.91148620, 0.26909593, -0.31109529,
    -0.91148620, 0.26909593, -0.31109529,
    -0.98767841, -0.14609681, -0.05609877,
    -0.98767841, -0.14609681, -0.05609877,
    -0.98767841, -0.14609681, -0.05609877,
    -0.98767841, -0.14609681, -0.05609877,
    -0.68370716, 0.24130253, -0.68870721,
    -0.68370716, 0.24130253, -0.68870721,
    -0.68370716, 0.24130253, -0.68870721,
    -0.68370716, 0.24130253, -0.68870721,
    -0.93790170, -0.34690063, -0.00060000,
    -0.93790170, -0.34690063, -0.00060000,
    -0.93790170, -0.34690063, -0.00060000,
    -0.93790170, -0.34690063, -0.00060000,
    -0.90577576, -0.42178871, -0.04079891,
    -0.90577576, -0.42178871, -0.04079891,
    -0.90577576, -0.42178871, -0.04079891,
    -0.90577576, -0.42178871, -0.04079891,
    -0.97183259, 0.23550790, -0.00880030,
    -0.97183259, 0.23550790, -0.00880030,
    -0.97183259, 0.23550790, -0.00880030,
    -0.97183259, 0.23550790, -0.00880030,
    -0.93891914, -0.28850588, 0.18760383,
    -0.93891914, -0.28850588, 0.18760383,
    -0.93891914, -0.28850588, 0.18760383,
    -0.93891914, -0.28850588, 0.18760383,
    -0.83203489, 0.55472326, -0.00020001,
    -0.83203489, 0.55472326, -0.00020001,
    -0.83203489, 0.55472326, -0.00020001,
    -0.83203489, 0.55472326, -0.00020001,
    0.45710784, 0.81631400, -0.35310605,
    0.45710784, 0.81631400, -0.35310605,
    0.45710784, 0.81631400, -0.35310605,
    0.45710784, 0.81631400, -0.35310605,
    -0.94854805, -0.15190769, 0.27781407,
    -0.94854805, -0.15190769, 0.27781407,
    -0.94854805, -0.15190769, 0.27781407,
    -0.94854805, -0.15190769, 0.27781407,
    -0.94415203, -0.10710590, 0.31161717,
    -0.94415203, -0.10710590, 0.31161717,
    -0.94415203, -0.10710590, 0.31161717,
    -0.94415203, -0.10710590, 0.31161717,
    -0.99637979, -0.08399830, 0.01309973,
    -0.99637979, -0.08399830, 0.01309973,
    -0.99637979, -0.08399830, 0.01309973,
    -0.99637979, -0.08399830, 0.01309973,
    -0.94119668, -0.10809962, 0.32009887,
    -0.94119668, -0.10809962, 0.32009887,
    -0.94119668, -0.10809962, 0.32009887,
    -0.94119668, -0.10809962, 0.32009887,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.00680021, -0.04990155, 0.99873099,
    -0.02460006, -0.50460118, 0.86300202,
    -0.02460006, -0.50460118, 0.86300202,
    -0.02460006, -0.50460118, 0.86300202,
    -0.02460006, -0.50460118, 0.86300202,
    -0.00940007, -0.05380040, 0.99850746,
    -0.00940007, -0.05380040, 0.99850746,
    -0.00940007, -0.05380040, 0.99850746,
    -0.00940007, -0.05380040, 0.99850746,
    -0.00940007, -0.05380040, 0.99850746,
    -0.00940007, -0.05380040, 0.99850746,
    -0.03119886, -0.04579832, 0.99846339,
    -0.03119886, -0.04579832, 0.99846339,
    -0.03119886, -0.04579832, 0.99846339,
    -0.03119886, -0.04579832, 0.99846339,
    -0.03119886, -0.04579832, 0.99846339,
    -0.31480886, -0.70651988, -0.63381783,
    -0.31480886, -0.70651988, -0.63381783,
    -0.31480886, -0.70651988, -0.63381783,
    -0.31480886, -0.70651988, -0.63381783,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.07979821, -0.16429632, 0.98317799,
    -0.04049840, -0.10859571, 0.99326072,
    -0.04049840, -0.10859571, 0.99326072,
    -0.04049840, -0.10859571, 0.99326072,
    -0.04049840, -0.10859571, 0.99326072,
    -0.04049840, -0.10859571, 0.99326072,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.03130095, -0.15170463, 0.98793014,
    -0.22521221, -0.70333813, -0.67423655,
    -0.22521221, -0.70333813, -0.67423655,
    -0.22521221, -0.70333813, -0.67423655,
    -0.22521221, -0.70333813, -0.67423655,
    -0.41821792, -0.51992228, -0.74483192,
    -0.41821792, -0.51992228, -0.74483192,
    -0.41821792, -0.51992228, -0.74483192,
    -0.41821792, -0.51992228, -0.74483192,
    -0.17799928, -0.59469759, -0.78399683,
    -0.17799928, -0.59469759, -0.78399683,
    -0.17799928, -0.59469759, -0.78399683,
    -0.17799928, -0.59469759, -0.78399683,
    -0.68929916, 0.12449985, -0.71369913,
    -0.68929916, 0.12449985, -0.71369913,
    -0.68929916, 0.12449985, -0.71369913,
    -0.68929916, 0.12449985, -0.71369913,
    -0.45502052, 0.11640525, -0.88283982,
    -0.45502052, 0.11640525, -0.88283982,
    -0.45502052, 0.11640525, -0.88283982,
    -0.45502052, 0.11640525, -0.88283982,
    -0.15529453, -0.68987568, -0.70707507,
    -0.15529453, -0.68987568, -0.70707507,
    -0.15529453, -0.68987568, -0.70707507,
    -0.15529453, -0.68987568, -0.70707507,
    -0.01630049, -0.69932121, -0.71462167,
    -0.01630049, -0.69932121, -0.71462167,
    -0.01630049, -0.69932121, -0.71462167,
    -0.01630049, -0.69932121, -0.71462167,
    -0.08009943, -0.61199564, -0.78679439,
    -0.08009943, -0.61199564, -0.78679439,
    -0.08009943, -0.61199564, -0.78679439,
    -0.08009943, -0.61199564, -0.78679439,
    -0.03589930, -0.61528796, -0.78748459,
    -0.03589930, -0.61528796, -0.78748459,
    -0.03589930, -0.61528796, -0.78748459,
    -0.03589930, -0.61528796, -0.78748459,
    -0.21658825, 0.08159557, -0.97284721,
    -0.21658825, 0.08159557, -0.97284721,
    -0.21658825, 0.08159557, -0.97284721,
    -0.21658825, 0.08159557, -0.97284721,
    -0.04379940, 0.05569924, -0.99748644,
    -0.04379940, 0.05569924, -0.99748644,
    -0.04379940, 0.05569924, -0.99748644,
    -0.04379940, 0.05569924, -0.99748644,
    -0.17629869, -0.15539885, 0.97199278,
    -0.17629869, -0.15539885, 0.97199278,
    -0.17629869, -0.15539885, 0.97199278,
    -0.17629869, -0.15539885, 0.97199278,
    -0.17629869, -0.15539885, 0.97199278,
    -0.19559823, -0.35879675, 0.91269174,
    -0.19559823, -0.35879675, 0.91269174,
    -0.19559823, -0.35879675, 0.91269174,
    -0.55339474, -0.17469834, 0.81439226,
    -0.55339474, -0.17469834, 0.81439226,
    -0.55339474, -0.17469834, 0.81439226,
    -0.55339474, -0.17469834, 0.81439226,
    -0.09859548, -0.04399798, 0.99415447,
    -0.09859548, -0.04399798, 0.99415447,
    -0.09859548, -0.04399798, 0.99415447,
    -0.09859548, -0.04399798, 0.99415447,
    -0.53102143, -0.07720312, 0.84383406,
    -0.53102143, -0.07720312, 0.84383406,
    -0.53102143, -0.07720312, 0.84383406,
    -0.53102143, -0.07720312, 0.84383406,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.07770218, -0.17370488, 0.98172755,
    -0.46630954, -0.17160351, 0.86781775,
    -0.46630954, -0.17160351, 0.86781775,
    -0.46630954, -0.17160351, 0.86781775,
    -0.46630954, -0.17160351, 0.86781775,
    -0.08099605, -0.10609483, 0.99105173,
    -0.08099605, -0.10609483, 0.99105173,
    -0.08099605, -0.10609483, 0.99105173,
    -0.08099605, -0.10609483, 0.99105173,
    -0.44861703, -0.15240579, 0.88063343,
    -0.44861703, -0.15240579, 0.88063343,
    -0.44861703, -0.15240579, 0.88063343,
    -0.44861703, -0.15240579, 0.88063343,
    -0.60438349, -0.64778230, -0.46378733,
    -0.60438349, -0.64778230, -0.46378733,
    -0.60438349, -0.64778230, -0.46378733,
    -0.60438349, -0.64778230, -0.46378733,
    -0.78244216, -0.32801767, -0.52932852,
    -0.78244216, -0.32801767, -0.52932852,
    -0.78244216, -0.32801767, -0.52932852,
    -0.78244216, -0.32801767, -0.52932852,
    -0.98413620, -0.03410125, -0.17410640,
    -0.98413620, -0.03410125, -0.17410640,
    -0.98413620, -0.03410125, -0.17410640,
    -0.98413620, -0.03410125, -0.17410640,
    -0.86989823, 0.10419979, -0.48209902,
    -0.86989823, 0.10419979, -0.48209902,
    -0.86989823, 0.10419979, -0.48209902,
    -0.86989823, 0.10419979, -0.48209902,
    -0.86090223, 0.18990049, -0.47200122,
    -0.86090223, 0.18990049, -0.47200122,
    -0.86090223, 0.18990049, -0.47200122,
    -0.86090223, 0.18990049, -0.47200122,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    -0.02569963, -0.11879830, 0.99258576,
    0.34360284, -0.93910777, -0.00370003,
    0.34360284, -0.93910777, -0.00370003,
    0.34360284, -0.93910777, -0.00370003,
    0.34360284, -0.93910777, -0.00370003,
    -0.67709547, 0.73589508, -0.00040000,
    -0.67709547, 0.73589508, -0.00040000,
    -0.67709547, 0.73589508, -0.00040000,
    -0.67709547, 0.73589508, -0.00040000,
    -0.90927220, -0.29209107, -0.29649093,
    -0.90927220, -0.29209107, -0.29649093,
    -0.90927220, -0.29209107, -0.29649093,
    -0.90927220, -0.29209107, -0.29649093,
    0.11620410, -0.13480475, -0.98403470,
    0.11620410, -0.13480475, -0.98403470,
    0.11620410, -0.13480475, -0.98403470,
    0.11620410, -0.13480475, -0.98403470,
    -0.89880111, 0.03570004, 0.43690054,
    -0.89880111, 0.03570004, 0.43690054,
    -0.89880111, 0.03570004, 0.43690054,
    -0.89880111, 0.03570004, 0.43690054,
    -0.97132686, -0.13600376, 0.19500539,
    -0.97132686, -0.13600376, 0.19500539,
    -0.97132686, -0.13600376, 0.19500539,
    -0.97132686, -0.13600376, 0.19500539,
    -0.95177645, -0.30679241, -0.00010000,
    -0.95177645, -0.30679241, -0.00010000,
    -0.95177645, -0.30679241, -0.00010000,
    -0.95177645, -0.30679241, -0.00010000,
    0.88477413, 0.22719336, 0.40688810,
    0.88477413, 0.22719336, 0.40688810,
    0.88477413, 0.22719336, 0.40688810,
    0.88477413, 0.22719336, 0.40688810,
    0.60228771, -0.50628967, 0.61718740,
    0.60228771, -0.50628967, 0.61718740,
    0.60228771, -0.50628967, 0.61718740,
    0.60228771, -0.50628967, 0.61718740,
    -0.13629980, -0.07129989, 0.98809852,
    -0.13629980, -0.07129989, 0.98809852,
    -0.13629980, -0.07129989, 0.98809852,
    -0.13629980, -0.07129989, 0.98809852,
    -0.39350883, -0.91932064, -0.00060001,
    -0.39350883, -0.91932064, -0.00060001,
    -0.39350883, -0.91932064, -0.00060001,
    -0.39350883, -0.91932064, -0.00060001,
    -0.99893751, -0.04400165, 0.01370051,
    -0.99893751, -0.04400165, 0.01370051,
    -0.99893751, -0.04400165, 0.01370051,
    -0.99893751, -0.04400165, 0.01370051,
    -0.98771247, 0.15610197, -0.00750009,
    -0.98771247, 0.15610197, -0.00750009,
    -0.98771247, 0.15610197, -0.00750009,
    -0.98771247, 0.15610197, -0.00750009,
    -0.98771247, 0.15610197, -0.00750009,
    -0.98771247, 0.15610197, -0.00750009,
    0.01689915, -0.64206781, 0.76646157,
    0.01689915, -0.64206781, 0.76646157,
    0.01689915, -0.64206781, 0.76646157,
    0.01689915, -0.64206781, 0.76646157,
    -0.92138457, -0.26229561, -0.28679520,
    -0.92138457, -0.26229561, -0.28679520,
    -0.92138457, -0.26229561, -0.28679520,
    -0.92138457, -0.26229561, -0.28679520,
    -0.13479389, -0.17129223, -0.97595573,
    -0.13479389, -0.17129223, -0.97595573,
    -0.13479389, -0.17129223, -0.97595573,
    -0.13479389, -0.17129223, -0.97595573,
    -0.13150208, 0.99131571, -0.00060001,
    -0.13150208, 0.99131571, -0.00060001,
    -0.13150208, 0.99131571, -0.00060001,
    -0.13150208, 0.99131571, -0.00060001,
    -0.02600080, 0.76372341, -0.64501977,
    -0.02600080, 0.76372341, -0.64501977,
    -0.02600080, 0.76372341, -0.64501977,
    -0.02600080, 0.76372341, -0.64501977,
    -0.71898050, 0.52618573, -0.45408768,
    -0.71898050, 0.52618573, -0.45408768,
    -0.71898050, 0.52618573, -0.45408768,
    -0.71898050, 0.52618573, -0.45408768,
    -0.18560182, 0.00550005, 0.98260964,
    -0.18560182, 0.00550005, 0.98260964,
    -0.18560182, 0.00550005, 0.98260964,
    -0.18560182, 0.00550005, 0.98260964,
    -0.99453295, -0.10430346, 0.00500017,
    -0.99453295, -0.10430346, 0.00500017,
    -0.99453295, -0.10430346, 0.00500017,
    -0.99453295, -0.10430346, 0.00500017,
    -0.94735124, -0.10729448, 0.30168447,
    -0.94735124, -0.10729448, 0.30168447,
    -0.94735124, -0.10729448, 0.30168447,
    -0.94735124, -0.10729448, 0.30168447,
    -0.14630896, 0.75504625, -0.63913915,
    -0.14630896, 0.75504625, -0.63913915,
    -0.14630896, 0.75504625, -0.63913915,
    -0.14630896, 0.75504625, -0.63913915,
    -0.14150448, -0.13100415, -0.98123106,
    -0.14150448, -0.13100415, -0.98123106,
    -0.14150448, -0.13100415, -0.98123106,
    -0.14150448, -0.13100415, -0.98123106,
    -0.99364572, -0.03490161, -0.10700492,
    -0.99364572, -0.03490161, -0.10700492,
    -0.99364572, -0.03490161, -0.10700492,
    -0.99364572, -0.03490161, -0.10700492,
    -0.97897206, -0.20399418, -0.00029999,
    -0.97897206, -0.20399418, -0.00029999,
    -0.97897206, -0.20399418, -0.00029999,
    -0.97897206, -0.20399418, -0.00029999,
    -0.97281956, -0.19250387, 0.12870259,
    -0.97281956, -0.19250387, 0.12870259,
    -0.97281956, -0.19250387, 0.12870259,
    -0.97281956, -0.19250387, 0.12870259,
    0.89746484, 0.26328969, 0.35388614,
    0.89746484, 0.26328969, 0.35388614,
    0.89746484, 0.26328969, 0.35388614,
    0.89746484, 0.26328969, 0.35388614,
    -0.87669210, -0.01569986, -0.48079567,
    -0.87669210, -0.01569986, -0.48079567,
    -0.87669210, -0.01569986, -0.48079567,
    -0.87669210, -0.01569986, -0.48079567,
    -0.48498569, -0.15389546, 0.86087460,
    -0.48498569, -0.15389546, 0.86087460,
    -0.48498569, -0.15389546, 0.86087460,
    -0.48498569, -0.15389546, 0.86087460,
    -0.03980087, -0.31720696, -0.94752078,
    -0.03980087, -0.31720696, -0.94752078,
    -0.03980087, -0.31720696, -0.94752078,
    -0.03980087, -0.31720696, -0.94752078,
    -0.11509951, -0.29769872, -0.94769593,
    -0.11509951, -0.29769872, -0.94769593,
    -0.11509951, -0.29769872, -0.94769593,
    -0.11509951, -0.29769872, -0.94769593,
    -0.32659904, -0.21749936, -0.91979731,
    -0.32659904, -0.21749936, -0.91979731,
    -0.32659904, -0.21749936, -0.91979731,
    -0.32659904, -0.21749936, -0.91979731,
    -0.63258311, -0.09389749, -0.76877947,
    -0.63258311, -0.09389749, -0.76877947,
    -0.63258311, -0.09389749, -0.76877947,
    -0.63258311, -0.09389749, -0.76877947,
    0.87932702, -0.47621463, 0.00190006,
    0.87932702, -0.47621463, 0.00190006,
    0.87932702, -0.47621463, 0.00190006,
    0.87932702, -0.47621463, 0.00190006,
    0.85725221, 0.31438248, -0.40777727,
    0.85725221, 0.31438248, -0.40777727,
    0.85725221, 0.31438248, -0.40777727,
    0.85725221, 0.31438248, -0.40777727,
    0.92697706, -0.37469073, -0.01789956,
    0.92697706, -0.37469073, -0.01789956,
    0.92697706, -0.37469073, -0.01789956,
    0.92697706, -0.37469073, -0.01789956,
    0.92697706, -0.37469073, -0.01789956,
    0.17170617, 0.15210546, 0.97333495,
    0.17170617, 0.15210546, 0.97333495,
    0.17170617, 0.15210546, 0.97333495,
    0.17170617, 0.15210546, 0.97333495,
    0.31799025, 0.51368426, 0.79687558,
    0.31799025, 0.51368426, 0.79687558,
    0.31799025, 0.51368426, 0.79687558,
    0.31799025, 0.51368426, 0.79687558,
    0.50771543, 0.42141281, 0.75142284,
    0.50771543, 0.42141281, 0.75142284,
    0.50771543, 0.42141281, 0.75142284,
    0.50771543, 0.42141281, 0.75142284,
    0.46639627, 0.05119959, 0.88309293,
    0.46639627, 0.05119959, 0.88309293,
    0.46639627, 0.05119959, 0.88309293,
    0.46639627, 0.05119959, 0.88309293,
    0.98490403, -0.17300071, 0.00590002,
    0.98490403, -0.17300071, 0.00590002,
    0.98490403, -0.17300071, 0.00590002,
    0.98490403, -0.17300071, 0.00590002,
    0.66009099, 0.73209000, 0.16829770,
    0.66009099, 0.73209000, 0.16829770,
    0.66009099, 0.73209000, 0.16829770,
    0.66009099, 0.73209000, 0.16829770,
    0.68921074, 0.67661054, 0.25920404,
    0.68921074, 0.67661054, 0.25920404,
    0.68921074, 0.67661054, 0.25920404,
    0.68921074, 0.67661054, 0.25920404,
    0.51449544, 0.75609330, 0.40449642,
    0.51449544, 0.75609330, 0.40449642,
    0.51449544, 0.75609330, 0.40449642,
    0.51449544, 0.75609330, 0.40449642,
    0.62099202, -0.78378993, 0.00649992,
    0.62099202, -0.78378993, 0.00649992,
    0.62099202, -0.78378993, 0.00649992,
    0.62099202, -0.78378993, 0.00649992,
    0.47658899, -0.81118126, 0.33889217,
    0.47658899, -0.81118126, 0.33889217,
    0.47658899, -0.81118126, 0.33889217,
    0.47658899, -0.81118126, 0.33889217,
    0.06420176, 0.32530890, -0.94342581,
    0.06420176, 0.32530890, -0.94342581,
    0.06420176, 0.32530890, -0.94342581,
    0.06420176, 0.32530890, -0.94342581,
    0.36359836, 0.55899748, -0.74519665,
    0.36359836, 0.55899748, -0.74519665,
    0.36359836, 0.55899748, -0.74519665,
    0.36359836, 0.55899748, -0.74519665,
    0.12670771, 0.58803577, -0.79884860,
    0.12670771, 0.58803577, -0.79884860,
    0.12670771, 0.58803577, -0.79884860,
    0.12670771, 0.58803577, -0.79884860,
    0.96738147, 0.07159863, -0.24299534,
    0.96738147, 0.07159863, -0.24299534,
    0.96738147, 0.07159863, -0.24299534,
    0.96738147, 0.07159863, -0.24299534,
    0.96738147, 0.07159863, -0.24299534,
    0.50447602, 0.30998527, -0.80586170,
    0.50447602, 0.30998527, -0.80586170,
    0.50447602, 0.30998527, -0.80586170,
    0.50447602, 0.30998527, -0.80586170,
    0.68148662, 0.38899236, -0.61988783,
    0.68148662, 0.38899236, -0.61988783,
    0.68148662, 0.38899236, -0.61988783,
    0.68148662, 0.38899236, -0.61988783,
    0.52291068, 0.50401029, -0.68741403,
    0.52291068, 0.50401029, -0.68741403,
    0.52291068, 0.50401029, -0.68741403,
    0.52291068, 0.50401029, -0.68741403,
    0.27270229, 0.33870284, -0.90050755,
    0.27270229, 0.33870284, -0.90050755,
    0.27270229, 0.33870284, -0.90050755,
    0.27270229, 0.33870284, -0.90050755,
    0.79811202, -0.60250908, -0.00010000,
    0.79811202, -0.60250908, -0.00010000,
    0.79811202, -0.60250908, -0.00010000,
    0.79811202, -0.60250908, -0.00010000,
    0.68579338, -0.72779297, 0.00219998,
    0.68579338, -0.72779297, 0.00219998,
    0.68579338, -0.72779297, 0.00219998,
    0.68579338, -0.72779297, 0.00219998,
    0.68579338, -0.72779297, 0.00219998,
    0.61068944, -0.74578711, 0.26619540,
    0.61068944, -0.74578711, 0.26619540,
    0.61068944, -0.74578711, 0.26619540,
    0.61068944, -0.74578711, 0.26619540,
    0.77468667, -0.61078949, 0.16369718,
    0.77468667, -0.61078949, 0.16369718,
    0.77468667, -0.61078949, 0.16369718,
    0.77468667, -0.61078949, 0.16369718,
    0.61848797, -0.78308477, 0.06519873,
    0.61848797, -0.78308477, 0.06519873,
    0.61848797, -0.78308477, 0.06519873,
    0.61848797, -0.78308477, 0.06519873,
    0.22080884, 0.92533703, 0.30821233,
    0.22080884, 0.92533703, 0.30821233,
    0.22080884, 0.92533703, 0.30821233,
    0.22080884, 0.92533703, 0.30821233,
    0.33519859, 0.79159667, 0.51089785,
    0.33519859, 0.79159667, 0.51089785,
    0.33519859, 0.79159667, 0.51089785,
    0.33519859, 0.79159667, 0.51089785,
    0.11680213, 0.80431468, 0.58261064,
    0.11680213, 0.80431468, 0.58261064,
    0.11680213, 0.80431468, 0.58261064,
    0.11680213, 0.80431468, 0.58261064,
    -0.01429969, 0.13619705, 0.99057856,
    -0.01429969, 0.13619705, 0.99057856,
    -0.01429969, 0.13619705, 0.99057856,
    -0.01429969, 0.13619705, 0.99057856,
    0.03660050, 0.49290679, 0.86931197,
    0.03660050, 0.49290679, 0.86931197,
    0.03660050, 0.49290679, 0.86931197,
    0.03660050, 0.49290679, 0.86931197,
    0.16689607, 0.51238793, 0.84238015,
    0.16689607, 0.51238793, 0.84238015,
    0.16689607, 0.51238793, 0.84238015,
    0.16689607, 0.51238793, 0.84238015,
    0.03719974, 0.15639892, 0.98699319,
    0.03719974, 0.15639892, 0.98699319,
    0.03719974, 0.15639892, 0.98699319,
    0.03719974, 0.15639892, 0.98699319,
    0.16430568, 0.77782688, -0.60662096,
    0.16430568, 0.77782688, -0.60662096,
    0.16430568, 0.77782688, -0.60662096,
    0.16430568, 0.77782688, -0.60662096,
    0.43222249, 0.70583673, -0.56122921,
    0.43222249, 0.70583673, -0.56122921,
    0.43222249, 0.70583673, -0.56122921,
    0.43222249, 0.70583673, -0.56122921,
    0.22131144, 0.89764638, -0.38111969,
    0.22131144, 0.89764638, -0.38111969,
    0.22131144, 0.89764638, -0.38111969,
    0.22131144, 0.89764638, -0.38111969,
    0.43859581, 0.89679144, -0.05829944,
    0.43859581, 0.89679144, -0.05829944,
    0.43859581, 0.89679144, -0.05829944,
    0.43859581, 0.89679144, -0.05829944,
    0.43859581, 0.89679144, -0.05829944,
    0.28319144, 0.95667110, -0.06769795,
    0.28319144, 0.95667110, -0.06769795,
    0.28319144, 0.95667110, -0.06769795,
    0.28319144, 0.95667110, -0.06769795,
    0.44787722, 0.85805636, 0.25128722,
    0.44787722, 0.85805636, 0.25128722,
    0.44787722, 0.85805636, 0.25128722,
    0.44787722, 0.85805636, 0.25128722,
    0.60726395, -0.64466173, -0.46437243,
    0.60726395, -0.64466173, -0.46437243,
    0.60726395, -0.64466173, -0.46437243,
    0.60726395, -0.64466173, -0.46437243,
    0.54738894, -0.68498616, -0.48079029,
    0.54738894, -0.68498616, -0.48079029,
    0.54738894, -0.68498616, -0.48079029,
    0.54738894, -0.68498616, -0.48079029,
    0.69139017, -0.71318985, -0.11549836,
    0.69139017, -0.71318985, -0.11549836,
    0.69139017, -0.71318985, -0.11549836,
    0.69139017, -0.71318985, -0.11549836,
    0.71519144, -0.64629226, -0.26609681,
    0.71519144, -0.64629226, -0.26609681,
    0.71519144, -0.64629226, -0.26609681,
    0.71519144, -0.64629226, -0.26609681,
    0.79087301, -0.61197912, 0.00119996,
    0.79087301, -0.61197912, 0.00119996,
    0.79087301, -0.61197912, 0.00119996,
    0.79087301, -0.61197912, 0.00119996,
    0.68490231, -0.72820245, 0.02510008,
    0.68490231, -0.72820245, 0.02510008,
    0.68490231, -0.72820245, 0.02510008,
    0.68490231, -0.72820245, 0.02510008,
    0.67049715, -0.74089685, -0.03879984,
    0.67049715, -0.74089685, -0.03879984,
    0.67049715, -0.74089685, -0.03879984,
    0.67049715, -0.74089685, -0.03879984,
    0.77643195, -0.62932590, -0.03320137,
    0.77643195, -0.62932590, -0.03320137,
    0.77643195, -0.62932590, -0.03320137,
    0.77643195, -0.62932590, -0.03320137,
    0.78056305, -0.62267052, -0.05479741,
    0.78056305, -0.62267052, -0.05479741,
    0.78056305, -0.62267052, -0.05479741,
    0.78056305, -0.62267052, -0.05479741,
    0.67346227, -0.73515881, -0.07739566,
    0.67346227, -0.73515881, -0.07739566,
    0.67346227, -0.73515881, -0.07739566,
    0.67346227, -0.73515881, -0.07739566,
    0.68639679, -0.72459661, -0.06179971,
    0.68639679, -0.72459661, -0.06179971,
    0.68639679, -0.72459661, -0.06179971,
    0.68639679, -0.72459661, -0.06179971,
    0.79209948, -0.60909960, -0.03969997,
    0.79209948, -0.60909960, -0.03969997,
    0.79209948, -0.60909960, -0.03969997,
    0.79209948, -0.60909960, -0.03969997,
    0.40990167, -0.80030326, -0.43760178,
    0.40990167, -0.80030326, -0.43760178,
    0.40990167, -0.80030326, -0.43760178,
    0.40990167, -0.80030326, -0.43760178,
    0.31710598, -0.84361592, -0.43330818,
    0.31710598, -0.84361592, -0.43330818,
    0.31710598, -0.84361592, -0.43330818,
    0.31710598, -0.84361592, -0.43330818,
    0.62479586, -0.78049483, 0.02139986,
    0.62479586, -0.78049483, 0.02139986,
    0.62479586, -0.78049483, 0.02139986,
    0.62479586, -0.78049483, 0.02139986,
    0.62479586, -0.78049483, 0.02139986,
    0.59297250, -0.79406317, -0.13359380,
    0.59297250, -0.79406317, -0.13359380,
    0.59297250, -0.79406317, -0.13359380,
    0.59297250, -0.79406317, -0.13359380,
    0.62302618, -0.77793269, -0.08160343,
    0.62302618, -0.77793269, -0.08160343,
    0.62302618, -0.77793269, -0.08160343,
    0.62302618, -0.77793269, -0.08160343,
    0.62302618, -0.77793269, -0.08160343,
    0.78426796, 0.53207826, -0.31908696,
    0.78426796, 0.53207826, -0.31908696,
    0.78426796, 0.53207826, -0.31908696,
    0.78426796, 0.53207826, -0.31908696,
    0.62250394, -0.77470490, -0.11100070,
    0.62250394, -0.77470490, -0.11100070,
    0.62250394, -0.77470490, -0.11100070,
    0.62250394, -0.77470490, -0.11100070,
    0.63639693, -0.76679630, -0.08379960,
    0.63639693, -0.76679630, -0.08379960,
    0.63639693, -0.76679630, -0.08379960,
    0.63639693, -0.76679630, -0.08379960,
    0.58408392, 0.63508251, -0.50548608,
    0.58408392, 0.63508251, -0.50548608,
    0.58408392, 0.63508251, -0.50548608,
    0.58408392, 0.63508251, -0.50548608,
    0.73351470, 0.53421070, -0.42020842,
    0.73351470, 0.53421070, -0.42020842,
    0.73351470, 0.53421070, -0.42020842,
    0.73351470, 0.53421070, -0.42020842,
    0.63661780, 0.69441942, -0.33540938,
    0.63661780, 0.69441942, -0.33540938,
    0.63661780, 0.69441942, -0.33540938,
    0.63661780, 0.69441942, -0.33540938,
    0.80945376, 0.58163863, 0.08050535,
    0.80945376, 0.58163863, 0.08050535,
    0.80945376, 0.58163863, 0.08050535,
    0.80945376, 0.58163863, 0.08050535,
    0.85028878, 0.52499308, -0.03729951,
    0.85028878, 0.52499308, -0.03729951,
    0.85028878, 0.52499308, -0.03729951,
    0.85028878, 0.52499308, -0.03729951,
    0.70179614, 0.70699611, -0.08739952,
    0.70179614, 0.70699611, -0.08739952,
    0.70179614, 0.70699611, -0.08739952,
    0.70179614, 0.70699611, -0.08739952,
    0.72108931, 0.69258973, 0.01869972,
    0.72108931, 0.69258973, 0.01869972,
    0.72108931, 0.69258973, 0.01869972,
    0.72108931, 0.69258973, 0.01869972,
    0.85339854, 0.52119911, 0.00789999,
    0.85339854, 0.52119911, 0.00789999,
    0.85339854, 0.52119911, 0.00789999,
    0.85339854, 0.52119911, 0.00789999,
    0.94386540, -0.03289879, 0.32868795,
    0.94386540, -0.03289879, 0.32868795,
    0.94386540, -0.03289879, 0.32868795,
    0.94386540, -0.03289879, 0.32868795,
    0.91960196, 0.30860066, 0.24310052,
    0.91960196, 0.30860066, 0.24310052,
    0.91960196, 0.30860066, 0.24310052,
    0.91960196, 0.30860066, 0.24310052,
    0.99905703, -0.04109823, 0.01399940,
    0.99905703, -0.04109823, 0.01399940,
    0.99905703, -0.04109823, 0.01399940,
    0.99905703, -0.04109823, 0.01399940,
    0.12430504, -0.16670675, -0.97813962,
    0.12430504, -0.16670675, -0.97813962,
    0.12430504, -0.16670675, -0.97813962,
    0.12430504, -0.16670675, -0.97813962,
    0.98630413, -0.16480069, -0.00670003,
    0.98630413, -0.16480069, -0.00670003,
    0.98630413, -0.16480069, -0.00670003,
    0.98630413, -0.16480069, -0.00670003,
    0.95857651, 0.28329306, 0.02959927,
    0.95857651, 0.28329306, 0.02959927,
    0.95857651, 0.28329306, 0.02959927,
    0.95857651, 0.28329306, 0.02959927,
    0.90966257, 0.26648903, -0.31858689,
    0.90966257, 0.26648903, -0.31858689,
    0.90966257, 0.26648903, -0.31858689,
    0.90966257, 0.26648903, -0.31858689,
    0.97121596, -0.21530354, -0.10190167,
    0.97121596, -0.21530354, -0.10190167,
    0.97121596, -0.21530354, -0.10190167,
    0.97121596, -0.21530354, -0.10190167,
    0.71362557, 0.23670848, -0.65932362,
    0.71362557, 0.23670848, -0.65932362,
    0.71362557, 0.23670848, -0.65932362,
    0.71362557, 0.23670848, -0.65932362,
    0.93937510, -0.34289091, -0.00049999,
    0.93937510, -0.34289091, -0.00049999,
    0.93937510, -0.34289091, -0.00049999,
    0.93937510, -0.34289091, -0.00049999,
    0.93937510, -0.34289091, -0.00049999,
    0.90099140, -0.41399605, -0.12969876,
    0.90099140, -0.41399605, -0.12969876,
    0.90099140, -0.41399605, -0.12969876,
    0.90099140, -0.41399605, -0.12969876,
    0.90099140, -0.41399605, -0.12969876,
    0.97377668, 0.22719456, -0.01189972,
    0.97377668, 0.22719456, -0.01189972,
    0.97377668, 0.22719456, -0.01189972,
    0.97377668, 0.22719456, -0.01189972,
    0.97377668, 0.22719456, -0.01189972,
    0.94462057, -0.28800627, 0.15730343,
    0.94462057, -0.28800627, 0.15730343,
    0.94462057, -0.28800627, 0.15730343,
    0.94462057, -0.28800627, 0.15730343,
    0.94462057, -0.28800627, 0.15730343,
    0.83203489, 0.55472326, -0.00020001,
    0.83203489, 0.55472326, -0.00020001,
    0.83203489, 0.55472326, -0.00020001,
    0.83203489, 0.55472326, -0.00020001,
    -0.70076686, -0.71246631, -0.03629828,
    -0.70076686, -0.71246631, -0.03629828,
    -0.70076686, -0.71246631, -0.03629828,
    -0.70076686, -0.71246631, -0.03629828,
    -0.70076686, -0.71246631, -0.03629828,
    -0.70076686, -0.71246631, -0.03629828,
    0.95062100, -0.15390340, 0.26950595,
    0.95062100, -0.15390340, 0.26950595,
    0.95062100, -0.15390340, 0.26950595,
    0.95062100, -0.15390340, 0.26950595,
    0.95062100, -0.15390340, 0.26950595,
    0.94640293, -0.11400035, 0.30220094,
    0.94640293, -0.11400035, 0.30220094,
    0.94640293, -0.11400035, 0.30220094,
    0.94640293, -0.11400035, 0.30220094,
    0.94640293, -0.11400035, 0.30220094,
    0.99637271, -0.08409770, 0.01299964,
    0.99637271, -0.08409770, 0.01299964,
    0.99637271, -0.08409770, 0.01299964,
    0.99637271, -0.08409770, 0.01299964,
    0.94446335, -0.11159567, 0.30908800,
    0.94446335, -0.11159567, 0.30908800,
    0.94446335, -0.11159567, 0.30908800,
    0.94446335, -0.11159567, 0.30908800,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    -0.00450022, -0.07920384, 0.99684828,
    0.02460006, -0.50460118, 0.86300202,
    0.02460006, -0.50460118, 0.86300202,
    0.02460006, -0.50460118, 0.86300202,
    0.02460006, -0.50460118, 0.86300202,
    0.00929993, -0.05409958, 0.99849224,
    0.00929993, -0.05409958, 0.99849224,
    0.00929993, -0.05409958, 0.99849224,
    0.00929993, -0.05409958, 0.99849224,
    0.00929993, -0.05409958, 0.99849224,
    0.00929993, -0.05409958, 0.99849224,
    0.02730117, -0.05970256, 0.99784280,
    0.02730117, -0.05970256, 0.99784280,
    0.02730117, -0.05970256, 0.99784280,
    0.02730117, -0.05970256, 0.99784280,
    0.02730117, -0.05970256, 0.99784280,
    0.46810952, -0.65811339, -0.58971200,
    0.46810952, -0.65811339, -0.58971200,
    0.46810952, -0.65811339, -0.58971200,
    0.46810952, -0.65811339, -0.58971200,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    0.00079998, -0.18429451, 0.98287074,
    -0.03980056, -0.09570135, 0.99461408,
    -0.03980056, -0.09570135, 0.99461408,
    -0.03980056, -0.09570135, 0.99461408,
    -0.03980056, -0.09570135, 0.99461408,
    -0.03980056, -0.09570135, 0.99461408,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.03400072, -0.18140383, 0.98282074,
    0.34902061, -0.66133905, -0.66393921,
    0.34902061, -0.66133905, -0.66393921,
    0.34902061, -0.66133905, -0.66393921,
    0.34902061, -0.66133905, -0.66393921,
    0.48132331, -0.57552787, -0.66113202,
    0.48132331, -0.57552787, -0.66113202,
    0.48132331, -0.57552787, -0.66113202,
    0.48132331, -0.57552787, -0.66113202,
    0.23990056, -0.61870145, -0.74810175,
    0.23990056, -0.61870145, -0.74810175,
    0.23990056, -0.61870145, -0.74810175,
    0.23990056, -0.61870145, -0.74810175,
    0.72166515, 0.11709435, -0.68226705,
    0.72166515, 0.11709435, -0.68226705,
    0.72166515, 0.11709435, -0.68226705,
    0.72166515, 0.11709435, -0.68226705,
    0.48659941, 0.10819987, -0.86689896,
    0.48659941, 0.10819987, -0.86689896,
    0.48659941, 0.10819987, -0.86689896,
    0.48659941, 0.10819987, -0.86689896,
    0.15359648, -0.67858446, -0.71828355,
    0.15359648, -0.67858446, -0.71828355,
    0.15359648, -0.67858446, -0.71828355,
    0.15359648, -0.67858446, -0.71828355,
    0.01819943, -0.69757813, -0.71627755,
    0.01819943, -0.69757813, -0.71627755,
    0.01819943, -0.69757813, -0.71627755,
    0.01819943, -0.69757813, -0.71627755,
    0.10909492, -0.62027111, -0.77676383,
    0.10909492, -0.62027111, -0.77676383,
    0.10909492, -0.62027111, -0.77676383,
    0.10909492, -0.62027111, -0.77676383,
    0.03899835, -0.61767389, -0.78546680,
    0.03899835, -0.61767389, -0.78546680,
    0.03899835, -0.61767389, -0.78546680,
    0.03899835, -0.61767389, -0.78546680,
    0.19150264, 0.07380102, -0.97871352,
    0.19150264, 0.07380102, -0.97871352,
    0.19150264, 0.07380102, -0.97871352,
    0.19150264, 0.07380102, -0.97871352,
    0.03360151, 0.05270237, -0.99804479,
    0.03360151, 0.05270237, -0.99804479,
    0.03360151, 0.05270237, -0.99804479,
    0.03360151, 0.05270237, -0.99804479,
    0.65886174, -0.60566483, -0.44617409,
    0.65886174, -0.60566483, -0.44617409,
    0.65886174, -0.60566483, -0.44617409,
    0.65886174, -0.60566483, -0.44617409,
    0.04889829, -0.00879969, 0.99876500,
    0.04889829, -0.00879969, 0.99876500,
    0.04889829, -0.00879969, 0.99876500,
    0.04889829, -0.00879969, 0.99876500,
    0.56873130, -0.06250344, 0.82014513,
    0.56873130, -0.06250344, 0.82014513,
    0.56873130, -0.06250344, 0.82014513,
    0.56873130, -0.06250344, 0.82014513,
    0.64877749, -0.32628868, 0.68747615,
    0.64877749, -0.32628868, 0.68747615,
    0.64877749, -0.32628868, 0.68747615,
    0.64877749, -0.32628868, 0.68747615,
    0.09319845, -0.01129981, 0.99558343,
    0.09319845, -0.01129981, 0.99558343,
    0.09319845, -0.01129981, 0.99558343,
    0.09319845, -0.01129981, 0.99558343,
    0.10379932, -0.10729929, 0.98879349,
    0.10379932, -0.10729929, 0.98879349,
    0.10379932, -0.10729929, 0.98879349,
    0.10379932, -0.10729929, 0.98879349,
    0.52140186, -0.12090043, 0.84470302,
    0.52140186, -0.12090043, 0.84470302,
    0.52140186, -0.12090043, 0.84470302,
    0.52140186, -0.12090043, 0.84470302,
    0.54021103, -0.05520113, 0.83971714,
    0.54021103, -0.05520113, 0.83971714,
    0.54021103, -0.05520113, 0.83971714,
    0.54021103, -0.05520113, 0.83971714,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.08019852, -0.20589620, 0.97528199,
    0.10149666, -0.08179731, 0.99146741,
    0.10149666, -0.08179731, 0.99146741,
    0.10149666, -0.08179731, 0.99146741,
    0.10149666, -0.08179731, 0.99146741,
    0.45591501, -0.14380474, 0.87832892,
    0.45591501, -0.14380474, 0.87832892,
    0.45591501, -0.14380474, 0.87832892,
    0.45591501, -0.14380474, 0.87832892,
    0.48518354, -0.19289346, 0.85287106,
    0.48518354, -0.19289346, 0.85287106,
    0.48518354, -0.19289346, 0.85287106,
    0.48518354, -0.19289346, 0.85287106,
    0.76978895, -0.43949369, -0.46289336,
    0.76978895, -0.43949369, -0.46289336,
    0.76978895, -0.43949369, -0.46289336,
    0.76978895, -0.43949369, -0.46289336,
    0.98145390, -0.03640200, -0.18821034,
    0.98145390, -0.03640200, -0.18821034,
    0.98145390, -0.03640200, -0.18821034,
    0.98145390, -0.03640200, -0.18821034,
    0.87728610, 0.10019841, -0.46939256,
    0.87728610, 0.10019841, -0.46939256,
    0.87728610, 0.10019841, -0.46939256,
    0.87728610, 0.10019841, -0.46939256,
    0.87005192, 0.18451101, -0.45712728,
    0.87005192, 0.18451101, -0.45712728,
    0.87005192, 0.18451101, -0.45712728,
    0.87005192, 0.18451101, -0.45712728,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    0.01579955, -0.10089710, 0.99477141,
    -0.34360284, -0.93910777, -0.00370003,
    -0.34360284, -0.93910777, -0.00370003,
    -0.34360284, -0.93910777, -0.00370003,
    -0.34360284, -0.93910777, -0.00370003,
    0.67709547, 0.73589508, -0.00040000,
    0.67709547, 0.73589508, -0.00040000,
    0.67709547, 0.73589508, -0.00040000,
    0.67709547, 0.73589508, -0.00040000,
    0.90781309, -0.28920417, -0.30370438,
    0.90781309, -0.28920417, -0.30370438,
    0.90781309, -0.28920417, -0.30370438,
    0.90781309, -0.28920417, -0.30370438,
    -0.11410185, -0.13600220, -0.98411593,
    -0.11410185, -0.13600220, -0.98411593,
    -0.11410185, -0.13600220, -0.98411593,
    -0.11410185, -0.13600220, -0.98411593,
    0.89880111, 0.03570004, 0.43690054,
    0.89880111, 0.03570004, 0.43690054,
    0.89880111, 0.03570004, 0.43690054,
    0.89880111, 0.03570004, 0.43690054,
    0.97132686, -0.13600376, 0.19500539,
    0.97132686, -0.13600376, 0.19500539,
    0.97132686, -0.13600376, 0.19500539,
    0.97132686, -0.13600376, 0.19500539,
    0.95177645, -0.30679241, -0.00010000,
    0.95177645, -0.30679241, -0.00010000,
    0.95177645, -0.30679241, -0.00010000,
    0.95177645, -0.30679241, -0.00010000,
    -0.88477413, 0.22719336, 0.40688810,
    -0.88477413, 0.22719336, 0.40688810,
    -0.88477413, 0.22719336, 0.40688810,
    -0.88477413, 0.22719336, 0.40688810,
    -0.60228771, -0.50628967, 0.61718740,
    -0.60228771, -0.50628967, 0.61718740,
    -0.60228771, -0.50628967, 0.61718740,
    -0.60228771, -0.50628967, 0.61718740,
    0.13629980, -0.07129989, 0.98809852,
    0.13629980, -0.07129989, 0.98809852,
    0.13629980, -0.07129989, 0.98809852,
    0.13629980, -0.07129989, 0.98809852,
    0.39350883, -0.91932064, -0.00060001,
    0.39350883, -0.91932064, -0.00060001,
    0.39350883, -0.91932064, -0.00060001,
    0.39350883, -0.91932064, -0.00060001,
    0.99893006, -0.04420133, 0.01360041,
    0.99893006, -0.04420133, 0.01360041,
    0.99893006, -0.04420133, 0.01360041,
    0.99893006, -0.04420133, 0.01360041,
    0.98679532, 0.16169923, -0.00939996,
    0.98679532, 0.16169923, -0.00939996,
    0.98679532, 0.16169923, -0.00939996,
    0.98679532, 0.16169923, -0.00939996,
    0.98679532, 0.16169923, -0.00939996,
    0.98679532, 0.16169923, -0.00939996,
    -0.01689915, -0.64206781, 0.76646157,
    -0.01689915, -0.64206781, 0.76646157,
    -0.01689915, -0.64206781, 0.76646157,
    -0.01689915, -0.64206781, 0.76646157,
    0.92138457, -0.26229561, -0.28679520,
    0.92138457, -0.26229561, -0.28679520,
    0.92138457, -0.26229561, -0.28679520,
    0.92138457, -0.26229561, -0.28679520,
    0.16350817, -0.16260813, -0.97304865,
    0.16350817, -0.16260813, -0.97304865,
    0.16350817, -0.16260813, -0.97304865,
    0.16350817, -0.16260813, -0.97304865,
    0.13130553, 0.99134177, -0.00060003,
    0.13130553, 0.99134177, -0.00060003,
    0.13130553, 0.99134177, -0.00060003,
    0.13130553, 0.99134177, -0.00060003,
    0.04210091, 0.75461637, -0.65481421,
    0.04210091, 0.75461637, -0.65481421,
    0.04210091, 0.75461637, -0.65481421,
    0.04210091, 0.75461637, -0.65481421,
    0.71388394, 0.52028830, -0.46868946,
    0.71388394, 0.52028830, -0.46868946,
    0.71388394, 0.52028830, -0.46868946,
    0.71388394, 0.52028830, -0.46868946,
    0.18560182, 0.00550005, 0.98260964,
    0.18560182, 0.00550005, 0.98260964,
    0.18560182, 0.00550005, 0.98260964,
    0.18560182, 0.00550005, 0.98260964,
    0.99452306, -0.10440242, 0.00490011,
    0.99452306, -0.10440242, 0.00490011,
    0.99452306, -0.10440242, 0.00490011,
    0.99452306, -0.10440242, 0.00490011,
    0.47139791, -0.19409914, 0.86029619,
    0.47139791, -0.19409914, 0.86029619,
    0.47139791, -0.19409914, 0.86029619,
    0.47139791, -0.19409914, 0.86029619,
    0.08599923, -0.19009829, 0.97799119,
    0.08599923, -0.19009829, 0.97799119,
    0.08599923, -0.19009829, 0.97799119,
    0.08599923, -0.19009829, 0.97799119,
    0.94805168, -0.11470625, 0.29671617,
    0.94805168, -0.11470625, 0.29671617,
    0.94805168, -0.11470625, 0.29671617,
    0.94805168, -0.11470625, 0.29671617,
    0.94805168, -0.11470625, 0.29671617,
    0.16700118, 0.75170530, -0.63800450,
    0.16700118, 0.75170530, -0.63800450,
    0.16700118, 0.75170530, -0.63800450,
    0.16700118, 0.75170530, -0.63800450,
    0.14150448, -0.13100415, -0.98123106,
    0.14150448, -0.13100415, -0.98123106,
    0.14150448, -0.13100415, -0.98123106,
    0.14150448, -0.13100415, -0.98123106,
    0.99199133, -0.03879966, -0.12019895,
    0.99199133, -0.03879966, -0.12019895,
    0.99199133, -0.03879966, -0.12019895,
    0.99199133, -0.03879966, -0.12019895,
    0.97897206, -0.20399418, -0.00029999,
    0.97897206, -0.20399418, -0.00029999,
    0.97897206, -0.20399418, -0.00029999,
    0.97897206, -0.20399418, -0.00029999,
    0.97281956, -0.19250387, 0.12870259,
    0.97281956, -0.19250387, 0.12870259,
    0.97281956, -0.19250387, 0.12870259,
    0.97281956, -0.19250387, 0.12870259,
    -0.89746484, 0.26328969, 0.35388614,
    -0.89746484, 0.26328969, 0.35388614,
    -0.89746484, 0.26328969, 0.35388614,
    -0.89746484, 0.26328969, 0.35388614,
    0.49290911, -0.18850349, 0.84941571,
    0.49290911, -0.18850349, 0.84941571,
    0.49290911, -0.18850349, 0.84941571,
    0.49290911, -0.18850349, 0.84941571,
    0.88089230, -0.02219981, -0.47279587,
    0.88089230, -0.02219981, -0.47279587,
    0.88089230, -0.02219981, -0.47279587,
    0.88089230, -0.02219981, -0.47279587,
    0.02940101, -0.31501082, -0.94863258,
    0.02940101, -0.31501082, -0.94863258,
    0.02940101, -0.31501082, -0.94863258,
    0.02940101, -0.31501082, -0.94863258,
    0.11599998, -0.30549996, -0.94509988,
    0.11599998, -0.30549996, -0.94509988,
    0.11599998, -0.30549996, -0.94509988,
    0.11599998, -0.30549996, -0.94509988,
    0.34539637, -0.23679751, -0.90809046,
    0.34539637, -0.23679751, -0.90809046,
    0.34539637, -0.23679751, -0.90809046,
    0.34539637, -0.23679751, -0.90809046,
    0.66229186, -0.10329873, -0.74209088,
    0.66229186, -0.10329873, -0.74209088,
    0.66229186, -0.10329873, -0.74209088,
    0.66229186, -0.10329873, -0.74209088,
    -0.87932702, -0.47621463, 0.00190006,
    -0.87932702, -0.47621463, 0.00190006,
    -0.87932702, -0.47621463, 0.00190006,
    -0.87932702, -0.47621463, 0.00190006,
    0.49788299, -0.18459369, 0.84737105,
    0.49788299, -0.18459369, 0.84737105,
    0.49788299, -0.18459369, 0.84737105,
    0.49788299, -0.18459369, 0.84737105,
    0.03729809, -0.06559664, 0.99714890,
    0.03729809, -0.06559664, 0.99714890,
    0.03729809, -0.06559664, 0.99714890,
    0.03729809, -0.06559664, 0.99714890,
    0.03729809, -0.06559664, 0.99714890,
    0.03729809, -0.06559664, 0.99714890,
    0.19929333, -0.35398815, 0.91376942,
    0.19929333, -0.35398815, 0.91376942,
    0.19929333, -0.35398815, 0.91376942,
    0.19929333, -0.35398815, 0.91376942,
    0.19929333, -0.35398815, 0.91376942,
    0.19929333, -0.35398815, 0.91376942,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05829854, -0.07369816, 0.99557514,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.05689849, -0.07069813, 0.99587365,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.21210135, -0.00900006, 0.97720623,
    -0.21210135, -0.00900006, 0.97720623,
    -0.21210135, -0.00900006, 0.97720623,
    -0.21210135, -0.00900006, 0.97720623,
    -0.21829106, -0.00679972, 0.97586002,
    -0.21829106, -0.00679972, 0.97586002,
    -0.21829106, -0.00679972, 0.97586002,
    -0.21829106, -0.00679972, 0.97586002,
    0.27429162, 0.16679490, -0.94707105,
    0.27429162, 0.16679490, -0.94707105,
    0.27429162, 0.16679490, -0.94707105,
    0.27429162, 0.16679490, -0.94707105,
    0.29990548, -0.01700031, -0.95381743,
    0.29990548, -0.01700031, -0.95381743,
    0.29990548, -0.01700031, -0.95381743,
    0.29990548, -0.01700031, -0.95381743,
    -0.20310694, 0.02090071, 0.97893347,
    -0.20310694, 0.02090071, 0.97893347,
    -0.20310694, 0.02090071, 0.97893347,
    -0.20310694, 0.02090071, 0.97893347,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.18899430, 0.02019939, 0.98177041,
    -0.18899430, 0.02019939, 0.98177041,
    -0.18899430, 0.02019939, 0.98177041,
    -0.18899430, 0.02019939, 0.98177041,
    -0.19800531, 0.03050082, 0.97972629,
    -0.19800531, 0.03050082, 0.97972629,
    -0.19800531, 0.03050082, 0.97972629,
    -0.19800531, 0.03050082, 0.97972629,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    0.19800158, 0.02400019, 0.97990783,
    0.19800158, 0.02400019, 0.97990783,
    0.19800158, 0.02400019, 0.97990783,
    0.19800158, 0.02400019, 0.97990783,
    -0.19530528, 0.00560015, 0.98072651,
    -0.19530528, 0.00560015, 0.98072651,
    -0.19530528, 0.00560015, 0.98072651,
    -0.19530528, 0.00560015, 0.98072651,
    -0.99178728, 0.12789836, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    0.18039668, 0.59648902, -0.78208560,
    0.18039668, 0.59648902, -0.78208560,
    0.18039668, 0.59648902, -0.78208560,
    0.18039668, 0.59648902, -0.78208560,
    0.19779376, -0.02319927, 0.97996909,
    0.19779376, -0.02319927, 0.97996909,
    0.19779376, -0.02319927, 0.97996909,
    0.19779376, -0.02319927, 0.97996909,
    0.28989777, -0.20839840, -0.93409282,
    0.28989777, -0.20839840, -0.93409282,
    0.28989777, -0.20839840, -0.93409282,
    0.28989777, -0.20839840, -0.93409282,
    0.19708993, -0.01629917, 0.98024992,
    0.19708993, -0.01629917, 0.98024992,
    0.19708993, -0.01629917, 0.98024992,
    0.19708993, -0.01629917, 0.98024992,
    0.19869554, 0.04159907, 0.97917802,
    0.19869554, 0.04159907, 0.97917802,
    0.19869554, 0.04159907, 0.97917802,
    0.19869554, 0.04159907, 0.97917802,
    0.23279091, 0.41578376, -0.87916566,
    0.23279091, 0.41578376, -0.87916566,
    0.23279091, 0.41578376, -0.87916566,
    0.23279091, 0.41578376, -0.87916566,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    -0.16760261, 0.00880014, 0.98581536,
    -0.16760261, 0.00880014, 0.98581536,
    -0.16760261, 0.00880014, 0.98581536,
    -0.16760261, 0.00880014, 0.98581536,
    0.25079185, -0.28359079, -0.92556994,
    0.25079185, -0.28359079, -0.92556994,
    0.25079185, -0.28359079, -0.92556994,
    0.25079185, -0.28359079, -0.92556994,
    0.00729965, -0.00649969, 0.99995223,
    0.00729965, -0.00649969, 0.99995223,
    0.00729965, -0.00649969, 0.99995223,
    0.00729965, -0.00649969, 0.99995223,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.18330552, 0.00720022, 0.98302962,
    -0.18330552, 0.00720022, 0.98302962,
    -0.18330552, 0.00720022, 0.98302962,
    -0.18330552, 0.00720022, 0.98302962,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    -0.19610482, 0.03310081, 0.98002410,
    -0.19610482, 0.03310081, 0.98002410,
    -0.19610482, 0.03310081, 0.98002410,
    -0.19610482, 0.03310081, 0.98002410,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.22850448, -0.04240083, -0.97261908,
    0.22850448, -0.04240083, -0.97261908,
    0.22850448, -0.04240083, -0.97261908,
    0.22850448, -0.04240083, -0.97261908,
    0.22859401, 0.00959975, -0.97347451,
    0.22859401, 0.00959975, -0.97347451,
    0.22859401, 0.00959975, -0.97347451,
    0.22859401, 0.00959975, -0.97347451,
    0.22870012, 0.01370001, -0.97340052,
    0.22870012, 0.01370001, -0.97340052,
    0.22870012, 0.01370001, -0.97340052,
    0.22870012, 0.01370001, -0.97340052,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.19130283, 0.00570008, 0.98151451,
    -0.19130283, 0.00570008, 0.98151451,
    -0.19130283, 0.00570008, 0.98151451,
    -0.19130283, 0.00570008, 0.98151451,
    -0.19739948, -0.00709998, 0.98029742,
    -0.19739948, -0.00709998, 0.98029742,
    -0.19739948, -0.00709998, 0.98029742,
    -0.19739948, -0.00709998, 0.98029742,
    -0.19620042, -0.01100002, 0.98050211,
    -0.19620042, -0.01100002, 0.98050211,
    -0.19620042, -0.01100002, 0.98050211,
    -0.19620042, -0.01100002, 0.98050211,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.20809584, -0.00739985, -0.97808045,
    0.20809584, -0.00739985, -0.97808045,
    0.20809584, -0.00739985, -0.97808045,
    0.20809584, -0.00739985, -0.97808045,
    0.06819807, 0.00000000, -0.99767180,
    0.06819807, 0.00000000, -0.99767180,
    0.06819807, 0.00000000, -0.99767180,
    0.06819807, 0.00000000, -0.99767180,
    0.05880031, -0.88240466, -0.46680246,
    0.05880031, -0.88240466, -0.46680246,
    0.05880031, -0.88240466, -0.46680246,
    0.05880031, -0.88240466, -0.46680246,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.26848759, -0.00729966, -0.96325548,
    -0.26848759, -0.00729966, -0.96325548,
    -0.26848759, -0.00729966, -0.96325548,
    -0.26848759, -0.00729966, -0.96325548,
    0.19079991, 0.00760000, 0.98159953,
    0.19079991, 0.00760000, 0.98159953,
    0.19079991, 0.00760000, 0.98159953,
    0.19079991, 0.00760000, 0.98159953,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.06489773, -0.87926918, 0.47188346,
    -0.06489773, -0.87926918, 0.47188346,
    -0.06489773, -0.87926918, 0.47188346,
    -0.06489773, -0.87926918, 0.47188346,
    -0.99486627, -0.10119657, -0.00059998,
    -0.99486627, -0.10119657, -0.00059998,
    -0.99486627, -0.10119657, -0.00059998,
    -0.99486627, -0.10119657, -0.00059998,
    0.20151070, 0.00820044, -0.97945199,
    0.20151070, 0.00820044, -0.97945199,
    0.20151070, 0.00820044, -0.97945199,
    0.20151070, 0.00820044, -0.97945199,
    0.20921036, 0.04470221, -0.97684837,
    0.20921036, 0.04470221, -0.97684837,
    0.20921036, 0.04470221, -0.97684837,
    0.20921036, 0.04470221, -0.97684837,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.22229682, -0.03399951, -0.97438604,
    -0.22229682, -0.03399951, -0.97438604,
    -0.22229682, -0.03399951, -0.97438604,
    -0.22229682, -0.03399951, -0.97438604,
    0.18610468, -0.00320008, 0.98252471,
    0.18610468, -0.00320008, 0.98252471,
    0.18610468, -0.00320008, 0.98252471,
    0.18610468, -0.00320008, 0.98252471,
    -0.22689216, 0.32108891, -0.91946825,
    -0.22689216, 0.32108891, -0.91946825,
    -0.22689216, 0.32108891, -0.91946825,
    -0.22689216, 0.32108891, -0.91946825,
    -0.19928897, -0.06249654, -0.97794585,
    -0.19928897, -0.06249654, -0.97794585,
    -0.19928897, -0.06249654, -0.97794585,
    -0.19928897, -0.06249654, -0.97794585,
    0.30599011, 0.20009353, -0.93076991,
    0.30599011, 0.20009353, -0.93076991,
    0.30599011, 0.20009353, -0.93076991,
    0.30599011, 0.20009353, -0.93076991,
    0.00309998, 0.93819340, 0.34609757,
    0.00309998, 0.93819340, 0.34609757,
    0.00309998, 0.93819340, 0.34609757,
    0.00309998, 0.93819340, 0.34609757,
    -0.99890882, 0.04670041, -0.00050000,
    -0.99890882, 0.04670041, -0.00050000,
    -0.99890882, 0.04670041, -0.00050000,
    -0.99890882, 0.04670041, -0.00050000,
    -0.16169659, -0.01099977, -0.98677921,
    -0.16169659, -0.01099977, -0.98677921,
    -0.16169659, -0.01099977, -0.98677921,
    -0.16169659, -0.01099977, -0.98677921,
    -0.15920465, -0.22600659, -0.96102804,
    -0.15920465, -0.22600659, -0.96102804,
    -0.15920465, -0.22600659, -0.96102804,
    -0.15920465, -0.22600659, -0.96102804,
    -0.85287806, 0.46638800, -0.23469396,
    -0.85287806, 0.46638800, -0.23469396,
    -0.85287806, 0.46638800, -0.23469396,
    -0.85287806, 0.46638800, -0.23469396,
    -0.05219935, 0.99858761, -0.00989988,
    -0.05219935, 0.99858761, -0.00989988,
    -0.05219935, 0.99858761, -0.00989988,
    -0.05219935, 0.99858761, -0.00989988,
    0.99229475, 0.12389934, 0.00030000,
    0.99229475, 0.12389934, 0.00030000,
    0.99229475, 0.12389934, 0.00030000,
    0.99229475, 0.12389934, 0.00030000,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    -0.00660020, 0.32720991, -0.94492863,
    -0.00660020, 0.32720991, -0.94492863,
    -0.00660020, 0.32720991, -0.94492863,
    -0.00660020, 0.32720991, -0.94492863,
    -0.00660020, 0.32720991, -0.94492863,
    0.00519987, -0.00469988, -0.99997544,
    0.00519987, -0.00469988, -0.99997544,
    0.00519987, -0.00469988, -0.99997544,
    0.00519987, -0.00469988, -0.99997544,
    0.32919376, -0.03309937, -0.94368210,
    0.32919376, -0.03309937, -0.94368210,
    0.32919376, -0.03309937, -0.94368210,
    0.32919376, -0.03309937, -0.94368210,
    0.19049483, -0.00539985, 0.98167335,
    0.19049483, -0.00539985, 0.98167335,
    0.19049483, -0.00539985, 0.98167335,
    0.19049483, -0.00539985, 0.98167335,
    0.05750253, 0.10930481, 0.99234365,
    0.05750253, 0.10930481, 0.99234365,
    0.05750253, 0.10930481, 0.99234365,
    0.05750253, 0.10930481, 0.99234365,
    -0.99228245, 0.12399781, -0.00029999,
    -0.99228245, 0.12399781, -0.00029999,
    -0.99228245, 0.12399781, -0.00029999,
    -0.99228245, 0.12399781, -0.00029999,
    -0.97331528, 0.22940360, 0.00560009,
    -0.97331528, 0.22940360, 0.00560009,
    -0.97331528, 0.22940360, 0.00560009,
    -0.97331528, 0.22940360, 0.00560009,
    -0.99890415, 0.04680019, 0.00050000,
    -0.99890415, 0.04680019, 0.00050000,
    -0.99890415, 0.04680019, 0.00050000,
    -0.99890415, 0.04680019, 0.00050000,
    -0.22080541, -0.14470355, -0.96452364,
    -0.22080541, -0.14470355, -0.96452364,
    -0.22080541, -0.14470355, -0.96452364,
    -0.22080541, -0.14470355, -0.96452364,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    0.21840729, 0.07420248, 0.97303250,
    0.21840729, 0.07420248, 0.97303250,
    0.21840729, 0.07420248, 0.97303250,
    0.21840729, 0.07420248, 0.97303250,
    0.27719966, -0.15759981, -0.94779884,
    0.27719966, -0.15759981, -0.94779884,
    0.27719966, -0.15759981, -0.94779884,
    0.27719966, -0.15759981, -0.94779884,
    -0.06240319, 0.99805102, 0.00000000,
    -0.06240319, 0.99805102, 0.00000000,
    -0.06240319, 0.99805102, 0.00000000,
    -0.06240319, 0.99805102, 0.00000000,
    -0.88630789, 0.46210412, -0.03030027,
    -0.88630789, 0.46210412, -0.03030027,
    -0.88630789, 0.46210412, -0.03030027,
    -0.88630789, 0.46210412, -0.03030027,
    -0.05209968, 0.99859380, 0.00979994,
    -0.05209968, 0.99859380, 0.00979994,
    -0.05209968, 0.99859380, 0.00979994,
    -0.05209968, 0.99859380, 0.00979994,
    0.02690103, 0.99963810, 0.00000000,
    0.02690103, 0.99963810, 0.00000000,
    0.02690103, 0.99963810, 0.00000000,
    0.02690103, 0.99963810, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.89572345, -0.44461164, 0.00000000,
    -0.99486627, -0.10119657, 0.00059998,
    -0.99486627, -0.10119657, 0.00059998,
    -0.99486627, -0.10119657, 0.00059998,
    -0.99486627, -0.10119657, 0.00059998,
    -0.99487651, -0.10109761, 0.00000000,
    -0.99487651, -0.10109761, 0.00000000,
    -0.99487651, -0.10109761, 0.00000000,
    -0.99487651, -0.10109761, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.96369678, -0.26699911, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -0.93487055, -0.35498882, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.94677640, -0.32189198, 0.00000000,
    0.22080027, -0.00590001, 0.97530120,
    0.22080027, -0.00590001, 0.97530120,
    0.22080027, -0.00590001, 0.97530120,
    0.22080027, -0.00590001, 0.97530120,
    0.01089993, -0.00969994, -0.99989355,
    0.01089993, -0.00969994, -0.99989355,
    0.01089993, -0.00969994, -0.99989355,
    0.01089993, -0.00969994, -0.99989355,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99889020, -0.04709954, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99980593, -0.01970012, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    -0.99944202, 0.03340140, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99768539, 0.06799900, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.99837426, 0.05699853, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    0.97577118, -0.21879354, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99202976, 0.12600378, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    -0.99978574, -0.02069970, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    0.99460853, -0.10370089, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    -0.99942181, 0.03400074, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99077776, -0.13549696, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    0.99974911, -0.02239886, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.98481576, 0.17360278, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.96485376, 0.26278741, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.98243472, 0.18660659, 0.00000000,
    -0.15899765, -0.13729797, 0.97768554,
    -0.15899765, -0.13729797, 0.97768554,
    -0.15899765, -0.13729797, 0.97768554,
    -0.15899765, -0.13729797, 0.97768554,
    -0.31409579, 0.05849922, -0.94758729,
    -0.31409579, 0.05849922, -0.94758729,
    -0.31409579, 0.05849922, -0.94758729,
    -0.31409579, 0.05849922, -0.94758729,
    0.20070793, -0.02040081, 0.97943868,
    0.20070793, -0.02040081, 0.97943868,
    0.20070793, -0.02040081, 0.97943868,
    0.20070793, -0.02040081, 0.97943868,
    -0.32750999, 0.41521267, -0.84872590,
    -0.32750999, 0.41521267, -0.84872590,
    -0.32750999, 0.41521267, -0.84872590,
    -0.32750999, 0.41521267, -0.84872590,
    0.05909717, -0.99825223, 0.00000000,
    0.05909717, -0.99825223, 0.00000000,
    0.05909717, -0.99825223, 0.00000000,
    0.05909717, -0.99825223, 0.00000000,
    0.24099484, -0.17079634, 0.95537956,
    0.24099484, -0.17079634, 0.95537956,
    0.24099484, -0.17079634, 0.95537956,
    0.24099484, -0.17079634, 0.95537956,
    -0.90771357, 0.41950627, 0.00840013,
    -0.90771357, 0.41950627, 0.00840013,
    -0.90771357, 0.41950627, 0.00840013,
    -0.90771357, 0.41950627, 0.00840013,
    -0.24149652, -0.07769888, 0.96728606,
    -0.24149652, -0.07769888, 0.96728606,
    -0.24149652, -0.07769888, 0.96728606,
    -0.24149652, -0.07769888, 0.96728606,
    -0.99199214, 0.12629900, 0.00040000,
    -0.99199214, 0.12629900, 0.00040000,
    -0.99199214, 0.12629900, 0.00040000,
    -0.99199214, 0.12629900, 0.00040000,
    -0.19140272, 0.03700053, 0.98081393,
    -0.19140272, 0.03700053, 0.98081393,
    -0.19140272, 0.03700053, 0.98081393,
    -0.19140272, 0.03700053, 0.98081393,
    -0.08340134, -0.99651604, 0.00000000,
    -0.08340134, -0.99651604, 0.00000000,
    -0.08340134, -0.99651604, 0.00000000,
    -0.08340134, -0.99651604, 0.00000000,
    -0.16370446, 0.10480285, 0.98092671,
    -0.16370446, 0.10480285, 0.98092671,
    -0.16370446, 0.10480285, 0.98092671,
    -0.16370446, 0.10480285, 0.98092671,
    -0.16140010, 0.09710006, 0.98210060,
    -0.16140010, 0.09710006, 0.98210060,
    -0.16140010, 0.09710006, 0.98210060,
    -0.16140010, 0.09710006, 0.98210060,
    -0.22758841, 0.97375039, 0.00369981,
    -0.22758841, 0.97375039, 0.00369981,
    -0.22758841, 0.97375039, 0.00369981,
    -0.22758841, 0.97375039, 0.00369981,
    0.20780630, 0.02580078, -0.97782967,
    0.20780630, 0.02580078, -0.97782967,
    0.20780630, 0.02580078, -0.97782967,
    0.20780630, 0.02580078, -0.97782967,
    -0.15409631, 0.02349944, 0.98777634,
    -0.15409631, 0.02349944, 0.98777634,
    -0.15409631, 0.02349944, 0.98777634,
    -0.15409631, 0.02349944, 0.98777634,
    0.00939969, -0.03429888, 0.99936742,
    0.00939969, -0.03429888, 0.99936742,
    0.00939969, -0.03429888, 0.99936742,
    0.00939969, -0.03429888, 0.99936742,
    0.00939969, -0.03429888, 0.99936742,
    -0.22749509, 0.97377898, 0.00069998,
    -0.22749509, 0.97377898, 0.00069998,
    -0.22749509, 0.97377898, 0.00069998,
    -0.22749509, 0.97377898, 0.00069998,
    0.18620863, -0.19110885, -0.96374465,
    0.18620863, -0.19110885, -0.96374465,
    0.18620863, -0.19110885, -0.96374465,
    0.18620863, -0.19110885, -0.96374465,
    -0.25669483, 0.40099193, -0.87938230,
    -0.25669483, 0.40099193, -0.87938230,
    -0.25669483, 0.40099193, -0.87938230,
    -0.25669483, 0.40099193, -0.87938230,
    -0.16329137, 0.00769959, -0.98654784,
    -0.16329137, 0.00769959, -0.98654784,
    -0.16329137, 0.00769959, -0.98654784,
    -0.16329137, 0.00769959, -0.98654784,
    -0.21978839, -0.17919053, -0.95894933,
    -0.21978839, -0.17919053, -0.95894933,
    -0.21978839, -0.17919053, -0.95894933,
    -0.21978839, -0.17919053, -0.95894933,
    -0.25671086, 0.03800161, -0.96574086,
    -0.25671086, 0.03800161, -0.96574086,
    -0.25671086, 0.03800161, -0.96574086,
    -0.25671086, 0.03800161, -0.96574086,
    -0.14519917, -0.53059697, -0.83509524,
    -0.14519917, -0.53059697, -0.83509524,
    -0.14519917, -0.53059697, -0.83509524,
    -0.14519917, -0.53059697, -0.83509524,
    0.99600474, -0.08930042, 0.00000000,
    0.99600474, -0.08930042, 0.00000000,
    0.99600474, -0.08930042, 0.00000000,
    0.99600474, -0.08930042, 0.00000000,
    -0.99987200, 0.01599955, 0.00000000,
    -0.99987200, 0.01599955, 0.00000000,
    -0.99987200, 0.01599955, 0.00000000,
    -0.99987200, 0.01599955, 0.00000000,
    -0.94829258, 0.31739752, 0.00000000,
    -0.94829258, 0.31739752, 0.00000000,
    -0.94829258, 0.31739752, 0.00000000,
    -0.94829258, 0.31739752, 0.00000000,
    0.97727103, -0.21199372, 0.00000000,
    0.97727103, -0.21199372, 0.00000000,
    0.97727103, -0.21199372, 0.00000000,
    0.97727103, -0.21199372, 0.00000000,
    -0.73272581, -0.68052398, 0.00000000,
    -0.73272581, -0.68052398, 0.00000000,
    -0.73272581, -0.68052398, 0.00000000,
    -0.73272581, -0.68052398, 0.00000000,
    0.19260400, -0.01050022, 0.98122039,
    0.19260400, -0.01050022, 0.98122039,
    0.19260400, -0.01050022, 0.98122039,
    0.19260400, -0.01050022, 0.98122039,
    0.12969760, -0.52879023, 0.83878450,
    0.12969760, -0.52879023, 0.83878450,
    0.12969760, -0.52879023, 0.83878450,
    0.12969760, -0.52879023, 0.83878450,
    -0.13179691, -0.00010000, -0.99127674,
    -0.13179691, -0.00010000, -0.99127674,
    -0.13179691, -0.00010000, -0.99127674,
    -0.13179691, -0.00010000, -0.99127674,
    0.15839642, -0.04209905, 0.98647770,
    0.15839642, -0.04209905, 0.98647770,
    0.15839642, -0.04209905, 0.98647770,
    0.15839642, -0.04209905, 0.98647770,
    0.97833919, -0.20700829, 0.00000000,
    0.97833919, -0.20700829, 0.00000000,
    0.97833919, -0.20700829, 0.00000000,
    0.97833919, -0.20700829, 0.00000000,
    0.96995398, 0.24328846, 0.00000000,
    0.96995398, 0.24328846, 0.00000000,
    0.96995398, 0.24328846, 0.00000000,
    0.96995398, 0.24328846, 0.00000000,
    -0.12899837, 0.03609954, -0.99098751,
    -0.12899837, 0.03609954, -0.99098751,
    -0.12899837, 0.03609954, -0.99098751,
    -0.12899837, 0.03609954, -0.99098751,
    -0.12490048, -0.01140004, -0.99210378,
    -0.12490048, -0.01140004, -0.99210378,
    -0.12490048, -0.01140004, -0.99210378,
    -0.12490048, -0.01140004, -0.99210378,
    -0.94829258, 0.31739752, 0.00000000,
    -0.94829258, 0.31739752, 0.00000000,
    -0.99484527, -0.10140461, 0.00000000,
    -0.99484527, -0.10140461, 0.00000000,
    -0.99484527, -0.10140461, 0.00000000,
    -0.99484527, -0.10140461, 0.00000000,
    0.95976896, -0.28079092, 0.00000000,
    0.95976896, -0.28079092, 0.00000000,
    0.95976896, -0.28079092, 0.00000000,
    0.95976896, -0.28079092, 0.00000000,
    -0.96375534, -0.26678764, 0.00000000,
    -0.96375534, -0.26678764, 0.00000000,
    -0.96375534, -0.26678764, 0.00000000,
    -0.96375534, -0.26678764, 0.00000000,
    0.16449624, 0.00069998, 0.98637746,
    0.16449624, 0.00069998, 0.98637746,
    0.16449624, 0.00069998, 0.98637746,
    0.16449624, 0.00069998, 0.98637746,
    0.16160840, -0.00270014, 0.98685127,
    0.16160840, -0.00270014, 0.98685127,
    0.16160840, -0.00270014, 0.98685127,
    0.16160840, -0.00270014, 0.98685127,
    -0.09670595, 0.41502551, -0.90465562,
    -0.09670595, 0.41502551, -0.90465562,
    -0.09670595, 0.41502551, -0.90465562,
    -0.09670595, 0.41502551, -0.90465562,
    0.14350591, -0.04000165, 0.98884070,
    0.14350591, -0.04000165, 0.98884070,
    0.14350591, -0.04000165, 0.98884070,
    0.14350591, -0.04000165, 0.98884070,
    0.98182195, -0.18980424, 0.00000000,
    0.98182195, -0.18980424, 0.00000000,
    0.98182195, -0.18980424, 0.00000000,
    0.98182195, -0.18980424, 0.00000000,
    -0.95675740, 0.29088705, 0.00000000,
    -0.95675740, 0.29088705, 0.00000000,
    -0.95675740, 0.29088705, 0.00000000,
    -0.95675740, 0.29088705, 0.00000000,
    0.97534458, 0.22068746, 0.00000000,
    0.97534458, 0.22068746, 0.00000000,
    0.97534458, 0.22068746, 0.00000000,
    0.97534458, 0.22068746, 0.00000000,
    -0.95330720, 0.30200228, 0.00000000,
    -0.95330720, 0.30200228, 0.00000000,
    -0.95330720, 0.30200228, 0.00000000,
    -0.95330720, 0.30200228, 0.00000000,
    -0.12070570, -0.02960140, -0.99224689,
    -0.12070570, -0.02960140, -0.99224689,
    -0.12070570, -0.02960140, -0.99224689,
    -0.12070570, -0.02960140, -0.99224689,
    0.16338998, 0.40087542, 0.90144473,
    0.16338998, 0.40087542, 0.90144473,
    0.16338998, 0.40087542, 0.90144473,
    0.16338998, 0.40087542, 0.90144473,
    0.27201106, 0.30121225, 0.91393718,
    0.27201106, 0.30121225, 0.91393718,
    0.27201106, 0.30121225, 0.91393718,
    0.27201106, 0.30121225, 0.91393718,
    0.21479472, 0.37239084, 0.90287778,
    0.21479472, 0.37239084, 0.90287778,
    0.21479472, 0.37239084, 0.90287778,
    0.21479472, 0.37239084, 0.90287778,
    0.97782875, 0.20940616, 0.00000000,
    0.97782875, 0.20940616, 0.00000000,
    0.97782875, 0.20940616, 0.00000000,
    0.97782875, 0.20940616, 0.00000000,
    -0.14829896, 0.39139724, -0.90819360,
    -0.14829896, 0.39139724, -0.90819360,
    -0.14829896, 0.39139724, -0.90819360,
    -0.14829896, 0.39139724, -0.90819360,
    -0.24310806, -0.43671448, -0.86612871,
    -0.24310806, -0.43671448, -0.86612871,
    -0.24310806, -0.43671448, -0.86612871,
    -0.24310806, -0.43671448, -0.86612871,
    0.99998140, -0.00609989, 0.00000000,
    0.99998140, -0.00609989, 0.00000000,
    0.99998140, -0.00609989, 0.00000000,
    0.99998140, -0.00609989, 0.00000000,
    -0.96498732, 0.26229655, 0.00000000,
    -0.96498732, 0.26229655, 0.00000000,
    -0.96498732, 0.26229655, 0.00000000,
    -0.96498732, 0.26229655, 0.00000000,
    -0.63610325, -0.77160395, 0.00000000,
    -0.63610325, -0.77160395, 0.00000000,
    -0.63610325, -0.77160395, 0.00000000,
    -0.63610325, -0.77160395, 0.00000000,
    0.93558738, -0.35309524, 0.00000000,
    0.93558738, -0.35309524, 0.00000000,
    0.93558738, -0.35309524, 0.00000000,
    0.93558738, -0.35309524, 0.00000000,
    -0.99702323, 0.07710180, 0.00000000,
    -0.99702323, 0.07710180, 0.00000000,
    -0.99702323, 0.07710180, 0.00000000,
    -0.99702323, 0.07710180, 0.00000000,
    -0.20390017, 0.36650031, -0.90780077,
    -0.20390017, 0.36650031, -0.90780077,
    -0.20390017, 0.36650031, -0.90780077,
    -0.20390017, 0.36650031, -0.90780077,
    0.21118964, -0.52707415, 0.82315963,
    0.21118964, -0.52707415, 0.82315963,
    0.21118964, -0.52707415, 0.82315963,
    0.21118964, -0.52707415, 0.82315963,
    -0.09860255, -0.97432523, -0.20240524,
    -0.09860255, -0.97432523, -0.20240524,
    -0.09860255, -0.97432523, -0.20240524,
    -0.09860255, -0.97432523, -0.20240524,
    0.17810078, -0.42790188, 0.88610389,
    0.17810078, -0.42790188, 0.88610389,
    0.17810078, -0.42790188, 0.88610389,
    0.17810078, -0.42790188, 0.88610389,
    0.61619501, -0.78759362, 0.00000000,
    0.61619501, -0.78759362, 0.00000000,
    0.61619501, -0.78759362, 0.00000000,
    0.61619501, -0.78759362, 0.00000000,
    -0.19681334, -0.44613024, -0.87305917,
    -0.19681334, -0.44613024, -0.87305917,
    -0.19681334, -0.44613024, -0.87305917,
    -0.19681334, -0.44613024, -0.87305917,
    0.43819114, -0.89888182, 0.00000000,
    0.43819114, -0.89888182, 0.00000000,
    0.43819114, -0.89888182, 0.00000000,
    0.43819114, -0.89888182, 0.00000000,
    -0.61061894, -0.79192456, 0.00000000,
    -0.61061894, -0.79192456, 0.00000000,
    -0.61061894, -0.79192456, 0.00000000,
    -0.61061894, -0.79192456, 0.00000000,
    -0.07789699, -0.99696141, 0.00000000,
    -0.07789699, -0.99696141, 0.00000000,
    -0.07789699, -0.99696141, 0.00000000,
    -0.07789699, -0.99696141, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.26750033, 0.35970044, -0.89390110,
    -0.26750033, 0.35970044, -0.89390110,
    -0.26750033, 0.35970044, -0.89390110,
    -0.26750033, 0.35970044, -0.89390110,
    0.00429984, -0.24559089, -0.96936403,
    0.00429984, -0.24559089, -0.96936403,
    0.00429984, -0.24559089, -0.96936403,
    0.00429984, -0.24559089, -0.96936403,
    -0.15120361, 0.01250030, 0.98842360,
    -0.15120361, 0.01250030, 0.98842360,
    -0.15120361, 0.01250030, 0.98842360,
    -0.15120361, 0.01250030, 0.98842360,
    -0.13969573, 0.00699979, 0.99016974,
    -0.13969573, 0.00699979, 0.99016974,
    -0.13969573, 0.00699979, 0.99016974,
    -0.13969573, 0.00699979, 0.99016974,
    -0.13150106, 0.00400003, 0.99130796,
    -0.13150106, 0.00400003, 0.99130796,
    -0.13150106, 0.00400003, 0.99130796,
    -0.13150106, 0.00400003, 0.99130796,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    0.99704624, 0.07680356, 0.00000000,
    0.19508926, -0.00879952, 0.98074602,
    0.19508926, -0.00879952, 0.98074602,
    0.19508926, -0.00879952, 0.98074602,
    0.19508926, -0.00879952, 0.98074602,
    -0.93612141, 0.34870798, -0.04560104,
    -0.93612141, 0.34870798, -0.04560104,
    -0.93612141, 0.34870798, -0.04560104,
    -0.93612141, 0.34870798, -0.04560104,
    0.00779967, 0.00489979, 0.99995758,
    0.00779967, 0.00489979, 0.99995758,
    0.00779967, 0.00489979, 0.99995758,
    0.00779967, 0.00489979, 0.99995758,
    0.00289995, 0.00499992, -0.99998330,
    0.00289995, 0.00499992, -0.99998330,
    0.00289995, 0.00499992, -0.99998330,
    0.00289995, 0.00499992, -0.99998330,
    0.00130006, 0.02260099, -0.99974372,
    0.00130006, 0.02260099, -0.99974372,
    0.00130006, 0.02260099, -0.99974372,
    0.00130006, 0.02260099, -0.99974372,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    0.00730020, 0.02220060, 0.99972688,
    0.00730020, 0.02220060, 0.99972688,
    0.00730020, 0.02220060, 0.99972688,
    0.00730020, 0.02220060, 0.99972688,
    0.00139997, -0.88368000, 0.46808941,
    0.00139997, -0.88368000, 0.46808941,
    0.00139997, -0.88368000, 0.46808941,
    0.00139997, -0.88368000, 0.46808941,
    0.00150003, -0.88361659, -0.46820879,
    0.00150003, -0.88361659, -0.46820879,
    0.00150003, -0.88361659, -0.46820879,
    0.00150003, -0.88361659, -0.46820879,
    0.00160000, 0.00000000, 0.99999872,
    0.00160000, 0.00000000, 0.99999872,
    0.00160000, 0.00000000, 0.99999872,
    0.00160000, 0.00000000, 0.99999872,
    0.00629988, 0.01409973, -0.99988075,
    0.00629988, 0.01409973, -0.99988075,
    0.00629988, 0.01409973, -0.99988075,
    0.00629988, 0.01409973, -0.99988075,
    0.22869507, -0.00609987, -0.97347900,
    0.22869507, -0.00609987, -0.97347900,
    0.22869507, -0.00609987, -0.97347900,
    0.22869507, -0.00609987, -0.97347900,
    0.00709982, -0.00039999, 0.99997472,
    0.00709982, -0.00039999, 0.99997472,
    0.00709982, -0.00039999, 0.99997472,
    0.00709982, -0.00039999, 0.99997472,
    0.00699982, -0.00119997, 0.99997478,
    0.00699982, -0.00119997, 0.99997478,
    0.00699982, -0.00119997, 0.99997478,
    0.00699982, -0.00119997, 0.99997478,
    -0.20239718, 0.00579992, -0.97928634,
    -0.20239718, 0.00579992, -0.97928634,
    -0.20239718, 0.00579992, -0.97928634,
    -0.20239718, 0.00579992, -0.97928634,
    0.00729980, -0.00039999, -0.99997328,
    0.00729980, -0.00039999, -0.99997328,
    0.00729980, -0.00039999, -0.99997328,
    0.00729980, -0.00039999, -0.99997328,
    0.00729980, -0.00119997, -0.99997264,
    0.00729980, -0.00119997, -0.99997264,
    0.00729980, -0.00119997, -0.99997264,
    0.00729980, -0.00119997, -0.99997264,
    0.00729978, 0.00269992, -0.99996971,
    0.00729978, 0.00269992, -0.99996971,
    0.00729978, 0.00269992, -0.99996971,
    0.00729978, 0.00269992, -0.99996971,
    0.00609993, 0.01359985, 0.99988891,
    0.00609993, 0.01359985, 0.99988891,
    0.00609993, 0.01359985, 0.99988891,
    0.00609993, 0.01359985, 0.99988891,
    0.00709980, 0.00259993, 0.99997142,
    0.00709980, 0.00259993, 0.99997142,
    0.00709980, 0.00259993, 0.99997142,
    0.00709980, 0.00259993, 0.99997142,
    0.00729967, 0.00599973, 0.99995536,
    0.00729967, 0.00599973, 0.99995536,
    0.00729967, 0.00599973, 0.99995536,
    0.00729967, 0.00599973, 0.99995536,
    0.00300003, -0.27370275, -0.96180965,
    0.00300003, -0.27370275, -0.96180965,
    0.00300003, -0.27370275, -0.96180965,
    0.00300003, -0.27370275, -0.96180965,
    0.00759976, 0.00209993, 0.99996892,
    0.00759976, 0.00209993, 0.99996892,
    0.00759976, 0.00209993, 0.99996892,
    0.00759976, 0.00209993, 0.99996892,
    0.00690006, 0.01160010, 0.99990891,
    0.00690006, 0.01160010, 0.99990891,
    0.00690006, 0.01160010, 0.99990891,
    0.00690006, 0.01160010, 0.99990891,
    0.00489972, 0.45817378, -0.88884913,
    0.00489972, 0.45817378, -0.88884913,
    0.00489972, 0.45817378, -0.88884913,
    0.00489972, 0.45817378, -0.88884913,
    0.00059997, 0.62407281, -0.78136596,
    0.00059997, 0.62407281, -0.78136596,
    0.00059997, 0.62407281, -0.78136596,
    0.00059997, 0.62407281, -0.78136596,
    0.00969982, 0.19079644, -0.98158170,
    0.00969982, 0.19079644, -0.98158170,
    0.00969982, 0.19079644, -0.98158170,
    0.00969982, 0.19079644, -0.98158170,
    -0.25379218, 0.01909941, -0.96707019,
    -0.25379218, 0.01909941, -0.96707019,
    -0.25379218, 0.01909941, -0.96707019,
    -0.25379218, 0.01909941, -0.96707019,
    -0.00020001, -0.19830804, -0.98013973,
    -0.00020001, -0.19830804, -0.98013973,
    -0.00020001, -0.19830804, -0.98013973,
    -0.00020001, -0.19830804, -0.98013973,
    0.00709982, -0.00059998, 0.99997462,
    0.00709982, -0.00059998, 0.99997462,
    0.00709982, -0.00059998, 0.99997462,
    0.00709982, -0.00059998, 0.99997462,
    0.00700007, -0.01150011, 0.99990937,
    0.00700007, -0.01150011, 0.99990937,
    0.00700007, -0.01150011, 0.99990937,
    0.00700007, -0.01150011, 0.99990937,
    0.00720032, -0.00770034, 0.99994443,
    0.00720032, -0.00770034, 0.99994443,
    0.00720032, -0.00770034, 0.99994443,
    0.00720032, -0.00770034, 0.99994443,
    0.00680032, -0.00780036, 0.99994645,
    0.00680032, -0.00780036, 0.99994645,
    0.00680032, -0.00780036, 0.99994645,
    0.00680032, -0.00780036, 0.99994645,
    0.00200000, 0.65259998, -0.75769998,
    0.00200000, 0.65259998, -0.75769998,
    0.00200000, 0.65259998, -0.75769998,
    0.00200000, 0.65259998, -0.75769998,
    -0.05230111, 0.99862122, -0.00450010,
    -0.05230111, 0.99862122, -0.00450010,
    -0.05230111, 0.99862122, -0.00450010,
    -0.05230111, 0.99862122, -0.00450010,
    0.03429866, -0.12659506, 0.99136133,
    0.03429866, -0.12659506, 0.99136133,
    0.03429866, -0.12659506, 0.99136133,
    0.03429866, -0.12659506, 0.99136133,
    0.03969844, 0.92426364, -0.37968507,
    0.03969844, 0.92426364, -0.37968507,
    0.03969844, 0.92426364, -0.37968507,
    0.03969844, 0.92426364, -0.37968507,
    -0.30950205, 0.95040629, -0.03060020,
    -0.30950205, 0.95040629, -0.03060020,
    -0.30950205, 0.95040629, -0.03060020,
    -0.30950205, 0.95040629, -0.03060020,
    -0.31361196, 0.91803501, -0.24260925,
    -0.31361196, 0.91803501, -0.24260925,
    -0.31361196, 0.91803501, -0.24260925,
    -0.31361196, 0.91803501, -0.24260925,
    -0.18729783, 0.98038866, -0.06129929,
    -0.18729783, 0.98038866, -0.06129929,
    -0.18729783, 0.98038866, -0.06129929,
    -0.18729783, 0.98038866, -0.06129929,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.02239912, -0.74537070, -0.66627381,
    0.02239912, -0.74537070, -0.66627381,
    0.02239912, -0.74537070, -0.66627381,
    0.02239912, -0.74537070, -0.66627381,
    -0.88378548, 0.46789231, 0.00000000,
    -0.88378548, 0.46789231, 0.00000000,
    -0.88378548, 0.46789231, 0.00000000,
    -0.88378548, 0.46789231, 0.00000000,
    0.00160000, 0.00000000, 0.99999872,
    0.00160000, 0.00000000, 0.99999872,
    -0.09120249, 0.64511761, -0.75862071,
    -0.09120249, 0.64511761, -0.75862071,
    -0.09120249, 0.64511761, -0.75862071,
    -0.09120249, 0.64511761, -0.75862071,
    -0.88378548, 0.46789231, 0.00000000,
    -0.88378548, 0.46789231, 0.00000000,
    -0.06630047, 0.80540570, 0.58900417,
    -0.06630047, 0.80540570, 0.58900417,
    -0.06630047, 0.80540570, 0.58900417,
    -0.06630047, 0.80540570, 0.58900417,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    0.00030000, 0.99861557, 0.05260082,
    0.00030000, 0.99861557, 0.05260082,
    0.00030000, 0.99861557, 0.05260082,
    0.00030000, 0.99861557, 0.05260082,
    0.18310370, -0.81341644, -0.55211116,
    0.18310370, -0.81341644, -0.55211116,
    0.18310370, -0.81341644, -0.55211116,
    0.18310370, -0.81341644, -0.55211116,
    0.20719948, 0.97829756, 0.00150000,
    0.20719948, 0.97829756, 0.00150000,
    0.20719948, 0.97829756, 0.00150000,
    0.20719948, 0.97829756, 0.00150000,
    0.21940705, 0.97563136, -0.00200006,
    0.21940705, 0.97563136, -0.00200006,
    0.21940705, 0.97563136, -0.00200006,
    0.21940705, 0.97563136, -0.00200006,
    0.03289917, -0.45928847, -0.88767772,
    0.03289917, -0.45928847, -0.88767772,
    0.03289917, -0.45928847, -0.88767772,
    0.03289917, -0.45928847, -0.88767772,
    -0.19819218, 0.98016134, 0.00189993,
    -0.19819218, 0.98016134, 0.00189993,
    -0.19819218, 0.98016134, 0.00189993,
    -0.19819218, 0.98016134, 0.00189993,
    0.00169994, 0.35918628, -0.93326434,
    0.00169994, 0.35918628, -0.93326434,
    0.00169994, 0.35918628, -0.93326434,
    0.00169994, 0.35918628, -0.93326434,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.89582284, 0.44441133, 0.00000000,
    0.07690336, 0.65702871, -0.74993277,
    0.07690336, 0.65702871, -0.74993277,
    0.07690336, 0.65702871, -0.74993277,
    0.07690336, 0.65702871, -0.74993277,
    -0.88378548, 0.46789231, 0.00000000,
    -0.88378548, 0.46789231, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    0.06749857, 0.35669244, -0.93178026,
    0.06749857, 0.35669244, -0.93178026,
    0.06749857, 0.35669244, -0.93178026,
    0.06749857, 0.35669244, -0.93178026,
    1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.17119733, -0.78338776, -0.59749066,
    -0.17119733, -0.78338776, -0.59749066,
    -0.17119733, -0.78338776, -0.59749066,
    -0.17119733, -0.78338776, -0.59749066,
    0.00139999, 0.81089197, 0.58519420,
    0.00139999, 0.81089197, 0.58519420,
    0.00139999, 0.81089197, 0.58519420,
    0.00139999, 0.81089197, 0.58519420,
    0.00170000, 0.00000000, -0.99999856,
    0.00170000, 0.00000000, -0.99999856,
    0.00170000, 0.00000000, -0.99999856,
    0.00170000, 0.00000000, -0.99999856,
    1.00000000, 0.00000000, 0.00000000,
    -0.91541675, -0.40250736, 0.00000000,
    -0.91541675, -0.40250736, 0.00000000,
    -0.91541675, -0.40250736, 0.00000000,
    -0.91541675, -0.40250736, 0.00000000,
    0.92481887, -0.38040776, 0.00000000,
    0.92481887, -0.38040776, 0.00000000,
    0.92481887, -0.38040776, 0.00000000,
    0.92481887, -0.38040776, 0.00000000,
    -0.88692035, -0.46191060, 0.00330008,
    -0.88692035, -0.46191060, 0.00330008,
    -0.88692035, -0.46191060, 0.00330008,
    -0.88692035, -0.46191060, 0.00330008,
    0.14460596, -0.00980040, -0.98944079,
    0.14460596, -0.00980040, -0.98944079,
    0.14460596, -0.00980040, -0.98944079,
    0.14460596, -0.00980040, -0.98944079,
    0.89887778, -0.43818917, 0.00299993,
    0.89887778, -0.43818917, 0.00299993,
    0.89887778, -0.43818917, 0.00299993,
    0.89887778, -0.43818917, 0.00299993,
    0.92481887, -0.38040776, 0.00000000,
    0.92481887, -0.38040776, 0.00000000,
    -0.18899556, 0.98197694, 0.00139997,
    -0.18899556, 0.98197694, 0.00139997,
    -0.18899556, 0.98197694, 0.00139997,
    -0.18899556, 0.98197694, 0.00139997,
    0.21919527, 0.97567896, 0.00199996,
    0.21919527, 0.97567896, 0.00199996,
    0.21919527, 0.97567896, 0.00199996,
    0.21919527, 0.97567896, 0.00199996,
    -0.19849985, 0.98009926, -0.00180000,
    -0.19849985, 0.98009926, -0.00180000,
    -0.19849985, 0.98009926, -0.00180000,
    -0.19849985, 0.98009926, -0.00180000,
    -0.07910208, 0.35470932, -0.93162447,
    -0.07910208, 0.35470932, -0.93162447,
    -0.07910208, 0.35470932, -0.93162447,
    -0.07910208, 0.35470932, -0.93162447,
    -0.43460728, -0.90061508, -0.00300005,
    -0.43460728, -0.90061508, -0.00300005,
    -0.43460728, -0.90061508, -0.00300005,
    -0.43460728, -0.90061508, -0.00300005,
    0.53528261, -0.84467255, -0.00089997,
    0.53528261, -0.84467255, -0.00089997,
    0.53528261, -0.84467255, -0.00089997,
    0.53528261, -0.84467255, -0.00089997,
    -0.37029685, -0.92889211, 0.00629995,
    -0.37029685, -0.92889211, 0.00629995,
    -0.37029685, -0.92889211, 0.00629995,
    -0.37029685, -0.92889211, 0.00629995,
    0.06799992, -0.86679903, -0.49399945,
    0.06799992, -0.86679903, -0.49399945,
    0.06799992, -0.86679903, -0.49399945,
    0.06799992, -0.86679903, -0.49399945,
    0.39810745, -0.91731716, 0.00630012,
    0.39810745, -0.91731716, 0.00630012,
    0.39810745, -0.91731716, 0.00630012,
    0.39810745, -0.91731716, 0.00630012,
    0.46828528, -0.88357223, -0.00299991,
    0.46828528, -0.88357223, -0.00299991,
    0.46828528, -0.88357223, -0.00299991,
    0.46828528, -0.88357223, -0.00299991,
    -0.01419953, 0.99846698, 0.05349823,
    -0.01419953, 0.99846698, 0.05349823,
    -0.01419953, 0.99846698, 0.05349823,
    -0.01419953, 0.99846698, 0.05349823,
    -0.15719414, -0.00299989, -0.98756316,
    -0.15719414, -0.00299989, -0.98756316,
    -0.15719414, -0.00299989, -0.98756316,
    -0.15719414, -0.00299989, -0.98756316,
    -0.91541675, -0.40250736, 0.00000000,
    -0.91541675, -0.40250736, 0.00000000,
    0.14700464, -0.00300009, -0.98913125,
    0.14700464, -0.00300009, -0.98913125,
    0.14700464, -0.00300009, -0.98913125,
    0.14700464, -0.00300009, -0.98913125,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00169998, -0.97209103, 0.23459783,
    0.00169998, -0.97209103, 0.23459783,
    0.00169998, -0.97209103, 0.23459783,
    0.00169998, -0.97209103, 0.23459783,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00650010, 0.54050860, 0.84131338,
    0.00650010, 0.54050860, 0.84131338,
    0.00650010, 0.54050860, 0.84131338,
    0.00650010, 0.54050860, 0.84131338,
    -0.49600950, -0.86831663, -0.00090002,
    -0.49600950, -0.86831663, -0.00090002,
    -0.49600950, -0.86831663, -0.00090002,
    -0.49600950, -0.86831663, -0.00090002,
    0.00020000, 0.99797555, 0.06359844,
    0.00020000, 0.99797555, 0.06359844,
    0.00020000, 0.99797555, 0.06359844,
    0.00020000, 0.99797555, 0.06359844,
    -0.07670012, -0.85740135, -0.50890080,
    -0.07670012, -0.85740135, -0.50890080,
    -0.07670012, -0.85740135, -0.50890080,
    -0.07670012, -0.85740135, -0.50890080,
    -0.88609162, 0.46329562, -0.01409987,
    -0.88609162, 0.46329562, -0.01409987,
    -0.88609162, 0.46329562, -0.01409987,
    -0.88609162, 0.46329562, -0.01409987,
    0.88442899, 0.46651529, 0.01220040,
    0.88442899, 0.46651529, 0.01220040,
    0.88442899, 0.46651529, 0.01220040,
    0.88442899, 0.46651529, 0.01220040,
    -0.99025505, 0.13899369, 0.00869961,
    -0.99025505, 0.13899369, 0.00869961,
    -0.99025505, 0.13899369, 0.00869961,
    -0.99025505, 0.13899369, 0.00869961,
    0.00420019, 0.01710077, -0.99984495,
    0.00420019, 0.01710077, -0.99984495,
    0.00420019, 0.01710077, -0.99984495,
    0.00420019, 0.01710077, -0.99984495,
    -0.86650888, 0.49900511, 0.01250013,
    -0.86650888, 0.49900511, 0.01250013,
    -0.86650888, 0.49900511, 0.01250013,
    -0.86650888, 0.49900511, 0.01250013,
    0.00160002, 0.83151037, -0.55550693,
    0.00160002, 0.83151037, -0.55550693,
    0.00160002, 0.83151037, -0.55550693,
    0.00160002, 0.83151037, -0.55550693,
    0.90262538, 0.43021210, -0.01360038,
    0.90262538, 0.43021210, -0.01360038,
    0.90262538, 0.43021210, -0.01360038,
    0.90262538, 0.43021210, -0.01360038,
    0.99488989, 0.10059898, 0.00859991,
    0.99488989, 0.10059898, 0.00859991,
    0.99488989, 0.10059898, 0.00859991,
    0.99488989, 0.10059898, 0.00859991,
    0.07229806, 0.82547789, -0.55978500,
    0.07229806, 0.82547789, -0.55978500,
    0.07229806, 0.82547789, -0.55978500,
    0.07229806, 0.82547789, -0.55978500,
    0.00809968, -0.00369985, 0.99996035,
    0.00809968, -0.00369985, 0.99996035,
    0.00809968, -0.00369985, 0.99996035,
    0.00809968, -0.00369985, 0.99996035,
    -0.91626058, 0.40058277, 0.00000000,
    -0.91626058, 0.40058277, 0.00000000,
    -0.91626058, 0.40058277, 0.00000000,
    -0.91626058, 0.40058277, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.00190007, -0.85873304, -0.51241971,
    0.00190007, -0.85873304, -0.51241971,
    0.00190007, -0.85873304, -0.51241971,
    0.00190007, -0.85873304, -0.51241971,
    0.00649968, -0.54477297, 0.83855839,
    0.00649968, -0.54477297, 0.83855839,
    0.00649968, -0.54477297, 0.83855839,
    0.00649968, -0.54477297, 0.83855839,
    -0.30829505, -0.00339995, 0.95128471,
    -0.30829505, -0.00339995, 0.95128471,
    -0.30829505, -0.00339995, 0.95128471,
    -0.30829505, -0.00339995, 0.95128471,
    -0.25661082, 0.52432211, 0.81193424,
    -0.25661082, 0.52432211, 0.81193424,
    -0.25661082, 0.52432211, 0.81193424,
    -0.25661082, 0.52432211, 0.81193424,
    0.92551669, 0.37870683, 0.00000000,
    0.92551669, 0.37870683, 0.00000000,
    0.92551669, 0.37870683, 0.00000000,
    0.92551669, 0.37870683, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.99999928, -0.00120000, 0.00000000,
    0.90012890, 0.43561399, 0.00290009,
    0.90012890, 0.43561399, 0.00290009,
    0.90012890, 0.43561399, 0.00290009,
    0.90012890, 0.43561399, 0.00290009,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    0.27069937, -0.35529917, -0.89469791,
    0.27069937, -0.35529917, -0.89469791,
    0.27069937, -0.35529917, -0.89469791,
    0.27069937, -0.35529917, -0.89469791,
    -0.28949203, -0.00359990, 0.95717365,
    -0.28949203, -0.00359990, 0.95717365,
    -0.28949203, -0.00359990, 0.95717365,
    -0.28949203, -0.00359990, 0.95717365,
    -0.88832142, 0.45921107, 0.00320008,
    -0.88832142, 0.45921107, 0.00320008,
    -0.88832142, 0.45921107, 0.00320008,
    -0.88832142, 0.45921107, 0.00320008,
    0.92551669, 0.37870683, 0.00000000,
    0.92551669, 0.37870683, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.99999902, -0.00140000, 0.00000000,
    -0.91626058, 0.40058277, 0.00000000,
    -0.91626058, 0.40058277, 0.00000000,
    0.00399995, -0.00309996, -0.99998720,
    0.00399995, -0.00309996, -0.99998720,
    0.00399995, -0.00309996, -0.99998720,
    0.00399995, -0.00309996, -0.99998720,
    -0.10260511, -0.97384846, 0.20271009,
    -0.10260511, -0.97384846, 0.20271009,
    -0.10260511, -0.97384846, 0.20271009,
    -0.10260511, -0.97384846, 0.20271009,
    -0.07789699, -0.99696141, 0.00000000,
    -0.07789699, -0.99696141, 0.00000000,
    0.15210569, -0.43511628, -0.88743320,
    0.15210569, -0.43511628, -0.88743320,
    0.15210569, -0.43511628, -0.88743320,
    0.15210569, -0.43511628, -0.88743320,
    -0.22150231, -0.43690457, 0.87180911,
    -0.22150231, -0.43690457, 0.87180911,
    -0.22150231, -0.43690457, 0.87180911,
    -0.22150231, -0.43690457, 0.87180911,
    -0.05399885, -0.97797919, -0.20159571,
    -0.05399885, -0.97797919, -0.20159571,
    -0.05399885, -0.97797919, -0.20159571,
    -0.05399885, -0.97797919, -0.20159571,
    -0.27000149, -0.42820236, 0.86240474,
    -0.27000149, -0.42820236, 0.86240474,
    -0.27000149, -0.42820236, 0.86240474,
    -0.27000149, -0.42820236, 0.86240474,
    0.24410124, 0.30780157, -0.91960469,
    0.24410124, 0.30780157, -0.91960469,
    0.24410124, 0.30780157, -0.91960469,
    0.24410124, 0.30780157, -0.91960469,
    0.18600922, -0.52592608, -0.82994116,
    0.18600922, -0.52592608, -0.82994116,
    0.18600922, -0.52592608, -0.82994116,
    0.18600922, -0.52592608, -0.82994116,
    0.18830206, 0.37690413, -0.90690993,
    0.18830206, 0.37690413, -0.90690993,
    0.18830206, 0.37690413, -0.90690993,
    0.18830206, 0.37690413, -0.90690993,
    -0.17530305, 0.38920677, 0.90431573,
    -0.17530305, 0.38920677, 0.90431573,
    -0.17530305, 0.38920677, 0.90431573,
    -0.17530305, 0.38920677, 0.90431573,
    -0.23140819, 0.36711300, 0.90093190,
    -0.23140819, 0.36711300, 0.90093190,
    -0.23140819, 0.36711300, 0.90093190,
    -0.23140819, 0.36711300, 0.90093190,
    -0.12089771, 0.41319219, 0.90258294,
    -0.12089771, 0.41319219, 0.90258294,
    -0.12089771, 0.41319219, 0.90258294,
    -0.12089771, 0.41319219, 0.90258294,
    0.11530286, -0.04000099, -0.99252464,
    0.11530286, -0.04000099, -0.99252464,
    0.11530286, -0.04000099, -0.99252464,
    0.11530286, -0.04000099, -0.99252464,
    -0.14870080, -0.02730015, 0.98850532,
    -0.14870080, -0.02730015, 0.98850532,
    -0.14870080, -0.02730015, 0.98850532,
    -0.14870080, -0.02730015, 0.98850532,
    0.13959826, 0.40479496, -0.90368875,
    0.13959826, 0.40479496, -0.90368875,
    0.13959826, 0.40479496, -0.90368875,
    0.13959826, 0.40479496, -0.90368875,
    -0.16180376, -0.00020000, 0.98682293,
    -0.16180376, -0.00020000, 0.98682293,
    -0.16180376, -0.00020000, 0.98682293,
    -0.16180376, -0.00020000, 0.98682293,
    -0.15339469, -0.01399952, 0.98806583,
    -0.15339469, -0.01399952, 0.98806583,
    -0.15339469, -0.01399952, 0.98806583,
    -0.15339469, -0.01399952, 0.98806583,
    0.13399750, 0.00059999, -0.99098149,
    0.13399750, 0.00059999, -0.99098149,
    0.13399750, 0.00059999, -0.99098149,
    0.13399750, 0.00059999, -0.99098149,
    0.12910489, -0.03430130, -0.99103751,
    0.12910489, -0.03430130, -0.99103751,
    0.12910489, -0.03430130, -0.99103751,
    0.12910489, -0.03430130, -0.99103751,
    -0.15829880, 0.04439966, 0.98639250,
    -0.15829880, 0.04439966, 0.98639250,
    -0.15829880, 0.04439966, 0.98639250,
    -0.15829880, 0.04439966, 0.98639250,
    0.13169833, -0.00219997, -0.99128740,
    0.13169833, -0.00219997, -0.99128740,
    0.13169833, -0.00219997, -0.99128740,
    0.13169833, -0.00219997, -0.99128740,
    -0.16879452, -0.53118274, 0.83027303,
    -0.16879452, -0.53118274, 0.83027303,
    -0.16879452, -0.53118274, 0.83027303,
    -0.16879452, -0.53118274, 0.83027303,
    -0.19270293, 0.00910014, 0.98121494,
    -0.19270293, 0.00910014, 0.98121494,
    -0.19270293, 0.00910014, 0.98121494,
    -0.19270293, 0.00910014, 0.98121494,
    0.10229994, -0.53879968, -0.83619951,
    0.10229994, -0.53879968, -0.83619951,
    0.10229994, -0.53879968, -0.83619951,
    0.10229994, -0.53879968, -0.83619951,
    0.17639745, 0.27409604, -0.94538633,
    0.17639745, 0.27409604, -0.94538633,
    0.17639745, 0.27409604, -0.94538633,
    0.17639745, 0.27409604, -0.94538633,
    0.18140000, 0.08760000, 0.97950001,
    0.18140000, 0.08760000, 0.97950001,
    0.18140000, 0.08760000, 0.97950001,
    0.18140000, 0.08760000, 0.97950001,
    0.15409313, -0.01989911, 0.98785593,
    0.15409313, -0.01989911, 0.98785593,
    0.15409313, -0.01989911, 0.98785593,
    0.15409313, -0.01989911, 0.98785593,
    0.20529773, -0.20499774, 0.95698943,
    0.20529773, -0.20499774, 0.95698943,
    0.20529773, -0.20499774, 0.95698943,
    0.20529773, -0.20499774, 0.95698943,
    0.16319241, -0.00889959, -0.98655412,
    0.16319241, -0.00889959, -0.98655412,
    0.16319241, -0.00889959, -0.98655412,
    0.16319241, -0.00889959, -0.98655412,
    0.25680529, -0.03240067, -0.96591989,
    0.25680529, -0.03240067, -0.96591989,
    0.25680529, -0.03240067, -0.96591989,
    0.25680529, -0.03240067, -0.96591989,
    0.00799969, -0.00359986, 0.99996152,
    0.00799969, -0.00359986, 0.99996152,
    0.00799969, -0.00359986, 0.99996152,
    0.00799969, -0.00359986, 0.99996152,
    -0.22749459, 0.97377686, 0.00219995,
    -0.22749459, 0.97377686, 0.00219995,
    -0.22749459, 0.97377686, 0.00219995,
    -0.22749459, 0.97377686, 0.00219995,
    -0.22319815, -0.50079585, -0.83629307,
    -0.22319815, -0.50079585, -0.83629307,
    -0.22319815, -0.50079585, -0.83629307,
    -0.22319815, -0.50079585, -0.83629307,
    -0.08419859, 0.81878629, -0.56789049,
    -0.08419859, 0.81878629, -0.56789049,
    -0.08419859, 0.81878629, -0.56789049,
    -0.08419859, 0.81878629, -0.56789049,
    -0.01130039, 0.99783414, 0.06480222,
    -0.01130039, 0.99783414, 0.06480222,
    -0.01130039, 0.99783414, 0.06480222,
    -0.01130039, 0.99783414, 0.06480222,
    -0.06890245, -0.96993454, 0.23340831,
    -0.06890245, -0.96993454, 0.23340831,
    -0.06890245, -0.96993454, 0.23340831,
    -0.06890245, -0.96993454, 0.23340831,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    -0.15539852, 0.01099990, -0.98779062,
    -0.15539852, 0.01099990, -0.98779062,
    -0.15539852, 0.01099990, -0.98779062,
    -0.15539852, 0.01099990, -0.98779062,
    -0.25570192, -0.52850397, 0.80950608,
    -0.25570192, -0.52850397, 0.80950608,
    -0.25570192, -0.52850397, 0.80950608,
    -0.25570192, -0.52850397, 0.80950608,
    -0.07460101, 0.00000000, 0.99721346,
    -0.07460101, 0.00000000, 0.99721346,
    -0.07460101, 0.00000000, 0.99721346,
    -0.07460101, 0.00000000, 0.99721346,
    -0.07990023, 0.00000000, -0.99680287,
    -0.07990023, 0.00000000, -0.99680287,
    -0.07990023, 0.00000000, -0.99680287,
    -0.07990023, 0.00000000, -0.99680287,
    -0.07460101, 0.00000000, 0.99721346,
    -0.07460101, 0.00000000, 0.99721346,
    0.00739980, -0.00069998, -0.99997238,
    0.00739980, -0.00069998, -0.99997238,
    0.00739980, -0.00069998, -0.99997238,
    0.00739980, -0.00069998, -0.99997238,
    -0.24359028, -0.17389306, -0.95416192,
    -0.24359028, -0.17389306, -0.95416192,
    -0.24359028, -0.17389306, -0.95416192,
    -0.24359028, -0.17389306, -0.95416192,
    -0.26068830, 0.21289044, -0.94165773,
    -0.26068830, 0.21289044, -0.94165773,
    -0.26068830, 0.21289044, -0.94165773,
    -0.26068830, 0.21289044, -0.94165773,
    -0.19179506, 0.61158423, -0.76758021,
    -0.19179506, 0.61158423, -0.76758021,
    -0.19179506, 0.61158423, -0.76758021,
    -0.19179506, 0.61158423, -0.76758021,
    -0.23050798, 0.47451643, -0.84952942,
    -0.23050798, 0.47451643, -0.84952942,
    -0.23050798, 0.47451643, -0.84952942,
    -0.23050798, 0.47451643, -0.84952942,
    -0.20090847, -0.03030128, 0.97914127,
    -0.20090847, -0.03030128, 0.97914127,
    -0.20090847, -0.03030128, 0.97914127,
    -0.20090847, -0.03030128, 0.97914127,
    -0.21861082, -0.24961235, -0.94334669,
    -0.21861082, -0.24961235, -0.94334669,
    -0.21861082, -0.24961235, -0.94334669,
    -0.21861082, -0.24961235, -0.94334669,
    -0.17370219, 0.01300016, 0.98471242,
    -0.17370219, 0.01300016, 0.98471242,
    -0.17370219, 0.01300016, 0.98471242,
    -0.17370219, 0.01300016, 0.98471242,
    -0.20320722, 0.03430122, -0.97853475,
    -0.20320722, 0.03430122, -0.97853475,
    -0.20320722, 0.03430122, -0.97853475,
    -0.20320722, 0.03430122, -0.97853475,
    -0.20460354, -0.00740013, -0.97881695,
    -0.20460354, -0.00740013, -0.97881695,
    -0.20460354, -0.00740013, -0.97881695,
    -0.20460354, -0.00740013, -0.97881695,
    -0.20340585, -0.01140033, -0.97902814,
    -0.20340585, -0.01140033, -0.97902814,
    -0.20340585, -0.01140033, -0.97902814,
    -0.20340585, -0.01140033, -0.97902814,
    -0.19830459, 0.00590014, -0.98012269,
    -0.19830459, 0.00590014, -0.98012269,
    -0.19830459, 0.00590014, -0.98012269,
    -0.19830459, 0.00590014, -0.98012269,
    -0.06779970, -0.87909609, -0.47179790,
    -0.06779970, -0.87909609, -0.47179790,
    -0.06779970, -0.87909609, -0.47179790,
    -0.06779970, -0.87909609, -0.47179790,
    -0.17999492, -0.05599842, 0.98207230,
    -0.17999492, -0.05599842, 0.98207230,
    -0.17999492, -0.05599842, 0.98207230,
    -0.17999492, -0.05599842, 0.98207230,
    0.00799972, -0.00229992, 0.99996536,
    0.00799972, -0.00229992, 0.99996536,
    0.00799972, -0.00229992, 0.99996536,
    0.00799972, -0.00229992, 0.99996536,
    -0.14550140, -0.00980009, 0.98930951,
    -0.14550140, -0.00980009, 0.98930951,
    -0.14550140, -0.00980009, 0.98930951,
    -0.14550140, -0.00980009, 0.98930951,
    -0.18510149, 0.36050290, -0.91420736,
    -0.18510149, 0.36050290, -0.91420736,
    -0.18510149, 0.36050290, -0.91420736,
    -0.18510149, 0.36050290, -0.91420736,
    -0.19070027, 0.00960001, -0.98160137,
    -0.19070027, 0.00960001, -0.98160137,
    -0.19070027, 0.00960001, -0.98160137,
    -0.19070027, 0.00960001, -0.98160137,
    -0.05559740, 0.99845326, 0.00010000,
    -0.05559740, 0.99845326, 0.00010000,
    -0.05559740, 0.99845326, 0.00010000,
    -0.05559740, 0.99845326, 0.00010000,
    -0.08440306, 0.99633612, 0.01380050,
    -0.08440306, 0.99633612, 0.01380050,
    -0.08440306, 0.99633612, 0.01380050,
    -0.08440306, 0.99633612, 0.01380050,
    -0.08210044, 0.99660539, -0.00610003,
    -0.08210044, 0.99660539, -0.00610003,
    -0.08210044, 0.99660539, -0.00610003,
    -0.08210044, 0.99660539, -0.00610003,
    -0.05259997, 0.99859940, -0.00570000,
    -0.05259997, 0.99859940, -0.00570000,
    -0.05259997, 0.99859940, -0.00570000,
    -0.05259997, 0.99859940, -0.00570000,
    0.23309440, 0.55778661, 0.79658088,
    0.23309440, 0.55778661, 0.79658088,
    0.23309440, 0.55778661, 0.79658088,
    0.23309440, 0.55778661, 0.79658088,
    0.00979983, 0.99788257, 0.06429888,
    0.00979983, 0.99788257, 0.06429888,
    0.00979983, 0.99788257, 0.06429888,
    0.00979983, 0.99788257, 0.06429888,
    0.05889874, -0.97387911, 0.21929530,
    0.05889874, -0.97387911, 0.21929530,
    0.05889874, -0.97387911, 0.21929530,
    0.05889874, -0.97387911, 0.21929530,
    0.23210097, -0.56200235, 0.79390333,
    0.23210097, -0.56200235, 0.79390333,
    0.23210097, -0.56200235, 0.79390333,
    0.23210097, -0.56200235, 0.79390333,
    0.06369804, 0.00000000, 0.99796922,
    0.06369804, 0.00000000, 0.99796922,
    0.06369804, 0.00000000, 0.99796922,
    0.06369804, 0.00000000, 0.99796922,
    0.01249961, 0.99856894, 0.05199838,
    0.01249961, 0.99856894, 0.05199838,
    0.01249961, 0.99856894, 0.05199838,
    0.01249961, 0.99856894, 0.05199838,
    0.05720285, 0.81144043, 0.58162898,
    0.05720285, 0.81144043, 0.58162898,
    0.05720285, 0.81144043, 0.58162898,
    0.05720285, 0.81144043, 0.58162898,
    0.00489995, -0.06919936, 0.99759082,
    0.00489995, -0.06919936, 0.99759082,
    0.00489995, -0.06919936, 0.99759082,
    0.00489995, -0.06919936, 0.99759082,
    -0.03509851, 0.95125973, -0.30638703,
    -0.03509851, 0.95125973, -0.30638703,
    -0.03509851, 0.95125973, -0.30638703,
    -0.03509851, 0.95125973, -0.30638703,
    0.19770985, -0.01480074, 0.98014884,
    0.19770985, -0.01480074, 0.98014884,
    0.19770985, -0.01480074, 0.98014884,
    0.19770985, -0.01480074, 0.98014884,
    0.21700572, -0.01680044, 0.97602575,
    0.21700572, -0.01680044, 0.97602575,
    0.21700572, -0.01680044, 0.97602575,
    0.21700572, -0.01680044, 0.97602575,
    -0.99178728, 0.12789836, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    0.21909243, -0.01639943, 0.97556628,
    0.21909243, -0.01639943, 0.97556628,
    0.21909243, -0.01639943, 0.97556628,
    0.21909243, -0.01639943, 0.97556628,
    0.22060139, -0.04090026, 0.97450613,
    0.22060139, -0.04090026, 0.97450613,
    0.22060139, -0.04090026, 0.97450613,
    0.22060139, -0.04090026, 0.97450613,
    0.20080114, -0.00720004, 0.97960556,
    0.20080114, -0.00720004, 0.97960556,
    0.20080114, -0.00720004, 0.97960556,
    0.20080114, -0.00720004, 0.97960556,
    0.22069944, 0.00929998, 0.97529753,
    0.22069944, 0.00929998, 0.97529753,
    0.22069944, 0.00929998, 0.97529753,
    0.22069944, 0.00929998, 0.97529753,
    0.22071128, 0.01320067, 0.97524985,
    0.22071128, 0.01320067, 0.97524985,
    0.22071128, 0.01320067, 0.97524985,
    0.22071128, 0.01320067, 0.97524985,
    0.06369804, 0.00000000, 0.99796922,
    0.06369804, 0.00000000, 0.99796922,
    0.05620112, -0.88251752, 0.46690927,
    0.05620112, -0.88251752, 0.46690927,
    0.05620112, -0.88251752, 0.46690927,
    0.05620112, -0.88251752, 0.46690927,
    0.11010136, 0.32230397, -0.94021159,
    0.11010136, 0.32230397, -0.94021159,
    0.11010136, 0.32230397, -0.94021159,
    0.11010136, 0.32230397, -0.94021159,
    -0.01909994, 0.94479704, 0.32709898,
    -0.01909994, 0.94479704, 0.32709898,
    -0.01909994, 0.94479704, 0.32709898,
    -0.01909994, 0.94479704, 0.32709898,
    0.02620029, 0.14550162, 0.98901103,
    0.02620029, 0.14550162, 0.98901103,
    0.02620029, 0.14550162, 0.98901103,
    0.02620029, 0.14550162, 0.98901103,
    0.01979902, 0.31328446, -0.94945292,
    0.01979902, 0.31328446, -0.94945292,
    0.01979902, 0.31328446, -0.94945292,
    0.01979902, 0.31328446, -0.94945292,
    -0.96630422, 0.25740112, -0.00090000,
    -0.96630422, 0.25740112, -0.00090000,
    -0.96630422, 0.25740112, -0.00090000,
    -0.96630422, 0.25740112, -0.00090000,
    -0.96102623, 0.27610754, 0.01390038,
    -0.96102623, 0.27610754, 0.01390038,
    -0.96102623, 0.27610754, 0.01390038,
    -0.96102623, 0.27610754, 0.01390038,
    -0.03089913, 0.93217383, -0.36068988,
    -0.03089913, 0.93217383, -0.36068988,
    -0.03089913, 0.93217383, -0.36068988,
    -0.03089913, 0.93217383, -0.36068988,
    -0.16230668, 0.51262111, -0.84313471,
    -0.16230668, 0.51262111, -0.84313471,
    -0.16230668, 0.51262111, -0.84313471,
    -0.16230668, 0.51262111, -0.84313471,
    -0.95238380, 0.30399483, 0.02349960,
    -0.95238380, 0.30399483, 0.02349960,
    -0.95238380, 0.30399483, 0.02349960,
    -0.95238380, 0.30399483, 0.02349960,
    -0.96606709, 0.25829120, 0.00019999,
    -0.96606709, 0.25829120, 0.00019999,
    -0.96606709, 0.25829120, 0.00019999,
    -0.96606709, 0.25829120, 0.00019999,
    -0.87454967, 0.48127230, -0.05949658,
    -0.87454967, 0.48127230, -0.05949658,
    -0.87454967, 0.48127230, -0.05949658,
    -0.87454967, 0.48127230, -0.05949658,
    -0.91756777, 0.34528787, -0.19709308,
    -0.91756777, 0.34528787, -0.19709308,
    -0.91756777, 0.34528787, -0.19709308,
    -0.91756777, 0.34528787, -0.19709308,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.20310694, 0.02090071, 0.97893347,
    0.20310694, 0.02090071, 0.97893347,
    0.20310694, 0.02090071, 0.97893347,
    0.20310694, 0.02090071, 0.97893347,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.18899430, 0.02019939, 0.98177041,
    0.18899430, 0.02019939, 0.98177041,
    0.18899430, 0.02019939, 0.98177041,
    0.18899430, 0.02019939, 0.98177041,
    0.19800531, 0.03050082, 0.97972629,
    0.19800531, 0.03050082, 0.97972629,
    0.19800531, 0.03050082, 0.97972629,
    0.19800531, 0.03050082, 0.97972629,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.19530528, 0.00560015, 0.98072651,
    0.19530528, 0.00560015, 0.98072651,
    0.19530528, 0.00560015, 0.98072651,
    0.19530528, 0.00560015, 0.98072651,
    0.99178728, 0.12789836, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    -0.22869507, -0.00609987, -0.97347900,
    -0.22869507, -0.00609987, -0.97347900,
    -0.22869507, -0.00609987, -0.97347900,
    -0.22869507, -0.00609987, -0.97347900,
    -0.28989777, -0.20839840, -0.93409282,
    -0.28989777, -0.20839840, -0.93409282,
    -0.28989777, -0.20839840, -0.93409282,
    -0.28989777, -0.20839840, -0.93409282,
    -0.30440575, 0.16400310, -0.93831771,
    -0.30440575, 0.16400310, -0.93831771,
    -0.30440575, 0.16400310, -0.93831771,
    -0.30440575, 0.16400310, -0.93831771,
    -0.20140060, 0.59340178, -0.77930233,
    -0.20140060, 0.59340178, -0.77930233,
    -0.20140060, 0.59340178, -0.77930233,
    -0.20140060, 0.59340178, -0.77930233,
    -0.25918372, 0.41157415, -0.87374511,
    -0.25918372, 0.41157415, -0.87374511,
    -0.25918372, 0.41157415, -0.87374511,
    -0.25918372, 0.41157415, -0.87374511,
    -0.21990262, 0.02460029, 0.97521160,
    -0.21990262, 0.02460029, 0.97521160,
    -0.21990262, 0.02460029, 0.97521160,
    -0.21990262, 0.02460029, 0.97521160,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    0.16760261, 0.00880014, 0.98581536,
    0.16760261, 0.00880014, 0.98581536,
    0.16760261, 0.00880014, 0.98581536,
    0.16760261, 0.00880014, 0.98581536,
    -0.25079185, -0.28359079, -0.92556994,
    -0.25079185, -0.28359079, -0.92556994,
    -0.25079185, -0.28359079, -0.92556994,
    -0.25079185, -0.28359079, -0.92556994,
    -0.00729965, -0.00649969, 0.99995223,
    -0.00729965, -0.00649969, 0.99995223,
    -0.00729965, -0.00649969, 0.99995223,
    -0.00729965, -0.00649969, 0.99995223,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.18330552, 0.00720022, 0.98302962,
    0.18330552, 0.00720022, 0.98302962,
    0.18330552, 0.00720022, 0.98302962,
    0.18330552, 0.00720022, 0.98302962,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    0.19610482, 0.03310081, 0.98002410,
    0.19610482, 0.03310081, 0.98002410,
    0.19610482, 0.03310081, 0.98002410,
    0.19610482, 0.03310081, 0.98002410,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.22850448, -0.04240083, -0.97261908,
    -0.22850448, -0.04240083, -0.97261908,
    -0.22850448, -0.04240083, -0.97261908,
    -0.22850448, -0.04240083, -0.97261908,
    -0.22859401, 0.00959975, -0.97347451,
    -0.22859401, 0.00959975, -0.97347451,
    -0.22859401, 0.00959975, -0.97347451,
    -0.22859401, 0.00959975, -0.97347451,
    -0.22870012, 0.01370001, -0.97340052,
    -0.22870012, 0.01370001, -0.97340052,
    -0.22870012, 0.01370001, -0.97340052,
    -0.22870012, 0.01370001, -0.97340052,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.19130283, 0.00570008, 0.98151451,
    0.19130283, 0.00570008, 0.98151451,
    0.19130283, 0.00570008, 0.98151451,
    0.19130283, 0.00570008, 0.98151451,
    0.19739948, -0.00709998, 0.98029742,
    0.19739948, -0.00709998, 0.98029742,
    0.19739948, -0.00709998, 0.98029742,
    0.19739948, -0.00709998, 0.98029742,
    0.19620042, -0.01100002, 0.98050211,
    0.19620042, -0.01100002, 0.98050211,
    0.19620042, -0.01100002, 0.98050211,
    0.19620042, -0.01100002, 0.98050211,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.20809584, -0.00739985, -0.97808045,
    -0.20809584, -0.00739985, -0.97808045,
    -0.20809584, -0.00739985, -0.97808045,
    -0.20809584, -0.00739985, -0.97808045,
    -0.06819807, 0.00000000, -0.99767180,
    -0.06819807, 0.00000000, -0.99767180,
    -0.06819807, 0.00000000, -0.99767180,
    -0.06819807, 0.00000000, -0.99767180,
    -0.05880031, -0.88240466, -0.46680246,
    -0.05880031, -0.88240466, -0.46680246,
    -0.05880031, -0.88240466, -0.46680246,
    -0.05880031, -0.88240466, -0.46680246,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    -0.21840712, 0.04250139, 0.97493177,
    -0.21840712, 0.04250139, 0.97493177,
    -0.21840712, 0.04250139, 0.97493177,
    -0.21840712, 0.04250139, 0.97493177,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.06489773, -0.87926918, 0.47188346,
    0.06489773, -0.87926918, 0.47188346,
    0.06489773, -0.87926918, 0.47188346,
    0.06489773, -0.87926918, 0.47188346,
    0.99486627, -0.10119657, -0.00059998,
    0.99486627, -0.10119657, -0.00059998,
    0.99486627, -0.10119657, -0.00059998,
    0.99486627, -0.10119657, -0.00059998,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.22229682, -0.03399951, -0.97438604,
    0.22229682, -0.03399951, -0.97438604,
    0.22229682, -0.03399951, -0.97438604,
    0.22229682, -0.03399951, -0.97438604,
    -0.20120880, -0.00330014, 0.97954282,
    -0.20120880, -0.00330014, 0.97954282,
    -0.20120880, -0.00330014, 0.97954282,
    -0.20120880, -0.00330014, 0.97954282,
    0.19928897, -0.06249654, -0.97794585,
    0.19928897, -0.06249654, -0.97794585,
    0.19928897, -0.06249654, -0.97794585,
    0.19928897, -0.06249654, -0.97794585,
    -0.20719358, 0.00769976, 0.97826966,
    -0.20719358, 0.00769976, 0.97826966,
    -0.20719358, 0.00769976, 0.97826966,
    -0.20719358, 0.00769976, 0.97826966,
    -0.30599011, 0.20009353, -0.93076991,
    -0.30599011, 0.20009353, -0.93076991,
    -0.30599011, 0.20009353, -0.93076991,
    -0.30599011, 0.20009353, -0.93076991,
    0.99890882, 0.04670041, -0.00050000,
    0.99890882, 0.04670041, -0.00050000,
    0.99890882, 0.04670041, -0.00050000,
    0.99890882, 0.04670041, -0.00050000,
    0.16169659, -0.01099977, -0.98677921,
    0.16169659, -0.01099977, -0.98677921,
    0.16169659, -0.01099977, -0.98677921,
    0.16169659, -0.01099977, -0.98677921,
    0.15920465, -0.22600659, -0.96102804,
    0.15920465, -0.22600659, -0.96102804,
    0.15920465, -0.22600659, -0.96102804,
    0.15920465, -0.22600659, -0.96102804,
    0.85287806, 0.46638800, -0.23469396,
    0.85287806, 0.46638800, -0.23469396,
    0.85287806, 0.46638800, -0.23469396,
    0.85287806, 0.46638800, -0.23469396,
    0.05219935, 0.99858761, -0.00989988,
    0.05219935, 0.99858761, -0.00989988,
    0.05219935, 0.99858761, -0.00989988,
    0.05219935, 0.99858761, -0.00989988,
    0.00660020, 0.32720991, -0.94492863,
    0.00660020, 0.32720991, -0.94492863,
    0.00660020, 0.32720991, -0.94492863,
    0.00660020, 0.32720991, -0.94492863,
    0.00660020, 0.32720991, -0.94492863,
    -0.00519987, -0.00469988, -0.99997544,
    -0.00519987, -0.00469988, -0.99997544,
    -0.00519987, -0.00469988, -0.99997544,
    -0.00519987, -0.00469988, -0.99997544,
    -0.32919376, -0.03309937, -0.94368210,
    -0.32919376, -0.03309937, -0.94368210,
    -0.32919376, -0.03309937, -0.94368210,
    -0.32919376, -0.03309937, -0.94368210,
    -0.99229475, 0.12389934, 0.00030000,
    -0.99229475, 0.12389934, 0.00030000,
    -0.99229475, 0.12389934, 0.00030000,
    -0.99229475, 0.12389934, 0.00030000,
    0.99228245, 0.12399781, -0.00029999,
    0.99228245, 0.12399781, -0.00029999,
    0.99228245, 0.12399781, -0.00029999,
    0.99228245, 0.12399781, -0.00029999,
    0.97331528, 0.22940360, 0.00560009,
    0.97331528, 0.22940360, 0.00560009,
    0.97331528, 0.22940360, 0.00560009,
    0.97331528, 0.22940360, 0.00560009,
    0.24831357, -0.00720039, -0.96865294,
    0.24831357, -0.00720039, -0.96865294,
    0.24831357, -0.00720039, -0.96865294,
    0.24831357, -0.00720039, -0.96865294,
    0.22080541, -0.14470355, -0.96452364,
    0.22080541, -0.14470355, -0.96452364,
    0.22080541, -0.14470355, -0.96452364,
    0.22080541, -0.14470355, -0.96452364,
    0.21399170, -0.23209099, -0.94886318,
    0.21399170, -0.23209099, -0.94886318,
    0.21399170, -0.23209099, -0.94886318,
    0.21399170, -0.23209099, -0.94886318,
    -0.21840729, 0.07420248, 0.97303250,
    -0.21840729, 0.07420248, 0.97303250,
    -0.21840729, 0.07420248, 0.97303250,
    -0.21840729, 0.07420248, 0.97303250,
    -0.27719966, -0.15759981, -0.94779884,
    -0.27719966, -0.15759981, -0.94779884,
    -0.27719966, -0.15759981, -0.94779884,
    -0.27719966, -0.15759981, -0.94779884,
    0.88630789, 0.46210412, -0.03030027,
    0.88630789, 0.46210412, -0.03030027,
    0.88630789, 0.46210412, -0.03030027,
    0.88630789, 0.46210412, -0.03030027,
    0.05209968, 0.99859380, 0.00979994,
    0.05209968, 0.99859380, 0.00979994,
    0.05209968, 0.99859380, 0.00979994,
    0.05209968, 0.99859380, 0.00979994,
    -0.02690103, 0.99963810, 0.00000000,
    -0.02690103, 0.99963810, 0.00000000,
    -0.02690103, 0.99963810, 0.00000000,
    -0.02690103, 0.99963810, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.89572345, -0.44461164, 0.00000000,
    0.99486627, -0.10119657, 0.00059998,
    0.99486627, -0.10119657, 0.00059998,
    0.99486627, -0.10119657, 0.00059998,
    0.99486627, -0.10119657, 0.00059998,
    0.99487651, -0.10109761, 0.00000000,
    0.99487651, -0.10109761, 0.00000000,
    0.99487651, -0.10109761, 0.00000000,
    0.99487651, -0.10109761, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.96369678, -0.26699911, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    0.93487055, -0.35498882, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    -0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    0.97789451, -0.20909883, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.94677640, -0.32189198, 0.00000000,
    -0.22080027, -0.00590001, 0.97530120,
    -0.22080027, -0.00590001, 0.97530120,
    -0.22080027, -0.00590001, 0.97530120,
    -0.22080027, -0.00590001, 0.97530120,
    -0.01089993, -0.00969994, -0.99989355,
    -0.01089993, -0.00969994, -0.99989355,
    -0.01089993, -0.00969994, -0.99989355,
    -0.01089993, -0.00969994, -0.99989355,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99889020, -0.04709954, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99980593, -0.01970012, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    0.99944202, 0.03340140, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99768539, 0.06799900, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.99837426, 0.05699853, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    -0.97577118, -0.21879354, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99202976, 0.12600378, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    0.99978574, -0.02069970, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    -0.99460853, -0.10370089, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    0.99942181, 0.03400074, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    -0.99077776, -0.13549696, 0.00000000,
    0.20670672, -0.01180038, 0.97833179,
    0.20670672, -0.01180038, 0.97833179,
    0.20670672, -0.01180038, 0.97833179,
    0.20670672, -0.01180038, 0.97833179,
    -0.99974911, -0.02239886, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.98481576, 0.17360278, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.96485376, 0.26278741, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.98243472, 0.18660659, 0.00000000,
    0.15899765, -0.13729797, 0.97768554,
    0.15899765, -0.13729797, 0.97768554,
    0.15899765, -0.13729797, 0.97768554,
    0.15899765, -0.13729797, 0.97768554,
    0.31409579, 0.05849922, -0.94758729,
    0.31409579, 0.05849922, -0.94758729,
    0.31409579, 0.05849922, -0.94758729,
    0.31409579, 0.05849922, -0.94758729,
    -0.20070793, -0.02040081, 0.97943868,
    -0.20070793, -0.02040081, 0.97943868,
    -0.20070793, -0.02040081, 0.97943868,
    -0.20070793, -0.02040081, 0.97943868,
    0.32750999, 0.41521267, -0.84872590,
    0.32750999, 0.41521267, -0.84872590,
    0.32750999, 0.41521267, -0.84872590,
    0.32750999, 0.41521267, -0.84872590,
    -0.05909717, -0.99825223, 0.00000000,
    -0.05909717, -0.99825223, 0.00000000,
    -0.05909717, -0.99825223, 0.00000000,
    -0.05909717, -0.99825223, 0.00000000,
    -0.24099484, -0.17079634, 0.95537956,
    -0.24099484, -0.17079634, 0.95537956,
    -0.24099484, -0.17079634, 0.95537956,
    -0.24099484, -0.17079634, 0.95537956,
    0.90771357, 0.41950627, 0.00840013,
    0.90771357, 0.41950627, 0.00840013,
    0.90771357, 0.41950627, 0.00840013,
    0.90771357, 0.41950627, 0.00840013,
    0.24149652, -0.07769888, 0.96728606,
    0.24149652, -0.07769888, 0.96728606,
    0.24149652, -0.07769888, 0.96728606,
    0.24149652, -0.07769888, 0.96728606,
    0.99199214, 0.12629900, 0.00040000,
    0.99199214, 0.12629900, 0.00040000,
    0.99199214, 0.12629900, 0.00040000,
    0.99199214, 0.12629900, 0.00040000,
    0.19140272, 0.03700053, 0.98081393,
    0.19140272, 0.03700053, 0.98081393,
    0.19140272, 0.03700053, 0.98081393,
    0.19140272, 0.03700053, 0.98081393,
    0.08340134, -0.99651604, 0.00000000,
    0.08340134, -0.99651604, 0.00000000,
    0.08340134, -0.99651604, 0.00000000,
    0.08340134, -0.99651604, 0.00000000,
    0.16370446, 0.10480285, 0.98092671,
    0.16370446, 0.10480285, 0.98092671,
    0.16370446, 0.10480285, 0.98092671,
    0.16370446, 0.10480285, 0.98092671,
    0.16140010, 0.09710006, 0.98210060,
    0.16140010, 0.09710006, 0.98210060,
    0.16140010, 0.09710006, 0.98210060,
    0.16140010, 0.09710006, 0.98210060,
    0.22758841, 0.97375039, 0.00369981,
    0.22758841, 0.97375039, 0.00369981,
    0.22758841, 0.97375039, 0.00369981,
    0.22758841, 0.97375039, 0.00369981,
    -0.05010218, -0.97814262, 0.20180879,
    -0.05010218, -0.97814262, 0.20180879,
    -0.05010218, -0.97814262, 0.20180879,
    -0.05010218, -0.97814262, 0.20180879,
    0.15409631, 0.02349944, 0.98777634,
    0.15409631, 0.02349944, 0.98777634,
    0.15409631, 0.02349944, 0.98777634,
    0.15409631, 0.02349944, 0.98777634,
    -0.00939969, -0.03429888, 0.99936742,
    -0.00939969, -0.03429888, 0.99936742,
    -0.00939969, -0.03429888, 0.99936742,
    -0.00939969, -0.03429888, 0.99936742,
    -0.00939969, -0.03429888, 0.99936742,
    0.22749509, 0.97377898, 0.00069998,
    0.22749509, 0.97377898, 0.00069998,
    0.22749509, 0.97377898, 0.00069998,
    0.22749509, 0.97377898, 0.00069998,
    -0.18620863, -0.19110885, -0.96374465,
    -0.18620863, -0.19110885, -0.96374465,
    -0.18620863, -0.19110885, -0.96374465,
    -0.18620863, -0.19110885, -0.96374465,
    0.25669483, 0.40099193, -0.87938230,
    0.25669483, 0.40099193, -0.87938230,
    0.25669483, 0.40099193, -0.87938230,
    0.25669483, 0.40099193, -0.87938230,
    0.16329137, 0.00769959, -0.98654784,
    0.16329137, 0.00769959, -0.98654784,
    0.16329137, 0.00769959, -0.98654784,
    0.16329137, 0.00769959, -0.98654784,
    0.21978839, -0.17919053, -0.95894933,
    0.21978839, -0.17919053, -0.95894933,
    0.21978839, -0.17919053, -0.95894933,
    0.21978839, -0.17919053, -0.95894933,
    0.25671086, 0.03800161, -0.96574086,
    0.25671086, 0.03800161, -0.96574086,
    0.25671086, 0.03800161, -0.96574086,
    0.25671086, 0.03800161, -0.96574086,
    0.14519917, -0.53059697, -0.83509524,
    0.14519917, -0.53059697, -0.83509524,
    0.14519917, -0.53059697, -0.83509524,
    0.14519917, -0.53059697, -0.83509524,
    -0.99600474, -0.08930042, 0.00000000,
    -0.99600474, -0.08930042, 0.00000000,
    -0.99600474, -0.08930042, 0.00000000,
    -0.99600474, -0.08930042, 0.00000000,
    0.99987200, 0.01599955, 0.00000000,
    0.99987200, 0.01599955, 0.00000000,
    0.99987200, 0.01599955, 0.00000000,
    0.99987200, 0.01599955, 0.00000000,
    0.94829258, 0.31739752, 0.00000000,
    0.94829258, 0.31739752, 0.00000000,
    0.94829258, 0.31739752, 0.00000000,
    0.94829258, 0.31739752, 0.00000000,
    -0.97727103, -0.21199372, 0.00000000,
    -0.97727103, -0.21199372, 0.00000000,
    -0.97727103, -0.21199372, 0.00000000,
    -0.97727103, -0.21199372, 0.00000000,
    0.73272581, -0.68052398, 0.00000000,
    0.73272581, -0.68052398, 0.00000000,
    0.73272581, -0.68052398, 0.00000000,
    0.73272581, -0.68052398, 0.00000000,
    -0.19260400, -0.01050022, 0.98122039,
    -0.19260400, -0.01050022, 0.98122039,
    -0.19260400, -0.01050022, 0.98122039,
    -0.19260400, -0.01050022, 0.98122039,
    -0.12970162, -0.52890661, 0.83871049,
    -0.12970162, -0.52890661, 0.83871049,
    -0.12970162, -0.52890661, 0.83871049,
    -0.12970162, -0.52890661, 0.83871049,
    0.13179691, -0.00010000, -0.99127674,
    0.13179691, -0.00010000, -0.99127674,
    0.13179691, -0.00010000, -0.99127674,
    0.13179691, -0.00010000, -0.99127674,
    -0.15839642, -0.04209905, 0.98647770,
    -0.15839642, -0.04209905, 0.98647770,
    -0.15839642, -0.04209905, 0.98647770,
    -0.15839642, -0.04209905, 0.98647770,
    -0.97833919, -0.20700829, 0.00000000,
    -0.97833919, -0.20700829, 0.00000000,
    -0.97833919, -0.20700829, 0.00000000,
    -0.97833919, -0.20700829, 0.00000000,
    -0.96995398, 0.24328846, 0.00000000,
    -0.96995398, 0.24328846, 0.00000000,
    -0.96995398, 0.24328846, 0.00000000,
    -0.96995398, 0.24328846, 0.00000000,
    0.12899837, 0.03609954, -0.99098751,
    0.12899837, 0.03609954, -0.99098751,
    0.12899837, 0.03609954, -0.99098751,
    0.12899837, 0.03609954, -0.99098751,
    0.12490048, -0.01140004, -0.99210378,
    0.12490048, -0.01140004, -0.99210378,
    0.12490048, -0.01140004, -0.99210378,
    0.12490048, -0.01140004, -0.99210378,
    0.94829258, 0.31739752, 0.00000000,
    0.94829258, 0.31739752, 0.00000000,
    0.99484527, -0.10140461, 0.00000000,
    0.99484527, -0.10140461, 0.00000000,
    0.99484527, -0.10140461, 0.00000000,
    0.99484527, -0.10140461, 0.00000000,
    -0.95976896, -0.28079092, 0.00000000,
    -0.95976896, -0.28079092, 0.00000000,
    -0.95976896, -0.28079092, 0.00000000,
    -0.95976896, -0.28079092, 0.00000000,
    0.96375534, -0.26678764, 0.00000000,
    0.96375534, -0.26678764, 0.00000000,
    0.96375534, -0.26678764, 0.00000000,
    0.96375534, -0.26678764, 0.00000000,
    -0.16449624, 0.00069998, 0.98637746,
    -0.16449624, 0.00069998, 0.98637746,
    -0.16449624, 0.00069998, 0.98637746,
    -0.16449624, 0.00069998, 0.98637746,
    -0.16160840, -0.00270014, 0.98685127,
    -0.16160840, -0.00270014, 0.98685127,
    -0.16160840, -0.00270014, 0.98685127,
    -0.16160840, -0.00270014, 0.98685127,
    0.09670595, 0.41502551, -0.90465562,
    0.09670595, 0.41502551, -0.90465562,
    0.09670595, 0.41502551, -0.90465562,
    0.09670595, 0.41502551, -0.90465562,
    -0.14350591, -0.04000165, 0.98884070,
    -0.14350591, -0.04000165, 0.98884070,
    -0.14350591, -0.04000165, 0.98884070,
    -0.14350591, -0.04000165, 0.98884070,
    -0.98182195, -0.18980424, 0.00000000,
    -0.98182195, -0.18980424, 0.00000000,
    -0.98182195, -0.18980424, 0.00000000,
    -0.98182195, -0.18980424, 0.00000000,
    0.95675740, 0.29088705, 0.00000000,
    0.95675740, 0.29088705, 0.00000000,
    0.95675740, 0.29088705, 0.00000000,
    0.95675740, 0.29088705, 0.00000000,
    -0.97534458, 0.22068746, 0.00000000,
    -0.97534458, 0.22068746, 0.00000000,
    -0.97534458, 0.22068746, 0.00000000,
    -0.97534458, 0.22068746, 0.00000000,
    0.95330720, 0.30200228, 0.00000000,
    0.95330720, 0.30200228, 0.00000000,
    0.95330720, 0.30200228, 0.00000000,
    0.95330720, 0.30200228, 0.00000000,
    0.12070570, -0.02960140, -0.99224689,
    0.12070570, -0.02960140, -0.99224689,
    0.12070570, -0.02960140, -0.99224689,
    0.12070570, -0.02960140, -0.99224689,
    -0.16338998, 0.40087542, 0.90144473,
    -0.16338998, 0.40087542, 0.90144473,
    -0.16338998, 0.40087542, 0.90144473,
    -0.16338998, 0.40087542, 0.90144473,
    -0.27201106, 0.30121225, 0.91393718,
    -0.27201106, 0.30121225, 0.91393718,
    -0.27201106, 0.30121225, 0.91393718,
    -0.27201106, 0.30121225, 0.91393718,
    -0.21479472, 0.37239084, 0.90287778,
    -0.21479472, 0.37239084, 0.90287778,
    -0.21479472, 0.37239084, 0.90287778,
    -0.21479472, 0.37239084, 0.90287778,
    -0.97782875, 0.20940616, 0.00000000,
    -0.97782875, 0.20940616, 0.00000000,
    -0.97782875, 0.20940616, 0.00000000,
    -0.97782875, 0.20940616, 0.00000000,
    0.14829896, 0.39139724, -0.90819360,
    0.14829896, 0.39139724, -0.90819360,
    0.14829896, 0.39139724, -0.90819360,
    0.14829896, 0.39139724, -0.90819360,
    0.24310806, -0.43671448, -0.86612871,
    0.24310806, -0.43671448, -0.86612871,
    0.24310806, -0.43671448, -0.86612871,
    0.24310806, -0.43671448, -0.86612871,
    -0.99998140, -0.00609989, 0.00000000,
    -0.99998140, -0.00609989, 0.00000000,
    -0.99998140, -0.00609989, 0.00000000,
    -0.99998140, -0.00609989, 0.00000000,
    0.96498732, 0.26229655, 0.00000000,
    0.96498732, 0.26229655, 0.00000000,
    0.96498732, 0.26229655, 0.00000000,
    0.96498732, 0.26229655, 0.00000000,
    0.63610325, -0.77160395, 0.00000000,
    0.63610325, -0.77160395, 0.00000000,
    0.63610325, -0.77160395, 0.00000000,
    0.63610325, -0.77160395, 0.00000000,
    -0.93558738, -0.35309524, 0.00000000,
    -0.93558738, -0.35309524, 0.00000000,
    -0.93558738, -0.35309524, 0.00000000,
    -0.93558738, -0.35309524, 0.00000000,
    0.99702323, 0.07710180, 0.00000000,
    0.99702323, 0.07710180, 0.00000000,
    0.99702323, 0.07710180, 0.00000000,
    0.99702323, 0.07710180, 0.00000000,
    0.20390017, 0.36650031, -0.90780077,
    0.20390017, 0.36650031, -0.90780077,
    0.20390017, 0.36650031, -0.90780077,
    0.20390017, 0.36650031, -0.90780077,
    -0.21118964, -0.52707415, 0.82315963,
    -0.21118964, -0.52707415, 0.82315963,
    -0.21118964, -0.52707415, 0.82315963,
    -0.21118964, -0.52707415, 0.82315963,
    0.09860255, -0.97432523, -0.20240524,
    0.09860255, -0.97432523, -0.20240524,
    0.09860255, -0.97432523, -0.20240524,
    0.09860255, -0.97432523, -0.20240524,
    -0.17810078, -0.42790188, 0.88610389,
    -0.17810078, -0.42790188, 0.88610389,
    -0.17810078, -0.42790188, 0.88610389,
    -0.17810078, -0.42790188, 0.88610389,
    -0.61619501, -0.78759362, 0.00000000,
    -0.61619501, -0.78759362, 0.00000000,
    -0.61619501, -0.78759362, 0.00000000,
    -0.61619501, -0.78759362, 0.00000000,
    0.19681334, -0.44613024, -0.87305917,
    0.19681334, -0.44613024, -0.87305917,
    0.19681334, -0.44613024, -0.87305917,
    0.19681334, -0.44613024, -0.87305917,
    -0.43819114, -0.89888182, 0.00000000,
    -0.43819114, -0.89888182, 0.00000000,
    -0.43819114, -0.89888182, 0.00000000,
    -0.43819114, -0.89888182, 0.00000000,
    0.61061894, -0.79192456, 0.00000000,
    0.61061894, -0.79192456, 0.00000000,
    0.61061894, -0.79192456, 0.00000000,
    0.61061894, -0.79192456, 0.00000000,
    0.07789699, -0.99696141, 0.00000000,
    0.07789699, -0.99696141, 0.00000000,
    0.07789699, -0.99696141, 0.00000000,
    0.07789699, -0.99696141, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    0.26771488, 0.35941997, -0.89394968,
    0.26771488, 0.35941997, -0.89394968,
    0.26771488, 0.35941997, -0.89394968,
    0.26771488, 0.35941997, -0.89394968,
    -0.00429984, -0.24559089, -0.96936403,
    -0.00429984, -0.24559089, -0.96936403,
    -0.00429984, -0.24559089, -0.96936403,
    -0.00429984, -0.24559089, -0.96936403,
    0.15120361, 0.01250030, 0.98842360,
    0.15120361, 0.01250030, 0.98842360,
    0.15120361, 0.01250030, 0.98842360,
    0.15120361, 0.01250030, 0.98842360,
    0.13969573, 0.00699979, 0.99016974,
    0.13969573, 0.00699979, 0.99016974,
    0.13969573, 0.00699979, 0.99016974,
    0.13969573, 0.00699979, 0.99016974,
    0.13150106, 0.00400003, 0.99130796,
    0.13150106, 0.00400003, 0.99130796,
    0.13150106, 0.00400003, 0.99130796,
    0.13150106, 0.00400003, 0.99130796,
    -0.20639036, -0.00549974, 0.97845428,
    -0.20639036, -0.00549974, 0.97845428,
    -0.20639036, -0.00549974, 0.97845428,
    -0.20639036, -0.00549974, 0.97845428,
    0.93612141, 0.34870798, -0.04560104,
    0.93612141, 0.34870798, -0.04560104,
    0.93612141, 0.34870798, -0.04560104,
    0.93612141, 0.34870798, -0.04560104,
    -0.00779967, 0.00489979, 0.99995758,
    -0.00779967, 0.00489979, 0.99995758,
    -0.00779967, 0.00489979, 0.99995758,
    -0.00779967, 0.00489979, 0.99995758,
    -0.00289995, 0.00499992, -0.99998330,
    -0.00289995, 0.00499992, -0.99998330,
    -0.00289995, 0.00499992, -0.99998330,
    -0.00289995, 0.00499992, -0.99998330,
    -0.00130006, 0.02260099, -0.99974372,
    -0.00130006, 0.02260099, -0.99974372,
    -0.00130006, 0.02260099, -0.99974372,
    -0.00130006, 0.02260099, -0.99974372,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    0.00000000, 0.01170037, -0.99993155,
    -0.00730020, 0.02220060, 0.99972688,
    -0.00730020, 0.02220060, 0.99972688,
    -0.00730020, 0.02220060, 0.99972688,
    -0.00730020, 0.02220060, 0.99972688,
    -0.00139997, -0.88368000, 0.46808941,
    -0.00139997, -0.88368000, 0.46808941,
    -0.00139997, -0.88368000, 0.46808941,
    -0.00139997, -0.88368000, 0.46808941,
    -0.00150003, -0.88361659, -0.46820879,
    -0.00150003, -0.88361659, -0.46820879,
    -0.00150003, -0.88361659, -0.46820879,
    -0.00150003, -0.88361659, -0.46820879,
    -0.00160000, 0.00000000, 0.99999872,
    -0.00160000, 0.00000000, 0.99999872,
    -0.00160000, 0.00000000, 0.99999872,
    -0.00160000, 0.00000000, 0.99999872,
    -0.00629988, 0.01409973, -0.99988075,
    -0.00629988, 0.01409973, -0.99988075,
    -0.00629988, 0.01409973, -0.99988075,
    -0.00629988, 0.01409973, -0.99988075,
    -0.31570253, -0.00980008, -0.94880760,
    -0.31570253, -0.00980008, -0.94880760,
    -0.31570253, -0.00980008, -0.94880760,
    -0.31570253, -0.00980008, -0.94880760,
    -0.00709982, -0.00039999, 0.99997472,
    -0.00709982, -0.00039999, 0.99997472,
    -0.00709982, -0.00039999, 0.99997472,
    -0.00709982, -0.00039999, 0.99997472,
    -0.00699982, -0.00119997, 0.99997478,
    -0.00699982, -0.00119997, 0.99997478,
    -0.00699982, -0.00119997, 0.99997478,
    -0.00699982, -0.00119997, 0.99997478,
    0.20239718, 0.00579992, -0.97928634,
    0.20239718, 0.00579992, -0.97928634,
    0.20239718, 0.00579992, -0.97928634,
    0.20239718, 0.00579992, -0.97928634,
    -0.00729980, -0.00039999, -0.99997328,
    -0.00729980, -0.00039999, -0.99997328,
    -0.00729980, -0.00039999, -0.99997328,
    -0.00729980, -0.00039999, -0.99997328,
    -0.00729980, -0.00119997, -0.99997264,
    -0.00729980, -0.00119997, -0.99997264,
    -0.00729980, -0.00119997, -0.99997264,
    -0.00729980, -0.00119997, -0.99997264,
    -0.00729978, 0.00269992, -0.99996971,
    -0.00729978, 0.00269992, -0.99996971,
    -0.00729978, 0.00269992, -0.99996971,
    -0.00729978, 0.00269992, -0.99996971,
    -0.00609993, 0.01359985, 0.99988891,
    -0.00609993, 0.01359985, 0.99988891,
    -0.00609993, 0.01359985, 0.99988891,
    -0.00609993, 0.01359985, 0.99988891,
    -0.00709980, 0.00259993, 0.99997142,
    -0.00709980, 0.00259993, 0.99997142,
    -0.00709980, 0.00259993, 0.99997142,
    -0.00709980, 0.00259993, 0.99997142,
    -0.00729967, 0.00599973, 0.99995536,
    -0.00729967, 0.00599973, 0.99995536,
    -0.00729967, 0.00599973, 0.99995536,
    -0.00729967, 0.00599973, 0.99995536,
    -0.00300003, -0.27370275, -0.96180965,
    -0.00300003, -0.27370275, -0.96180965,
    -0.00300003, -0.27370275, -0.96180965,
    -0.00300003, -0.27370275, -0.96180965,
    -0.00759976, 0.00209993, 0.99996892,
    -0.00759976, 0.00209993, 0.99996892,
    -0.00759976, 0.00209993, 0.99996892,
    -0.00759976, 0.00209993, 0.99996892,
    -0.00690006, 0.01160010, 0.99990891,
    -0.00690006, 0.01160010, 0.99990891,
    -0.00690006, 0.01160010, 0.99990891,
    -0.00690006, 0.01160010, 0.99990891,
    -0.00489972, 0.45817378, -0.88884913,
    -0.00489972, 0.45817378, -0.88884913,
    -0.00489972, 0.45817378, -0.88884913,
    -0.00489972, 0.45817378, -0.88884913,
    -0.00059997, 0.62407281, -0.78136596,
    -0.00059997, 0.62407281, -0.78136596,
    -0.00059997, 0.62407281, -0.78136596,
    -0.00059997, 0.62407281, -0.78136596,
    -0.00969982, 0.19079644, -0.98158170,
    -0.00969982, 0.19079644, -0.98158170,
    -0.00969982, 0.19079644, -0.98158170,
    -0.00969982, 0.19079644, -0.98158170,
    0.25379218, 0.01909941, -0.96707019,
    0.25379218, 0.01909941, -0.96707019,
    0.25379218, 0.01909941, -0.96707019,
    0.25379218, 0.01909941, -0.96707019,
    0.00020001, -0.19830804, -0.98013973,
    0.00020001, -0.19830804, -0.98013973,
    0.00020001, -0.19830804, -0.98013973,
    0.00020001, -0.19830804, -0.98013973,
    -0.00709982, -0.00059998, 0.99997462,
    -0.00709982, -0.00059998, 0.99997462,
    -0.00709982, -0.00059998, 0.99997462,
    -0.00709982, -0.00059998, 0.99997462,
    -0.00700007, -0.01150011, 0.99990937,
    -0.00700007, -0.01150011, 0.99990937,
    -0.00700007, -0.01150011, 0.99990937,
    -0.00700007, -0.01150011, 0.99990937,
    -0.00720032, -0.00770034, 0.99994443,
    -0.00720032, -0.00770034, 0.99994443,
    -0.00720032, -0.00770034, 0.99994443,
    -0.00720032, -0.00770034, 0.99994443,
    -0.00680032, -0.00780036, 0.99994645,
    -0.00680032, -0.00780036, 0.99994645,
    -0.00680032, -0.00780036, 0.99994645,
    -0.00680032, -0.00780036, 0.99994645,
    -0.00200000, 0.65259998, -0.75769998,
    -0.00200000, 0.65259998, -0.75769998,
    -0.00200000, 0.65259998, -0.75769998,
    -0.00200000, 0.65259998, -0.75769998,
    0.30950205, 0.95040629, -0.03060020,
    0.30950205, 0.95040629, -0.03060020,
    0.30950205, 0.95040629, -0.03060020,
    0.30950205, 0.95040629, -0.03060020,
    0.31370973, 0.91802849, -0.24250753,
    0.31370973, 0.91802849, -0.24250753,
    0.31370973, 0.91802849, -0.24250753,
    0.31370973, 0.91802849, -0.24250753,
    0.18729783, 0.98038866, -0.06129929,
    0.18729783, 0.98038866, -0.06129929,
    0.18729783, 0.98038866, -0.06129929,
    0.18729783, 0.98038866, -0.06129929,
    -0.04200064, -0.12620192, 0.99111504,
    -0.04200064, -0.12620192, 0.99111504,
    -0.04200064, -0.12620192, 0.99111504,
    -0.04200064, -0.12620192, 0.99111504,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.02239912, -0.74537070, -0.66627381,
    -0.02239912, -0.74537070, -0.66627381,
    -0.02239912, -0.74537070, -0.66627381,
    -0.02239912, -0.74537070, -0.66627381,
    0.88378548, 0.46789231, 0.00000000,
    0.88378548, 0.46789231, 0.00000000,
    0.88378548, 0.46789231, 0.00000000,
    0.88378548, 0.46789231, 0.00000000,
    -0.00160000, 0.00000000, 0.99999872,
    -0.00160000, 0.00000000, 0.99999872,
    0.09120249, 0.64511761, -0.75862071,
    0.09120249, 0.64511761, -0.75862071,
    0.09120249, 0.64511761, -0.75862071,
    0.09120249, 0.64511761, -0.75862071,
    0.88378548, 0.46789231, 0.00000000,
    0.88378548, 0.46789231, 0.00000000,
    0.06630047, 0.80540570, 0.58900417,
    0.06630047, 0.80540570, 0.58900417,
    0.06630047, 0.80540570, 0.58900417,
    0.06630047, 0.80540570, 0.58900417,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    -0.00030000, 0.99861557, 0.05260082,
    -0.00030000, 0.99861557, 0.05260082,
    -0.00030000, 0.99861557, 0.05260082,
    -0.00030000, 0.99861557, 0.05260082,
    -0.18310370, -0.81341644, -0.55211116,
    -0.18310370, -0.81341644, -0.55211116,
    -0.18310370, -0.81341644, -0.55211116,
    -0.18310370, -0.81341644, -0.55211116,
    -0.20719948, 0.97829756, 0.00150000,
    -0.20719948, 0.97829756, 0.00150000,
    -0.20719948, 0.97829756, 0.00150000,
    -0.20719948, 0.97829756, 0.00150000,
    -0.21940705, 0.97563136, -0.00200006,
    -0.21940705, 0.97563136, -0.00200006,
    -0.21940705, 0.97563136, -0.00200006,
    -0.21940705, 0.97563136, -0.00200006,
    -0.03289917, -0.45928847, -0.88767772,
    -0.03289917, -0.45928847, -0.88767772,
    -0.03289917, -0.45928847, -0.88767772,
    -0.03289917, -0.45928847, -0.88767772,
    0.19819218, 0.98016134, 0.00189993,
    0.19819218, 0.98016134, 0.00189993,
    0.19819218, 0.98016134, 0.00189993,
    0.19819218, 0.98016134, 0.00189993,
    -0.00169994, 0.35918628, -0.93326434,
    -0.00169994, 0.35918628, -0.93326434,
    -0.00169994, 0.35918628, -0.93326434,
    -0.00169994, 0.35918628, -0.93326434,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.89582284, 0.44441133, 0.00000000,
    -0.07690336, 0.65702871, -0.74993277,
    -0.07690336, 0.65702871, -0.74993277,
    -0.07690336, 0.65702871, -0.74993277,
    -0.07690336, 0.65702871, -0.74993277,
    0.88378548, 0.46789231, 0.00000000,
    0.88378548, 0.46789231, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    -0.06749857, 0.35669244, -0.93178026,
    -0.06749857, 0.35669244, -0.93178026,
    -0.06749857, 0.35669244, -0.93178026,
    -0.06749857, 0.35669244, -0.93178026,
    -1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    1.00000000, 0.00000000, 0.00000000,
    0.17119733, -0.78338776, -0.59749066,
    0.17119733, -0.78338776, -0.59749066,
    0.17119733, -0.78338776, -0.59749066,
    0.17119733, -0.78338776, -0.59749066,
    -0.00139999, 0.81089197, 0.58519420,
    -0.00139999, 0.81089197, 0.58519420,
    -0.00139999, 0.81089197, 0.58519420,
    -0.00139999, 0.81089197, 0.58519420,
    -0.00170000, 0.00000000, -0.99999856,
    -0.00170000, 0.00000000, -0.99999856,
    -0.00170000, 0.00000000, -0.99999856,
    -0.00170000, 0.00000000, -0.99999856,
    -1.00000000, 0.00000000, 0.00000000,
    0.91541675, -0.40250736, 0.00000000,
    0.91541675, -0.40250736, 0.00000000,
    0.91541675, -0.40250736, 0.00000000,
    0.91541675, -0.40250736, 0.00000000,
    -0.92481887, -0.38040776, 0.00000000,
    -0.92481887, -0.38040776, 0.00000000,
    -0.92481887, -0.38040776, 0.00000000,
    -0.92481887, -0.38040776, 0.00000000,
    0.88692035, -0.46191060, 0.00330008,
    0.88692035, -0.46191060, 0.00330008,
    0.88692035, -0.46191060, 0.00330008,
    0.88692035, -0.46191060, 0.00330008,
    -0.14460596, -0.00980040, -0.98944079,
    -0.14460596, -0.00980040, -0.98944079,
    -0.14460596, -0.00980040, -0.98944079,
    -0.14460596, -0.00980040, -0.98944079,
    -0.89887778, -0.43818917, 0.00299993,
    -0.89887778, -0.43818917, 0.00299993,
    -0.89887778, -0.43818917, 0.00299993,
    -0.89887778, -0.43818917, 0.00299993,
    -0.92481887, -0.38040776, 0.00000000,
    -0.92481887, -0.38040776, 0.00000000,
    0.18899556, 0.98197694, 0.00139997,
    0.18899556, 0.98197694, 0.00139997,
    0.18899556, 0.98197694, 0.00139997,
    0.18899556, 0.98197694, 0.00139997,
    -0.21919527, 0.97567896, 0.00199996,
    -0.21919527, 0.97567896, 0.00199996,
    -0.21919527, 0.97567896, 0.00199996,
    -0.21919527, 0.97567896, 0.00199996,
    0.19849985, 0.98009926, -0.00180000,
    0.19849985, 0.98009926, -0.00180000,
    0.19849985, 0.98009926, -0.00180000,
    0.19849985, 0.98009926, -0.00180000,
    0.07910208, 0.35470932, -0.93162447,
    0.07910208, 0.35470932, -0.93162447,
    0.07910208, 0.35470932, -0.93162447,
    0.07910208, 0.35470932, -0.93162447,
    0.43460728, -0.90061508, -0.00300005,
    0.43460728, -0.90061508, -0.00300005,
    0.43460728, -0.90061508, -0.00300005,
    0.43460728, -0.90061508, -0.00300005,
    -0.53528261, -0.84467255, -0.00089997,
    -0.53528261, -0.84467255, -0.00089997,
    -0.53528261, -0.84467255, -0.00089997,
    -0.53528261, -0.84467255, -0.00089997,
    0.37029685, -0.92889211, 0.00629995,
    0.37029685, -0.92889211, 0.00629995,
    0.37029685, -0.92889211, 0.00629995,
    0.37029685, -0.92889211, 0.00629995,
    -0.06799992, -0.86679903, -0.49399945,
    -0.06799992, -0.86679903, -0.49399945,
    -0.06799992, -0.86679903, -0.49399945,
    -0.06799992, -0.86679903, -0.49399945,
    -0.39810745, -0.91731716, 0.00630012,
    -0.39810745, -0.91731716, 0.00630012,
    -0.39810745, -0.91731716, 0.00630012,
    -0.39810745, -0.91731716, 0.00630012,
    -0.46828528, -0.88357223, -0.00299991,
    -0.46828528, -0.88357223, -0.00299991,
    -0.46828528, -0.88357223, -0.00299991,
    -0.46828528, -0.88357223, -0.00299991,
    0.01419953, 0.99846698, 0.05349823,
    0.01419953, 0.99846698, 0.05349823,
    0.01419953, 0.99846698, 0.05349823,
    0.01419953, 0.99846698, 0.05349823,
    0.15719414, -0.00299989, -0.98756316,
    0.15719414, -0.00299989, -0.98756316,
    0.15719414, -0.00299989, -0.98756316,
    0.15719414, -0.00299989, -0.98756316,
    0.91541675, -0.40250736, 0.00000000,
    0.91541675, -0.40250736, 0.00000000,
    -0.14700464, -0.00300009, -0.98913125,
    -0.14700464, -0.00300009, -0.98913125,
    -0.14700464, -0.00300009, -0.98913125,
    -0.14700464, -0.00300009, -0.98913125,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    -0.00169998, -0.97209103, 0.23459783,
    -0.00169998, -0.97209103, 0.23459783,
    -0.00169998, -0.97209103, 0.23459783,
    -0.00169998, -0.97209103, 0.23459783,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    -0.00650010, 0.54050860, 0.84131338,
    -0.00650010, 0.54050860, 0.84131338,
    -0.00650010, 0.54050860, 0.84131338,
    -0.00650010, 0.54050860, 0.84131338,
    0.49600950, -0.86831663, -0.00090002,
    0.49600950, -0.86831663, -0.00090002,
    0.49600950, -0.86831663, -0.00090002,
    0.49600950, -0.86831663, -0.00090002,
    -0.00020000, 0.99797555, 0.06359844,
    -0.00020000, 0.99797555, 0.06359844,
    -0.00020000, 0.99797555, 0.06359844,
    -0.00020000, 0.99797555, 0.06359844,
    0.07670012, -0.85740135, -0.50890080,
    0.07670012, -0.85740135, -0.50890080,
    0.07670012, -0.85740135, -0.50890080,
    0.07670012, -0.85740135, -0.50890080,
    0.88609162, 0.46329562, -0.01409987,
    0.88609162, 0.46329562, -0.01409987,
    0.88609162, 0.46329562, -0.01409987,
    0.88609162, 0.46329562, -0.01409987,
    -0.88442899, 0.46651529, 0.01220040,
    -0.88442899, 0.46651529, 0.01220040,
    -0.88442899, 0.46651529, 0.01220040,
    -0.88442899, 0.46651529, 0.01220040,
    0.99025505, 0.13899369, 0.00869961,
    0.99025505, 0.13899369, 0.00869961,
    0.99025505, 0.13899369, 0.00869961,
    0.99025505, 0.13899369, 0.00869961,
    -0.00420019, 0.01710077, -0.99984495,
    -0.00420019, 0.01710077, -0.99984495,
    -0.00420019, 0.01710077, -0.99984495,
    -0.00420019, 0.01710077, -0.99984495,
    0.86650888, 0.49900511, 0.01250013,
    0.86650888, 0.49900511, 0.01250013,
    0.86650888, 0.49900511, 0.01250013,
    0.86650888, 0.49900511, 0.01250013,
    -0.00160002, 0.83151037, -0.55550693,
    -0.00160002, 0.83151037, -0.55550693,
    -0.00160002, 0.83151037, -0.55550693,
    -0.00160002, 0.83151037, -0.55550693,
    -0.90262538, 0.43021210, -0.01360038,
    -0.90262538, 0.43021210, -0.01360038,
    -0.90262538, 0.43021210, -0.01360038,
    -0.90262538, 0.43021210, -0.01360038,
    -0.99488989, 0.10059898, 0.00859991,
    -0.99488989, 0.10059898, 0.00859991,
    -0.99488989, 0.10059898, 0.00859991,
    -0.99488989, 0.10059898, 0.00859991,
    -0.07229806, 0.82547789, -0.55978500,
    -0.07229806, 0.82547789, -0.55978500,
    -0.07229806, 0.82547789, -0.55978500,
    -0.07229806, 0.82547789, -0.55978500,
    -0.00809968, -0.00369985, 0.99996035,
    -0.00809968, -0.00369985, 0.99996035,
    -0.00809968, -0.00369985, 0.99996035,
    -0.00809968, -0.00369985, 0.99996035,
    0.91626058, 0.40058277, 0.00000000,
    0.91626058, 0.40058277, 0.00000000,
    0.91626058, 0.40058277, 0.00000000,
    0.91626058, 0.40058277, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.00190007, -0.85873304, -0.51241971,
    -0.00190007, -0.85873304, -0.51241971,
    -0.00190007, -0.85873304, -0.51241971,
    -0.00190007, -0.85873304, -0.51241971,
    -0.00649968, -0.54477297, 0.83855839,
    -0.00649968, -0.54477297, 0.83855839,
    -0.00649968, -0.54477297, 0.83855839,
    -0.00649968, -0.54477297, 0.83855839,
    0.30829505, -0.00339995, 0.95128471,
    0.30829505, -0.00339995, 0.95128471,
    0.30829505, -0.00339995, 0.95128471,
    0.30829505, -0.00339995, 0.95128471,
    0.25661082, 0.52432211, 0.81193424,
    0.25661082, 0.52432211, 0.81193424,
    0.25661082, 0.52432211, 0.81193424,
    0.25661082, 0.52432211, 0.81193424,
    -0.92551669, 0.37870683, 0.00000000,
    -0.92551669, 0.37870683, 0.00000000,
    -0.92551669, 0.37870683, 0.00000000,
    -0.92551669, 0.37870683, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.99999928, -0.00120000, 0.00000000,
    -0.90012890, 0.43561399, 0.00290009,
    -0.90012890, 0.43561399, 0.00290009,
    -0.90012890, 0.43561399, 0.00290009,
    -0.90012890, 0.43561399, 0.00290009,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    -0.27069937, -0.35529917, -0.89469791,
    -0.27069937, -0.35529917, -0.89469791,
    -0.27069937, -0.35529917, -0.89469791,
    -0.27069937, -0.35529917, -0.89469791,
    0.88832142, 0.45921107, 0.00320008,
    0.88832142, 0.45921107, 0.00320008,
    0.88832142, 0.45921107, 0.00320008,
    0.88832142, 0.45921107, 0.00320008,
    -0.92551669, 0.37870683, 0.00000000,
    -0.92551669, 0.37870683, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.99999902, -0.00140000, 0.00000000,
    0.91626058, 0.40058277, 0.00000000,
    0.91626058, 0.40058277, 0.00000000,
    -0.00399995, -0.00309996, -0.99998720,
    -0.00399995, -0.00309996, -0.99998720,
    -0.00399995, -0.00309996, -0.99998720,
    -0.00399995, -0.00309996, -0.99998720,
    0.10260511, -0.97384846, 0.20271009,
    0.10260511, -0.97384846, 0.20271009,
    0.10260511, -0.97384846, 0.20271009,
    0.10260511, -0.97384846, 0.20271009,
    0.07789699, -0.99696141, 0.00000000,
    0.07789699, -0.99696141, 0.00000000,
    -0.15210569, -0.43511628, -0.88743320,
    -0.15210569, -0.43511628, -0.88743320,
    -0.15210569, -0.43511628, -0.88743320,
    -0.15210569, -0.43511628, -0.88743320,
    0.22150231, -0.43690457, 0.87180911,
    0.22150231, -0.43690457, 0.87180911,
    0.22150231, -0.43690457, 0.87180911,
    0.22150231, -0.43690457, 0.87180911,
    0.05399885, -0.97797919, -0.20159571,
    0.05399885, -0.97797919, -0.20159571,
    0.05399885, -0.97797919, -0.20159571,
    0.05399885, -0.97797919, -0.20159571,
    0.27000149, -0.42820236, 0.86240474,
    0.27000149, -0.42820236, 0.86240474,
    0.27000149, -0.42820236, 0.86240474,
    0.27000149, -0.42820236, 0.86240474,
    -0.24410124, 0.30780157, -0.91960469,
    -0.24410124, 0.30780157, -0.91960469,
    -0.24410124, 0.30780157, -0.91960469,
    -0.24410124, 0.30780157, -0.91960469,
    -0.18600922, -0.52592608, -0.82994116,
    -0.18600922, -0.52592608, -0.82994116,
    -0.18600922, -0.52592608, -0.82994116,
    -0.18600922, -0.52592608, -0.82994116,
    -0.18830206, 0.37690413, -0.90690993,
    -0.18830206, 0.37690413, -0.90690993,
    -0.18830206, 0.37690413, -0.90690993,
    -0.18830206, 0.37690413, -0.90690993,
    0.17530305, 0.38920677, 0.90431573,
    0.17530305, 0.38920677, 0.90431573,
    0.17530305, 0.38920677, 0.90431573,
    0.17530305, 0.38920677, 0.90431573,
    0.23140819, 0.36711300, 0.90093190,
    0.23140819, 0.36711300, 0.90093190,
    0.23140819, 0.36711300, 0.90093190,
    0.23140819, 0.36711300, 0.90093190,
    0.12090271, 0.41310926, 0.90262023,
    0.12090271, 0.41310926, 0.90262023,
    0.12090271, 0.41310926, 0.90262023,
    0.12090271, 0.41310926, 0.90262023,
    -0.11530286, -0.04000099, -0.99252464,
    -0.11530286, -0.04000099, -0.99252464,
    -0.11530286, -0.04000099, -0.99252464,
    -0.11530286, -0.04000099, -0.99252464,
    0.14870080, -0.02730015, 0.98850532,
    0.14870080, -0.02730015, 0.98850532,
    0.14870080, -0.02730015, 0.98850532,
    0.14870080, -0.02730015, 0.98850532,
    -0.13959826, 0.40479496, -0.90368875,
    -0.13959826, 0.40479496, -0.90368875,
    -0.13959826, 0.40479496, -0.90368875,
    -0.13959826, 0.40479496, -0.90368875,
    0.16180376, -0.00020000, 0.98682293,
    0.16180376, -0.00020000, 0.98682293,
    0.16180376, -0.00020000, 0.98682293,
    0.16180376, -0.00020000, 0.98682293,
    0.15339469, -0.01399952, 0.98806583,
    0.15339469, -0.01399952, 0.98806583,
    0.15339469, -0.01399952, 0.98806583,
    0.15339469, -0.01399952, 0.98806583,
    -0.13399750, 0.00059999, -0.99098149,
    -0.13399750, 0.00059999, -0.99098149,
    -0.13399750, 0.00059999, -0.99098149,
    -0.13399750, 0.00059999, -0.99098149,
    -0.12910489, -0.03430130, -0.99103751,
    -0.12910489, -0.03430130, -0.99103751,
    -0.12910489, -0.03430130, -0.99103751,
    -0.12910489, -0.03430130, -0.99103751,
    0.15829880, 0.04439966, 0.98639250,
    0.15829880, 0.04439966, 0.98639250,
    0.15829880, 0.04439966, 0.98639250,
    0.15829880, 0.04439966, 0.98639250,
    -0.13169833, -0.00219997, -0.99128740,
    -0.13169833, -0.00219997, -0.99128740,
    -0.13169833, -0.00219997, -0.99128740,
    -0.13169833, -0.00219997, -0.99128740,
    0.16879452, -0.53118274, 0.83027303,
    0.16879452, -0.53118274, 0.83027303,
    0.16879452, -0.53118274, 0.83027303,
    0.16879452, -0.53118274, 0.83027303,
    0.19270293, 0.00910014, 0.98121494,
    0.19270293, 0.00910014, 0.98121494,
    0.19270293, 0.00910014, 0.98121494,
    0.19270293, 0.00910014, 0.98121494,
    -0.10229994, -0.53879968, -0.83619951,
    -0.10229994, -0.53879968, -0.83619951,
    -0.10229994, -0.53879968, -0.83619951,
    -0.10229994, -0.53879968, -0.83619951,
    -0.17639745, 0.27409604, -0.94538633,
    -0.17639745, 0.27409604, -0.94538633,
    -0.17639745, 0.27409604, -0.94538633,
    -0.17639745, 0.27409604, -0.94538633,
    -0.18140000, 0.08760000, 0.97950001,
    -0.18140000, 0.08760000, 0.97950001,
    -0.18140000, 0.08760000, 0.97950001,
    -0.18140000, 0.08760000, 0.97950001,
    -0.15409313, -0.01989911, 0.98785593,
    -0.15409313, -0.01989911, 0.98785593,
    -0.15409313, -0.01989911, 0.98785593,
    -0.15409313, -0.01989911, 0.98785593,
    -0.20529773, -0.20499774, 0.95698943,
    -0.20529773, -0.20499774, 0.95698943,
    -0.20529773, -0.20499774, 0.95698943,
    -0.20529773, -0.20499774, 0.95698943,
    -0.16319241, -0.00889959, -0.98655412,
    -0.16319241, -0.00889959, -0.98655412,
    -0.16319241, -0.00889959, -0.98655412,
    -0.16319241, -0.00889959, -0.98655412,
    -0.25680529, -0.03240067, -0.96591989,
    -0.25680529, -0.03240067, -0.96591989,
    -0.25680529, -0.03240067, -0.96591989,
    -0.25680529, -0.03240067, -0.96591989,
    -0.00799969, -0.00359986, 0.99996152,
    -0.00799969, -0.00359986, 0.99996152,
    -0.00799969, -0.00359986, 0.99996152,
    -0.00799969, -0.00359986, 0.99996152,
    0.22749459, 0.97377686, 0.00219995,
    0.22749459, 0.97377686, 0.00219995,
    0.22749459, 0.97377686, 0.00219995,
    0.22749459, 0.97377686, 0.00219995,
    0.22319815, -0.50079585, -0.83629307,
    0.22319815, -0.50079585, -0.83629307,
    0.22319815, -0.50079585, -0.83629307,
    0.22319815, -0.50079585, -0.83629307,
    0.08419859, 0.81878629, -0.56789049,
    0.08419859, 0.81878629, -0.56789049,
    0.08419859, 0.81878629, -0.56789049,
    0.08419859, 0.81878629, -0.56789049,
    0.01130039, 0.99783414, 0.06480222,
    0.01130039, 0.99783414, 0.06480222,
    0.01130039, 0.99783414, 0.06480222,
    0.01130039, 0.99783414, 0.06480222,
    0.06890245, -0.96993454, 0.23340831,
    0.06890245, -0.96993454, 0.23340831,
    0.06890245, -0.96993454, 0.23340831,
    0.06890245, -0.96993454, 0.23340831,
    0.00000000, -1.00000000, 0.00000000,
    0.00000000, -1.00000000, 0.00000000,
    0.15539852, 0.01099990, -0.98779062,
    0.15539852, 0.01099990, -0.98779062,
    0.15539852, 0.01099990, -0.98779062,
    0.15539852, 0.01099990, -0.98779062,
    0.25570192, -0.52850397, 0.80950608,
    0.25570192, -0.52850397, 0.80950608,
    0.25570192, -0.52850397, 0.80950608,
    0.25570192, -0.52850397, 0.80950608,
    0.07460101, 0.00000000, 0.99721346,
    0.07460101, 0.00000000, 0.99721346,
    0.07460101, 0.00000000, 0.99721346,
    0.07460101, 0.00000000, 0.99721346,
    0.07990023, 0.00000000, -0.99680287,
    0.07990023, 0.00000000, -0.99680287,
    0.07990023, 0.00000000, -0.99680287,
    0.07990023, 0.00000000, -0.99680287,
    0.07460101, 0.00000000, 0.99721346,
    0.07460101, 0.00000000, 0.99721346,
    -0.00739980, -0.00069998, -0.99997238,
    -0.00739980, -0.00069998, -0.99997238,
    -0.00739980, -0.00069998, -0.99997238,
    -0.00739980, -0.00069998, -0.99997238,
    0.24359028, -0.17389306, -0.95416192,
    0.24359028, -0.17389306, -0.95416192,
    0.24359028, -0.17389306, -0.95416192,
    0.24359028, -0.17389306, -0.95416192,
    0.26068830, 0.21289044, -0.94165773,
    0.26068830, 0.21289044, -0.94165773,
    0.26068830, 0.21289044, -0.94165773,
    0.26068830, 0.21289044, -0.94165773,
    0.19179506, 0.61158423, -0.76758021,
    0.19179506, 0.61158423, -0.76758021,
    0.19179506, 0.61158423, -0.76758021,
    0.19179506, 0.61158423, -0.76758021,
    0.23050798, 0.47451643, -0.84952942,
    0.23050798, 0.47451643, -0.84952942,
    0.23050798, 0.47451643, -0.84952942,
    0.23050798, 0.47451643, -0.84952942,
    0.20090847, -0.03030128, 0.97914127,
    0.20090847, -0.03030128, 0.97914127,
    0.20090847, -0.03030128, 0.97914127,
    0.20090847, -0.03030128, 0.97914127,
    0.21861082, -0.24961235, -0.94334669,
    0.21861082, -0.24961235, -0.94334669,
    0.21861082, -0.24961235, -0.94334669,
    0.21861082, -0.24961235, -0.94334669,
    0.17370219, 0.01300016, 0.98471242,
    0.17370219, 0.01300016, 0.98471242,
    0.17370219, 0.01300016, 0.98471242,
    0.17370219, 0.01300016, 0.98471242,
    0.20320722, 0.03430122, -0.97853475,
    0.20320722, 0.03430122, -0.97853475,
    0.20320722, 0.03430122, -0.97853475,
    0.20320722, 0.03430122, -0.97853475,
    0.20460354, -0.00740013, -0.97881695,
    0.20460354, -0.00740013, -0.97881695,
    0.20460354, -0.00740013, -0.97881695,
    0.20460354, -0.00740013, -0.97881695,
    0.20340585, -0.01140033, -0.97902814,
    0.20340585, -0.01140033, -0.97902814,
    0.20340585, -0.01140033, -0.97902814,
    0.20340585, -0.01140033, -0.97902814,
    0.19830459, 0.00590014, -0.98012269,
    0.19830459, 0.00590014, -0.98012269,
    0.19830459, 0.00590014, -0.98012269,
    0.19830459, 0.00590014, -0.98012269,
    0.06779970, -0.87909609, -0.47179790,
    0.06779970, -0.87909609, -0.47179790,
    0.06779970, -0.87909609, -0.47179790,
    0.06779970, -0.87909609, -0.47179790,
    0.17999492, -0.05599842, 0.98207230,
    0.17999492, -0.05599842, 0.98207230,
    0.17999492, -0.05599842, 0.98207230,
    0.17999492, -0.05599842, 0.98207230,
    -0.00799972, -0.00229992, 0.99996536,
    -0.00799972, -0.00229992, 0.99996536,
    -0.00799972, -0.00229992, 0.99996536,
    -0.00799972, -0.00229992, 0.99996536,
    0.14550140, -0.00980009, 0.98930951,
    0.14550140, -0.00980009, 0.98930951,
    0.14550140, -0.00980009, 0.98930951,
    0.14550140, -0.00980009, 0.98930951,
    0.18510149, 0.36050290, -0.91420736,
    0.18510149, 0.36050290, -0.91420736,
    0.18510149, 0.36050290, -0.91420736,
    0.18510149, 0.36050290, -0.91420736,
    0.19070027, 0.00960001, -0.98160137,
    0.19070027, 0.00960001, -0.98160137,
    0.19070027, 0.00960001, -0.98160137,
    0.19070027, 0.00960001, -0.98160137,
    0.05559740, 0.99845326, 0.00010000,
    0.05559740, 0.99845326, 0.00010000,
    0.05559740, 0.99845326, 0.00010000,
    0.05559740, 0.99845326, 0.00010000,
    0.08440306, 0.99633612, 0.01380050,
    0.08440306, 0.99633612, 0.01380050,
    0.08440306, 0.99633612, 0.01380050,
    0.08440306, 0.99633612, 0.01380050,
    0.08210044, 0.99660539, -0.00610003,
    0.08210044, 0.99660539, -0.00610003,
    0.08210044, 0.99660539, -0.00610003,
    0.08210044, 0.99660539, -0.00610003,
    0.05259997, 0.99859940, -0.00570000,
    0.05259997, 0.99859940, -0.00570000,
    0.05259997, 0.99859940, -0.00570000,
    0.05259997, 0.99859940, -0.00570000,
    -0.23309440, 0.55778661, 0.79658088,
    -0.23309440, 0.55778661, 0.79658088,
    -0.23309440, 0.55778661, 0.79658088,
    -0.23309440, 0.55778661, 0.79658088,
    -0.00979983, 0.99788257, 0.06429888,
    -0.00979983, 0.99788257, 0.06429888,
    -0.00979983, 0.99788257, 0.06429888,
    -0.00979983, 0.99788257, 0.06429888,
    -0.05889874, -0.97387911, 0.21929530,
    -0.05889874, -0.97387911, 0.21929530,
    -0.05889874, -0.97387911, 0.21929530,
    -0.05889874, -0.97387911, 0.21929530,
    -0.23210097, -0.56200235, 0.79390333,
    -0.23210097, -0.56200235, 0.79390333,
    -0.23210097, -0.56200235, 0.79390333,
    -0.23210097, -0.56200235, 0.79390333,
    -0.06369804, 0.00000000, 0.99796922,
    -0.06369804, 0.00000000, 0.99796922,
    -0.06369804, 0.00000000, 0.99796922,
    -0.06369804, 0.00000000, 0.99796922,
    -0.01249961, 0.99856894, 0.05199838,
    -0.01249961, 0.99856894, 0.05199838,
    -0.01249961, 0.99856894, 0.05199838,
    -0.01249961, 0.99856894, 0.05199838,
    -0.05720285, 0.81144043, 0.58162898,
    -0.05720285, 0.81144043, 0.58162898,
    -0.05720285, 0.81144043, 0.58162898,
    -0.05720285, 0.81144043, 0.58162898,
    -0.00489995, -0.06919936, 0.99759082,
    -0.00489995, -0.06919936, 0.99759082,
    -0.00489995, -0.06919936, 0.99759082,
    -0.00489995, -0.06919936, 0.99759082,
    0.08230025, 0.99660306, 0.00300001,
    0.08230025, 0.99660306, 0.00300001,
    0.08230025, 0.99660306, 0.00300001,
    0.08230025, 0.99660306, 0.00300001,
    0.06030061, 0.95180960, -0.30070303,
    0.06030061, 0.95180960, -0.30070303,
    0.06030061, 0.95180960, -0.30070303,
    0.06030061, 0.95180960, -0.30070303,
    0.07720120, 0.99701551, -0.00020000,
    0.07720120, 0.99701551, -0.00020000,
    0.07720120, 0.99701551, -0.00020000,
    0.07720120, 0.99701551, -0.00020000,
    -0.21970340, -0.01720027, 0.97541508,
    -0.21970340, -0.01720027, 0.97541508,
    -0.21970340, -0.01720027, 0.97541508,
    -0.21970340, -0.01720027, 0.97541508,
    -0.22039674, -0.01559977, 0.97528556,
    -0.22039674, -0.01559977, 0.97528556,
    -0.22039674, -0.01559977, 0.97528556,
    -0.22039674, -0.01559977, 0.97528556,
    -0.22040039, -0.02450004, 0.97510175,
    -0.22040039, -0.02450004, 0.97510175,
    -0.22040039, -0.02450004, 0.97510175,
    -0.22040039, -0.02450004, 0.97510175,
    -0.99974911, -0.02239886, 0.00000000,
    -0.99974911, -0.02239886, 0.00000000,
    -0.21700572, -0.01680044, 0.97602575,
    -0.21700572, -0.01680044, 0.97602575,
    -0.21700572, -0.01680044, 0.97602575,
    -0.21700572, -0.01680044, 0.97602575,
    0.99178728, 0.12789836, 0.00000000,
    0.99178728, 0.12789836, 0.00000000,
    -0.21909243, -0.01639943, 0.97556628,
    -0.21909243, -0.01639943, 0.97556628,
    -0.21909243, -0.01639943, 0.97556628,
    -0.21909243, -0.01639943, 0.97556628,
    -0.22060139, -0.04090026, 0.97450613,
    -0.22060139, -0.04090026, 0.97450613,
    -0.22060139, -0.04090026, 0.97450613,
    -0.22060139, -0.04090026, 0.97450613,
    -0.20080114, -0.00720004, 0.97960556,
    -0.20080114, -0.00720004, 0.97960556,
    -0.20080114, -0.00720004, 0.97960556,
    -0.20080114, -0.00720004, 0.97960556,
    -0.22069944, 0.00929998, 0.97529753,
    -0.22069944, 0.00929998, 0.97529753,
    -0.22069944, 0.00929998, 0.97529753,
    -0.22069944, 0.00929998, 0.97529753,
    -0.22071128, 0.01320067, 0.97524985,
    -0.22071128, 0.01320067, 0.97524985,
    -0.22071128, 0.01320067, 0.97524985,
    -0.22071128, 0.01320067, 0.97524985,
    -0.06369804, 0.00000000, 0.99796922,
    -0.06369804, 0.00000000, 0.99796922,
    -0.05620112, -0.88251752, 0.46690927,
    -0.05620112, -0.88251752, 0.46690927,
    -0.05620112, -0.88251752, 0.46690927,
    -0.05620112, -0.88251752, 0.46690927,
    -0.23069253, 0.02639915, -0.97266852,
    -0.23069253, 0.02639915, -0.97266852,
    -0.23069253, 0.02639915, -0.97266852,
    -0.23069253, 0.02639915, -0.97266852,
    -0.22979308, 0.04559863, -0.97217072,
    -0.22979308, 0.04559863, -0.97217072,
    -0.22979308, 0.04559863, -0.97217072,
    -0.22979308, 0.04559863, -0.97217072,
    -0.21869079, 0.00829965, -0.97575891,
    -0.21869079, 0.00829965, -0.97575891,
    -0.21869079, 0.00829965, -0.97575891,
    -0.21869079, 0.00829965, -0.97575891,
    -0.23099137, -0.23129136, -0.94506470,
    -0.23099137, -0.23129136, -0.94506470,
    -0.23099137, -0.23129136, -0.94506470,
    -0.23099137, -0.23129136, -0.94506470,
    0.20880350, 0.32260541, -0.92321549,
    0.20880350, 0.32260541, -0.92321549,
    0.20880350, 0.32260541, -0.92321549,
    0.20880350, 0.32260541, -0.92321549,
    0.99890415, 0.04680019, 0.00050000,
    0.99890415, 0.04680019, 0.00050000,
    0.99890415, 0.04680019, 0.00050000,
    0.99890415, 0.04680019, 0.00050000,
    -0.03350105, 0.31460985, -0.94862971,
    -0.03350105, 0.31460985, -0.94862971,
    -0.03350105, 0.31460985, -0.94862971,
    -0.03350105, 0.31460985, -0.94862971,
    -0.04630105, 0.92452088, -0.37830854,
    -0.04630105, 0.92452088, -0.37830854,
    -0.04630105, 0.92452088, -0.37830854,
    -0.04630105, 0.92452088, -0.37830854,
    -0.15190209, 0.32990453, -0.93171281,
    -0.15190209, 0.32990453, -0.93171281,
    -0.15190209, 0.32990453, -0.93171281,
    -0.15190209, 0.32990453, -0.93171281,
    0.01909994, 0.94479704, 0.32709898,
    0.01909994, 0.94479704, 0.32709898,
    0.01909994, 0.94479704, 0.32709898,
    0.01909994, 0.94479704, 0.32709898,
    -0.02620029, 0.14550162, 0.98901103,
    -0.02620029, 0.14550162, 0.98901103,
    -0.02620029, 0.14550162, 0.98901103,
    -0.02620029, 0.14550162, 0.98901103,
    -0.00350009, 0.93822463, 0.34600908,
    -0.00350009, 0.93822463, 0.34600908,
    -0.00350009, 0.93822463, 0.34600908,
    -0.00350009, 0.93822463, 0.34600908,
    -0.06679969, 0.10989950, 0.99169547,
    -0.06679969, 0.10989950, 0.99169547,
    -0.06679969, 0.10989950, 0.99169547,
    -0.06679969, 0.10989950, 0.99169547,
    0.96630422, 0.25740112, -0.00090000,
    0.96630422, 0.25740112, -0.00090000,
    0.96630422, 0.25740112, -0.00090000,
    0.96630422, 0.25740112, -0.00090000,
    0.96102623, 0.27610754, 0.01390038,
    0.96102623, 0.27610754, 0.01390038,
    0.96102623, 0.27610754, 0.01390038,
    0.96102623, 0.27610754, 0.01390038,
    0.03089913, 0.93217383, -0.36068988,
    0.03089913, 0.93217383, -0.36068988,
    0.03089913, 0.93217383, -0.36068988,
    0.03089913, 0.93217383, -0.36068988,
    0.16230668, 0.51262111, -0.84313471,
    0.16230668, 0.51262111, -0.84313471,
    0.16230668, 0.51262111, -0.84313471,
    0.16230668, 0.51262111, -0.84313471,
    0.95238380, 0.30399483, 0.02349960,
    0.95238380, 0.30399483, 0.02349960,
    0.95238380, 0.30399483, 0.02349960,
    0.95238380, 0.30399483, 0.02349960,
    0.96606709, 0.25829120, 0.00019999,
    0.96606709, 0.25829120, 0.00019999,
    0.96606709, 0.25829120, 0.00019999,
    0.96606709, 0.25829120, 0.00019999,
    0.87454967, 0.48127230, -0.05949658,
    0.87454967, 0.48127230, -0.05949658,
    0.87454967, 0.48127230, -0.05949658,
    0.87454967, 0.48127230, -0.05949658,
    0.91756777, 0.34528787, -0.19709308,
    0.91756777, 0.34528787, -0.19709308,
    0.91756777, 0.34528787, -0.19709308,
    0.91756777, 0.34528787, -0.19709308,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    -0.01730061, -0.13470472, 0.99073474,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.01670076, -0.13470610, 0.99074485,
    0.05010218, -0.97814262, 0.20180879,
    0.05010218, -0.97814262, 0.20180879,
    0.05010218, -0.97814262, 0.20180879,
    0.05010218, -0.97814262, 0.20180879,
    -0.44099669, 0.81989384, -0.36509726,
    -0.44099669, 0.81989384, -0.36509726,
    -0.44099669, 0.81989384, -0.36509726,
    -0.44099669, 0.81989384, -0.36509726,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99704624, 0.07680356, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    -0.99178728, 0.12789836, 0.00000000,
    0.28949203, -0.00359990, 0.95717365,
    0.28949203, -0.00359990, 0.95717365,
    0.28949203, -0.00359990, 0.95717365,
    0.28949203, -0.00359990, 0.95717365,
  ]),
  uvs: new Float32Array([
    0.79112100, 0.91809200,
    0.79202100, 0.91809200,
    0.79202100, 0.91908900,
    0.79112100, 0.91908900,
    0.79202100, 0.91809200,
    0.79280400, 0.91809200,
    0.79280400, 0.91908900,
    0.79202100, 0.91908900,
    0.79202100, 0.91908900,
    0.79280400, 0.91908900,
    0.79280400, 0.92008600,
    0.79202100, 0.92008600,
    0.79112100, 0.91908900,
    0.79202100, 0.91908900,
    0.79202100, 0.92008600,
    0.79112100, 0.92008600,
    0.79679300, 0.92407500,
    0.79779000, 0.92407500,
    0.79779000, 0.92485800,
    0.79679300, 0.92485800,
    0.79779000, 0.92407500,
    0.79878700, 0.92407500,
    0.79878700, 0.92485800,
    0.79779000, 0.92485800,
    0.79779000, 0.92485800,
    0.79878700, 0.92485800,
    0.79878700, 0.92528600,
    0.79848500, 0.92539500,
    0.79798100, 0.92559000,
    0.79779000, 0.92567700,
    0.79679300, 0.92485800,
    0.79779000, 0.92485800,
    0.79779000, 0.92567700,
    0.79754000, 0.92575800,
    0.79679300, 0.92575800,
    0.79878700, 0.92407500,
    0.79978400, 0.92407500,
    0.79978400, 0.92456700,
    0.79961400, 0.92472300,
    0.79941100, 0.92485800,
    0.79878700, 0.92485800,
    0.79978400, 0.92407500,
    0.80005100, 0.92407500,
    0.79998400, 0.92424200,
    0.79989700, 0.92438900,
    0.79978400, 0.92456700,
    0.79878700, 0.92485800,
    0.79941100, 0.92485800,
    0.79908800, 0.92511400,
    0.79885500, 0.92526000,
    0.79878700, 0.92528600,
    0.79679300, 0.92575800,
    0.79754000, 0.92575800,
    0.79679300, 0.92603900,
    0.79112100, 0.91809200,
    0.79112100, 0.91908900,
    0.79202100, 0.91908900,
    0.79202100, 0.91809200,
    0.79202100, 0.91809200,
    0.79202100, 0.91908900,
    0.79280400, 0.91908900,
    0.79280400, 0.91809200,
    0.79202100, 0.91908900,
    0.79202100, 0.92008600,
    0.79280400, 0.92008600,
    0.79280400, 0.91908900,
    0.79112100, 0.91908900,
    0.79112100, 0.92008600,
    0.79202100, 0.92008600,
    0.79202100, 0.91908900,
    0.79679300, 0.92407500,
    0.79679300, 0.92485800,
    0.79779000, 0.92485800,
    0.79779000, 0.92407500,
    0.79779000, 0.92407500,
    0.79779000, 0.92485800,
    0.79878700, 0.92485800,
    0.79878700, 0.92407500,
    0.79779000, 0.92485800,
    0.79779000, 0.92563500,
    0.79808000, 0.92549900,
    0.79869000, 0.92522100,
    0.79878700, 0.92516900,
    0.79878700, 0.92485800,
    0.79679300, 0.92485800,
    0.79679300, 0.92575800,
    0.79742200, 0.92575800,
    0.79779000, 0.92563500,
    0.79779000, 0.92485800,
    0.79878700, 0.92407500,
    0.79878700, 0.92485800,
    0.79931100, 0.92485800,
    0.79962200, 0.92468200,
    0.79978400, 0.92453200,
    0.79978400, 0.92407500,
    0.79978400, 0.92407500,
    0.79978400, 0.92453200,
    0.79986200, 0.92445700,
    0.79998100, 0.92425600,
    0.80005100, 0.92407500,
    0.79878700, 0.92485800,
    0.79878700, 0.92516900,
    0.79931100, 0.92485800,
    0.79679300, 0.92575800,
    0.79679300, 0.92603800,
    0.79705500, 0.92593900,
    0.79742200, 0.92575800,
    0.79071900, 0.91908900,
    0.79071400, 0.91809200,
    0.79112100, 0.91809200,
    0.79112100, 0.91908900,
    0.79084000, 0.92008600,
    0.79071900, 0.91908900,
    0.79112100, 0.91908900,
    0.79112100, 0.92008600,
    0.79071700, 0.91908900,
    0.79084100, 0.92008600,
    0.79112100, 0.92008600,
    0.79112100, 0.91908900,
    0.04307400, 0.94153000,
    0.04307400, 0.94252700,
    0.04397400, 0.94252700,
    0.04397400, 0.94153000,
    0.04397400, 0.94153000,
    0.04397400, 0.94252700,
    0.04475800, 0.94252700,
    0.04475800, 0.94153000,
    0.04397400, 0.94252700,
    0.04397400, 0.94352400,
    0.04475800, 0.94352400,
    0.04475800, 0.94252700,
    0.04307400, 0.94252700,
    0.04307400, 0.94352400,
    0.04397400, 0.94352400,
    0.04397400, 0.94252700,
    0.04974300, 0.94751200,
    0.04974300, 0.94829600,
    0.05074000, 0.94829600,
    0.05074000, 0.94751200,
    0.04974300, 0.94829600,
    0.04974300, 0.94911400,
    0.04993400, 0.94902800,
    0.05043800, 0.94883200,
    0.05074000, 0.94872400,
    0.05074000, 0.94829600,
    0.04874600, 0.94829600,
    0.04874600, 0.94919600,
    0.04949300, 0.94919600,
    0.04974300, 0.94911400,
    0.04974300, 0.94829600,
    0.05074000, 0.94751200,
    0.05074000, 0.94829600,
    0.05136400, 0.94829600,
    0.05156700, 0.94816100,
    0.05173700, 0.94800500,
    0.05173700, 0.94751200,
    0.05173700, 0.94751200,
    0.05173700, 0.94800500,
    0.05185000, 0.94782700,
    0.05193700, 0.94768000,
    0.05200400, 0.94751200,
    0.05074000, 0.94829600,
    0.05074000, 0.94872400,
    0.05080900, 0.94869800,
    0.05104100, 0.94855200,
    0.05136400, 0.94829600,
    0.04397400, 0.94153000,
    0.04475800, 0.94153000,
    0.04475800, 0.94252700,
    0.04397400, 0.94252700,
    0.04397400, 0.94252700,
    0.04475800, 0.94252700,
    0.04475800, 0.94352400,
    0.04397400, 0.94352400,
    0.04974300, 0.94751200,
    0.05074000, 0.94751200,
    0.05074000, 0.94829600,
    0.04974300, 0.94829600,
    0.04974300, 0.94829600,
    0.05074000, 0.94829600,
    0.05074000, 0.94860600,
    0.05064300, 0.94865900,
    0.05003300, 0.94893600,
    0.04974300, 0.94907200,
    0.04874600, 0.94829600,
    0.04974300, 0.94829600,
    0.04974300, 0.94907200,
    0.04937500, 0.94919600,
    0.04874600, 0.94919600,
    0.05074000, 0.94751200,
    0.05173700, 0.94751200,
    0.05173700, 0.94796900,
    0.05157600, 0.94812000,
    0.05126400, 0.94829600,
    0.05074000, 0.94829600,
    0.05173700, 0.94751200,
    0.05200400, 0.94751200,
    0.05193400, 0.94769300,
    0.05181500, 0.94789500,
    0.05173700, 0.94796900,
    0.05074000, 0.94829600,
    0.05126400, 0.94829600,
    0.05074000, 0.94860600,
    0.04874600, 0.94919600,
    0.04937500, 0.94919600,
    0.04900800, 0.94937600,
    0.04874600, 0.94947600,
    0.04267200, 0.94252700,
    0.04307400, 0.94252700,
    0.04307400, 0.94153000,
    0.04266700, 0.94153000,
    0.04279300, 0.94352400,
    0.04307400, 0.94352400,
    0.04307400, 0.94252700,
    0.04267200, 0.94252700,
    0.04267000, 0.94252700,
    0.04307400, 0.94252700,
    0.04307400, 0.94352400,
    0.04279400, 0.94352400,
    0.79280400, 0.91809200,
    0.79202100, 0.91809200,
    0.79202100, 0.91809200,
    0.79280400, 0.91809200,
    0.79202100, 0.91809200,
    0.79112100, 0.91809200,
    0.79112100, 0.91809200,
    0.79202100, 0.91809200,
    0.79112100, 0.91908900,
    0.79112100, 0.91809200,
    0.79112100, 0.91809200,
    0.79112100, 0.91908900,
    0.79202100, 0.91809200,
    0.79280400, 0.91809200,
    0.79280400, 0.91809200,
    0.79202100, 0.91809200,
    0.79112100, 0.91809200,
    0.79202100, 0.91809200,
    0.79202100, 0.91809200,
    0.79112100, 0.91809200,
    0.79978400, 0.92453200,
    0.79962200, 0.92468200,
    0.79962200, 0.92468200,
    0.79978400, 0.92453200,
    0.79962200, 0.92468200,
    0.79931100, 0.92485800,
    0.79931100, 0.92485800,
    0.79962200, 0.92468200,
    0.79742200, 0.92575800,
    0.79705500, 0.92593900,
    0.79705500, 0.92593900,
    0.79742200, 0.92575800,
    0.79705500, 0.92593900,
    0.79679300, 0.92603800,
    0.79679300, 0.92603800,
    0.79705500, 0.92593900,
    0.80005100, 0.92407500,
    0.79998100, 0.92425600,
    0.79998100, 0.92425600,
    0.80005100, 0.92407500,
    0.79998100, 0.92425600,
    0.79986200, 0.92445700,
    0.79986200, 0.92445700,
    0.79998100, 0.92425600,
    0.79986200, 0.92445700,
    0.79978400, 0.92453200,
    0.79978400, 0.92453200,
    0.79986200, 0.92445700,
    0.79878700, 0.92516900,
    0.79869000, 0.92522100,
    0.79869000, 0.92522100,
    0.79878700, 0.92516900,
    0.79869000, 0.92522100,
    0.79808000, 0.92549900,
    0.79808000, 0.92549900,
    0.79869000, 0.92522100,
    0.79808000, 0.92549900,
    0.79779000, 0.92563500,
    0.79779000, 0.92563500,
    0.79808000, 0.92549900,
    0.79779000, 0.92563500,
    0.79742200, 0.92575800,
    0.79742200, 0.92575800,
    0.79779000, 0.92563500,
    0.79931100, 0.92485800,
    0.79878700, 0.92516900,
    0.79878700, 0.92516900,
    0.79931100, 0.92485800,
    0.79908800, 0.92511400,
    0.79941100, 0.92485800,
    0.79941100, 0.92485800,
    0.79908800, 0.92511400,
    0.79885500, 0.92526000,
    0.79908800, 0.92511400,
    0.79908800, 0.92511400,
    0.79885500, 0.92526000,
    0.79878700, 0.92528600,
    0.79885500, 0.92526000,
    0.79885500, 0.92526000,
    0.79878700, 0.92528600,
    0.79961400, 0.92472300,
    0.79978400, 0.92456700,
    0.79978400, 0.92456700,
    0.79961400, 0.92472300,
    0.79941100, 0.92485800,
    0.79961400, 0.92472300,
    0.79961400, 0.92472300,
    0.79941100, 0.92485800,
    0.79679300, 0.92603900,
    0.79754000, 0.92575800,
    0.79754000, 0.92575800,
    0.79679300, 0.92603900,
    0.79998400, 0.92424200,
    0.80005100, 0.92407500,
    0.80005100, 0.92407500,
    0.79998400, 0.92424200,
    0.79989700, 0.92438900,
    0.79998400, 0.92424200,
    0.79998400, 0.92424200,
    0.79989700, 0.92438900,
    0.79978400, 0.92456700,
    0.79989700, 0.92438900,
    0.79989700, 0.92438900,
    0.79978400, 0.92456700,
    0.79848500, 0.92539500,
    0.79878700, 0.92528600,
    0.79878700, 0.92528600,
    0.79848500, 0.92539500,
    0.79798100, 0.92559000,
    0.79848500, 0.92539500,
    0.79848500, 0.92539500,
    0.79798100, 0.92559000,
    0.79779000, 0.92567700,
    0.79798100, 0.92559000,
    0.79798100, 0.92559000,
    0.79779000, 0.92567700,
    0.79754000, 0.92575800,
    0.79779000, 0.92567700,
    0.79779000, 0.92567700,
    0.79754000, 0.92575800,
    0.79112100, 0.91809200,
    0.79071400, 0.91809200,
    0.79071400, 0.91809200,
    0.79112100, 0.91809200,
    0.79071400, 0.91809200,
    0.79071900, 0.91908900,
    0.79071900, 0.91908900,
    0.79071400, 0.91809200,
    0.79071900, 0.91908900,
    0.79084000, 0.92008600,
    0.79084000, 0.92008600,
    0.79071900, 0.91908900,
    0.79071700, 0.91908900,
    0.79112100, 0.91908900,
    0.79112100, 0.91908900,
    0.79071700, 0.91908900,
    0.79084100, 0.92008600,
    0.79071700, 0.91908900,
    0.79071700, 0.91908900,
    0.79084100, 0.92008600,
    0.05572600, 0.92658300,
    0.05672300, 0.92658300,
    0.05672300, 0.92764800,
    0.05572600, 0.92764800,
    0.04874600, 0.92258400,
    0.05074000, 0.92258400,
    0.05074000, 0.92457900,
    0.04874600, 0.92457900,
    0.05472900, 0.94919600,
    0.05572600, 0.94919600,
    0.05572600, 0.95029000,
    0.05472900, 0.95029000,
    0.05572600, 0.94919600,
    0.05672300, 0.94919600,
    0.05672300, 0.95029000,
    0.05572600, 0.95029000,
    0.05572600, 0.95029000,
    0.05672300, 0.95029000,
    0.05672300, 0.95150100,
    0.05572600, 0.95150100,
    0.05472900, 0.95029000,
    0.05572600, 0.95029000,
    0.05572600, 0.95150100,
    0.05472900, 0.95150100,
    0.05074000, 0.92059000,
    0.05273500, 0.92059000,
    0.05273500, 0.92258400,
    0.05074000, 0.92258400,
    0.06239500, 0.94053200,
    0.06348900, 0.94053200,
    0.06348900, 0.94252700,
    0.06239500, 0.94252700,
    0.06348900, 0.94252700,
    0.06470000, 0.94252700,
    0.06470000, 0.94352400,
    0.06348900, 0.94352400,
    0.06239500, 0.94252700,
    0.06348900, 0.94252700,
    0.06348900, 0.94352400,
    0.06239500, 0.94352400,
    0.05423000, 0.93077500,
    0.05572600, 0.93077500,
    0.05572600, 0.93155800,
    0.05423000, 0.93155800,
    0.05572600, 0.92987500,
    0.05672300, 0.92987500,
    0.05672300, 0.93077500,
    0.05572600, 0.93077500,
    0.05572600, 0.93077500,
    0.05672300, 0.93077500,
    0.05672300, 0.93155800,
    0.05572600, 0.93155800,
    0.05472900, 0.92457900,
    0.05572600, 0.92457900,
    0.05572600, 0.92658300,
    0.05423000, 0.92658300,
    0.05423000, 0.92457900,
    0.05423000, 0.92879000,
    0.05572600, 0.92879000,
    0.05572600, 0.92987500,
    0.05423000, 0.92987500,
    0.05572600, 0.92764800,
    0.05672300, 0.92764800,
    0.05672300, 0.92879000,
    0.05572600, 0.92879000,
    0.05572600, 0.92879000,
    0.05672300, 0.92879000,
    0.05672300, 0.92987500,
    0.05572600, 0.92987500,
    0.05423000, 0.92987500,
    0.05572600, 0.92987500,
    0.05572600, 0.93077500,
    0.05423000, 0.93077500,
    0.04475800, 0.93654400,
    0.04475800, 0.93853800,
    0.04397400, 0.93853800,
    0.04397400, 0.93654400,
    0.05173700, 0.94800500,
    0.05185000, 0.94782700,
    0.05193700, 0.94768000,
    0.05200400, 0.94751200,
    0.05273500, 0.94751200,
    0.05273500, 0.94829600,
    0.05136400, 0.94829600,
    0.05156700, 0.94816100,
    0.04198000, 0.94252700,
    0.04267200, 0.94252700,
    0.04279300, 0.94352400,
    0.04198000, 0.94352400,
    0.04076900, 0.94252700,
    0.04198000, 0.94252700,
    0.04198000, 0.94352400,
    0.04076900, 0.94352400,
    0.04307400, 0.93654400,
    0.04307400, 0.93853800,
    0.04198000, 0.93853800,
    0.04198000, 0.93654400,
    0.06071100, 0.94053200,
    0.06149500, 0.94053200,
    0.06149500, 0.94252700,
    0.06071100, 0.94252700,
    0.06149500, 0.94252700,
    0.06239500, 0.94252700,
    0.06239500, 0.94352400,
    0.06149500, 0.94352400,
    0.06071100, 0.94252700,
    0.06149500, 0.94252700,
    0.06149500, 0.94352400,
    0.06071100, 0.94352400,
    0.05472900, 0.94751200,
    0.05572600, 0.94751200,
    0.05572600, 0.94829600,
    0.05472900, 0.94829600,
    0.05572600, 0.94751200,
    0.05672300, 0.94751200,
    0.05672300, 0.94829600,
    0.05572600, 0.94829600,
    0.05572600, 0.94829600,
    0.05672300, 0.94829600,
    0.05672300, 0.94919600,
    0.05572600, 0.94919600,
    0.05472900, 0.94829600,
    0.05572600, 0.94829600,
    0.05572600, 0.94919600,
    0.05472900, 0.94919600,
    0.06071100, 0.93554700,
    0.06149500, 0.93554700,
    0.06149500, 0.93654400,
    0.06071100, 0.93654400,
    0.06149500, 0.93554700,
    0.06239500, 0.93554700,
    0.06239500, 0.93654400,
    0.06149500, 0.93654400,
    0.06149500, 0.93654400,
    0.06149500, 0.93853800,
    0.06071100, 0.93853800,
    0.06071100, 0.93654400,
    0.06239500, 0.93853800,
    0.06239500, 0.94053200,
    0.06149500, 0.94053200,
    0.06149500, 0.93853800,
    0.06149500, 0.93853800,
    0.06149500, 0.94053200,
    0.06071100, 0.94053200,
    0.06071100, 0.93853800,
    0.06149500, 0.94053200,
    0.06239500, 0.94053200,
    0.06239500, 0.94252700,
    0.06149500, 0.94252700,
    0.04076900, 0.93554700,
    0.04198000, 0.93554700,
    0.04198000, 0.93654400,
    0.04076900, 0.93654400,
    0.04198000, 0.93554700,
    0.04307400, 0.93554700,
    0.04307400, 0.93654400,
    0.04198000, 0.93654400,
    0.04198000, 0.93654400,
    0.04198000, 0.93853800,
    0.04076900, 0.93853800,
    0.04076900, 0.93654400,
    0.04307400, 0.93853800,
    0.04307400, 0.94053200,
    0.04198000, 0.94053200,
    0.04198000, 0.93853800,
    0.04198000, 0.93853800,
    0.04198000, 0.94053200,
    0.04076900, 0.94053200,
    0.04076900, 0.93853800,
    0.04076900, 0.94053200,
    0.04198000, 0.94053200,
    0.04198000, 0.94252700,
    0.04076900, 0.94252700,
    0.04307400, 0.93554700,
    0.04397400, 0.93554700,
    0.04397400, 0.93654400,
    0.04307400, 0.93654400,
    0.04397400, 0.93554700,
    0.04475800, 0.93554700,
    0.04475800, 0.93654400,
    0.04397400, 0.93654400,
    0.04397400, 0.93654400,
    0.04397400, 0.93853800,
    0.04307400, 0.93853800,
    0.04307400, 0.93654400,
    0.04475800, 0.93853800,
    0.04475800, 0.94053200,
    0.04397400, 0.94053200,
    0.04397400, 0.93853800,
    0.04397400, 0.93853800,
    0.04397400, 0.94053200,
    0.04307400, 0.94053200,
    0.04307400, 0.93853800,
    0.06470000, 0.93654400,
    0.06470000, 0.93853800,
    0.06348900, 0.93853800,
    0.06348900, 0.93654400,
    0.04397400, 0.94053200,
    0.04475800, 0.94053200,
    0.04475800, 0.94153000,
    0.04397400, 0.94153000,
    0.04307400, 0.94053200,
    0.04397400, 0.94053200,
    0.04397400, 0.94153000,
    0.04307400, 0.94153000,
    0.06239500, 0.93554700,
    0.06348900, 0.93554700,
    0.06348900, 0.93654400,
    0.06239500, 0.93654400,
    0.06348900, 0.93554700,
    0.06470000, 0.93554700,
    0.06470000, 0.93654400,
    0.06348900, 0.93654400,
    0.06348900, 0.93654400,
    0.06348900, 0.93853800,
    0.06239500, 0.93853800,
    0.06239500, 0.93654400,
    0.06470000, 0.94053200,
    0.06348900, 0.94053200,
    0.06348900, 0.93853800,
    0.06470000, 0.93853800,
    0.06348900, 0.93853800,
    0.06348900, 0.94053200,
    0.06239500, 0.94053200,
    0.06239500, 0.93853800,
    0.06348900, 0.94053200,
    0.06470000, 0.94053200,
    0.06470000, 0.94252700,
    0.06348900, 0.94252700,
    0.05472900, 0.91959300,
    0.05572600, 0.91959300,
    0.05572600, 0.92059000,
    0.05472900, 0.92059000,
    0.05572600, 0.91959300,
    0.05672300, 0.91959300,
    0.05672300, 0.92059000,
    0.05572600, 0.92059000,
    0.05572600, 0.92059000,
    0.05572600, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92059000,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05074000, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05074000, 0.92457900,
    0.05672300, 0.92059000,
    0.05672300, 0.92258400,
    0.05572600, 0.92258400,
    0.05572600, 0.92059000,
    0.05572600, 0.92457900,
    0.05672300, 0.92457900,
    0.05672300, 0.92658300,
    0.05572600, 0.92658300,
    0.05273500, 0.92658300,
    0.05074000, 0.92658300,
    0.05074000, 0.92457900,
    0.05273500, 0.92457900,
    0.05423000, 0.92764800,
    0.05572600, 0.92764800,
    0.05572600, 0.92879000,
    0.05423000, 0.92879000,
    0.04874600, 0.92059000,
    0.05074000, 0.92059000,
    0.05074000, 0.92258400,
    0.04874600, 0.92258400,
    0.05074000, 0.92658300,
    0.04874600, 0.92658300,
    0.04874600, 0.92457900,
    0.05074000, 0.92457900,
    0.05672300, 0.92258400,
    0.05672300, 0.92457900,
    0.05572600, 0.92457900,
    0.05572600, 0.92258400,
    0.04874600, 0.91959300,
    0.05074000, 0.91959300,
    0.05074000, 0.92059000,
    0.04874600, 0.92059000,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.06149500, 0.93654400,
    0.06149500, 0.93853800,
    0.06239500, 0.93853800,
    0.06239500, 0.93654400,
    0.05074000, 0.91959300,
    0.05273500, 0.91959300,
    0.05273500, 0.92059000,
    0.05074000, 0.92059000,
    0.05323300, 0.91959300,
    0.05423000, 0.91959300,
    0.05423000, 0.92059000,
    0.05323300, 0.92059000,
    0.05423000, 0.92059000,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92059000,
    0.05423000, 0.91959300,
    0.05472900, 0.91959300,
    0.05472900, 0.92059000,
    0.05423000, 0.92059000,
    0.05074000, 0.94872400,
    0.05080900, 0.94869800,
    0.05104100, 0.94855200,
    0.05136400, 0.94829600,
    0.05273500, 0.94829600,
    0.05273500, 0.94919600,
    0.05074000, 0.94919600,
    0.04874600, 0.94751200,
    0.04974300, 0.94751200,
    0.04974300, 0.94829600,
    0.04874600, 0.94829600,
    0.05074000, 0.94751200,
    0.05173700, 0.94751200,
    0.05173700, 0.94800500,
    0.05156700, 0.94816100,
    0.05136400, 0.94829600,
    0.05074000, 0.94829600,
    0.05173700, 0.94751200,
    0.05200400, 0.94751200,
    0.05193700, 0.94768000,
    0.05185000, 0.94782700,
    0.05173700, 0.94800500,
    0.05074000, 0.92764800,
    0.05074000, 0.92879000,
    0.04874600, 0.92879000,
    0.04874600, 0.92764800,
    0.05273500, 0.94751200,
    0.05373200, 0.94751200,
    0.05373200, 0.94813800,
    0.05369500, 0.94793700,
    0.05363500, 0.94775300,
    0.05362200, 0.94773100,
    0.05357200, 0.94778700,
    0.05349100, 0.94787600,
    0.05338400, 0.94801100,
    0.05329200, 0.94817500,
    0.05324200, 0.94829600,
    0.05273500, 0.94829600,
    0.05373200, 0.94751200,
    0.05472900, 0.94751200,
    0.05472900, 0.94829600,
    0.05375200, 0.94829600,
    0.05373200, 0.94813800,
    0.05273500, 0.94829600,
    0.05324200, 0.94829600,
    0.05323300, 0.94837700,
    0.05322800, 0.94850500,
    0.05327600, 0.94870700,
    0.05332700, 0.94889700,
    0.05341400, 0.94913400,
    0.05343500, 0.94919600,
    0.05273500, 0.94919600,
    0.04874600, 0.92879000,
    0.05074000, 0.92879000,
    0.05074000, 0.92987500,
    0.04874600, 0.92987500,
    0.05273500, 0.92764800,
    0.05273500, 0.92879000,
    0.05074000, 0.92879000,
    0.05074000, 0.92764800,
    0.05074000, 0.92879000,
    0.05273500, 0.92879000,
    0.05273500, 0.92987500,
    0.05074000, 0.92987500,
    0.05423000, 0.92764800,
    0.05423000, 0.92879000,
    0.05323300, 0.92879000,
    0.05323300, 0.92764800,
    0.05423000, 0.92879000,
    0.05423000, 0.92987500,
    0.05323300, 0.92987500,
    0.05323300, 0.92879000,
    0.05074000, 0.92987500,
    0.05074000, 0.93077500,
    0.04874600, 0.93077500,
    0.04874600, 0.92987500,
    0.04874600, 0.93077500,
    0.05074000, 0.93077500,
    0.05074000, 0.93155800,
    0.04874600, 0.93155800,
    0.05273500, 0.92987500,
    0.05273500, 0.93077500,
    0.05074000, 0.93077500,
    0.05074000, 0.92987500,
    0.05074000, 0.93077500,
    0.05273500, 0.93077500,
    0.05273500, 0.93155800,
    0.05074000, 0.93155800,
    0.05423000, 0.92987500,
    0.05423000, 0.93077500,
    0.05323300, 0.93077500,
    0.05323300, 0.92987500,
    0.05423000, 0.93077500,
    0.05423000, 0.93155800,
    0.05323300, 0.93155800,
    0.05323300, 0.93077500,
    0.04874600, 0.94947700,
    0.04949300, 0.94919600,
    0.05074000, 0.94919600,
    0.05074000, 0.95029000,
    0.04874600, 0.95029000,
    0.04874600, 0.94919600,
    0.04949300, 0.94919600,
    0.04874600, 0.94947700,
    0.04874600, 0.95029000,
    0.05074000, 0.95029000,
    0.05074000, 0.95150100,
    0.04874600, 0.95150100,
    0.05273500, 0.94919600,
    0.05273500, 0.95029000,
    0.05074000, 0.95029000,
    0.05074000, 0.94919600,
    0.05074000, 0.95029000,
    0.05273500, 0.95029000,
    0.05273500, 0.95150100,
    0.05074000, 0.95150100,
    0.05423000, 0.94919600,
    0.05423000, 0.95029000,
    0.05323300, 0.95029000,
    0.05273500, 0.95029000,
    0.05273500, 0.94919600,
    0.05343500, 0.94919600,
    0.05361800, 0.94957000,
    0.05364700, 0.94942500,
    0.05366400, 0.94919600,
    0.05423000, 0.95029000,
    0.05423000, 0.95150100,
    0.05323300, 0.95150100,
    0.05323300, 0.95029000,
    0.05423000, 0.94919600,
    0.05472900, 0.94919600,
    0.05472900, 0.95029000,
    0.05423000, 0.95029000,
    0.05423000, 0.95029000,
    0.05472900, 0.95029000,
    0.05472900, 0.95150100,
    0.05423000, 0.95150100,
    0.04874600, 0.92658300,
    0.05074000, 0.92658300,
    0.05074000, 0.92764800,
    0.04874600, 0.92764800,
    0.05074000, 0.92658300,
    0.05273500, 0.92658300,
    0.05273500, 0.92764800,
    0.05074000, 0.92764800,
    0.05423000, 0.92457900,
    0.05423000, 0.92658300,
    0.05323300, 0.92658300,
    0.05323300, 0.92457900,
    0.05423000, 0.92658300,
    0.05423000, 0.92764800,
    0.05323300, 0.92764800,
    0.05323300, 0.92658300,
    0.05423000, 0.92658300,
    0.05572600, 0.92658300,
    0.05572600, 0.92764800,
    0.05423000, 0.92764800,
    0.05368500, 0.94913300,
    0.05375900, 0.94868600,
    0.05376900, 0.94851600,
    0.05376500, 0.94834300,
    0.05375200, 0.94829600,
    0.05472900, 0.94829600,
    0.05472900, 0.94919600,
    0.05423000, 0.94919600,
    0.05366400, 0.94919600,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05423000, 0.92059000,
    0.05472900, 0.92059000,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05572600, 0.92258400,
    0.05572600, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92457900,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92059000,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92059000,
    0.05273500, 0.91959300,
    0.05323300, 0.91959300,
    0.05323300, 0.92059000,
    0.05273500, 0.92059000,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92457900,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92658300,
    0.05273500, 0.92658300,
    0.05273500, 0.92457900,
    0.05323300, 0.92258400,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92658300,
    0.05323300, 0.92658300,
    0.05323300, 0.92764800,
    0.05273500, 0.92764800,
    0.05273500, 0.95029000,
    0.05323300, 0.95029000,
    0.05323300, 0.95150100,
    0.05273500, 0.95150100,
    0.05273500, 0.93077500,
    0.05323300, 0.93077500,
    0.05323300, 0.93155800,
    0.05273500, 0.93155800,
    0.05273500, 0.92987500,
    0.05323300, 0.92987500,
    0.05323300, 0.93077500,
    0.05273500, 0.93077500,
    0.05273500, 0.92879000,
    0.05323300, 0.92879000,
    0.05323300, 0.92987500,
    0.05273500, 0.92987500,
    0.05273500, 0.92764800,
    0.05323300, 0.92764800,
    0.05323300, 0.92879000,
    0.05273500, 0.92879000,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05572600, 0.92658300,
    0.05572600, 0.92764800,
    0.05672300, 0.92764800,
    0.05672300, 0.92658300,
    0.04874600, 0.92258400,
    0.04874600, 0.92358100,
    0.04874600, 0.92457900,
    0.05074000, 0.92457900,
    0.05074000, 0.92258400,
    0.05472900, 0.94919600,
    0.05472900, 0.95029000,
    0.05572600, 0.95029000,
    0.05572600, 0.94919600,
    0.05572600, 0.94919600,
    0.05572600, 0.95029000,
    0.05672300, 0.95029000,
    0.05672300, 0.94919600,
    0.05572600, 0.95029000,
    0.05572600, 0.95150100,
    0.05672300, 0.95150100,
    0.05672300, 0.95029000,
    0.05472900, 0.95029000,
    0.05472900, 0.95150100,
    0.05572600, 0.95150100,
    0.05572600, 0.95029000,
    0.05074000, 0.92059000,
    0.05074000, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92059000,
    0.06239500, 0.94053200,
    0.06239500, 0.94252700,
    0.06348900, 0.94252700,
    0.06348900, 0.94053200,
    0.06348900, 0.94252700,
    0.06348900, 0.94352400,
    0.06470000, 0.94352400,
    0.06470000, 0.94252700,
    0.06239500, 0.94252700,
    0.06239500, 0.94352400,
    0.06348900, 0.94352400,
    0.06348900, 0.94252700,
    0.04307400, 0.94153000,
    0.04307400, 0.94252700,
    0.04397400, 0.94252700,
    0.04397400, 0.94153000,
    0.04307400, 0.94252700,
    0.04307400, 0.94352400,
    0.04397400, 0.94352400,
    0.04397400, 0.94252700,
    0.05423000, 0.93077500,
    0.05423000, 0.93155800,
    0.05572600, 0.93155800,
    0.05572600, 0.93077500,
    0.05572600, 0.92987500,
    0.05572600, 0.93077500,
    0.05672300, 0.93077500,
    0.05672300, 0.92987500,
    0.05572600, 0.93077500,
    0.05572600, 0.93155800,
    0.05672300, 0.93155800,
    0.05672300, 0.93077500,
    0.05572600, 0.92658300,
    0.05572600, 0.92457900,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92658300,
    0.05423000, 0.92879000,
    0.05423000, 0.92987500,
    0.05572600, 0.92987500,
    0.05572600, 0.92879000,
    0.05572600, 0.92764800,
    0.05572600, 0.92879000,
    0.05672300, 0.92879000,
    0.05672300, 0.92764800,
    0.05572600, 0.92879000,
    0.05572600, 0.92987500,
    0.05672300, 0.92987500,
    0.05672300, 0.92879000,
    0.05423000, 0.92987500,
    0.05423000, 0.93077500,
    0.05572600, 0.93077500,
    0.05572600, 0.92987500,
    0.04076900, 0.94153000,
    0.04076900, 0.94252700,
    0.04198000, 0.94252700,
    0.04198000, 0.94153000,
    0.04198000, 0.94153000,
    0.04198000, 0.94252700,
    0.04267000, 0.94252700,
    0.04307400, 0.94252700,
    0.04307400, 0.94153000,
    0.04198000, 0.94252700,
    0.04198000, 0.94352400,
    0.04279400, 0.94352400,
    0.04267000, 0.94252700,
    0.04076900, 0.94252700,
    0.04076900, 0.94352400,
    0.04198000, 0.94352400,
    0.04198000, 0.94252700,
    0.04397400, 0.93654400,
    0.04397400, 0.93853800,
    0.04475800, 0.93853800,
    0.04475800, 0.93654400,
    0.06071100, 0.94053200,
    0.06071100, 0.94252700,
    0.06149500, 0.94252700,
    0.06149500, 0.94053200,
    0.06149500, 0.94252700,
    0.06149500, 0.94352400,
    0.06239500, 0.94352400,
    0.06239500, 0.94252700,
    0.06071100, 0.94252700,
    0.06071100, 0.94352400,
    0.06149500, 0.94352400,
    0.06149500, 0.94252700,
    0.05472900, 0.94751200,
    0.05472900, 0.94829600,
    0.05572600, 0.94829600,
    0.05572600, 0.94751200,
    0.05572600, 0.94751200,
    0.05572600, 0.94829600,
    0.05672300, 0.94829600,
    0.05672300, 0.94751200,
    0.05572600, 0.94829600,
    0.05572600, 0.94919600,
    0.05672300, 0.94919600,
    0.05672300, 0.94829600,
    0.05472900, 0.94829600,
    0.05472900, 0.94919600,
    0.05572600, 0.94919600,
    0.05572600, 0.94829600,
    0.06071100, 0.93554700,
    0.06071100, 0.93654400,
    0.06149500, 0.93654400,
    0.06149500, 0.93554700,
    0.06149500, 0.93554700,
    0.06149500, 0.93654400,
    0.06239500, 0.93654400,
    0.06239500, 0.93554700,
    0.06071100, 0.93654400,
    0.06071100, 0.93853800,
    0.06149500, 0.93853800,
    0.06149500, 0.93654400,
    0.06149500, 0.93853800,
    0.06149500, 0.94053200,
    0.06239500, 0.94053200,
    0.06239500, 0.93953500,
    0.06239500, 0.93853800,
    0.06071100, 0.93853800,
    0.06071100, 0.94053200,
    0.06149500, 0.94053200,
    0.06149500, 0.93853800,
    0.06149500, 0.94053200,
    0.06149500, 0.94252700,
    0.06239500, 0.94252700,
    0.06239500, 0.94053200,
    0.04076900, 0.93554700,
    0.04076900, 0.93654400,
    0.04198000, 0.93654400,
    0.04198000, 0.93554700,
    0.04198000, 0.93554700,
    0.04198000, 0.93654400,
    0.04307400, 0.93654400,
    0.04307400, 0.93554700,
    0.04198000, 0.93654400,
    0.04198000, 0.93754100,
    0.04307400, 0.93754100,
    0.04307400, 0.93654400,
    0.04076900, 0.93654400,
    0.04076900, 0.93754100,
    0.04198000, 0.93754100,
    0.04198000, 0.93654400,
    0.04076900, 0.93754100,
    0.04076900, 0.93853800,
    0.04198000, 0.93853800,
    0.04198000, 0.93754100,
    0.04198000, 0.93754100,
    0.04198000, 0.93853800,
    0.04307400, 0.93853800,
    0.04307400, 0.93754100,
    0.04198000, 0.93853800,
    0.04198000, 0.93953500,
    0.04307400, 0.93953500,
    0.04307400, 0.93853800,
    0.04076900, 0.93853800,
    0.04076900, 0.93953500,
    0.04198000, 0.93953500,
    0.04198000, 0.93853800,
    0.04076900, 0.93953500,
    0.04076900, 0.94053200,
    0.04198000, 0.94053200,
    0.04198000, 0.93953500,
    0.04198000, 0.93953500,
    0.04198000, 0.94053200,
    0.04307400, 0.94053200,
    0.04307400, 0.93953500,
    0.04198000, 0.94053200,
    0.04198000, 0.94153000,
    0.04307400, 0.94153000,
    0.04307400, 0.94053200,
    0.04076900, 0.94053200,
    0.04076900, 0.94153000,
    0.04198000, 0.94153000,
    0.04198000, 0.94053200,
    0.04307400, 0.93554700,
    0.04307400, 0.93654400,
    0.04397400, 0.93654400,
    0.04397400, 0.93554700,
    0.04397400, 0.93554700,
    0.04397400, 0.93654400,
    0.04475800, 0.93654400,
    0.04475800, 0.93554700,
    0.04307400, 0.93754100,
    0.04307400, 0.93853800,
    0.04397400, 0.93853800,
    0.04397400, 0.93654400,
    0.04307400, 0.93654400,
    0.04397400, 0.93853800,
    0.04397400, 0.94053200,
    0.04475800, 0.94053200,
    0.04475800, 0.93853800,
    0.04307400, 0.93953500,
    0.04307400, 0.94053200,
    0.04397400, 0.94053200,
    0.04397400, 0.93853800,
    0.04307400, 0.93853800,
    0.06348900, 0.93654400,
    0.06348900, 0.93853800,
    0.06470000, 0.93853800,
    0.06470000, 0.93654400,
    0.04397400, 0.94053200,
    0.04397400, 0.94153000,
    0.04475800, 0.94153000,
    0.04475800, 0.94053200,
    0.04307400, 0.94053200,
    0.04307400, 0.94153000,
    0.04397400, 0.94153000,
    0.04397400, 0.94053200,
    0.06239500, 0.93554700,
    0.06239500, 0.93654400,
    0.06348900, 0.93654400,
    0.06348900, 0.93554700,
    0.06348900, 0.93554700,
    0.06348900, 0.93654400,
    0.06470000, 0.93654400,
    0.06470000, 0.93554700,
    0.06239500, 0.93654400,
    0.06239500, 0.93853800,
    0.06348900, 0.93853800,
    0.06348900, 0.93654400,
    0.06348900, 0.94053200,
    0.06348900, 0.94252700,
    0.06470000, 0.94252700,
    0.06470000, 0.94053200,
    0.06348900, 0.93853800,
    0.06348900, 0.93953500,
    0.06470000, 0.93953500,
    0.06470000, 0.93853800,
    0.06239500, 0.93853800,
    0.06239500, 0.93953500,
    0.06348900, 0.93953500,
    0.06348900, 0.93853800,
    0.06239500, 0.93953500,
    0.06239500, 0.94053200,
    0.06348900, 0.94053200,
    0.06348900, 0.93953500,
    0.06348900, 0.93953500,
    0.06348900, 0.94053200,
    0.06470000, 0.94053200,
    0.06470000, 0.93953500,
    0.05472900, 0.91959300,
    0.05472900, 0.92059000,
    0.05572600, 0.92059000,
    0.05572600, 0.91959300,
    0.05572600, 0.91959300,
    0.05572600, 0.92059000,
    0.05672300, 0.92059000,
    0.05672300, 0.91959300,
    0.05472900, 0.92258400,
    0.05572600, 0.92258400,
    0.05572600, 0.92059000,
    0.05472900, 0.92059000,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05074000, 0.92258400,
    0.05074000, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05572600, 0.92059000,
    0.05572600, 0.92258400,
    0.05672300, 0.92258400,
    0.05672300, 0.92059000,
    0.05572600, 0.92457900,
    0.05572600, 0.92658300,
    0.05672300, 0.92658300,
    0.05672300, 0.92457900,
    0.05074000, 0.92457900,
    0.05074000, 0.92658300,
    0.05273500, 0.92658300,
    0.05273500, 0.92457900,
    0.05423000, 0.92764800,
    0.05423000, 0.92879000,
    0.05572600, 0.92879000,
    0.05572600, 0.92764800,
    0.04874600, 0.92059000,
    0.04874600, 0.92158700,
    0.04874600, 0.92258400,
    0.05074000, 0.92258400,
    0.05074000, 0.92059000,
    0.04874600, 0.92557600,
    0.04874600, 0.92658300,
    0.05074000, 0.92658300,
    0.05074000, 0.92457900,
    0.04874600, 0.92457900,
    0.05572600, 0.92258400,
    0.05572600, 0.92457900,
    0.05672300, 0.92457900,
    0.05672300, 0.92358100,
    0.05672300, 0.92258400,
    0.05074000, 0.92059000,
    0.05074000, 0.91959300,
    0.04974300, 0.91959300,
    0.04874600, 0.91959300,
    0.04874600, 0.92059000,
    0.05423000, 0.92258400,
    0.05423000, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92258400,
    0.04198000, 0.94053200,
    0.04307400, 0.94053200,
    0.04307400, 0.94153000,
    0.04266700, 0.94153000,
    0.04267200, 0.94252700,
    0.04198000, 0.94252700,
    0.05273500, 0.92059000,
    0.05273500, 0.91959300,
    0.05173700, 0.91959300,
    0.05074000, 0.91959300,
    0.05074000, 0.92059000,
    0.05423000, 0.92059000,
    0.05423000, 0.91959300,
    0.05373200, 0.91959300,
    0.05323300, 0.91959300,
    0.05323300, 0.92059000,
    0.05423000, 0.92258400,
    0.05423000, 0.92059000,
    0.05323300, 0.92059000,
    0.05323300, 0.92258400,
    0.05423000, 0.91959300,
    0.05423000, 0.92059000,
    0.05472900, 0.92059000,
    0.05472900, 0.91959300,
    0.05200400, 0.94751200,
    0.05193400, 0.94769300,
    0.05181500, 0.94789500,
    0.05173700, 0.94796900,
    0.05157600, 0.94812000,
    0.05126400, 0.94829600,
    0.05273500, 0.94829600,
    0.05273500, 0.94751200,
    0.04874600, 0.94751200,
    0.04874600, 0.94829600,
    0.04974300, 0.94829600,
    0.04974300, 0.94751200,
    0.05074000, 0.94751200,
    0.05074000, 0.94829600,
    0.05126400, 0.94829600,
    0.05157600, 0.94812000,
    0.05173700, 0.94796900,
    0.05173700, 0.94751200,
    0.05173700, 0.94751200,
    0.05173700, 0.94796900,
    0.05181500, 0.94789500,
    0.05193400, 0.94769300,
    0.05200400, 0.94751200,
    0.05074000, 0.92879000,
    0.05074000, 0.92764800,
    0.04874600, 0.92764800,
    0.04874600, 0.92879000,
    0.05273500, 0.94751200,
    0.05273500, 0.94829600,
    0.05324200, 0.94829600,
    0.05329200, 0.94817500,
    0.05338400, 0.94801100,
    0.05349100, 0.94787600,
    0.05357200, 0.94778700,
    0.05362200, 0.94773100,
    0.05363500, 0.94775300,
    0.05369500, 0.94793700,
    0.05373200, 0.94813800,
    0.05373200, 0.94751200,
    0.05373200, 0.94751200,
    0.05373200, 0.94813800,
    0.05375200, 0.94829600,
    0.05472900, 0.94829600,
    0.05472900, 0.94751200,
    0.05273500, 0.94829600,
    0.05273500, 0.94919600,
    0.05343500, 0.94919600,
    0.05341400, 0.94913400,
    0.05332700, 0.94889700,
    0.05327600, 0.94870700,
    0.05322800, 0.94850500,
    0.05323300, 0.94837700,
    0.05324200, 0.94829600,
    0.04874600, 0.92879000,
    0.04874600, 0.92987500,
    0.05074000, 0.92987500,
    0.05074000, 0.92879000,
    0.05273500, 0.92879000,
    0.05273500, 0.92764800,
    0.05074000, 0.92764800,
    0.05074000, 0.92879000,
    0.05074000, 0.92879000,
    0.05074000, 0.92987500,
    0.05273500, 0.92987500,
    0.05273500, 0.92879000,
    0.05423000, 0.92879000,
    0.05423000, 0.92764800,
    0.05323300, 0.92764800,
    0.05323300, 0.92879000,
    0.05423000, 0.92987500,
    0.05423000, 0.92879000,
    0.05323300, 0.92879000,
    0.05323300, 0.92987500,
    0.05074000, 0.93077500,
    0.05074000, 0.92987500,
    0.04874600, 0.92987500,
    0.04874600, 0.93077500,
    0.04874600, 0.93077500,
    0.04874600, 0.93155800,
    0.05074000, 0.93155800,
    0.05074000, 0.93077500,
    0.05273500, 0.93077500,
    0.05273500, 0.92987500,
    0.05074000, 0.92987500,
    0.05074000, 0.93077500,
    0.05074000, 0.93077500,
    0.05074000, 0.93155800,
    0.05273500, 0.93155800,
    0.05273500, 0.93077500,
    0.05423000, 0.93077500,
    0.05423000, 0.92987500,
    0.05323300, 0.92987500,
    0.05323300, 0.93077500,
    0.05423000, 0.93155800,
    0.05423000, 0.93077500,
    0.05323300, 0.93077500,
    0.05323300, 0.93155800,
    0.04874600, 0.92658300,
    0.04874600, 0.92764800,
    0.05074000, 0.92764800,
    0.05074000, 0.92658300,
    0.04974300, 0.94919600,
    0.04974300, 0.95029000,
    0.05074000, 0.95029000,
    0.05074000, 0.94919600,
    0.04974300, 0.95029000,
    0.04974300, 0.95150100,
    0.05074000, 0.95150100,
    0.05074000, 0.95029000,
    0.04874600, 0.95029000,
    0.04874600, 0.95150100,
    0.04974300, 0.95150100,
    0.04974300, 0.95029000,
    0.05074000, 0.94919600,
    0.05074000, 0.95029000,
    0.05173700, 0.95029000,
    0.05173700, 0.94919600,
    0.05173700, 0.94919600,
    0.05173700, 0.95029000,
    0.05273500, 0.95029000,
    0.05273500, 0.94919600,
    0.05173700, 0.95029000,
    0.05173700, 0.95150100,
    0.05273500, 0.95150100,
    0.05273500, 0.95029000,
    0.05074000, 0.95029000,
    0.05074000, 0.95150100,
    0.05173700, 0.95150100,
    0.05173700, 0.95029000,
    0.05273500, 0.94919600,
    0.05273500, 0.95029000,
    0.05298400, 0.95029000,
    0.05323300, 0.95029000,
    0.05373200, 0.95029000,
    0.05373200, 0.94919600,
    0.05366400, 0.94919600,
    0.05364700, 0.94942500,
    0.05361800, 0.94957000,
    0.05343500, 0.94919600,
    0.05423000, 0.94919600,
    0.05423000, 0.95029000,
    0.05472900, 0.95029000,
    0.05472900, 0.94919600,
    0.05423000, 0.95029000,
    0.05423000, 0.95150100,
    0.05472900, 0.95150100,
    0.05472900, 0.95029000,
    0.05323300, 0.95029000,
    0.05323300, 0.95150100,
    0.05373200, 0.95150100,
    0.05373200, 0.95029000,
    0.05074000, 0.92658300,
    0.05074000, 0.92764800,
    0.05273500, 0.92764800,
    0.05273500, 0.92658300,
    0.05423000, 0.92658300,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92658300,
    0.05423000, 0.92764800,
    0.05423000, 0.92658300,
    0.05323300, 0.92658300,
    0.05323300, 0.92764800,
    0.05423000, 0.92658300,
    0.05423000, 0.92764800,
    0.05572600, 0.92764800,
    0.05572600, 0.92658300,
    0.05373200, 0.94919600,
    0.05423000, 0.94919600,
    0.05472900, 0.94919600,
    0.05472900, 0.94829600,
    0.05375200, 0.94829600,
    0.05376500, 0.94834300,
    0.05376900, 0.94851600,
    0.05375900, 0.94868600,
    0.05368500, 0.94913300,
    0.05366400, 0.94919600,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05423000, 0.92457900,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92457900,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05423000, 0.92059000,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92059000,
    0.05472900, 0.92457900,
    0.05572600, 0.92457900,
    0.05572600, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92457900,
    0.05423000, 0.92258400,
    0.05423000, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92258400,
    0.05472900, 0.92258400,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92059000,
    0.05273500, 0.92059000,
    0.05273500, 0.92258400,
    0.05373200, 0.95029000,
    0.05373200, 0.95150100,
    0.05423000, 0.95150100,
    0.05423000, 0.95029000,
    0.05373200, 0.94919600,
    0.05373200, 0.95029000,
    0.05423000, 0.95029000,
    0.05423000, 0.94919600,
    0.05273500, 0.91959300,
    0.05273500, 0.92059000,
    0.05323300, 0.92059000,
    0.05323300, 0.91959300,
    0.05298400, 0.91959300,
    0.05472900, 0.92457900,
    0.05472900, 0.92457900,
    0.05423000, 0.92457900,
    0.05423000, 0.92457900,
    0.05323300, 0.92457900,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05323300, 0.92658300,
    0.05323300, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92658300,
    0.05323300, 0.92457900,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05323300, 0.92258400,
    0.05323300, 0.92258400,
    0.05298400, 0.95029000,
    0.05298400, 0.95150100,
    0.05323300, 0.95150100,
    0.05323300, 0.95029000,
    0.05273500, 0.92658300,
    0.05273500, 0.92764800,
    0.05323300, 0.92764800,
    0.05323300, 0.92658300,
    0.05273500, 0.93077500,
    0.05273500, 0.93155800,
    0.05323300, 0.93155800,
    0.05323300, 0.93077500,
    0.05273500, 0.92987500,
    0.05273500, 0.93077500,
    0.05323300, 0.93077500,
    0.05323300, 0.92987500,
    0.05273500, 0.92879000,
    0.05273500, 0.92987500,
    0.05323300, 0.92987500,
    0.05323300, 0.92879000,
    0.05273500, 0.92764800,
    0.05273500, 0.92879000,
    0.05323300, 0.92879000,
    0.05323300, 0.92764800,
    0.05273500, 0.92457900,
    0.05273500, 0.92457900,
    0.05273500, 0.92258400,
    0.05273500, 0.92258400,
    0.05273500, 0.95029000,
    0.05273500, 0.95150100,
    0.05298400, 0.95150100,
    0.05298400, 0.95029000,
    0.05126400, 0.94829600,
    0.05074000, 0.94860600,
    0.05074000, 0.94919600,
    0.05173700, 0.94919600,
    0.05273500, 0.94919600,
    0.05273500, 0.94829600,
    0.04937500, 0.94919600,
    0.04900800, 0.94937600,
    0.04874600, 0.94947600,
    0.04874600, 0.95029000,
    0.04974300, 0.95029000,
    0.04974300, 0.94919600,
    0.04949300, 0.94919600,
    0.04974300, 0.94911400,
    0.04993400, 0.94902800,
    0.05043800, 0.94883200,
    0.05074000, 0.94872400,
    0.05074000, 0.94919600,
    0.04974300, 0.94907200,
    0.04937500, 0.94919600,
    0.04974300, 0.94919600,
    0.05074000, 0.94919600,
    0.05074000, 0.94860600,
    0.05064300, 0.94865900,
    0.05003300, 0.94893600,
    0.29639400, 0.91190400,
    0.31468500, 0.91190400,
    0.31468500, 0.91800100,
    0.29639400, 0.91800100,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.44676300, 0.96849000,
    0.44676300, 0.96848800,
    0.44676300, 0.97037200,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.29639400, 0.96936200,
    0.31468500, 0.96936200,
    0.31468500, 0.97287200,
    0.29639400, 0.97287200,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.20250400, 0.96107300,
    0.20250400, 0.95918900,
    0.20250400, 0.95918900,
    0.20250500, 0.96107300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.91045800,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.91045800,
    0.29639400, 0.92703300,
    0.29639400, 0.92514900,
    0.31468500, 0.92514900,
    0.31468500, 0.92703300,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.31468500, 0.96572400,
    0.29639400, 0.96572400,
    0.29639400, 0.96384000,
    0.31468500, 0.96384000,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.97401200,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.97401300,
    0.44676300, 0.97401200,
    0.44676300, 0.97037200,
    0.44676300, 0.97037400,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.20250400, 0.90115700,
    0.20250400, 0.89506000,
    0.20250400, 0.89506000,
    0.20250400, 0.90115700,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.20250500, 0.91686000,
    0.20250400, 0.91335000,
    0.20250400, 0.91335000,
    0.20250400, 0.91686000,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.96107300,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.07750400, 0.96107300,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.17754600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.94993100,
    0.17754600, 0.94993100,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.91861500,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.08864700, 0.94993100,
    0.08676300, 0.94993100,
    0.08676300, 0.94383400,
    0.08864700, 0.94383400,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93773700,
    0.17754600, 0.93164100,
    0.18105600, 0.93164100,
    0.18105600, 0.93773700,
    0.17754600, 0.93773700,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.94383400,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.20250400, 0.91335000,
    0.20250400, 0.90725400,
    0.20250400, 0.90725400,
    0.20250400, 0.91335000,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.29639400, 0.89971100,
    0.31468500, 0.89971100,
    0.31468500, 0.90580700,
    0.29639400, 0.90580700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.94383400,
    0.20250400, 0.92049900,
    0.20250400, 0.92049900,
    0.20250400, 0.92238200,
    0.20250400, 0.92238200,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96295700,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.94383400,
    0.18105600, 0.94383400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.55797300, 0.92654700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.92654700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.93264400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.93264400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.07750400, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96822100,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.09053000, 0.94383400,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.20250500, 0.91686000,
    0.20250400, 0.91686000,
    0.20250400, 0.92049900,
    0.20250400, 0.92049900,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401200,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037200,
    0.20250400, 0.96107300,
    0.20250500, 0.96107300,
    0.20250500, 0.96471200,
    0.20250500, 0.96471200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.31468500, 0.92151100,
    0.31468500, 0.92514900,
    0.29639400, 0.92514900,
    0.29639400, 0.92151100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.31468500, 0.96572400,
    0.31468500, 0.96936200,
    0.29639400, 0.96936200,
    0.29639400, 0.96572400,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.08864700, 0.93773700,
    0.08864700, 0.94383400,
    0.08676300, 0.94383400,
    0.08676300, 0.93773700,
    0.82555100, 0.93763500,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.82555100, 0.93763500,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.08864700, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.08864700, 0.94383400,
    0.08864700, 0.93164100,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.08864700, 0.93773700,
    0.08864700, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.08864700, 0.94993100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.90115700,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.67468500, 0.94383400,
    0.67468500, 0.93773700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.67468500, 0.94993100,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.93164100,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.93773700,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.93773700,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.93773700,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.67280100, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67280100, 0.94993100,
    0.67280100, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67280100, 0.93773700,
    0.66916300, 0.93773700,
    0.66916300, 0.93164100,
    0.66916300, 0.94993100,
    0.66916300, 0.94383400,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.66565300, 0.94383400,
    0.66565300, 0.94993100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.90115700,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.93773700,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.90115700,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.94383400,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.66565300, 0.93164100,
    0.66565300, 0.93773700,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.31468500, 0.91800100,
    0.31468500, 0.92151100,
    0.29639400, 0.92151100,
    0.29639400, 0.91800100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.20250400, 0.96822100,
    0.20250500, 0.96471200,
    0.20250500, 0.96471200,
    0.20250400, 0.96822100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401200,
    0.44676300, 0.97401300,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.17754600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.94383400,
    0.17754600, 0.94383400,
    0.17579100, 0.93773700,
    0.17754600, 0.93773700,
    0.17754600, 0.94383400,
    0.17579100, 0.94383400,
    0.17579100, 0.93164100,
    0.17754600, 0.93164100,
    0.17754600, 0.93773700,
    0.17579100, 0.93773700,
    0.17579100, 0.94383400,
    0.17754600, 0.94383400,
    0.17754600, 0.94993100,
    0.17579100, 0.94993100,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96295700,
    0.08864700, 0.93164100,
    0.08864700, 0.93773700,
    0.08676300, 0.93773700,
    0.08676300, 0.93164100,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.96848800,
    0.44676300, 0.97037200,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96295700,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96295700,
    0.07750400, 0.92049900,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.07750400, 0.92049900,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.09053000, 0.94383400,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.07750400, 0.92049900,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.29639400, 0.91190400,
    0.29639400, 0.91800100,
    0.31468500, 0.91800100,
    0.31468500, 0.91190400,
    0.29639400, 0.96936200,
    0.29639400, 0.97287200,
    0.31468500, 0.97287200,
    0.31468500, 0.96936200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.29639400, 0.92514900,
    0.29639400, 0.92703300,
    0.31468500, 0.92703300,
    0.31468500, 0.92514900,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.20250400, 0.96107300,
    0.20250500, 0.96107300,
    0.20250400, 0.95918900,
    0.20250400, 0.95918900,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.97401200,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.97401200,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.43750500, 0.95313500,
    0.43750500, 0.95313500,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.91655500,
    0.44676300, 0.91655500,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.20250400, 0.90115700,
    0.20250400, 0.90115700,
    0.20250400, 0.89506000,
    0.20250400, 0.89506000,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.20250500, 0.91686000,
    0.20250400, 0.91686000,
    0.20250400, 0.91335000,
    0.20250400, 0.91335000,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90115700,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.09053000, 0.93164100,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.17754600, 0.94383400,
    0.17754600, 0.94993100,
    0.18105600, 0.94993100,
    0.18105600, 0.94383400,
    0.16276500, 0.91861500,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.89506000,
    0.16276500, 0.89506000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.17754600, 0.93164100,
    0.17754600, 0.93773700,
    0.18105600, 0.93773700,
    0.18105600, 0.93164100,
    0.18105600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.20250400, 0.91335000,
    0.20250400, 0.91335000,
    0.20250400, 0.90725400,
    0.20250400, 0.90725400,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.43750500, 0.94703900,
    0.43750500, 0.94703900,
    0.44676300, 0.97037400,
    0.44676300, 0.97037200,
    0.44676300, 0.96848800,
    0.44676300, 0.96849000,
    0.43750500, 0.95923200,
    0.43750500, 0.95923200,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.44676300, 0.91045800,
    0.44676300, 0.91045800,
    0.29639400, 0.89971100,
    0.29639400, 0.90580700,
    0.31468500, 0.90580700,
    0.31468500, 0.89971100,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.18105600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.96295700,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.18105600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96822100,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96107300,
    0.16276500, 0.95918900,
    0.16276500, 0.95918900,
    0.16276500, 0.96107300,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.20250400, 0.91686000,
    0.20250500, 0.91686000,
    0.20250400, 0.92049900,
    0.20250400, 0.92049900,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.93168300,
    0.44676300, 0.93168300,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401300,
    0.44676300, 0.97401200,
    0.44676300, 0.97037200,
    0.44676300, 0.97037400,
    0.20250500, 0.96107300,
    0.20250400, 0.96107300,
    0.20250500, 0.96471200,
    0.20250500, 0.96471200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.29639400, 0.92514900,
    0.31468500, 0.92514900,
    0.31468500, 0.92151100,
    0.29639400, 0.92151100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.97401300,
    0.44676300, 0.97401300,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.29639400, 0.96936200,
    0.31468500, 0.96936200,
    0.31468500, 0.96572400,
    0.29639400, 0.96572400,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.08864700, 0.93773700,
    0.08864700, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93773700,
    0.08864700, 0.93164100,
    0.08864700, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.08864700, 0.94383400,
    0.08864700, 0.94993100,
    0.09053000, 0.94993100,
    0.09053000, 0.94383400,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.67468500, 0.94993100,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.93164100,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.92049900,
    0.67280100, 0.94383400,
    0.67280100, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67280100, 0.93164100,
    0.67280100, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.66916300, 0.93164100,
    0.66916300, 0.93773700,
    0.66916300, 0.94993100,
    0.66916300, 0.94383400,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.66565300, 0.94993100,
    0.66565300, 0.94383400,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.90725400,
    0.68394300, 0.90725400,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.93164100,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.67468500, 0.93164100,
    0.67468500, 0.93164100,
    0.67468500, 0.93773700,
    0.67468500, 0.93773700,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.67468500, 0.94993100,
    0.67468500, 0.94993100,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.68394300, 0.89506000,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.92238200,
    0.68394300, 0.92238200,
    0.68394300, 0.89506000,
    0.68394300, 0.89506000,
    0.68394300, 0.90115700,
    0.68394300, 0.90115700,
    0.67468500, 0.94383400,
    0.67468500, 0.94383400,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.90725400,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.92049900,
    0.68394300, 0.92049900,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.93264400,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.55797300, 0.92654700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750500, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750500, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.16276500, 0.90115700,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.07750400, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.18105600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.18105600, 0.93773700,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.66565300, 0.93773700,
    0.66565300, 0.93164100,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.96471200,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.68394300, 0.96822100,
    0.68394300, 0.91335000,
    0.68394300, 0.91686000,
    0.68394300, 0.91686000,
    0.68394300, 0.91335000,
    0.68394300, 0.96471200,
    0.68394300, 0.96822100,
    0.44676300, 0.92980000,
    0.44676300, 0.92980000,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.29639400, 0.91800100,
    0.29639400, 0.92151100,
    0.31468500, 0.92151100,
    0.31468500, 0.91800100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.20250400, 0.96822100,
    0.20250500, 0.96471200,
    0.20250500, 0.96471200,
    0.20250400, 0.96822100,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.97401200,
    0.44676300, 0.97752200,
    0.44676300, 0.97752200,
    0.44676300, 0.97401300,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.92616100,
    0.44676300, 0.92616100,
    0.44676300, 0.92265200,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96107300,
    0.16276500, 0.96107300,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.96471200,
    0.16276500, 0.96471200,
    0.16276500, 0.96822100,
    0.16276500, 0.91686000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.91686000,
    0.17754600, 0.93773700,
    0.17754600, 0.94383400,
    0.18105600, 0.94383400,
    0.18105600, 0.93773700,
    0.17579100, 0.93773700,
    0.17579100, 0.94383400,
    0.17754600, 0.94383400,
    0.17754600, 0.93773700,
    0.17579100, 0.93164100,
    0.17579100, 0.93773700,
    0.17754600, 0.93773700,
    0.17754600, 0.93164100,
    0.17579100, 0.94383400,
    0.17579100, 0.94993100,
    0.17754600, 0.94993100,
    0.17754600, 0.94383400,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.07750400, 0.96295700,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.08676300, 0.94383400,
    0.08676300, 0.94993100,
    0.08864700, 0.94993100,
    0.08864700, 0.94383400,
    0.08676300, 0.93164100,
    0.08676300, 0.93773700,
    0.08864700, 0.93773700,
    0.08864700, 0.93164100,
    0.08676300, 0.93773700,
    0.08676300, 0.94383400,
    0.08864700, 0.94383400,
    0.08864700, 0.93773700,
    0.29639400, 0.96384000,
    0.29639400, 0.96572400,
    0.31468500, 0.96572400,
    0.31468500, 0.96384000,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.43750500, 0.94094200,
    0.43750500, 0.94094200,
    0.44676300, 0.96848800,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037200,
    0.44676300, 0.92265200,
    0.44676300, 0.92265200,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.44676300, 0.96849000,
    0.44676300, 0.96849000,
    0.44676300, 0.97037400,
    0.44676300, 0.97037400,
    0.20250400, 0.92238200,
    0.20250400, 0.92238200,
    0.20250400, 0.92049900,
    0.20250400, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92049900,
    0.16276500, 0.92238200,
    0.16276500, 0.92238200,
    0.16276500, 0.91335000,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.92238200,
    0.07750400, 0.92238200,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.96295700,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96295700,
    0.07750400, 0.96295700,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.07750400, 0.96107300,
    0.07750400, 0.96107300,
    0.07750400, 0.95918900,
    0.07750400, 0.95918900,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.94993100,
    0.09053000, 0.94993100,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.07750400, 0.92049900,
    0.07750400, 0.92049900,
    0.07750400, 0.91861500,
    0.07750400, 0.91861500,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.94383400,
    0.09053000, 0.94383400,
    0.09053000, 0.93164100,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.09053000, 0.93164100,
    0.09053000, 0.93164100,
    0.09053000, 0.93773700,
    0.09053000, 0.93773700,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.67382800, 0.91406200,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.07750400, 0.90115700,
    0.06239500, 0.93654400,
    0.06239500, 0.93853800,
    0.06149500, 0.93853800,
    0.06149500, 0.93654400,
    0.16276500, 0.91335000,
    0.16276500, 0.90725400,
    0.16276500, 0.90725400,
    0.16276500, 0.91335000,
    0.44676300, 0.90436100,
    0.44676300, 0.90436100,
    0.68394300, 0.95918900,
    0.68394300, 0.96107300,
    0.68394300, 0.96107300,
    0.68394300, 0.95918900,
  ]),
  materialIndex: 0,
};

export const BOB_MESHES: BobMesh[] = [
  BOB_MESH_0,
];
